!function (t, e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function (t) {
        if (!t.document) throw new Error("jQuery requires a window with a document");
        return e(t)
    } : e(t)
}("undefined" != typeof window ? window : this, function (_, t) {
    "use strict";

    function m(t) {
        return null != t && t === t.window
    }

    var e = [], n = Object.getPrototypeOf, a = e.slice, g = e.flat ? function (t) {
            return e.flat.call(t)
        } : function (t) {
            return e.concat.apply([], t)
        }, l = e.push, o = e.indexOf, i = {}, r = i.toString, v = i.hasOwnProperty, s = v.toString, u = s.call(Object),
        y = {}, w = function (t) {
            return "function" == typeof t && "number" != typeof t.nodeType
        }, C = _.document, c = {type: !0, src: !0, nonce: !0, noModule: !0};

    function x(t, e, n) {
        var i, o, r = (n = n || C).createElement("script");
        if (r.text = t, e) for (i in c) (o = e[i] || e.getAttribute && e.getAttribute(i)) && r.setAttribute(i, o);
        n.head.appendChild(r).parentNode.removeChild(r)
    }

    function f(t) {
        return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? i[r.call(t)] || "object" : typeof t
    }

    var h = "3.5.1", z = function (t, e) {
        return new z.fn.init(t, e)
    };

    function p(t) {
        var e = !!t && "length" in t && t.length, n = f(t);
        return !w(t) && !m(t) && ("array" === n || 0 === e || "number" == typeof e && 0 < e && e - 1 in t)
    }

    z.fn = z.prototype = {
        jquery: h, constructor: z, length: 0, toArray: function () {
            return a.call(this)
        }, get: function (t) {
            return null == t ? a.call(this) : t < 0 ? this[t + this.length] : this[t]
        }, pushStack: function (t) {
            t = z.merge(this.constructor(), t);
            return t.prevObject = this, t
        }, each: function (t) {
            return z.each(this, t)
        }, map: function (n) {
            return this.pushStack(z.map(this, function (t, e) {
                return n.call(t, e, t)
            }))
        }, slice: function () {
            return this.pushStack(a.apply(this, arguments))
        }, first: function () {
            return this.eq(0)
        }, last: function () {
            return this.eq(-1)
        }, even: function () {
            return this.pushStack(z.grep(this, function (t, e) {
                return (e + 1) % 2
            }))
        }, odd: function () {
            return this.pushStack(z.grep(this, function (t, e) {
                return e % 2
            }))
        }, eq: function (t) {
            var e = this.length, t = +t + (t < 0 ? e : 0);
            return this.pushStack(0 <= t && t < e ? [this[t]] : [])
        }, end: function () {
            return this.prevObject || this.constructor()
        }, push: l, sort: e.sort, splice: e.splice
    }, z.extend = z.fn.extend = function () {
        var t, e, n, i, o, r = arguments[0] || {}, s = 1, a = arguments.length, l = !1;
        for ("boolean" == typeof r && (l = r, r = arguments[s] || {}, s++), "object" == typeof r || w(r) || (r = {}), s === a && (r = this, s--); s < a; s++) if (null != (t = arguments[s])) for (e in t) n = t[e], "__proto__" !== e && r !== n && (l && n && (z.isPlainObject(n) || (i = Array.isArray(n))) ? (o = r[e], o = i && !Array.isArray(o) ? [] : i || z.isPlainObject(o) ? o : {}, i = !1, r[e] = z.extend(l, o, n)) : void 0 !== n && (r[e] = n));
        return r
    }, z.extend({
        expando: "jQuery" + (h + Math.random()).replace(/\D/g, ""), isReady: !0, error: function (t) {
            throw new Error(t)
        }, noop: function () {
        }, isPlainObject: function (t) {
            return !(!t || "[object Object]" !== r.call(t) || (t = n(t)) && ("function" != typeof (t = v.call(t, "constructor") && t.constructor) || s.call(t) !== u))
        }, isEmptyObject: function (t) {
            for (var e in t) return !1;
            return !0
        }, globalEval: function (t, e, n) {
            x(t, {nonce: e && e.nonce}, n)
        }, each: function (t, e) {
            var n, i = 0;
            if (p(t)) for (n = t.length; i < n && !1 !== e.call(t[i], i, t[i]); i++) ; else for (i in t) if (!1 === e.call(t[i], i, t[i])) break;
            return t
        }, makeArray: function (t, e) {
            e = e || [];
            return null != t && (p(Object(t)) ? z.merge(e, "string" == typeof t ? [t] : t) : l.call(e, t)), e
        }, inArray: function (t, e, n) {
            return null == e ? -1 : o.call(e, t, n)
        }, merge: function (t, e) {
            for (var n = +e.length, i = 0, o = t.length; i < n; i++) t[o++] = e[i];
            return t.length = o, t
        }, grep: function (t, e, n) {
            for (var i = [], o = 0, r = t.length, s = !n; o < r; o++) !e(t[o], o) != s && i.push(t[o]);
            return i
        }, map: function (t, e, n) {
            var i, o, r = 0, s = [];
            if (p(t)) for (i = t.length; r < i; r++) null != (o = e(t[r], r, n)) && s.push(o); else for (r in t) null != (o = e(t[r], r, n)) && s.push(o);
            return g(s)
        }, guid: 1, support: y
    }), "function" == typeof Symbol && (z.fn[Symbol.iterator] = e[Symbol.iterator]), z.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (t, e) {
        i["[object " + e + "]"] = e.toLowerCase()
    });
    var d = function (n) {
        function h(t, e) {
            return t = "0x" + t.slice(1) - 65536, e || (t < 0 ? String.fromCharCode(65536 + t) : String.fromCharCode(t >> 10 | 55296, 1023 & t | 56320))
        }

        function i() {
            _()
        }

        var t, p, x, r, o, d, f, m, b, l, u, _, C, s, z, g, a, c, v, T = "sizzle" + +new Date, y = n.document, S = 0,
            w = 0, E = lt(), k = lt(), L = lt(), W = lt(), I = function (t, e) {
                return t === e && (u = !0), 0
            }, D = {}.hasOwnProperty, e = [], O = e.pop, A = e.push, j = e.push, H = e.slice, N = function (t, e) {
                for (var n = 0, i = t.length; n < i; n++) if (t[n] === e) return n;
                return -1
            },
            P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            M = "[\\x20\\t\\r\\n\\f]", R = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            $ = "\\[" + M + "*(" + R + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + M + "*\\]",
            q = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + $ + ")*)|.*)\\)|)",
            F = new RegExp(M + "+", "g"), B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
            Z = new RegExp("^" + M + "*," + M + "*"), U = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
            Y = new RegExp(M + "|>"), X = new RegExp(q), V = new RegExp("^" + R + "$"), G = {
                ID: new RegExp("^#(" + R + ")"),
                CLASS: new RegExp("^\\.(" + R + ")"),
                TAG: new RegExp("^(" + R + "|[*])"),
                ATTR: new RegExp("^" + $),
                PSEUDO: new RegExp("^" + q),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + P + ")$", "i"),
                needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i")
            }, Q = /HTML$/i, J = /^(?:input|select|textarea|button)$/i, K = /^h\d$/i, tt = /^[^{]+\{\s*\[native \w/,
            et = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, nt = /[+~]/,
            it = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
            ot = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, rt = function (t, e) {
                return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
            }, st = yt(function (t) {
                return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
            }, {dir: "parentNode", next: "legend"});
        try {
            j.apply(e = H.call(y.childNodes), y.childNodes), e[y.childNodes.length].nodeType
        } catch (t) {
            j = {
                apply: e.length ? function (t, e) {
                    A.apply(t, H.call(e))
                } : function (t, e) {
                    for (var n = t.length, i = 0; t[n++] = e[i++];) ;
                    t.length = n - 1
                }
            }
        }

        function at(t, e, n, i) {
            var o, r, s, a, l, u, c = e && e.ownerDocument, h = e ? e.nodeType : 9;
            if (n = n || [], "string" != typeof t || !t || 1 !== h && 9 !== h && 11 !== h) return n;
            if (!i && (_(e), e = e || C, z)) {
                if (11 !== h && (a = et.exec(t))) if (u = a[1]) {
                    if (9 === h) {
                        if (!(r = e.getElementById(u))) return n;
                        if (r.id === u) return n.push(r), n
                    } else if (c && (r = c.getElementById(u)) && v(e, r) && r.id === u) return n.push(r), n
                } else {
                    if (a[2]) return j.apply(n, e.getElementsByTagName(t)), n;
                    if ((u = a[3]) && p.getElementsByClassName && e.getElementsByClassName) return j.apply(n, e.getElementsByClassName(u)), n
                }
                if (p.qsa && !W[t + " "] && (!g || !g.test(t)) && (1 !== h || "object" !== e.nodeName.toLowerCase())) {
                    if (u = t, c = e, 1 === h && (Y.test(t) || U.test(t))) {
                        for ((c = nt.test(t) && mt(e.parentNode) || e) === e && p.scope || ((s = e.getAttribute("id")) ? s = s.replace(ot, rt) : e.setAttribute("id", s = T)), o = (l = d(t)).length; o--;) l[o] = (s ? "#" + s : ":scope") + " " + vt(l[o]);
                        u = l.join(",")
                    }
                    try {
                        return j.apply(n, c.querySelectorAll(u)), n
                    } catch (e) {
                        W(t, !0)
                    } finally {
                        s === T && e.removeAttribute("id")
                    }
                }
            }
            return m(t.replace(B, "$1"), e, n, i)
        }

        function lt() {
            var i = [];
            return function t(e, n) {
                return i.push(e + " ") > x.cacheLength && delete t[i.shift()], t[e + " "] = n
            }
        }

        function ut(t) {
            return t[T] = !0, t
        }

        function ct(t) {
            var e = C.createElement("fieldset");
            try {
                return !!t(e)
            } catch (t) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e), e = null
            }
        }

        function ht(t, e) {
            for (var n = t.split("|"), i = n.length; i--;) x.attrHandle[n[i]] = e
        }

        function pt(t, e) {
            var n = e && t, i = n && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
            if (i) return i;
            if (n) for (; n = n.nextSibling;) if (n === e) return -1;
            return t ? 1 : -1
        }

        function dt(e) {
            return function (t) {
                return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && st(t) === e : t.disabled === e : "label" in t && t.disabled === e
            }
        }

        function ft(s) {
            return ut(function (r) {
                return r = +r, ut(function (t, e) {
                    for (var n, i = s([], t.length, r), o = i.length; o--;) t[n = i[o]] && (t[n] = !(e[n] = t[n]))
                })
            })
        }

        function mt(t) {
            return t && void 0 !== t.getElementsByTagName && t
        }

        for (t in p = at.support = {}, o = at.isXML = function (t) {
            var e = t.namespaceURI, t = (t.ownerDocument || t).documentElement;
            return !Q.test(e || t && t.nodeName || "HTML")
        }, _ = at.setDocument = function (t) {
            var e, t = t ? t.ownerDocument || t : y;
            return t != C && 9 === t.nodeType && t.documentElement && (s = (C = t).documentElement, z = !o(C), y != C && (e = C.defaultView) && e.top !== e && (e.addEventListener ? e.addEventListener("unload", i, !1) : e.attachEvent && e.attachEvent("onunload", i)), p.scope = ct(function (t) {
                return s.appendChild(t).appendChild(C.createElement("div")), void 0 !== t.querySelectorAll && !t.querySelectorAll(":scope fieldset div").length
            }), p.attributes = ct(function (t) {
                return t.className = "i", !t.getAttribute("className")
            }), p.getElementsByTagName = ct(function (t) {
                return t.appendChild(C.createComment("")), !t.getElementsByTagName("*").length
            }), p.getElementsByClassName = tt.test(C.getElementsByClassName), p.getById = ct(function (t) {
                return s.appendChild(t).id = T, !C.getElementsByName || !C.getElementsByName(T).length
            }), p.getById ? (x.filter.ID = function (t) {
                var e = t.replace(it, h);
                return function (t) {
                    return t.getAttribute("id") === e
                }
            }, x.find.ID = function (t, e) {
                if (void 0 !== e.getElementById && z) {
                    t = e.getElementById(t);
                    return t ? [t] : []
                }
            }) : (x.filter.ID = function (t) {
                var e = t.replace(it, h);
                return function (t) {
                    t = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                    return t && t.value === e
                }
            }, x.find.ID = function (t, e) {
                if (void 0 !== e.getElementById && z) {
                    var n, i, o, r = e.getElementById(t);
                    if (r) {
                        if ((n = r.getAttributeNode("id")) && n.value === t) return [r];
                        for (o = e.getElementsByName(t), i = 0; r = o[i++];) if ((n = r.getAttributeNode("id")) && n.value === t) return [r]
                    }
                    return []
                }
            }), x.find.TAG = p.getElementsByTagName ? function (t, e) {
                return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : p.qsa ? e.querySelectorAll(t) : void 0
            } : function (t, e) {
                var n, i = [], o = 0, r = e.getElementsByTagName(t);
                if ("*" !== t) return r;
                for (; n = r[o++];) 1 === n.nodeType && i.push(n);
                return i
            }, x.find.CLASS = p.getElementsByClassName && function (t, e) {
                if (void 0 !== e.getElementsByClassName && z) return e.getElementsByClassName(t)
            }, a = [], g = [], (p.qsa = tt.test(C.querySelectorAll)) && (ct(function (t) {
                var e;
                s.appendChild(t).innerHTML = "<a id='" + T + "'></a><select id='" + T + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + M + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || g.push("\\[" + M + "*(?:value|" + P + ")"), t.querySelectorAll("[id~=" + T + "-]").length || g.push("~="), (e = C.createElement("input")).setAttribute("name", ""), t.appendChild(e), t.querySelectorAll("[name='']").length || g.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"), t.querySelectorAll(":checked").length || g.push(":checked"), t.querySelectorAll("a#" + T + "+*").length || g.push(".#.+[+~]"), t.querySelectorAll("\\\f"), g.push("[\\r\\n\\f]")
            }), ct(function (t) {
                t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var e = C.createElement("input");
                e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && g.push("name" + M + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), s.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), g.push(",.*:")
            })), (p.matchesSelector = tt.test(c = s.matches || s.webkitMatchesSelector || s.mozMatchesSelector || s.oMatchesSelector || s.msMatchesSelector)) && ct(function (t) {
                p.disconnectedMatch = c.call(t, "*"), c.call(t, "[s!='']:x"), a.push("!=", q)
            }), g = g.length && new RegExp(g.join("|")), a = a.length && new RegExp(a.join("|")), e = tt.test(s.compareDocumentPosition), v = e || tt.test(s.contains) ? function (t, e) {
                var n = 9 === t.nodeType ? t.documentElement : t, e = e && e.parentNode;
                return t === e || !(!e || 1 !== e.nodeType || !(n.contains ? n.contains(e) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(e)))
            } : function (t, e) {
                if (e) for (; e = e.parentNode;) if (e === t) return !0;
                return !1
            }, I = e ? function (t, e) {
                if (t === e) return u = !0, 0;
                var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                return n || (1 & (n = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !p.sortDetached && e.compareDocumentPosition(t) === n ? t == C || t.ownerDocument == y && v(y, t) ? -1 : e == C || e.ownerDocument == y && v(y, e) ? 1 : l ? N(l, t) - N(l, e) : 0 : 4 & n ? -1 : 1)
            } : function (t, e) {
                if (t === e) return u = !0, 0;
                var n, i = 0, o = t.parentNode, r = e.parentNode, s = [t], a = [e];
                if (!o || !r) return t == C ? -1 : e == C ? 1 : o ? -1 : r ? 1 : l ? N(l, t) - N(l, e) : 0;
                if (o === r) return pt(t, e);
                for (n = t; n = n.parentNode;) s.unshift(n);
                for (n = e; n = n.parentNode;) a.unshift(n);
                for (; s[i] === a[i];) i++;
                return i ? pt(s[i], a[i]) : s[i] == y ? -1 : a[i] == y ? 1 : 0
            }), C
        }, at.matches = function (t, e) {
            return at(t, null, null, e)
        }, at.matchesSelector = function (t, e) {
            if (_(t), p.matchesSelector && z && !W[e + " "] && (!a || !a.test(e)) && (!g || !g.test(e))) try {
                var n = c.call(t, e);
                if (n || p.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n
            } catch (t) {
                W(e, !0)
            }
            return 0 < at(e, C, null, [t]).length
        }, at.contains = function (t, e) {
            return (t.ownerDocument || t) != C && _(t), v(t, e)
        }, at.attr = function (t, e) {
            (t.ownerDocument || t) != C && _(t);
            var n = x.attrHandle[e.toLowerCase()],
                n = n && D.call(x.attrHandle, e.toLowerCase()) ? n(t, e, !z) : void 0;
            return void 0 !== n ? n : p.attributes || !z ? t.getAttribute(e) : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
        }, at.escape = function (t) {
            return (t + "").replace(ot, rt)
        }, at.error = function (t) {
            throw new Error("Syntax error, unrecognized expression: " + t)
        }, at.uniqueSort = function (t) {
            var e, n = [], i = 0, o = 0;
            if (u = !p.detectDuplicates, l = !p.sortStable && t.slice(0), t.sort(I), u) {
                for (; e = t[o++];) e === t[o] && (i = n.push(o));
                for (; i--;) t.splice(n[i], 1)
            }
            return l = null, t
        }, r = at.getText = function (t) {
            var e, n = "", i = 0, o = t.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof t.textContent) return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling) n += r(t)
                } else if (3 === o || 4 === o) return t.nodeValue
            } else for (; e = t[i++];) n += r(e);
            return n
        }, (x = at.selectors = {
            cacheLength: 50,
            createPseudo: ut,
            match: G,
            attrHandle: {},
            find: {},
            relative: {
                ">": {dir: "parentNode", first: !0},
                " ": {dir: "parentNode"},
                "+": {dir: "previousSibling", first: !0},
                "~": {dir: "previousSibling"}
            },
            preFilter: {
                ATTR: function (t) {
                    return t[1] = t[1].replace(it, h), t[3] = (t[3] || t[4] || t[5] || "").replace(it, h), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                }, CHILD: function (t) {
                    return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || at.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && at.error(t[0]), t
                }, PSEUDO: function (t) {
                    var e, n = !t[6] && t[2];
                    return G.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && X.test(n) && (e = d(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3))
                }
            },
            filter: {
                TAG: function (t) {
                    var e = t.replace(it, h).toLowerCase();
                    return "*" === t ? function () {
                        return !0
                    } : function (t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e
                    }
                }, CLASS: function (t) {
                    var e = E[t + " "];
                    return e || (e = new RegExp("(^|" + M + ")" + t + "(" + M + "|$)")) && E(t, function (t) {
                        return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                    })
                }, ATTR: function (e, n, i) {
                    return function (t) {
                        t = at.attr(t, e);
                        return null == t ? "!=" === n : !n || (t += "", "=" === n ? t === i : "!=" === n ? t !== i : "^=" === n ? i && 0 === t.indexOf(i) : "*=" === n ? i && -1 < t.indexOf(i) : "$=" === n ? i && t.slice(-i.length) === i : "~=" === n ? -1 < (" " + t.replace(F, " ") + " ").indexOf(i) : "|=" === n && (t === i || t.slice(0, i.length + 1) === i + "-"))
                    }
                }, CHILD: function (f, t, e, m, g) {
                    var v = "nth" !== f.slice(0, 3), y = "last" !== f.slice(-4), w = "of-type" === t;
                    return 1 === m && 0 === g ? function (t) {
                        return !!t.parentNode
                    } : function (t, e, n) {
                        var i, o, r, s, a, l, u = v != y ? "nextSibling" : "previousSibling", c = t.parentNode,
                            h = w && t.nodeName.toLowerCase(), p = !n && !w, d = !1;
                        if (c) {
                            if (v) {
                                for (; u;) {
                                    for (s = t; s = s[u];) if (w ? s.nodeName.toLowerCase() === h : 1 === s.nodeType) return !1;
                                    l = u = "only" === f && !l && "nextSibling"
                                }
                                return !0
                            }
                            if (l = [y ? c.firstChild : c.lastChild], y && p) {
                                for (d = (a = (i = (o = (r = (s = c)[T] || (s[T] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[f] || [])[0] === S && i[1]) && i[2], s = a && c.childNodes[a]; s = ++a && s && s[u] || (d = a = 0) || l.pop();) if (1 === s.nodeType && ++d && s === t) {
                                    o[f] = [S, a, d];
                                    break
                                }
                            } else if (!1 === (d = p ? a = (i = (o = (r = (s = t)[T] || (s[T] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[f] || [])[0] === S && i[1] : d)) for (; (s = ++a && s && s[u] || (d = a = 0) || l.pop()) && ((w ? s.nodeName.toLowerCase() !== h : 1 !== s.nodeType) || !++d || (p && ((o = (r = s[T] || (s[T] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[f] = [S, d]), s !== t));) ;
                            return (d -= g) === m || d % m == 0 && 0 <= d / m
                        }
                    }
                }, PSEUDO: function (t, r) {
                    var e, s = x.pseudos[t] || x.setFilters[t.toLowerCase()] || at.error("unsupported pseudo: " + t);
                    return s[T] ? s(r) : 1 < s.length ? (e = [t, t, "", r], x.setFilters.hasOwnProperty(t.toLowerCase()) ? ut(function (t, e) {
                        for (var n, i = s(t, r), o = i.length; o--;) t[n = N(t, i[o])] = !(e[n] = i[o])
                    }) : function (t) {
                        return s(t, 0, e)
                    }) : s
                }
            },
            pseudos: {
                not: ut(function (t) {
                    var i = [], o = [], a = f(t.replace(B, "$1"));
                    return a[T] ? ut(function (t, e, n, i) {
                        for (var o, r = a(t, null, i, []), s = t.length; s--;) (o = r[s]) && (t[s] = !(e[s] = o))
                    }) : function (t, e, n) {
                        return i[0] = t, a(i, null, n, o), i[0] = null, !o.pop()
                    }
                }), has: ut(function (e) {
                    return function (t) {
                        return 0 < at(e, t).length
                    }
                }), contains: ut(function (e) {
                    return e = e.replace(it, h), function (t) {
                        return -1 < (t.textContent || r(t)).indexOf(e)
                    }
                }), lang: ut(function (n) {
                    return V.test(n || "") || at.error("unsupported lang: " + n), n = n.replace(it, h).toLowerCase(), function (t) {
                        var e;
                        do {
                            if (e = z ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (e = e.toLowerCase()) === n || 0 === e.indexOf(n + "-")
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1
                    }
                }), target: function (t) {
                    var e = n.location && n.location.hash;
                    return e && e.slice(1) === t.id
                }, root: function (t) {
                    return t === s
                }, focus: function (t) {
                    return t === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                }, enabled: dt(!1), disabled: dt(!0), checked: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && !!t.checked || "option" === e && !!t.selected
                }, selected: function (t) {
                    return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                }, empty: function (t) {
                    for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
                    return !0
                }, parent: function (t) {
                    return !x.pseudos.empty(t)
                }, header: function (t) {
                    return K.test(t.nodeName)
                }, input: function (t) {
                    return J.test(t.nodeName)
                }, button: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && "button" === t.type || "button" === e
                }, text: function (t) {
                    return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (t = t.getAttribute("type")) || "text" === t.toLowerCase())
                }, first: ft(function () {
                    return [0]
                }), last: ft(function (t, e) {
                    return [e - 1]
                }), eq: ft(function (t, e, n) {
                    return [n < 0 ? n + e : n]
                }), even: ft(function (t, e) {
                    for (var n = 0; n < e; n += 2) t.push(n);
                    return t
                }), odd: ft(function (t, e) {
                    for (var n = 1; n < e; n += 2) t.push(n);
                    return t
                }), lt: ft(function (t, e, n) {
                    for (var i = n < 0 ? n + e : e < n ? e : n; 0 <= --i;) t.push(i);
                    return t
                }), gt: ft(function (t, e, n) {
                    for (var i = n < 0 ? n + e : n; ++i < e;) t.push(i);
                    return t
                })
            }
        }).pseudos.nth = x.pseudos.eq, {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        }) x.pseudos[t] = function (e) {
            return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }(t);
        for (t in {submit: !0, reset: !0}) x.pseudos[t] = function (n) {
            return function (t) {
                var e = t.nodeName.toLowerCase();
                return ("input" === e || "button" === e) && t.type === n
            }
        }(t);

        function gt() {
        }

        function vt(t) {
            for (var e = 0, n = t.length, i = ""; e < n; e++) i += t[e].value;
            return i
        }

        function yt(s, t, e) {
            var a = t.dir, l = t.next, u = l || a, c = e && "parentNode" === u, h = w++;
            return t.first ? function (t, e, n) {
                for (; t = t[a];) if (1 === t.nodeType || c) return s(t, e, n);
                return !1
            } : function (t, e, n) {
                var i, o, r = [S, h];
                if (n) {
                    for (; t = t[a];) if ((1 === t.nodeType || c) && s(t, e, n)) return !0
                } else for (; t = t[a];) if (1 === t.nodeType || c) if (i = (o = t[T] || (t[T] = {}))[t.uniqueID] || (o[t.uniqueID] = {}), l && l === t.nodeName.toLowerCase()) t = t[a] || t; else {
                    if ((o = i[u]) && o[0] === S && o[1] === h) return r[2] = o[2];
                    if ((i[u] = r)[2] = s(t, e, n)) return !0
                }
                return !1
            }
        }

        function wt(o) {
            return 1 < o.length ? function (t, e, n) {
                for (var i = o.length; i--;) if (!o[i](t, e, n)) return !1;
                return !0
            } : o[0]
        }

        function xt(t, e, n, i, o) {
            for (var r, s = [], a = 0, l = t.length, u = null != e; a < l; a++) (r = t[a]) && (n && !n(r, i, o) || (s.push(r), u && e.push(a)));
            return s
        }

        function bt(t) {
            for (var i, e, n, o = t.length, r = x.relative[t[0].type], s = r || x.relative[" "], a = r ? 1 : 0, l = yt(function (t) {
                return t === i
            }, s, !0), u = yt(function (t) {
                return -1 < N(i, t)
            }, s, !0), c = [function (t, e, n) {
                n = !r && (n || e !== b) || ((i = e).nodeType ? l : u)(t, e, n);
                return i = null, n
            }]; a < o; a++) if (e = x.relative[t[a].type]) c = [yt(wt(c), e)]; else {
                if ((e = x.filter[t[a].type].apply(null, t[a].matches))[T]) {
                    for (n = ++a; n < o && !x.relative[t[n].type]; n++) ;
                    return function t(d, f, m, g, v, e) {
                        return g && !g[T] && (g = t(g)), v && !v[T] && (v = t(v, e)), ut(function (t, e, n, i) {
                            var o, r, s, a = [], l = [], u = e.length, c = t || function (t, e, n) {
                                    for (var i = 0, o = e.length; i < o; i++) at(t, e[i], n);
                                    return n
                                }(f || "*", n.nodeType ? [n] : n, []), h = !d || !t && f ? c : xt(c, a, d, n, i),
                                p = m ? v || (t ? d : u || g) ? [] : e : h;
                            if (m && m(h, p, n, i), g) for (o = xt(p, l), g(o, [], n, i), r = o.length; r--;) (s = o[r]) && (p[l[r]] = !(h[l[r]] = s));
                            if (t) {
                                if (v || d) {
                                    if (v) {
                                        for (o = [], r = p.length; r--;) (s = p[r]) && o.push(h[r] = s);
                                        v(null, p = [], o, i)
                                    }
                                    for (r = p.length; r--;) (s = p[r]) && -1 < (o = v ? N(t, s) : a[r]) && (t[o] = !(e[o] = s))
                                }
                            } else p = xt(p === e ? p.splice(u, p.length) : p), v ? v(null, e, p, i) : j.apply(e, p)
                        })
                    }(1 < a && wt(c), 1 < a && vt(t.slice(0, a - 1).concat({value: " " === t[a - 2].type ? "*" : ""})).replace(B, "$1"), e, a < n && bt(t.slice(a, n)), n < o && bt(t = t.slice(n)), n < o && vt(t))
                }
                c.push(e)
            }
            return wt(c)
        }

        return gt.prototype = x.filters = x.pseudos, x.setFilters = new gt, d = at.tokenize = function (t, e) {
            var n, i, o, r, s, a, l, u = k[t + " "];
            if (u) return e ? 0 : u.slice(0);
            for (s = t, a = [], l = x.preFilter; s;) {
                for (r in n && !(i = Z.exec(s)) || (i && (s = s.slice(i[0].length) || s), a.push(o = [])), n = !1, (i = U.exec(s)) && (n = i.shift(), o.push({
                    value: n,
                    type: i[0].replace(B, " ")
                }), s = s.slice(n.length)), x.filter) !(i = G[r].exec(s)) || l[r] && !(i = l[r](i)) || (n = i.shift(), o.push({
                    value: n,
                    type: r,
                    matches: i
                }), s = s.slice(n.length));
                if (!n) break
            }
            return e ? s.length : s ? at.error(t) : k(t, a).slice(0)
        }, f = at.compile = function (t, e) {
            var n, g, v, y, w, i, o = [], r = [], s = L[t + " "];
            if (!s) {
                for (n = (e = e || d(t)).length; n--;) ((s = bt(e[n]))[T] ? o : r).push(s);
                (s = L(t, (y = 0 < (v = o).length, w = 0 < (g = r).length, i = function (t, e, n, i, o) {
                    var r, s, a, l = 0, u = "0", c = t && [], h = [], p = b, d = t || w && x.find.TAG("*", o),
                        f = S += null == p ? 1 : Math.random() || .1, m = d.length;
                    for (o && (b = e == C || e || o); u !== m && null != (r = d[u]); u++) {
                        if (w && r) {
                            for (s = 0, e || r.ownerDocument == C || (_(r), n = !z); a = g[s++];) if (a(r, e || C, n)) {
                                i.push(r);
                                break
                            }
                            o && (S = f)
                        }
                        y && ((r = !a && r) && l--, t && c.push(r))
                    }
                    if (l += u, y && u !== l) {
                        for (s = 0; a = v[s++];) a(c, h, e, n);
                        if (t) {
                            if (0 < l) for (; u--;) c[u] || h[u] || (h[u] = O.call(i));
                            h = xt(h)
                        }
                        j.apply(i, h), o && !t && 0 < h.length && 1 < l + v.length && at.uniqueSort(i)
                    }
                    return o && (S = f, b = p), c
                }, y ? ut(i) : i))).selector = t
            }
            return s
        }, m = at.select = function (t, e, n, i) {
            var o, r, s, a, l, u = "function" == typeof t && t, c = !i && d(t = u.selector || t);
            if (n = n || [], 1 === c.length) {
                if (2 < (r = c[0] = c[0].slice(0)).length && "ID" === (s = r[0]).type && 9 === e.nodeType && z && x.relative[r[1].type]) {
                    if (!(e = (x.find.ID(s.matches[0].replace(it, h), e) || [])[0])) return n;
                    u && (e = e.parentNode), t = t.slice(r.shift().value.length)
                }
                for (o = G.needsContext.test(t) ? 0 : r.length; o-- && (s = r[o], !x.relative[a = s.type]);) if ((l = x.find[a]) && (i = l(s.matches[0].replace(it, h), nt.test(r[0].type) && mt(e.parentNode) || e))) {
                    if (r.splice(o, 1), !(t = i.length && vt(r))) return j.apply(n, i), n;
                    break
                }
            }
            return (u || f(t, c))(i, e, !z, n, !e || nt.test(t) && mt(e.parentNode) || e), n
        }, p.sortStable = T.split("").sort(I).join("") === T, p.detectDuplicates = !!u, _(), p.sortDetached = ct(function (t) {
            return 1 & t.compareDocumentPosition(C.createElement("fieldset"))
        }), ct(function (t) {
            return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
        }) || ht("type|href|height|width", function (t, e, n) {
            if (!n) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }), p.attributes && ct(function (t) {
            return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
        }) || ht("value", function (t, e, n) {
            if (!n && "input" === t.nodeName.toLowerCase()) return t.defaultValue
        }), ct(function (t) {
            return null == t.getAttribute("disabled")
        }) || ht(P, function (t, e, n) {
            if (!n) return !0 === t[e] ? e.toLowerCase() : (e = t.getAttributeNode(e)) && e.specified ? e.value : null
        }), at
    }(_);
    z.find = d, z.expr = d.selectors, z.expr[":"] = z.expr.pseudos, z.uniqueSort = z.unique = d.uniqueSort, z.text = d.getText, z.isXMLDoc = d.isXML, z.contains = d.contains, z.escapeSelector = d.escape;

    function b(t, e, n) {
        for (var i = [], o = void 0 !== n; (t = t[e]) && 9 !== t.nodeType;) if (1 === t.nodeType) {
            if (o && z(t).is(n)) break;
            i.push(t)
        }
        return i
    }

    function T(t, e) {
        for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
        return n
    }

    var S = z.expr.match.needsContext;

    function E(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
    }

    var k = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function L(t, n, i) {
        return w(n) ? z.grep(t, function (t, e) {
            return !!n.call(t, e, t) !== i
        }) : n.nodeType ? z.grep(t, function (t) {
            return t === n !== i
        }) : "string" != typeof n ? z.grep(t, function (t) {
            return -1 < o.call(n, t) !== i
        }) : z.filter(n, t, i)
    }

    z.filter = function (t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === i.nodeType ? z.find.matchesSelector(i, t) ? [i] : [] : z.find.matches(t, z.grep(e, function (t) {
            return 1 === t.nodeType
        }))
    }, z.fn.extend({
        find: function (t) {
            var e, n, i = this.length, o = this;
            if ("string" != typeof t) return this.pushStack(z(t).filter(function () {
                for (e = 0; e < i; e++) if (z.contains(o[e], this)) return !0
            }));
            for (n = this.pushStack([]), e = 0; e < i; e++) z.find(t, o[e], n);
            return 1 < i ? z.uniqueSort(n) : n
        }, filter: function (t) {
            return this.pushStack(L(this, t || [], !1))
        }, not: function (t) {
            return this.pushStack(L(this, t || [], !0))
        }, is: function (t) {
            return !!L(this, "string" == typeof t && S.test(t) ? z(t) : t || [], !1).length
        }
    });
    var W = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (z.fn.init = function (t, e, n) {
        if (!t) return this;
        if (n = n || I, "string" != typeof t) return t.nodeType ? (this[0] = t, this.length = 1, this) : w(t) ? void 0 !== n.ready ? n.ready(t) : t(z) : z.makeArray(t, this);
        if (!(i = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : W.exec(t)) || !i[1] && e) return (!e || e.jquery ? e || n : this.constructor(e)).find(t);
        if (i[1]) {
            if (e = e instanceof z ? e[0] : e, z.merge(this, z.parseHTML(i[1], e && e.nodeType ? e.ownerDocument || e : C, !0)), k.test(i[1]) && z.isPlainObject(e)) for (var i in e) w(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
            return this
        }
        return (t = C.getElementById(i[2])) && (this[0] = t, this.length = 1), this
    }).prototype = z.fn;
    var I = z(C), D = /^(?:parents|prev(?:Until|All))/, O = {children: !0, contents: !0, next: !0, prev: !0};

    function A(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType;) ;
        return t
    }

    z.fn.extend({
        has: function (t) {
            var e = z(t, this), n = e.length;
            return this.filter(function () {
                for (var t = 0; t < n; t++) if (z.contains(this, e[t])) return !0
            })
        }, closest: function (t, e) {
            var n, i = 0, o = this.length, r = [], s = "string" != typeof t && z(t);
            if (!S.test(t)) for (; i < o; i++) for (n = this[i]; n && n !== e; n = n.parentNode) if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && z.find.matchesSelector(n, t))) {
                r.push(n);
                break
            }
            return this.pushStack(1 < r.length ? z.uniqueSort(r) : r)
        }, index: function (t) {
            return t ? "string" == typeof t ? o.call(z(t), this[0]) : o.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        }, add: function (t, e) {
            return this.pushStack(z.uniqueSort(z.merge(this.get(), z(t, e))))
        }, addBack: function (t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }), z.each({
        parent: function (t) {
            t = t.parentNode;
            return t && 11 !== t.nodeType ? t : null
        }, parents: function (t) {
            return b(t, "parentNode")
        }, parentsUntil: function (t, e, n) {
            return b(t, "parentNode", n)
        }, next: function (t) {
            return A(t, "nextSibling")
        }, prev: function (t) {
            return A(t, "previousSibling")
        }, nextAll: function (t) {
            return b(t, "nextSibling")
        }, prevAll: function (t) {
            return b(t, "previousSibling")
        }, nextUntil: function (t, e, n) {
            return b(t, "nextSibling", n)
        }, prevUntil: function (t, e, n) {
            return b(t, "previousSibling", n)
        }, siblings: function (t) {
            return T((t.parentNode || {}).firstChild, t)
        }, children: function (t) {
            return T(t.firstChild)
        }, contents: function (t) {
            return null != t.contentDocument && n(t.contentDocument) ? t.contentDocument : (E(t, "template") && (t = t.content || t), z.merge([], t.childNodes))
        }
    }, function (i, o) {
        z.fn[i] = function (t, e) {
            var n = z.map(this, o, t);
            return (e = "Until" !== i.slice(-5) ? t : e) && "string" == typeof e && (n = z.filter(e, n)), 1 < this.length && (O[i] || z.uniqueSort(n), D.test(i) && n.reverse()), this.pushStack(n)
        }
    });
    var j = /[^\x20\t\r\n\f]+/g;

    function H(t) {
        return t
    }

    function N(t) {
        throw t
    }

    function P(t, e, n, i) {
        var o;
        try {
            t && w(o = t.promise) ? o.call(t).done(e).fail(n) : t && w(o = t.then) ? o.call(t, e, n) : e.apply(void 0, [t].slice(i))
        } catch (t) {
            n.apply(void 0, [t])
        }
    }

    z.Callbacks = function (i) {
        var n;
        i = "string" == typeof i ? (n = {}, z.each(i.match(j) || [], function (t, e) {
            n[e] = !0
        }), n) : z.extend({}, i);

        function o() {
            for (s = s || i.once, e = r = !0; l.length; u = -1) for (t = l.shift(); ++u < a.length;) !1 === a[u].apply(t[0], t[1]) && i.stopOnFalse && (u = a.length, t = !1);
            i.memory || (t = !1), r = !1, s && (a = t ? [] : "")
        }

        var r, t, e, s, a = [], l = [], u = -1, c = {
            add: function () {
                return a && (t && !r && (u = a.length - 1, l.push(t)), function n(t) {
                    z.each(t, function (t, e) {
                        w(e) ? i.unique && c.has(e) || a.push(e) : e && e.length && "string" !== f(e) && n(e)
                    })
                }(arguments), t && !r && o()), this
            }, remove: function () {
                return z.each(arguments, function (t, e) {
                    for (var n; -1 < (n = z.inArray(e, a, n));) a.splice(n, 1), n <= u && u--
                }), this
            }, has: function (t) {
                return t ? -1 < z.inArray(t, a) : 0 < a.length
            }, empty: function () {
                return a = a && [], this
            }, disable: function () {
                return s = l = [], a = t = "", this
            }, disabled: function () {
                return !a
            }, lock: function () {
                return s = l = [], t || r || (a = t = ""), this
            }, locked: function () {
                return !!s
            }, fireWith: function (t, e) {
                return s || (e = [t, (e = e || []).slice ? e.slice() : e], l.push(e), r || o()), this
            }, fire: function () {
                return c.fireWith(this, arguments), this
            }, fired: function () {
                return !!e
            }
        };
        return c
    }, z.extend({
        Deferred: function (t) {
            var r = [["notify", "progress", z.Callbacks("memory"), z.Callbacks("memory"), 2], ["resolve", "done", z.Callbacks("once memory"), z.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", z.Callbacks("once memory"), z.Callbacks("once memory"), 1, "rejected"]],
                o = "pending", s = {
                    state: function () {
                        return o
                    }, always: function () {
                        return a.done(arguments).fail(arguments), this
                    }, catch: function (t) {
                        return s.then(null, t)
                    }, pipe: function () {
                        var o = arguments;
                        return z.Deferred(function (i) {
                            z.each(r, function (t, e) {
                                var n = w(o[e[4]]) && o[e[4]];
                                a[e[1]](function () {
                                    var t = n && n.apply(this, arguments);
                                    t && w(t.promise) ? t.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[e[0] + "With"](this, n ? [t] : arguments)
                                })
                            }), o = null
                        }).promise()
                    }, then: function (e, n, i) {
                        var l = 0;

                        function u(o, r, s, a) {
                            return function () {
                                function t() {
                                    var t, e;
                                    if (!(o < l)) {
                                        if ((t = s.apply(n, i)) === r.promise()) throw new TypeError("Thenable self-resolution");
                                        e = t && ("object" == typeof t || "function" == typeof t) && t.then, w(e) ? a ? e.call(t, u(l, r, H, a), u(l, r, N, a)) : (l++, e.call(t, u(l, r, H, a), u(l, r, N, a), u(l, r, H, r.notifyWith))) : (s !== H && (n = void 0, i = [t]), (a || r.resolveWith)(n, i))
                                    }
                                }

                                var n = this, i = arguments, e = a ? t : function () {
                                    try {
                                        t()
                                    } catch (t) {
                                        z.Deferred.exceptionHook && z.Deferred.exceptionHook(t, e.stackTrace), l <= o + 1 && (s !== N && (n = void 0, i = [t]), r.rejectWith(n, i))
                                    }
                                };
                                o ? e() : (z.Deferred.getStackHook && (e.stackTrace = z.Deferred.getStackHook()), _.setTimeout(e))
                            }
                        }

                        return z.Deferred(function (t) {
                            r[0][3].add(u(0, t, w(i) ? i : H, t.notifyWith)), r[1][3].add(u(0, t, w(e) ? e : H)), r[2][3].add(u(0, t, w(n) ? n : N))
                        }).promise()
                    }, promise: function (t) {
                        return null != t ? z.extend(t, s) : s
                    }
                }, a = {};
            return z.each(r, function (t, e) {
                var n = e[2], i = e[5];
                s[e[1]] = n.add, i && n.add(function () {
                    o = i
                }, r[3 - t][2].disable, r[3 - t][3].disable, r[0][2].lock, r[0][3].lock), n.add(e[3].fire), a[e[0]] = function () {
                    return a[e[0] + "With"](this === a ? void 0 : this, arguments), this
                }, a[e[0] + "With"] = n.fireWith
            }), s.promise(a), t && t.call(a, a), a
        }, when: function (t) {
            function e(e) {
                return function (t) {
                    o[e] = this, r[e] = 1 < arguments.length ? a.call(arguments) : t, --n || s.resolveWith(o, r)
                }
            }

            var n = arguments.length, i = n, o = Array(i), r = a.call(arguments), s = z.Deferred();
            if (n <= 1 && (P(t, s.done(e(i)).resolve, s.reject, !n), "pending" === s.state() || w(r[i] && r[i].then))) return s.then();
            for (; i--;) P(r[i], e(i), s.reject);
            return s.promise()
        }
    });
    var M = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    z.Deferred.exceptionHook = function (t, e) {
        _.console && _.console.warn && t && M.test(t.name) && _.console.warn("jQuery.Deferred exception: " + t.message, t.stack, e)
    }, z.readyException = function (t) {
        _.setTimeout(function () {
            throw t
        })
    };
    var R = z.Deferred();

    function $() {
        C.removeEventListener("DOMContentLoaded", $), _.removeEventListener("load", $), z.ready()
    }

    z.fn.ready = function (t) {
        return R.then(t).catch(function (t) {
            z.readyException(t)
        }), this
    }, z.extend({
        isReady: !1, readyWait: 1, ready: function (t) {
            (!0 === t ? --z.readyWait : z.isReady) || (z.isReady = !0) !== t && 0 < --z.readyWait || R.resolveWith(C, [z])
        }
    }), z.ready.then = R.then, "complete" === C.readyState || "loading" !== C.readyState && !C.documentElement.doScroll ? _.setTimeout(z.ready) : (C.addEventListener("DOMContentLoaded", $), _.addEventListener("load", $));
    var q = function (t, e, n, i, o, r, s) {
        var a = 0, l = t.length, u = null == n;
        if ("object" === f(n)) for (a in o = !0, n) q(t, e, a, n[a], !0, r, s); else if (void 0 !== i && (o = !0, w(i) || (s = !0), e = u ? s ? (e.call(t, i), null) : (u = e, function (t, e, n) {
            return u.call(z(t), n)
        }) : e)) for (; a < l; a++) e(t[a], n, s ? i : i.call(t[a], a, e(t[a], n)));
        return o ? t : u ? e.call(t) : l ? e(t[0], n) : r
    }, F = /^-ms-/, B = /-([a-z])/g;

    function Z(t, e) {
        return e.toUpperCase()
    }

    function U(t) {
        return t.replace(F, "ms-").replace(B, Z)
    }

    function Y(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    }

    function X() {
        this.expando = z.expando + X.uid++
    }

    X.uid = 1, X.prototype = {
        cache: function (t) {
            var e = t[this.expando];
            return e || (e = {}, Y(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))), e
        }, set: function (t, e, n) {
            var i, o = this.cache(t);
            if ("string" == typeof e) o[U(e)] = n; else for (i in e) o[U(i)] = e[i];
            return o
        }, get: function (t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][U(e)]
        }, access: function (t, e, n) {
            return void 0 === e || e && "string" == typeof e && void 0 === n ? this.get(t, e) : (this.set(t, e, n), void 0 !== n ? n : e)
        }, remove: function (t, e) {
            var n, i = t[this.expando];
            if (void 0 !== i) {
                if (void 0 !== e) {
                    n = (e = Array.isArray(e) ? e.map(U) : (e = U(e)) in i ? [e] : e.match(j) || []).length;
                    for (; n--;) delete i[e[n]]
                }
                void 0 !== e && !z.isEmptyObject(i) || (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        }, hasData: function (t) {
            t = t[this.expando];
            return void 0 !== t && !z.isEmptyObject(t)
        }
    };
    var V = new X, G = new X, Q = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, J = /[A-Z]/g;

    function K(t, e, n) {
        var i, o;
        if (void 0 === n && 1 === t.nodeType) if (i = "data-" + e.replace(J, "-$&").toLowerCase(), "string" == typeof (n = t.getAttribute(i))) {
            try {
                n = "true" === (o = n) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : Q.test(o) ? JSON.parse(o) : o)
            } catch (t) {
            }
            G.set(t, e, n)
        } else n = void 0;
        return n
    }

    z.extend({
        hasData: function (t) {
            return G.hasData(t) || V.hasData(t)
        }, data: function (t, e, n) {
            return G.access(t, e, n)
        }, removeData: function (t, e) {
            G.remove(t, e)
        }, _data: function (t, e, n) {
            return V.access(t, e, n)
        }, _removeData: function (t, e) {
            V.remove(t, e)
        }
    }), z.fn.extend({
        data: function (n, t) {
            var e, i, o, r = this[0], s = r && r.attributes;
            if (void 0 !== n) return "object" == typeof n ? this.each(function () {
                G.set(this, n)
            }) : q(this, function (t) {
                var e;
                return r && void 0 === t ? void 0 !== (e = G.get(r, n)) || void 0 !== (e = K(r, n)) ? e : void 0 : void this.each(function () {
                    G.set(this, n, t)
                })
            }, null, t, 1 < arguments.length, null, !0);
            if (this.length && (o = G.get(r), 1 === r.nodeType && !V.get(r, "hasDataAttrs"))) {
                for (e = s.length; e--;) s[e] && 0 === (i = s[e].name).indexOf("data-") && (i = U(i.slice(5)), K(r, i, o[i]));
                V.set(r, "hasDataAttrs", !0)
            }
            return o
        }, removeData: function (t) {
            return this.each(function () {
                G.remove(this, t)
            })
        }
    }), z.extend({
        queue: function (t, e, n) {
            var i;
            if (t) return i = V.get(t, e = (e || "fx") + "queue"), n && (!i || Array.isArray(n) ? i = V.access(t, e, z.makeArray(n)) : i.push(n)), i || []
        }, dequeue: function (t, e) {
            var n = z.queue(t, e = e || "fx"), i = n.length, o = n.shift(), r = z._queueHooks(t, e);
            "inprogress" === o && (o = n.shift(), i--), o && ("fx" === e && n.unshift("inprogress"), delete r.stop, o.call(t, function () {
                z.dequeue(t, e)
            }, r)), !i && r && r.empty.fire()
        }, _queueHooks: function (t, e) {
            var n = e + "queueHooks";
            return V.get(t, n) || V.access(t, n, {
                empty: z.Callbacks("once memory").add(function () {
                    V.remove(t, [e + "queue", n])
                })
            })
        }
    }), z.fn.extend({
        queue: function (e, n) {
            var t = 2;
            return "string" != typeof e && (n = e, e = "fx", t--), arguments.length < t ? z.queue(this[0], e) : void 0 === n ? this : this.each(function () {
                var t = z.queue(this, e, n);
                z._queueHooks(this, e), "fx" === e && "inprogress" !== t[0] && z.dequeue(this, e)
            })
        }, dequeue: function (t) {
            return this.each(function () {
                z.dequeue(this, t)
            })
        }, clearQueue: function (t) {
            return this.queue(t || "fx", [])
        }, promise: function (t, e) {
            function n() {
                --o || r.resolveWith(s, [s])
            }

            var i, o = 1, r = z.Deferred(), s = this, a = this.length;
            for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; a--;) (i = V.get(s[a], t + "queueHooks")) && i.empty && (o++, i.empty.add(n));
            return n(), r.promise(e)
        }
    });
    var tt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, et = new RegExp("^(?:([+-])=|)(" + tt + ")([a-z%]*)$", "i"),
        nt = ["Top", "Right", "Bottom", "Left"], it = C.documentElement, ot = function (t) {
            return z.contains(t.ownerDocument, t)
        }, rt = {composed: !0};
    it.getRootNode && (ot = function (t) {
        return z.contains(t.ownerDocument, t) || t.getRootNode(rt) === t.ownerDocument
    });

    function st(t, e) {
        return "none" === (t = e || t).style.display || "" === t.style.display && ot(t) && "none" === z.css(t, "display")
    }

    function at(t, e, n, i) {
        var o, r, s = 20, a = i ? function () {
                return i.cur()
            } : function () {
                return z.css(t, e, "")
            }, l = a(), u = n && n[3] || (z.cssNumber[e] ? "" : "px"),
            c = t.nodeType && (z.cssNumber[e] || "px" !== u && +l) && et.exec(z.css(t, e));
        if (c && c[3] !== u) {
            for (u = u || c[3], c = +(l /= 2) || 1; s--;) z.style(t, e, c + u), (1 - r) * (1 - (r = a() / l || .5)) <= 0 && (s = 0), c /= r;
            z.style(t, e, (c *= 2) + u), n = n || []
        }
        return n && (c = +c || +l || 0, o = n[1] ? c + (n[1] + 1) * n[2] : +n[2], i && (i.unit = u, i.start = c, i.end = o)), o
    }

    var lt = {};

    function ut(t, e) {
        for (var n, i, o, r, s, a, l = [], u = 0, c = t.length; u < c; u++) (i = t[u]).style && (n = i.style.display, e ? ("none" === n && (l[u] = V.get(i, "display") || null, l[u] || (i.style.display = "")), "" === i.style.display && st(i) && (l[u] = (a = r = o = void 0, r = i.ownerDocument, s = i.nodeName, (a = lt[s]) || (o = r.body.appendChild(r.createElement(s)), a = z.css(o, "display"), o.parentNode.removeChild(o), lt[s] = a = "none" === a ? "block" : a)))) : "none" !== n && (l[u] = "none", V.set(i, "display", n)));
        for (u = 0; u < c; u++) null != l[u] && (t[u].style.display = l[u]);
        return t
    }

    z.fn.extend({
        show: function () {
            return ut(this, !0)
        }, hide: function () {
            return ut(this)
        }, toggle: function (t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function () {
                st(this) ? z(this).show() : z(this).hide()
            })
        }
    });
    var ct = /^(?:checkbox|radio)$/i, ht = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, pt = /^$|^module$|\/(?:java|ecma)script/i,
        h = C.createDocumentFragment().appendChild(C.createElement("div"));
    (d = C.createElement("input")).setAttribute("type", "radio"), d.setAttribute("checked", "checked"), d.setAttribute("name", "t"), h.appendChild(d), y.checkClone = h.cloneNode(!0).cloneNode(!0).lastChild.checked, h.innerHTML = "<textarea>x</textarea>", y.noCloneChecked = !!h.cloneNode(!0).lastChild.defaultValue, h.innerHTML = "<option></option>", y.option = !!h.lastChild;
    var dt = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };

    function ft(t, e) {
        var n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
        return void 0 === e || e && E(t, e) ? z.merge([t], n) : n
    }

    function mt(t, e) {
        for (var n = 0, i = t.length; n < i; n++) V.set(t[n], "globalEval", !e || V.get(e[n], "globalEval"))
    }

    dt.tbody = dt.tfoot = dt.colgroup = dt.caption = dt.thead, dt.th = dt.td, y.option || (dt.optgroup = dt.option = [1, "<select multiple='multiple'>", "</select>"]);
    var gt = /<|&#?\w+;/;

    function vt(t, e, n, i, o) {
        for (var r, s, a, l, u, c = e.createDocumentFragment(), h = [], p = 0, d = t.length; p < d; p++) if ((r = t[p]) || 0 === r) if ("object" === f(r)) z.merge(h, r.nodeType ? [r] : r); else if (gt.test(r)) {
            for (s = s || c.appendChild(e.createElement("div")), a = (ht.exec(r) || ["", ""])[1].toLowerCase(), a = dt[a] || dt._default, s.innerHTML = a[1] + z.htmlPrefilter(r) + a[2], u = a[0]; u--;) s = s.lastChild;
            z.merge(h, s.childNodes), (s = c.firstChild).textContent = ""
        } else h.push(e.createTextNode(r));
        for (c.textContent = "", p = 0; r = h[p++];) if (i && -1 < z.inArray(r, i)) o && o.push(r); else if (l = ot(r), s = ft(c.appendChild(r), "script"), l && mt(s), n) for (u = 0; r = s[u++];) pt.test(r.type || "") && n.push(r);
        return c
    }

    var yt = /^key/, wt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, xt = /^([^.]*)(?:\.(.+)|)/;

    function bt() {
        return !0
    }

    function _t() {
        return !1
    }

    function Ct(t, e) {
        return t === function () {
            try {
                return C.activeElement
            } catch (t) {
            }
        }() == ("focus" === e)
    }

    function zt(t, e, n, i, o, r) {
        var s, a;
        if ("object" == typeof e) {
            for (a in "string" != typeof n && (i = i || n, n = void 0), e) zt(t, a, n, i, e[a], r);
            return t
        }
        if (null == i && null == o ? (o = n, i = n = void 0) : null == o && ("string" == typeof n ? (o = i, i = void 0) : (o = i, i = n, n = void 0)), !1 === o) o = _t; else if (!o) return t;
        return 1 === r && (s = o, (o = function (t) {
            return z().off(t), s.apply(this, arguments)
        }).guid = s.guid || (s.guid = z.guid++)), t.each(function () {
            z.event.add(this, e, o, i, n)
        })
    }

    function Tt(t, o, r) {
        r ? (V.set(t, o, !1), z.event.add(t, o, {
            namespace: !1, handler: function (t) {
                var e, n, i = V.get(this, o);
                if (1 & t.isTrigger && this[o]) {
                    if (i.length) (z.event.special[o] || {}).delegateType && t.stopPropagation(); else if (i = a.call(arguments), V.set(this, o, i), e = r(this, o), this[o](), i !== (n = V.get(this, o)) || e ? V.set(this, o, !1) : n = {}, i !== n) return t.stopImmediatePropagation(), t.preventDefault(), n.value
                } else i.length && (V.set(this, o, {value: z.event.trigger(z.extend(i[0], z.Event.prototype), i.slice(1), this)}), t.stopImmediatePropagation())
            }
        })) : void 0 === V.get(t, o) && z.event.add(t, o, bt)
    }

    z.event = {
        global: {}, add: function (e, t, n, i, o) {
            var r, s, a, l, u, c, h, p, d, f = V.get(e);
            if (Y(e)) for (n.handler && (n = (r = n).handler, o = r.selector), o && z.find.matchesSelector(it, o), n.guid || (n.guid = z.guid++), (a = f.events) || (a = f.events = Object.create(null)), (s = f.handle) || (s = f.handle = function (t) {
                return void 0 !== z && z.event.triggered !== t.type ? z.event.dispatch.apply(e, arguments) : void 0
            }), l = (t = (t || "").match(j) || [""]).length; l--;) h = d = (u = xt.exec(t[l]) || [])[1], p = (u[2] || "").split(".").sort(), h && (c = z.event.special[h] || {}, h = (o ? c.delegateType : c.bindType) || h, c = z.event.special[h] || {}, u = z.extend({
                type: h,
                origType: d,
                data: i,
                handler: n,
                guid: n.guid,
                selector: o,
                needsContext: o && z.expr.match.needsContext.test(o),
                namespace: p.join(".")
            }, r), (d = a[h]) || ((d = a[h] = []).delegateCount = 0, c.setup && !1 !== c.setup.call(e, i, p, s) || e.addEventListener && e.addEventListener(h, s)), c.add && (c.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)), o ? d.splice(d.delegateCount++, 0, u) : d.push(u), z.event.global[h] = !0)
        }, remove: function (t, e, n, i, o) {
            var r, s, a, l, u, c, h, p, d, f, m, g = V.hasData(t) && V.get(t);
            if (g && (l = g.events)) {
                for (u = (e = (e || "").match(j) || [""]).length; u--;) if (d = m = (a = xt.exec(e[u]) || [])[1], f = (a[2] || "").split(".").sort(), d) {
                    for (h = z.event.special[d] || {}, p = l[d = (i ? h.delegateType : h.bindType) || d] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--;) c = p[r], !o && m !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (p.splice(r, 1), c.selector && p.delegateCount--, h.remove && h.remove.call(t, c));
                    s && !p.length && (h.teardown && !1 !== h.teardown.call(t, f, g.handle) || z.removeEvent(t, d, g.handle), delete l[d])
                } else for (d in l) z.event.remove(t, d + e[u], n, i, !0);
                z.isEmptyObject(l) && V.remove(t, "handle events")
            }
        }, dispatch: function (t) {
            var e, n, i, o, r, s = new Array(arguments.length), a = z.event.fix(t),
                l = (V.get(this, "events") || Object.create(null))[a.type] || [], t = z.event.special[a.type] || {};
            for (s[0] = a, e = 1; e < arguments.length; e++) s[e] = arguments[e];
            if (a.delegateTarget = this, !t.preDispatch || !1 !== t.preDispatch.call(this, a)) {
                for (r = z.event.handlers.call(this, a, l), e = 0; (i = r[e++]) && !a.isPropagationStopped();) for (a.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !a.isImmediatePropagationStopped();) a.rnamespace && !1 !== o.namespace && !a.rnamespace.test(o.namespace) || (a.handleObj = o, a.data = o.data, void 0 !== (o = ((z.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (a.result = o) && (a.preventDefault(), a.stopPropagation()));
                return t.postDispatch && t.postDispatch.call(this, a), a.result
            }
        }, handlers: function (t, e) {
            var n, i, o, r, s, a = [], l = e.delegateCount, u = t.target;
            if (l && u.nodeType && !("click" === t.type && 1 <= t.button)) for (; u !== this; u = u.parentNode || this) if (1 === u.nodeType && ("click" !== t.type || !0 !== u.disabled)) {
                for (r = [], s = {}, n = 0; n < l; n++) void 0 === s[o = (i = e[n]).selector + " "] && (s[o] = i.needsContext ? -1 < z(o, this).index(u) : z.find(o, this, null, [u]).length), s[o] && r.push(i);
                r.length && a.push({elem: u, handlers: r})
            }
            return u = this, l < e.length && a.push({elem: u, handlers: e.slice(l)}), a
        }, addProp: function (e, t) {
            Object.defineProperty(z.Event.prototype, e, {
                enumerable: !0, configurable: !0, get: w(t) ? function () {
                    if (this.originalEvent) return t(this.originalEvent)
                } : function () {
                    if (this.originalEvent) return this.originalEvent[e]
                }, set: function (t) {
                    Object.defineProperty(this, e, {enumerable: !0, configurable: !0, writable: !0, value: t})
                }
            })
        }, fix: function (t) {
            return t[z.expando] ? t : new z.Event(t)
        }, special: {
            load: {noBubble: !0}, click: {
                setup: function (t) {
                    t = this || t;
                    return ct.test(t.type) && t.click && E(t, "input") && Tt(t, "click", bt), !1
                }, trigger: function (t) {
                    t = this || t;
                    return ct.test(t.type) && t.click && E(t, "input") && Tt(t, "click"), !0
                }, _default: function (t) {
                    t = t.target;
                    return ct.test(t.type) && t.click && E(t, "input") && V.get(t, "click") || E(t, "a")
                }
            }, beforeunload: {
                postDispatch: function (t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    }, z.removeEvent = function (t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n)
    }, z.Event = function (t, e) {
        if (!(this instanceof z.Event)) return new z.Event(t, e);
        t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? bt : _t, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && z.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[z.expando] = !0
    }, z.Event.prototype = {
        constructor: z.Event,
        isDefaultPrevented: _t,
        isPropagationStopped: _t,
        isImmediatePropagationStopped: _t,
        isSimulated: !1,
        preventDefault: function () {
            var t = this.originalEvent;
            this.isDefaultPrevented = bt, t && !this.isSimulated && t.preventDefault()
        },
        stopPropagation: function () {
            var t = this.originalEvent;
            this.isPropagationStopped = bt, t && !this.isSimulated && t.stopPropagation()
        },
        stopImmediatePropagation: function () {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = bt, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
        }
    }, z.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (t) {
            var e = t.button;
            return null == t.which && yt.test(t.type) ? null != t.charCode ? t.charCode : t.keyCode : !t.which && void 0 !== e && wt.test(t.type) ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : t.which
        }
    }, z.event.addProp), z.each({focus: "focusin", blur: "focusout"}, function (t, e) {
        z.event.special[t] = {
            setup: function () {
                return Tt(this, t, Ct), !1
            }, trigger: function () {
                return Tt(this, t), !0
            }, delegateType: e
        }
    }), z.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function (t, o) {
        z.event.special[t] = {
            delegateType: o, bindType: o, handle: function (t) {
                var e, n = t.relatedTarget, i = t.handleObj;
                return n && (n === this || z.contains(this, n)) || (t.type = i.origType, e = i.handler.apply(this, arguments), t.type = o), e
            }
        }
    }), z.fn.extend({
        on: function (t, e, n, i) {
            return zt(this, t, e, n, i)
        }, one: function (t, e, n, i) {
            return zt(this, t, e, n, i, 1)
        }, off: function (t, e, n) {
            var i, o;
            if (t && t.preventDefault && t.handleObj) return i = t.handleObj, z(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" != typeof t) return !1 !== e && "function" != typeof e || (n = e, e = void 0), !1 === n && (n = _t), this.each(function () {
                z.event.remove(this, t, n, e)
            });
            for (o in t) this.off(o, e, t[o]);
            return this
        }
    });
    var St = /<script|<style|<link/i, Et = /checked\s*(?:[^=]|=\s*.checked.)/i,
        kt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function Lt(t, e) {
        return E(t, "table") && E(11 !== e.nodeType ? e : e.firstChild, "tr") && z(t).children("tbody")[0] || t
    }

    function Wt(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
    }

    function It(t) {
        return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t
    }

    function Dt(t, e) {
        var n, i, o, r;
        if (1 === e.nodeType) {
            if (V.hasData(t) && (r = V.get(t).events)) for (o in V.remove(e, "handle events"), r) for (n = 0, i = r[o].length; n < i; n++) z.event.add(e, o, r[o][n]);
            G.hasData(t) && (t = G.access(t), t = z.extend({}, t), G.set(e, t))
        }
    }

    function Ot(n, i, o, r) {
        i = g(i);
        var t, e, s, a, l, u, c = 0, h = n.length, p = h - 1, d = i[0], f = w(d);
        if (f || 1 < h && "string" == typeof d && !y.checkClone && Et.test(d)) return n.each(function (t) {
            var e = n.eq(t);
            f && (i[0] = d.call(this, t, e.html())), Ot(e, i, o, r)
        });
        if (h && (e = (t = vt(i, n[0].ownerDocument, !1, n, r)).firstChild, 1 === t.childNodes.length && (t = e), e || r)) {
            for (a = (s = z.map(ft(t, "script"), Wt)).length; c < h; c++) l = t, c !== p && (l = z.clone(l, !0, !0), a && z.merge(s, ft(l, "script"))), o.call(n[c], l, c);
            if (a) for (u = s[s.length - 1].ownerDocument, z.map(s, It), c = 0; c < a; c++) l = s[c], pt.test(l.type || "") && !V.access(l, "globalEval") && z.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? z._evalUrl && !l.noModule && z._evalUrl(l.src, {nonce: l.nonce || l.getAttribute("nonce")}, u) : x(l.textContent.replace(kt, ""), l, u))
        }
        return n
    }

    function At(t, e, n) {
        for (var i, o = e ? z.filter(e, t) : t, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || z.cleanData(ft(i)), i.parentNode && (n && ot(i) && mt(ft(i, "script")), i.parentNode.removeChild(i));
        return t
    }

    z.extend({
        htmlPrefilter: function (t) {
            return t
        }, clone: function (t, e, n) {
            var i, o, r, s, a, l, u, c = t.cloneNode(!0), h = ot(t);
            if (!(y.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || z.isXMLDoc(t))) for (s = ft(c), i = 0, o = (r = ft(t)).length; i < o; i++) a = r[i], "input" === (u = (l = s[i]).nodeName.toLowerCase()) && ct.test(a.type) ? l.checked = a.checked : "input" !== u && "textarea" !== u || (l.defaultValue = a.defaultValue);
            if (e) if (n) for (r = r || ft(t), s = s || ft(c), i = 0, o = r.length; i < o; i++) Dt(r[i], s[i]); else Dt(t, c);
            return 0 < (s = ft(c, "script")).length && mt(s, !h && ft(t, "script")), c
        }, cleanData: function (t) {
            for (var e, n, i, o = z.event.special, r = 0; void 0 !== (n = t[r]); r++) if (Y(n)) {
                if (e = n[V.expando]) {
                    if (e.events) for (i in e.events) o[i] ? z.event.remove(n, i) : z.removeEvent(n, i, e.handle);
                    n[V.expando] = void 0
                }
                n[G.expando] && (n[G.expando] = void 0)
            }
        }
    }), z.fn.extend({
        detach: function (t) {
            return At(this, t, !0)
        }, remove: function (t) {
            return At(this, t)
        }, text: function (t) {
            return q(this, function (t) {
                return void 0 === t ? z.text(this) : this.empty().each(function () {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        }, append: function () {
            return Ot(this, arguments, function (t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Lt(this, t).appendChild(t)
            })
        }, prepend: function () {
            return Ot(this, arguments, function (t) {
                var e;
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (e = Lt(this, t)).insertBefore(t, e.firstChild)
            })
        }, before: function () {
            return Ot(this, arguments, function (t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        }, after: function () {
            return Ot(this, arguments, function (t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        }, empty: function () {
            for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (z.cleanData(ft(t, !1)), t.textContent = "");
            return this
        }, clone: function (t, e) {
            return t = null != t && t, e = null == e ? t : e, this.map(function () {
                return z.clone(this, t, e)
            })
        }, html: function (t) {
            return q(this, function (t) {
                var e = this[0] || {}, n = 0, i = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if ("string" == typeof t && !St.test(t) && !dt[(ht.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = z.htmlPrefilter(t);
                    try {
                        for (; n < i; n++) 1 === (e = this[n] || {}).nodeType && (z.cleanData(ft(e, !1)), e.innerHTML = t);
                        e = 0
                    } catch (t) {
                    }
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        }, replaceWith: function () {
            var n = [];
            return Ot(this, arguments, function (t) {
                var e = this.parentNode;
                z.inArray(this, n) < 0 && (z.cleanData(ft(this)), e && e.replaceChild(t, this))
            }, n)
        }
    }), z.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function (t, s) {
        z.fn[t] = function (t) {
            for (var e, n = [], i = z(t), o = i.length - 1, r = 0; r <= o; r++) e = r === o ? this : this.clone(!0), z(i[r])[s](e), l.apply(n, e.get());
            return this.pushStack(n)
        }
    });

    function jt(t, e, n) {
        var i, o = {};
        for (i in e) o[i] = t.style[i], t.style[i] = e[i];
        for (i in n = n.call(t), e) t.style[i] = o[i];
        return n
    }

    var Ht, Nt, Pt, Mt, Rt, $t, qt, Ft, Bt = new RegExp("^(" + tt + ")(?!px)[a-z%]+$", "i"), Zt = function (t) {
        var e = t.ownerDocument.defaultView;
        return (e = !e || !e.opener ? _ : e).getComputedStyle(t)
    }, Ut = new RegExp(nt.join("|"), "i");

    function Yt(t, e, n) {
        var i, o, r = t.style;
        return (n = n || Zt(t)) && ("" !== (o = n.getPropertyValue(e) || n[e]) || ot(t) || (o = z.style(t, e)), !y.pixelBoxStyles() && Bt.test(o) && Ut.test(e) && (i = r.width, t = r.minWidth, e = r.maxWidth, r.minWidth = r.maxWidth = r.width = o, o = n.width, r.width = i, r.minWidth = t, r.maxWidth = e)), void 0 !== o ? o + "" : o
    }

    function Xt(t, e) {
        return {
            get: function () {
                if (!t()) return (this.get = e).apply(this, arguments);
                delete this.get
            }
        }
    }

    function Vt() {
        var t;
        Ft && (qt.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Ft.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", it.appendChild(qt).appendChild(Ft), t = _.getComputedStyle(Ft), Ht = "1%" !== t.top, $t = 12 === Gt(t.marginLeft), Ft.style.right = "60%", Mt = 36 === Gt(t.right), Nt = 36 === Gt(t.width), Ft.style.position = "absolute", Pt = 12 === Gt(Ft.offsetWidth / 3), it.removeChild(qt), Ft = null)
    }

    function Gt(t) {
        return Math.round(parseFloat(t))
    }

    qt = C.createElement("div"), (Ft = C.createElement("div")).style && (Ft.style.backgroundClip = "content-box", Ft.cloneNode(!0).style.backgroundClip = "", y.clearCloneStyle = "content-box" === Ft.style.backgroundClip, z.extend(y, {
        boxSizingReliable: function () {
            return Vt(), Nt
        }, pixelBoxStyles: function () {
            return Vt(), Mt
        }, pixelPosition: function () {
            return Vt(), Ht
        }, reliableMarginLeft: function () {
            return Vt(), $t
        }, scrollboxSize: function () {
            return Vt(), Pt
        }, reliableTrDimensions: function () {
            var t, e, n;
            return null == Rt && (t = C.createElement("table"), n = C.createElement("tr"), e = C.createElement("div"), t.style.cssText = "position:absolute;left:-11111px", n.style.height = "1px", e.style.height = "9px", it.appendChild(t).appendChild(n).appendChild(e), n = _.getComputedStyle(n), Rt = 3 < parseInt(n.height), it.removeChild(t)), Rt
        }
    }));
    var Qt = ["Webkit", "Moz", "ms"], Jt = C.createElement("div").style, Kt = {};

    function te(t) {
        return z.cssProps[t] || Kt[t] || (t in Jt ? t : Kt[t] = function (t) {
            for (var e = t[0].toUpperCase() + t.slice(1), n = Qt.length; n--;) if ((t = Qt[n] + e) in Jt) return t
        }(t) || t)
    }

    var ee = /^(none|table(?!-c[ea]).+)/, ne = /^--/,
        ie = {position: "absolute", visibility: "hidden", display: "block"},
        oe = {letterSpacing: "0", fontWeight: "400"};

    function re(t, e, n) {
        var i = et.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e
    }

    function se(t, e, n, i, o, r) {
        var s = "width" === e ? 1 : 0, a = 0, l = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; s < 4; s += 2) "margin" === n && (l += z.css(t, n + nt[s], !0, o)), i ? ("content" === n && (l -= z.css(t, "padding" + nt[s], !0, o)), "margin" !== n && (l -= z.css(t, "border" + nt[s] + "Width", !0, o))) : (l += z.css(t, "padding" + nt[s], !0, o), "padding" !== n ? l += z.css(t, "border" + nt[s] + "Width", !0, o) : a += z.css(t, "border" + nt[s] + "Width", !0, o));
        return !i && 0 <= r && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - r - l - a - .5)) || 0), l
    }

    function ae(t, e, n) {
        var i = Zt(t), o = (!y.boxSizingReliable() || n) && "border-box" === z.css(t, "boxSizing", !1, i), r = o,
            s = Yt(t, e, i), a = "offset" + e[0].toUpperCase() + e.slice(1);
        if (Bt.test(s)) {
            if (!n) return s;
            s = "auto"
        }
        return (!y.boxSizingReliable() && o || !y.reliableTrDimensions() && E(t, "tr") || "auto" === s || !parseFloat(s) && "inline" === z.css(t, "display", !1, i)) && t.getClientRects().length && (o = "border-box" === z.css(t, "boxSizing", !1, i), (r = a in t) && (s = t[a])), (s = parseFloat(s) || 0) + se(t, e, n || (o ? "border" : "content"), r, i, s) + "px"
    }

    function le(t, e, n, i, o) {
        return new le.prototype.init(t, e, n, i, o)
    }

    z.extend({
        cssHooks: {
            opacity: {
                get: function (t, e) {
                    if (e) {
                        t = Yt(t, "opacity");
                        return "" === t ? "1" : t
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function (t, e, n, i) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var o, r, s, a = U(e), l = ne.test(e), u = t.style;
                if (l || (e = te(a)), s = z.cssHooks[e] || z.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (o = s.get(t, !1, i)) ? o : u[e];
                "string" == (r = typeof n) && (o = et.exec(n)) && o[1] && (n = at(t, e, o), r = "number"), null != n && n == n && ("number" !== r || l || (n += o && o[3] || (z.cssNumber[a] ? "" : "px")), y.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (u[e] = "inherit"), s && "set" in s && void 0 === (n = s.set(t, n, i)) || (l ? u.setProperty(e, n) : u[e] = n))
            }
        },
        css: function (t, e, n, i) {
            var o, r = U(e);
            return ne.test(e) || (e = te(r)), "normal" === (o = void 0 === (o = (r = z.cssHooks[e] || z.cssHooks[r]) && "get" in r ? r.get(t, !0, n) : o) ? Yt(t, e, i) : o) && e in oe && (o = oe[e]), "" === n || n ? (e = parseFloat(o), !0 === n || isFinite(e) ? e || 0 : o) : o
        }
    }), z.each(["height", "width"], function (t, a) {
        z.cssHooks[a] = {
            get: function (t, e, n) {
                if (e) return !ee.test(z.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? ae(t, a, n) : jt(t, ie, function () {
                    return ae(t, a, n)
                })
            }, set: function (t, e, n) {
                var i, o = Zt(t), r = !y.scrollboxSize() && "absolute" === o.position,
                    s = (r || n) && "border-box" === z.css(t, "boxSizing", !1, o), n = n ? se(t, a, n, s, o) : 0;
                return s && r && (n -= Math.ceil(t["offset" + a[0].toUpperCase() + a.slice(1)] - parseFloat(o[a]) - se(t, a, "border", !1, o) - .5)), n && (i = et.exec(e)) && "px" !== (i[3] || "px") && (t.style[a] = e, e = z.css(t, a)), re(0, e, n)
            }
        }
    }), z.cssHooks.marginLeft = Xt(y.reliableMarginLeft, function (t, e) {
        if (e) return (parseFloat(Yt(t, "marginLeft")) || t.getBoundingClientRect().left - jt(t, {marginLeft: 0}, function () {
            return t.getBoundingClientRect().left
        })) + "px"
    }), z.each({margin: "", padding: "", border: "Width"}, function (o, r) {
        z.cssHooks[o + r] = {
            expand: function (t) {
                for (var e = 0, n = {}, i = "string" == typeof t ? t.split(" ") : [t]; e < 4; e++) n[o + nt[e] + r] = i[e] || i[e - 2] || i[0];
                return n
            }
        }, "margin" !== o && (z.cssHooks[o + r].set = re)
    }), z.fn.extend({
        css: function (t, e) {
            return q(this, function (t, e, n) {
                var i, o, r = {}, s = 0;
                if (Array.isArray(e)) {
                    for (i = Zt(t), o = e.length; s < o; s++) r[e[s]] = z.css(t, e[s], !1, i);
                    return r
                }
                return void 0 !== n ? z.style(t, e, n) : z.css(t, e)
            }, t, e, 1 < arguments.length)
        }
    }), ((z.Tween = le).prototype = {
        constructor: le, init: function (t, e, n, i, o, r) {
            this.elem = t, this.prop = n, this.easing = o || z.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = i, this.unit = r || (z.cssNumber[n] ? "" : "px")
        }, cur: function () {
            var t = le.propHooks[this.prop];
            return (t && t.get ? t : le.propHooks._default).get(this)
        }, run: function (t) {
            var e, n = le.propHooks[this.prop];
            return this.options.duration ? this.pos = e = z.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), (n && n.set ? n : le.propHooks._default).set(this), this
        }
    }).init.prototype = le.prototype, (le.propHooks = {
        _default: {
            get: function (t) {
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (t = z.css(t.elem, t.prop, "")) && "auto" !== t ? t : 0
            }, set: function (t) {
                z.fx.step[t.prop] ? z.fx.step[t.prop](t) : 1 !== t.elem.nodeType || !z.cssHooks[t.prop] && null == t.elem.style[te(t.prop)] ? t.elem[t.prop] = t.now : z.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    }).scrollTop = le.propHooks.scrollLeft = {
        set: function (t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    }, z.easing = {
        linear: function (t) {
            return t
        }, swing: function (t) {
            return .5 - Math.cos(t * Math.PI) / 2
        }, _default: "swing"
    }, z.fx = le.prototype.init, z.fx.step = {};
    var ue, ce, he = /^(?:toggle|show|hide)$/, pe = /queueHooks$/;

    function de() {
        ce && (!1 === C.hidden && _.requestAnimationFrame ? _.requestAnimationFrame(de) : _.setTimeout(de, z.fx.interval), z.fx.tick())
    }

    function fe() {
        return _.setTimeout(function () {
            ue = void 0
        }), ue = Date.now()
    }

    function me(t, e) {
        var n, i = 0, o = {height: t};
        for (e = e ? 1 : 0; i < 4; i += 2 - e) o["margin" + (n = nt[i])] = o["padding" + n] = t;
        return e && (o.opacity = o.width = t), o
    }

    function ge(t, e, n) {
        for (var i, o = (ve.tweeners[e] || []).concat(ve.tweeners["*"]), r = 0, s = o.length; r < s; r++) if (i = o[r].call(n, e, t)) return i
    }

    function ve(o, t, e) {
        var n, r, i = 0, s = ve.prefilters.length, a = z.Deferred().always(function () {
            delete l.elem
        }), l = function () {
            if (r) return !1;
            for (var t = ue || fe(), t = Math.max(0, u.startTime + u.duration - t), e = 1 - (t / u.duration || 0), n = 0, i = u.tweens.length; n < i; n++) u.tweens[n].run(e);
            return a.notifyWith(o, [u, e, t]), e < 1 && i ? t : (i || a.notifyWith(o, [u, 1, 0]), a.resolveWith(o, [u]), !1)
        }, u = a.promise({
            elem: o,
            props: z.extend({}, t),
            opts: z.extend(!0, {specialEasing: {}, easing: z.easing._default}, e),
            originalProperties: t,
            originalOptions: e,
            startTime: ue || fe(),
            duration: e.duration,
            tweens: [],
            createTween: function (t, e) {
                t = z.Tween(o, u.opts, t, e, u.opts.specialEasing[t] || u.opts.easing);
                return u.tweens.push(t), t
            },
            stop: function (t) {
                var e = 0, n = t ? u.tweens.length : 0;
                if (r) return this;
                for (r = !0; e < n; e++) u.tweens[e].run(1);
                return t ? (a.notifyWith(o, [u, 1, 0]), a.resolveWith(o, [u, t])) : a.rejectWith(o, [u, t]), this
            }
        }), c = u.props;
        for (function (t, e) {
            var n, i, o, r, s;
            for (n in t) if (o = e[i = U(n)], r = t[n], Array.isArray(r) && (o = r[1], r = t[n] = r[0]), n !== i && (t[i] = r, delete t[n]), (s = z.cssHooks[i]) && "expand" in s) for (n in r = s.expand(r), delete t[i], r) n in t || (t[n] = r[n], e[n] = o); else e[i] = o
        }(c, u.opts.specialEasing); i < s; i++) if (n = ve.prefilters[i].call(u, o, c, u.opts)) return w(n.stop) && (z._queueHooks(u.elem, u.opts.queue).stop = n.stop.bind(n)), n;
        return z.map(c, ge, u), w(u.opts.start) && u.opts.start.call(o, u), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always), z.fx.timer(z.extend(l, {
            elem: o,
            anim: u,
            queue: u.opts.queue
        })), u
    }

    z.Animation = z.extend(ve, {
        tweeners: {
            "*": [function (t, e) {
                var n = this.createTween(t, e);
                return at(n.elem, t, et.exec(e), n), n
            }]
        }, tweener: function (t, e) {
            for (var n, i = 0, o = (t = w(t) ? (e = t, ["*"]) : t.match(j)).length; i < o; i++) n = t[i], ve.tweeners[n] = ve.tweeners[n] || [], ve.tweeners[n].unshift(e)
        }, prefilters: [function (t, e, n) {
            var i, o, r, s, a, l, u, c = "width" in e || "height" in e, h = this, p = {}, d = t.style,
                f = t.nodeType && st(t), m = V.get(t, "fxshow");
            for (i in n.queue || (null == (s = z._queueHooks(t, "fx")).unqueued && (s.unqueued = 0, a = s.empty.fire, s.empty.fire = function () {
                s.unqueued || a()
            }), s.unqueued++, h.always(function () {
                h.always(function () {
                    s.unqueued--, z.queue(t, "fx").length || s.empty.fire()
                })
            })), e) if (o = e[i], he.test(o)) {
                if (delete e[i], r = r || "toggle" === o, o === (f ? "hide" : "show")) {
                    if ("show" !== o || !m || void 0 === m[i]) continue;
                    f = !0
                }
                p[i] = m && m[i] || z.style(t, i)
            }
            if ((l = !z.isEmptyObject(e)) || !z.isEmptyObject(p)) for (i in c && 1 === t.nodeType && (n.overflow = [d.overflow, d.overflowX, d.overflowY], null == (u = m && m.display) && (u = V.get(t, "display")), "none" === (c = z.css(t, "display")) && (u ? c = u : (ut([t], !0), u = t.style.display || u, c = z.css(t, "display"), ut([t]))), ("inline" === c || "inline-block" === c && null != u) && "none" === z.css(t, "float") && (l || (h.done(function () {
                d.display = u
            }), null == u && (c = d.display, u = "none" === c ? "" : c)), d.display = "inline-block")), n.overflow && (d.overflow = "hidden", h.always(function () {
                d.overflow = n.overflow[0], d.overflowX = n.overflow[1], d.overflowY = n.overflow[2]
            })), l = !1, p) l || (m ? "hidden" in m && (f = m.hidden) : m = V.access(t, "fxshow", {display: u}), r && (m.hidden = !f), f && ut([t], !0), h.done(function () {
                for (i in f || ut([t]), V.remove(t, "fxshow"), p) z.style(t, i, p[i])
            })), l = ge(f ? m[i] : 0, i, h), i in m || (m[i] = l.start, f && (l.end = l.start, l.start = 0))
        }], prefilter: function (t, e) {
            e ? ve.prefilters.unshift(t) : ve.prefilters.push(t)
        }
    }), z.speed = function (t, e, n) {
        var i = t && "object" == typeof t ? z.extend({}, t) : {
            complete: n || !n && e || w(t) && t,
            duration: t,
            easing: n && e || e && !w(e) && e
        };
        return z.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in z.fx.speeds ? i.duration = z.fx.speeds[i.duration] : i.duration = z.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function () {
            w(i.old) && i.old.call(this), i.queue && z.dequeue(this, i.queue)
        }, i
    }, z.fn.extend({
        fadeTo: function (t, e, n, i) {
            return this.filter(st).css("opacity", 0).show().end().animate({opacity: e}, t, n, i)
        }, animate: function (e, t, n, i) {
            var o = z.isEmptyObject(e), r = z.speed(t, n, i), i = function () {
                var t = ve(this, z.extend({}, e), r);
                (o || V.get(this, "finish")) && t.stop(!0)
            };
            return i.finish = i, o || !1 === r.queue ? this.each(i) : this.queue(r.queue, i)
        }, stop: function (o, t, r) {
            function s(t) {
                var e = t.stop;
                delete t.stop, e(r)
            }

            return "string" != typeof o && (r = t, t = o, o = void 0), t && this.queue(o || "fx", []), this.each(function () {
                var t = !0, e = null != o && o + "queueHooks", n = z.timers, i = V.get(this);
                if (e) i[e] && i[e].stop && s(i[e]); else for (e in i) i[e] && i[e].stop && pe.test(e) && s(i[e]);
                for (e = n.length; e--;) n[e].elem !== this || null != o && n[e].queue !== o || (n[e].anim.stop(r), t = !1, n.splice(e, 1));
                !t && r || z.dequeue(this, o)
            })
        }, finish: function (s) {
            return !1 !== s && (s = s || "fx"), this.each(function () {
                var t, e = V.get(this), n = e[s + "queue"], i = e[s + "queueHooks"], o = z.timers, r = n ? n.length : 0;
                for (e.finish = !0, z.queue(this, s, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === s && (o[t].anim.stop(!0), o.splice(t, 1));
                for (t = 0; t < r; t++) n[t] && n[t].finish && n[t].finish.call(this);
                delete e.finish
            })
        }
    }), z.each(["toggle", "show", "hide"], function (t, i) {
        var o = z.fn[i];
        z.fn[i] = function (t, e, n) {
            return null == t || "boolean" == typeof t ? o.apply(this, arguments) : this.animate(me(i, !0), t, e, n)
        }
    }), z.each({
        slideDown: me("show"),
        slideUp: me("hide"),
        slideToggle: me("toggle"),
        fadeIn: {opacity: "show"},
        fadeOut: {opacity: "hide"},
        fadeToggle: {opacity: "toggle"}
    }, function (t, i) {
        z.fn[t] = function (t, e, n) {
            return this.animate(i, t, e, n)
        }
    }), z.timers = [], z.fx.tick = function () {
        var t, e = 0, n = z.timers;
        for (ue = Date.now(); e < n.length; e++) (t = n[e])() || n[e] !== t || n.splice(e--, 1);
        n.length || z.fx.stop(), ue = void 0
    }, z.fx.timer = function (t) {
        z.timers.push(t), z.fx.start()
    }, z.fx.interval = 13, z.fx.start = function () {
        ce || (ce = !0, de())
    }, z.fx.stop = function () {
        ce = null
    }, z.fx.speeds = {slow: 600, fast: 200, _default: 400}, z.fn.delay = function (i, t) {
        return i = z.fx && z.fx.speeds[i] || i, this.queue(t = t || "fx", function (t, e) {
            var n = _.setTimeout(t, i);
            e.stop = function () {
                _.clearTimeout(n)
            }
        })
    }, h = C.createElement("input"), tt = C.createElement("select").appendChild(C.createElement("option")), h.type = "checkbox", y.checkOn = "" !== h.value, y.optSelected = tt.selected, (h = C.createElement("input")).value = "t", h.type = "radio", y.radioValue = "t" === h.value;
    var ye, we = z.expr.attrHandle;
    z.fn.extend({
        attr: function (t, e) {
            return q(this, z.attr, t, e, 1 < arguments.length)
        }, removeAttr: function (t) {
            return this.each(function () {
                z.removeAttr(this, t)
            })
        }
    }), z.extend({
        attr: function (t, e, n) {
            var i, o, r = t.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return void 0 === t.getAttribute ? z.prop(t, e, n) : (1 === r && z.isXMLDoc(t) || (o = z.attrHooks[e.toLowerCase()] || (z.expr.match.bool.test(e) ? ye : void 0)), void 0 !== n ? null === n ? void z.removeAttr(t, e) : o && "set" in o && void 0 !== (i = o.set(t, n, e)) ? i : (t.setAttribute(e, n + ""), n) : !(o && "get" in o && null !== (i = o.get(t, e))) && null == (i = z.find.attr(t, e)) ? void 0 : i)
        }, attrHooks: {
            type: {
                set: function (t, e) {
                    if (!y.radioValue && "radio" === e && E(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e), n && (t.value = n), e
                    }
                }
            }
        }, removeAttr: function (t, e) {
            var n, i = 0, o = e && e.match(j);
            if (o && 1 === t.nodeType) for (; n = o[i++];) t.removeAttribute(n)
        }
    }), ye = {
        set: function (t, e, n) {
            return !1 === e ? z.removeAttr(t, n) : t.setAttribute(n, n), n
        }
    }, z.each(z.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var s = we[e] || z.find.attr;
        we[e] = function (t, e, n) {
            var i, o, r = e.toLowerCase();
            return n || (o = we[r], we[r] = i, i = null != s(t, e, n) ? r : null, we[r] = o), i
        }
    });
    var xe = /^(?:input|select|textarea|button)$/i, be = /^(?:a|area)$/i;

    function _e(t) {
        return (t.match(j) || []).join(" ")
    }

    function Ce(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }

    function ze(t) {
        return Array.isArray(t) ? t : "string" == typeof t && t.match(j) || []
    }

    z.fn.extend({
        prop: function (t, e) {
            return q(this, z.prop, t, e, 1 < arguments.length)
        }, removeProp: function (t) {
            return this.each(function () {
                delete this[z.propFix[t] || t]
            })
        }
    }), z.extend({
        prop: function (t, e, n) {
            var i, o, r = t.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return 1 === r && z.isXMLDoc(t) || (e = z.propFix[e] || e, o = z.propHooks[e]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(t, n, e)) ? i : t[e] = n : o && "get" in o && null !== (i = o.get(t, e)) ? i : t[e]
        }, propHooks: {
            tabIndex: {
                get: function (t) {
                    var e = z.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : xe.test(t.nodeName) || be.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        }, propFix: {for: "htmlFor", class: "className"}
    }), y.optSelected || (z.propHooks.selected = {
        get: function (t) {
            t = t.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        }, set: function (t) {
            t = t.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), z.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        z.propFix[this.toLowerCase()] = this
    }), z.fn.extend({
        addClass: function (e) {
            var t, n, i, o, r, s, a = 0;
            if (w(e)) return this.each(function (t) {
                z(this).addClass(e.call(this, t, Ce(this)))
            });
            if ((t = ze(e)).length) for (; n = this[a++];) if (s = Ce(n), i = 1 === n.nodeType && " " + _e(s) + " ") {
                for (r = 0; o = t[r++];) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                s !== (s = _e(i)) && n.setAttribute("class", s)
            }
            return this
        }, removeClass: function (e) {
            var t, n, i, o, r, s, a = 0;
            if (w(e)) return this.each(function (t) {
                z(this).removeClass(e.call(this, t, Ce(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ((t = ze(e)).length) for (; n = this[a++];) if (s = Ce(n), i = 1 === n.nodeType && " " + _e(s) + " ") {
                for (r = 0; o = t[r++];) for (; -1 < i.indexOf(" " + o + " ");) i = i.replace(" " + o + " ", " ");
                s !== (s = _e(i)) && n.setAttribute("class", s)
            }
            return this
        }, toggleClass: function (o, e) {
            var r = typeof o, s = "string" == r || Array.isArray(o);
            return "boolean" == typeof e && s ? e ? this.addClass(o) : this.removeClass(o) : w(o) ? this.each(function (t) {
                z(this).toggleClass(o.call(this, t, Ce(this), e), e)
            }) : this.each(function () {
                var t, e, n, i;
                if (s) for (e = 0, n = z(this), i = ze(o); t = i[e++];) n.hasClass(t) ? n.removeClass(t) : n.addClass(t); else void 0 !== o && "boolean" != r || ((t = Ce(this)) && V.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", !t && !1 !== o && V.get(this, "__className__") || ""))
            })
        }, hasClass: function (t) {
            for (var e, n = 0, i = " " + t + " "; e = this[n++];) if (1 === e.nodeType && -1 < (" " + _e(Ce(e)) + " ").indexOf(i)) return !0;
            return !1
        }
    });
    var Te = /\r/g;
    z.fn.extend({
        val: function (e) {
            var n, t, i, o = this[0];
            return arguments.length ? (i = w(e), this.each(function (t) {
                1 === this.nodeType && (null == (t = i ? e.call(this, t, z(this).val()) : e) ? t = "" : "number" == typeof t ? t += "" : Array.isArray(t) && (t = z.map(t, function (t) {
                    return null == t ? "" : t + ""
                })), (n = z.valHooks[this.type] || z.valHooks[this.nodeName.toLowerCase()]) && "set" in n && void 0 !== n.set(this, t, "value") || (this.value = t))
            })) : o ? (n = z.valHooks[o.type] || z.valHooks[o.nodeName.toLowerCase()]) && "get" in n && void 0 !== (t = n.get(o, "value")) ? t : "string" == typeof (t = o.value) ? t.replace(Te, "") : null == t ? "" : t : void 0
        }
    }), z.extend({
        valHooks: {
            option: {
                get: function (t) {
                    var e = z.find.attr(t, "value");
                    return null != e ? e : _e(z.text(t))
                }
            }, select: {
                get: function (t) {
                    for (var e, n = t.options, i = t.selectedIndex, o = "select-one" === t.type, r = o ? null : [], s = o ? i + 1 : n.length, a = i < 0 ? s : o ? i : 0; a < s; a++) if (((e = n[a]).selected || a === i) && !e.disabled && (!e.parentNode.disabled || !E(e.parentNode, "optgroup"))) {
                        if (e = z(e).val(), o) return e;
                        r.push(e)
                    }
                    return r
                }, set: function (t, e) {
                    for (var n, i, o = t.options, r = z.makeArray(e), s = o.length; s--;) ((i = o[s]).selected = -1 < z.inArray(z.valHooks.option.get(i), r)) && (n = !0);
                    return n || (t.selectedIndex = -1), r
                }
            }
        }
    }), z.each(["radio", "checkbox"], function () {
        z.valHooks[this] = {
            set: function (t, e) {
                if (Array.isArray(e)) return t.checked = -1 < z.inArray(z(t).val(), e)
            }
        }, y.checkOn || (z.valHooks[this].get = function (t) {
            return null === t.getAttribute("value") ? "on" : t.value
        })
    }), y.focusin = "onfocusin" in _;

    function Se(t) {
        t.stopPropagation()
    }

    var Ee = /^(?:focusinfocus|focusoutblur)$/;
    z.extend(z.event, {
        trigger: function (t, e, n, i) {
            var o, r, s, a, l, u, c, h = [n || C], p = v.call(t, "type") ? t.type : t,
                d = v.call(t, "namespace") ? t.namespace.split(".") : [], f = c = r = n = n || C;
            if (3 !== n.nodeType && 8 !== n.nodeType && !Ee.test(p + z.event.triggered) && (-1 < p.indexOf(".") && (p = (d = p.split(".")).shift(), d.sort()), a = p.indexOf(":") < 0 && "on" + p, (t = t[z.expando] ? t : new z.Event(p, "object" == typeof t && t)).isTrigger = i ? 2 : 3, t.namespace = d.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + d.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = n), e = null == e ? [t] : z.makeArray(e, [t]), u = z.event.special[p] || {}, i || !u.trigger || !1 !== u.trigger.apply(n, e))) {
                if (!i && !u.noBubble && !m(n)) {
                    for (s = u.delegateType || p, Ee.test(s + p) || (f = f.parentNode); f; f = f.parentNode) h.push(f), r = f;
                    r === (n.ownerDocument || C) && h.push(r.defaultView || r.parentWindow || _)
                }
                for (o = 0; (f = h[o++]) && !t.isPropagationStopped();) c = f, t.type = 1 < o ? s : u.bindType || p, (l = (V.get(f, "events") || Object.create(null))[t.type] && V.get(f, "handle")) && l.apply(f, e), (l = a && f[a]) && l.apply && Y(f) && (t.result = l.apply(f, e), !1 === t.result && t.preventDefault());
                return t.type = p, i || t.isDefaultPrevented() || u._default && !1 !== u._default.apply(h.pop(), e) || !Y(n) || a && w(n[p]) && !m(n) && ((r = n[a]) && (n[a] = null), z.event.triggered = p, t.isPropagationStopped() && c.addEventListener(p, Se), n[p](), t.isPropagationStopped() && c.removeEventListener(p, Se), z.event.triggered = void 0, r && (n[a] = r)), t.result
            }
        }, simulate: function (t, e, n) {
            t = z.extend(new z.Event, n, {type: t, isSimulated: !0});
            z.event.trigger(t, null, e)
        }
    }), z.fn.extend({
        trigger: function (t, e) {
            return this.each(function () {
                z.event.trigger(t, e, this)
            })
        }, triggerHandler: function (t, e) {
            var n = this[0];
            if (n) return z.event.trigger(t, e, n, !0)
        }
    }), y.focusin || z.each({focus: "focusin", blur: "focusout"}, function (n, i) {
        function o(t) {
            z.event.simulate(i, t.target, z.event.fix(t))
        }

        z.event.special[i] = {
            setup: function () {
                var t = this.ownerDocument || this.document || this, e = V.access(t, i);
                e || t.addEventListener(n, o, !0), V.access(t, i, (e || 0) + 1)
            }, teardown: function () {
                var t = this.ownerDocument || this.document || this, e = V.access(t, i) - 1;
                e ? V.access(t, i, e) : (t.removeEventListener(n, o, !0), V.remove(t, i))
            }
        }
    });
    var ke = _.location, Le = {guid: Date.now()}, We = /\?/;
    z.parseXML = function (t) {
        var e;
        if (!t || "string" != typeof t) return null;
        try {
            e = (new _.DOMParser).parseFromString(t, "text/xml")
        } catch (t) {
            e = void 0
        }
        return e && !e.getElementsByTagName("parsererror").length || z.error("Invalid XML: " + t), e
    };
    var Ie = /\[\]$/, De = /\r?\n/g, Oe = /^(?:submit|button|image|reset|file)$/i,
        Ae = /^(?:input|select|textarea|keygen)/i;
    z.param = function (t, e) {
        function n(t, e) {
            e = w(e) ? e() : e, o[o.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == e ? "" : e)
        }

        var i, o = [];
        if (null == t) return "";
        if (Array.isArray(t) || t.jquery && !z.isPlainObject(t)) z.each(t, function () {
            n(this.name, this.value)
        }); else for (i in t) !function n(i, t, o, r) {
            if (Array.isArray(t)) z.each(t, function (t, e) {
                o || Ie.test(i) ? r(i, e) : n(i + "[" + ("object" == typeof e && null != e ? t : "") + "]", e, o, r)
            }); else if (o || "object" !== f(t)) r(i, t); else for (var e in t) n(i + "[" + e + "]", t[e], o, r)
        }(i, t[i], e, n);
        return o.join("&")
    }, z.fn.extend({
        serialize: function () {
            return z.param(this.serializeArray())
        }, serializeArray: function () {
            return this.map(function () {
                var t = z.prop(this, "elements");
                return t ? z.makeArray(t) : this
            }).filter(function () {
                var t = this.type;
                return this.name && !z(this).is(":disabled") && Ae.test(this.nodeName) && !Oe.test(t) && (this.checked || !ct.test(t))
            }).map(function (t, e) {
                var n = z(this).val();
                return null == n ? null : Array.isArray(n) ? z.map(n, function (t) {
                    return {name: e.name, value: t.replace(De, "\r\n")}
                }) : {name: e.name, value: n.replace(De, "\r\n")}
            }).get()
        }
    });
    var je = /%20/g, He = /#.*$/, Ne = /([?&])_=[^&]*/, Pe = /^(.*?):[ \t]*([^\r\n]*)$/gm, Me = /^(?:GET|HEAD)$/,
        Re = /^\/\//, $e = {}, qe = {}, Fe = "*/".concat("*"), Be = C.createElement("a");

    function Ze(r) {
        return function (t, e) {
            "string" != typeof t && (e = t, t = "*");
            var n, i = 0, o = t.toLowerCase().match(j) || [];
            if (w(e)) for (; n = o[i++];) "+" === n[0] ? (n = n.slice(1) || "*", (r[n] = r[n] || []).unshift(e)) : (r[n] = r[n] || []).push(e)
        }
    }

    function Ue(e, i, o, r) {
        var s = {}, a = e === qe;

        function l(t) {
            var n;
            return s[t] = !0, z.each(e[t] || [], function (t, e) {
                e = e(i, o, r);
                return "string" != typeof e || a || s[e] ? a ? !(n = e) : void 0 : (i.dataTypes.unshift(e), l(e), !1)
            }), n
        }

        return l(i.dataTypes[0]) || !s["*"] && l("*")
    }

    function Ye(t, e) {
        var n, i, o = z.ajaxSettings.flatOptions || {};
        for (n in e) void 0 !== e[n] && ((o[n] ? t : i = i || {})[n] = e[n]);
        return i && z.extend(!0, t, i), t
    }

    Be.href = ke.href, z.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ke.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ke.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Fe,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
            responseFields: {xml: "responseXML", text: "responseText", json: "responseJSON"},
            converters: {"* text": String, "text html": !0, "text json": JSON.parse, "text xml": z.parseXML},
            flatOptions: {url: !0, context: !0}
        },
        ajaxSetup: function (t, e) {
            return e ? Ye(Ye(t, z.ajaxSettings), e) : Ye(z.ajaxSettings, t)
        },
        ajaxPrefilter: Ze($e),
        ajaxTransport: Ze(qe),
        ajax: function (t, e) {
            "object" == typeof t && (e = t, t = void 0);
            var l, u, c, n, h, p, d, i, o, f = z.ajaxSetup({}, e = e || {}), m = f.context || f,
                g = f.context && (m.nodeType || m.jquery) ? z(m) : z.event, v = z.Deferred(),
                y = z.Callbacks("once memory"), w = f.statusCode || {}, r = {}, s = {}, a = "canceled", x = {
                    readyState: 0, getResponseHeader: function (t) {
                        var e;
                        if (p) {
                            if (!n) for (n = {}; e = Pe.exec(c);) n[e[1].toLowerCase() + " "] = (n[e[1].toLowerCase() + " "] || []).concat(e[2]);
                            e = n[t.toLowerCase() + " "]
                        }
                        return null == e ? null : e.join(", ")
                    }, getAllResponseHeaders: function () {
                        return p ? c : null
                    }, setRequestHeader: function (t, e) {
                        return null == p && (t = s[t.toLowerCase()] = s[t.toLowerCase()] || t, r[t] = e), this
                    }, overrideMimeType: function (t) {
                        return null == p && (f.mimeType = t), this
                    }, statusCode: function (t) {
                        if (t) if (p) x.always(t[x.status]); else for (var e in t) w[e] = [w[e], t[e]];
                        return this
                    }, abort: function (t) {
                        t = t || a;
                        return l && l.abort(t), b(0, t), this
                    }
                };
            if (v.promise(x), f.url = ((t || f.url || ke.href) + "").replace(Re, ke.protocol + "//"), f.type = e.method || e.type || f.method || f.type, f.dataTypes = (f.dataType || "*").toLowerCase().match(j) || [""], null == f.crossDomain) {
                o = C.createElement("a");
                try {
                    o.href = f.url, o.href = o.href, f.crossDomain = Be.protocol + "//" + Be.host != o.protocol + "//" + o.host
                } catch (t) {
                    f.crossDomain = !0
                }
            }
            if (f.data && f.processData && "string" != typeof f.data && (f.data = z.param(f.data, f.traditional)), Ue($e, f, e, x), p) return x;
            for (i in (d = z.event && f.global) && 0 == z.active++ && z.event.trigger("ajaxStart"), f.type = f.type.toUpperCase(), f.hasContent = !Me.test(f.type), u = f.url.replace(He, ""), f.hasContent ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(je, "+")) : (o = f.url.slice(u.length), f.data && (f.processData || "string" == typeof f.data) && (u += (We.test(u) ? "&" : "?") + f.data, delete f.data), !1 === f.cache && (u = u.replace(Ne, "$1"), o = (We.test(u) ? "&" : "?") + "_=" + Le.guid++ + o), f.url = u + o), f.ifModified && (z.lastModified[u] && x.setRequestHeader("If-Modified-Since", z.lastModified[u]), z.etag[u] && x.setRequestHeader("If-None-Match", z.etag[u])), (f.data && f.hasContent && !1 !== f.contentType || e.contentType) && x.setRequestHeader("Content-Type", f.contentType), x.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Fe + "; q=0.01" : "") : f.accepts["*"]), f.headers) x.setRequestHeader(i, f.headers[i]);
            if (f.beforeSend && (!1 === f.beforeSend.call(m, x, f) || p)) return x.abort();
            if (a = "abort", y.add(f.complete), x.done(f.success), x.fail(f.error), l = Ue(qe, f, e, x)) {
                if (x.readyState = 1, d && g.trigger("ajaxSend", [x, f]), p) return x;
                f.async && 0 < f.timeout && (h = _.setTimeout(function () {
                    x.abort("timeout")
                }, f.timeout));
                try {
                    p = !1, l.send(r, b)
                } catch (t) {
                    if (p) throw t;
                    b(-1, t)
                }
            } else b(-1, "No Transport");

            function b(t, e, n, i) {
                var o, r, s, a = e;
                p || (p = !0, h && _.clearTimeout(h), l = void 0, c = i || "", x.readyState = 0 < t ? 4 : 0, i = 200 <= t && t < 300 || 304 === t, n && (s = function (t, e, n) {
                    for (var i, o, r, s, a = t.contents, l = t.dataTypes; "*" === l[0];) l.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (i) for (o in a) if (a[o] && a[o].test(i)) {
                        l.unshift(o);
                        break
                    }
                    if (l[0] in n) r = l[0]; else {
                        for (o in n) {
                            if (!l[0] || t.converters[o + " " + l[0]]) {
                                r = o;
                                break
                            }
                            s = s || o
                        }
                        r = r || s
                    }
                    if (r) return r !== l[0] && l.unshift(r), n[r]
                }(f, x, n)), !i && -1 < z.inArray("script", f.dataTypes) && (f.converters["text script"] = function () {
                }), s = function (t, e, n, i) {
                    var o, r, s, a, l, u = {}, c = t.dataTypes.slice();
                    if (c[1]) for (s in t.converters) u[s.toLowerCase()] = t.converters[s];
                    for (r = c.shift(); r;) if (t.responseFields[r] && (n[t.responseFields[r]] = e), !l && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = r, r = c.shift()) if ("*" === r) r = l; else if ("*" !== l && l !== r) {
                        if (!(s = u[l + " " + r] || u["* " + r])) for (o in u) if ((a = o.split(" "))[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                            !0 === s ? s = u[o] : !0 !== u[o] && (r = a[0], c.unshift(a[1]));
                            break
                        }
                        if (!0 !== s) if (s && t.throws) e = s(e); else try {
                            e = s(e)
                        } catch (t) {
                            return {state: "parsererror", error: s ? t : "No conversion from " + l + " to " + r}
                        }
                    }
                    return {state: "success", data: e}
                }(f, s, x, i), i ? (f.ifModified && ((n = x.getResponseHeader("Last-Modified")) && (z.lastModified[u] = n), (n = x.getResponseHeader("etag")) && (z.etag[u] = n)), 204 === t || "HEAD" === f.type ? a = "nocontent" : 304 === t ? a = "notmodified" : (a = s.state, o = s.data, i = !(r = s.error))) : (r = a, !t && a || (a = "error", t < 0 && (t = 0))), x.status = t, x.statusText = (e || a) + "", i ? v.resolveWith(m, [o, a, x]) : v.rejectWith(m, [x, a, r]), x.statusCode(w), w = void 0, d && g.trigger(i ? "ajaxSuccess" : "ajaxError", [x, f, i ? o : r]), y.fireWith(m, [x, a]), d && (g.trigger("ajaxComplete", [x, f]), --z.active || z.event.trigger("ajaxStop")))
            }

            return x
        },
        getJSON: function (t, e, n) {
            return z.get(t, e, n, "json")
        },
        getScript: function (t, e) {
            return z.get(t, void 0, e, "script")
        }
    }), z.each(["get", "post"], function (t, o) {
        z[o] = function (t, e, n, i) {
            return w(e) && (i = i || n, n = e, e = void 0), z.ajax(z.extend({
                url: t,
                type: o,
                dataType: i,
                data: e,
                success: n
            }, z.isPlainObject(t) && t))
        }
    }), z.ajaxPrefilter(function (t) {
        for (var e in t.headers) "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "")
    }), z._evalUrl = function (t, e, n) {
        return z.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function () {
                }
            },
            dataFilter: function (t) {
                z.globalEval(t, e, n)
            }
        })
    }, z.fn.extend({
        wrapAll: function (t) {
            return this[0] && (w(t) && (t = t.call(this[0])), t = z(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
                for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                return t
            }).append(this)), this
        }, wrapInner: function (n) {
            return w(n) ? this.each(function (t) {
                z(this).wrapInner(n.call(this, t))
            }) : this.each(function () {
                var t = z(this), e = t.contents();
                e.length ? e.wrapAll(n) : t.append(n)
            })
        }, wrap: function (e) {
            var n = w(e);
            return this.each(function (t) {
                z(this).wrapAll(n ? e.call(this, t) : e)
            })
        }, unwrap: function (t) {
            return this.parent(t).not("body").each(function () {
                z(this).replaceWith(this.childNodes)
            }), this
        }
    }), z.expr.pseudos.hidden = function (t) {
        return !z.expr.pseudos.visible(t)
    }, z.expr.pseudos.visible = function (t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
    }, z.ajaxSettings.xhr = function () {
        try {
            return new _.XMLHttpRequest
        } catch (t) {
        }
    };
    var Xe = {0: 200, 1223: 204}, Ve = z.ajaxSettings.xhr();
    y.cors = !!Ve && "withCredentials" in Ve, y.ajax = Ve = !!Ve, z.ajaxTransport(function (o) {
        var r, s;
        if (y.cors || Ve && !o.crossDomain) return {
            send: function (t, e) {
                var n, i = o.xhr();
                if (i.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields) for (n in o.xhrFields) i[n] = o.xhrFields[n];
                for (n in o.mimeType && i.overrideMimeType && i.overrideMimeType(o.mimeType), o.crossDomain || t["X-Requested-With"] || (t["X-Requested-With"] = "XMLHttpRequest"), t) i.setRequestHeader(n, t[n]);
                r = function (t) {
                    return function () {
                        r && (r = s = i.onload = i.onerror = i.onabort = i.ontimeout = i.onreadystatechange = null, "abort" === t ? i.abort() : "error" === t ? "number" != typeof i.status ? e(0, "error") : e(i.status, i.statusText) : e(Xe[i.status] || i.status, i.statusText, "text" !== (i.responseType || "text") || "string" != typeof i.responseText ? {binary: i.response} : {text: i.responseText}, i.getAllResponseHeaders()))
                    }
                }, i.onload = r(), s = i.onerror = i.ontimeout = r("error"), void 0 !== i.onabort ? i.onabort = s : i.onreadystatechange = function () {
                    4 === i.readyState && _.setTimeout(function () {
                        r && s()
                    })
                }, r = r("abort");
                try {
                   // i.send(o.hasContent && o.data || null)
                } catch (t) {
                    if (r) throw t
                }
            }, abort: function () {
                r && r()
            }
        }
    }), z.ajaxPrefilter(function (t) {
        t.crossDomain && (t.contents.script = !1)
    }), z.ajaxSetup({
        accepts: {script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},
        contents: {script: /\b(?:java|ecma)script\b/},
        converters: {
            "text script": function (t) {
                return z.globalEval(t), t
            }
        }
    }), z.ajaxPrefilter("script", function (t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
    }), z.ajaxTransport("script", function (n) {
        var i, o;
        if (n.crossDomain || n.scriptAttrs) return {
            send: function (t, e) {
                i = z("<script>").attr(n.scriptAttrs || {}).prop({
                    charset: n.scriptCharset,
                    src: n.url
                }).on("load error", o = function (t) {
                    i.remove(), o = null, t && e("error" === t.type ? 404 : 200, t.type)
                }), C.head.appendChild(i[0])
            }, abort: function () {
                o && o()
            }
        }
    });
    var Ge = [], Qe = /(=)\?(?=&|$)|\?\?/;
    z.ajaxSetup({
        jsonp: "callback", jsonpCallback: function () {
            var t = Ge.pop() || z.expando + "_" + Le.guid++;
            return this[t] = !0, t
        }
    }), z.ajaxPrefilter("json jsonp", function (t, e, n) {
        var i, o, r,
            s = !1 !== t.jsonp && (Qe.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Qe.test(t.data) && "data");
        if (s || "jsonp" === t.dataTypes[0]) return i = t.jsonpCallback = w(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(Qe, "$1" + i) : !1 !== t.jsonp && (t.url += (We.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function () {
            return r || z.error(i + " was not called"), r[0]
        }, t.dataTypes[0] = "json", o = _[i], _[i] = function () {
            r = arguments
        }, n.always(function () {
            void 0 === o ? z(_).removeProp(i) : _[i] = o, t[i] && (t.jsonpCallback = e.jsonpCallback, Ge.push(i)), r && w(o) && o(r[0]), r = o = void 0
        }), "script"
    }), y.createHTMLDocument = ((h = C.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === h.childNodes.length), z.parseHTML = function (t, e, n) {
        return "string" != typeof t ? [] : ("boolean" == typeof e && (n = e, e = !1), e || (y.createHTMLDocument ? ((i = (e = C.implementation.createHTMLDocument("")).createElement("base")).href = C.location.href, e.head.appendChild(i)) : e = C), i = !n && [], (n = k.exec(t)) ? [e.createElement(n[1])] : (n = vt([t], e, i), i && i.length && z(i).remove(), z.merge([], n.childNodes)));
        var i
    }, z.fn.load = function (t, e, n) {
        var i, o, r, s = this, a = t.indexOf(" ");
        return -1 < a && (i = _e(t.slice(a)), t = t.slice(0, a)), w(e) ? (n = e, e = void 0) : e && "object" == typeof e && (o = "POST"), 0 < s.length && z.ajax({
            url: t,
            type: o || "GET",
            dataType: "html",
            data: e
        }).done(function (t) {
            r = arguments, s.html(i ? z("<div>").append(z.parseHTML(t)).find(i) : t)
        }).always(n && function (t, e) {
            s.each(function () {
                n.apply(this, r || [t.responseText, e, t])
            })
        }), this
    }, z.expr.pseudos.animated = function (e) {
        return z.grep(z.timers, function (t) {
            return e === t.elem
        }).length
    }, z.offset = {
        setOffset: function (t, e, n) {
            var i, o, r, s, a = z.css(t, "position"), l = z(t), u = {};
            "static" === a && (t.style.position = "relative"), r = l.offset(), i = z.css(t, "top"), s = z.css(t, "left"), s = ("absolute" === a || "fixed" === a) && -1 < (i + s).indexOf("auto") ? (o = (a = l.position()).top, a.left) : (o = parseFloat(i) || 0, parseFloat(s) || 0), null != (e = w(e) ? e.call(t, n, z.extend({}, r)) : e).top && (u.top = e.top - r.top + o), null != e.left && (u.left = e.left - r.left + s), "using" in e ? e.using.call(t, u) : ("number" == typeof u.top && (u.top += "px"), "number" == typeof u.left && (u.left += "px"), l.css(u))
        }
    }, z.fn.extend({
        offset: function (e) {
            if (arguments.length) return void 0 === e ? this : this.each(function (t) {
                z.offset.setOffset(this, e, t)
            });
            var t, n = this[0];
            return n ? n.getClientRects().length ? (t = n.getBoundingClientRect(), n = n.ownerDocument.defaultView, {
                top: t.top + n.pageYOffset,
                left: t.left + n.pageXOffset
            }) : {top: 0, left: 0} : void 0
        }, position: function () {
            if (this[0]) {
                var t, e, n, i = this[0], o = {top: 0, left: 0};
                if ("fixed" === z.css(i, "position")) e = i.getBoundingClientRect(); else {
                    for (e = this.offset(), n = i.ownerDocument, t = i.offsetParent || n.documentElement; t && (t === n.body || t === n.documentElement) && "static" === z.css(t, "position");) t = t.parentNode;
                    t && t !== i && 1 === t.nodeType && ((o = z(t).offset()).top += z.css(t, "borderTopWidth", !0), o.left += z.css(t, "borderLeftWidth", !0))
                }
                return {
                    top: e.top - o.top - z.css(i, "marginTop", !0),
                    left: e.left - o.left - z.css(i, "marginLeft", !0)
                }
            }
        }, offsetParent: function () {
            return this.map(function () {
                for (var t = this.offsetParent; t && "static" === z.css(t, "position");) t = t.offsetParent;
                return t || it
            })
        }
    }), z.each({scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function (e, o) {
        var r = "pageYOffset" === o;
        z.fn[e] = function (t) {
            return q(this, function (t, e, n) {
                var i;
                return m(t) ? i = t : 9 === t.nodeType && (i = t.defaultView), void 0 === n ? i ? i[o] : t[e] : void (i ? i.scrollTo(r ? i.pageXOffset : n, r ? n : i.pageYOffset) : t[e] = n)
            }, e, t, arguments.length)
        }
    }), z.each(["top", "left"], function (t, n) {
        z.cssHooks[n] = Xt(y.pixelPosition, function (t, e) {
            if (e) return e = Yt(t, n), Bt.test(e) ? z(t).position()[n] + "px" : e
        })
    }), z.each({Height: "height", Width: "width"}, function (s, a) {
        z.each({padding: "inner" + s, content: a, "": "outer" + s}, function (i, r) {
            z.fn[r] = function (t, e) {
                var n = arguments.length && (i || "boolean" != typeof t),
                    o = i || (!0 === t || !0 === e ? "margin" : "border");
                return q(this, function (t, e, n) {
                    var i;
                    return m(t) ? 0 === r.indexOf("outer") ? t["inner" + s] : t.document.documentElement["client" + s] : 9 === t.nodeType ? (i = t.documentElement, Math.max(t.body["scroll" + s], i["scroll" + s], t.body["offset" + s], i["offset" + s], i["client" + s])) : void 0 === n ? z.css(t, e, o) : z.style(t, e, n, o)
                }, a, n ? t : void 0, n)
            }
        })
    }), z.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, e) {
        z.fn[e] = function (t) {
            return this.on(e, t)
        }
    }), z.fn.extend({
        bind: function (t, e, n) {
            return this.on(t, null, e, n)
        }, unbind: function (t, e) {
            return this.off(t, null, e)
        }, delegate: function (t, e, n, i) {
            return this.on(e, t, n, i)
        }, undelegate: function (t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        }, hover: function (t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }), z.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (t, n) {
        z.fn[n] = function (t, e) {
            return 0 < arguments.length ? this.on(n, null, t, e) : this.trigger(n)
        }
    });
    var Je = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    z.proxy = function (t, e) {
        var n, i;
        if ("string" == typeof e && (i = t[e], e = t, t = i), w(t)) return n = a.call(arguments, 2), (i = function () {
            return t.apply(e || this, n.concat(a.call(arguments)))
        }).guid = t.guid = t.guid || z.guid++, i
    }, z.holdReady = function (t) {
        t ? z.readyWait++ : z.ready(!0)
    }, z.isArray = Array.isArray, z.parseJSON = JSON.parse, z.nodeName = E, z.isFunction = w, z.isWindow = m, z.camelCase = U, z.type = f, z.now = Date.now, z.isNumeric = function (t) {
        var e = z.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
    }, z.trim = function (t) {
        return null == t ? "" : (t + "").replace(Je, "")
    }, "function" == typeof define && define.amd && define("jquery", [], function () {
        return z
    });
    var Ke = _.jQuery, tn = _.$;
    return z.noConflict = function (t) {
        return _.$ === z && (_.$ = tn), t && _.jQuery === z && (_.jQuery = Ke), z
    }, void 0 === t && (_.jQuery = _.$ = z), z
}), function (t, e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function (t) {
        if (!t.document) throw new Error("jQuery requires a window with a document");
        return e(t)
    } : e(t)
}("undefined" != typeof window ? window : this, function (_, t) {
    "use strict";

    function m(t) {
        return null != t && t === t.window
    }

    var e = [], n = Object.getPrototypeOf, a = e.slice, g = e.flat ? function (t) {
            return e.flat.call(t)
        } : function (t) {
            return e.concat.apply([], t)
        }, l = e.push, o = e.indexOf, i = {}, r = i.toString, v = i.hasOwnProperty, s = v.toString, u = s.call(Object),
        y = {}, w = function (t) {
            return "function" == typeof t && "number" != typeof t.nodeType
        }, C = _.document, c = {type: !0, src: !0, nonce: !0, noModule: !0};

    function x(t, e, n) {
        var i, o, r = (n = n || C).createElement("script");
        if (r.text = t, e) for (i in c) (o = e[i] || e.getAttribute && e.getAttribute(i)) && r.setAttribute(i, o);
        n.head.appendChild(r).parentNode.removeChild(r)
    }

    function f(t) {
        return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? i[r.call(t)] || "object" : typeof t
    }

    var z = function (t, e) {
        return new z.fn.init(t, e)
    };

    function h(t) {
        var e = !!t && "length" in t && t.length, n = f(t);
        return !w(t) && !m(t) && ("array" === n || 0 === e || "number" == typeof e && 0 < e && e - 1 in t)
    }

    z.fn = z.prototype = {
        jquery: "3.5.1", constructor: z, length: 0, toArray: function () {
            return a.call(this)
        }, get: function (t) {
            return null == t ? a.call(this) : t < 0 ? this[t + this.length] : this[t]
        }, pushStack: function (t) {
            t = z.merge(this.constructor(), t);
            return t.prevObject = this, t
        }, each: function (t) {
            return z.each(this, t)
        }, map: function (n) {
            return this.pushStack(z.map(this, function (t, e) {
                return n.call(t, e, t)
            }))
        }, slice: function () {
            return this.pushStack(a.apply(this, arguments))
        }, first: function () {
            return this.eq(0)
        }, last: function () {
            return this.eq(-1)
        }, even: function () {
            return this.pushStack(z.grep(this, function (t, e) {
                return (e + 1) % 2
            }))
        }, odd: function () {
            return this.pushStack(z.grep(this, function (t, e) {
                return e % 2
            }))
        }, eq: function (t) {
            var e = this.length, t = +t + (t < 0 ? e : 0);
            return this.pushStack(0 <= t && t < e ? [this[t]] : [])
        }, end: function () {
            return this.prevObject || this.constructor()
        }, push: l, sort: e.sort, splice: e.splice
    }, z.extend = z.fn.extend = function () {
        var t, e, n, i, o, r = arguments[0] || {}, s = 1, a = arguments.length, l = !1;
        for ("boolean" == typeof r && (l = r, r = arguments[s] || {}, s++), "object" == typeof r || w(r) || (r = {}), s === a && (r = this, s--); s < a; s++) if (null != (t = arguments[s])) for (e in t) n = t[e], "__proto__" !== e && r !== n && (l && n && (z.isPlainObject(n) || (i = Array.isArray(n))) ? (o = r[e], o = i && !Array.isArray(o) ? [] : i || z.isPlainObject(o) ? o : {}, i = !1, r[e] = z.extend(l, o, n)) : void 0 !== n && (r[e] = n));
        return r
    }, z.extend({
        expando: "jQuery" + ("3.5.1" + Math.random()).replace(/\D/g, ""), isReady: !0, error: function (t) {
            throw new Error(t)
        }, noop: function () {
        }, isPlainObject: function (t) {
            return !(!t || "[object Object]" !== r.call(t) || (t = n(t)) && ("function" != typeof (t = v.call(t, "constructor") && t.constructor) || s.call(t) !== u))
        }, isEmptyObject: function (t) {
            for (var e in t) return !1;
            return !0
        }, globalEval: function (t, e, n) {
            x(t, {nonce: e && e.nonce}, n)
        }, each: function (t, e) {
            var n, i = 0;
            if (h(t)) for (n = t.length; i < n && !1 !== e.call(t[i], i, t[i]); i++) ; else for (i in t) if (!1 === e.call(t[i], i, t[i])) break;
            return t
        }, makeArray: function (t, e) {
            e = e || [];
            return null != t && (h(Object(t)) ? z.merge(e, "string" == typeof t ? [t] : t) : l.call(e, t)), e
        }, inArray: function (t, e, n) {
            return null == e ? -1 : o.call(e, t, n)
        }, merge: function (t, e) {
            for (var n = +e.length, i = 0, o = t.length; i < n; i++) t[o++] = e[i];
            return t.length = o, t
        }, grep: function (t, e, n) {
            for (var i = [], o = 0, r = t.length, s = !n; o < r; o++) !e(t[o], o) != s && i.push(t[o]);
            return i
        }, map: function (t, e, n) {
            var i, o, r = 0, s = [];
            if (h(t)) for (i = t.length; r < i; r++) null != (o = e(t[r], r, n)) && s.push(o); else for (r in t) null != (o = e(t[r], r, n)) && s.push(o);
            return g(s)
        }, guid: 1, support: y
    }), "function" == typeof Symbol && (z.fn[Symbol.iterator] = e[Symbol.iterator]), z.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (t, e) {
        i["[object " + e + "]"] = e.toLowerCase()
    });
    var p = function (n) {
        function h(t, e) {
            return t = "0x" + t.slice(1) - 65536, e || (t < 0 ? String.fromCharCode(65536 + t) : String.fromCharCode(t >> 10 | 55296, 1023 & t | 56320))
        }

        function i() {
            _()
        }

        var t, p, x, r, o, d, f, m, b, l, u, _, C, s, z, g, a, c, v, T = "sizzle" + +new Date, y = n.document, S = 0,
            w = 0, E = lt(), k = lt(), L = lt(), W = lt(), I = function (t, e) {
                return t === e && (u = !0), 0
            }, D = {}.hasOwnProperty, e = [], O = e.pop, A = e.push, j = e.push, H = e.slice, N = function (t, e) {
                for (var n = 0, i = t.length; n < i; n++) if (t[n] === e) return n;
                return -1
            },
            P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            M = "[\\x20\\t\\r\\n\\f]", R = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            $ = "\\[" + M + "*(" + R + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + M + "*\\]",
            q = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + $ + ")*)|.*)\\)|)",
            F = new RegExp(M + "+", "g"), B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
            Z = new RegExp("^" + M + "*," + M + "*"), U = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
            Y = new RegExp(M + "|>"), X = new RegExp(q), V = new RegExp("^" + R + "$"), G = {
                ID: new RegExp("^#(" + R + ")"),
                CLASS: new RegExp("^\\.(" + R + ")"),
                TAG: new RegExp("^(" + R + "|[*])"),
                ATTR: new RegExp("^" + $),
                PSEUDO: new RegExp("^" + q),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + P + ")$", "i"),
                needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i")
            }, Q = /HTML$/i, J = /^(?:input|select|textarea|button)$/i, K = /^h\d$/i, tt = /^[^{]+\{\s*\[native \w/,
            et = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, nt = /[+~]/,
            it = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
            ot = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, rt = function (t, e) {
                return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
            }, st = yt(function (t) {
                return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase()
            }, {dir: "parentNode", next: "legend"});
        try {
            j.apply(e = H.call(y.childNodes), y.childNodes), e[y.childNodes.length].nodeType
        } catch (t) {
            j = {
                apply: e.length ? function (t, e) {
                    A.apply(t, H.call(e))
                } : function (t, e) {
                    for (var n = t.length, i = 0; t[n++] = e[i++];) ;
                    t.length = n - 1
                }
            }
        }

        function at(t, e, n, i) {
            var o, r, s, a, l, u, c = e && e.ownerDocument, h = e ? e.nodeType : 9;
            if (n = n || [], "string" != typeof t || !t || 1 !== h && 9 !== h && 11 !== h) return n;
            if (!i && (_(e), e = e || C, z)) {
                if (11 !== h && (a = et.exec(t))) if (u = a[1]) {
                    if (9 === h) {
                        if (!(r = e.getElementById(u))) return n;
                        if (r.id === u) return n.push(r), n
                    } else if (c && (r = c.getElementById(u)) && v(e, r) && r.id === u) return n.push(r), n
                } else {
                    if (a[2]) return j.apply(n, e.getElementsByTagName(t)), n;
                    if ((u = a[3]) && p.getElementsByClassName && e.getElementsByClassName) return j.apply(n, e.getElementsByClassName(u)), n
                }
                if (p.qsa && !W[t + " "] && (!g || !g.test(t)) && (1 !== h || "object" !== e.nodeName.toLowerCase())) {
                    if (u = t, c = e, 1 === h && (Y.test(t) || U.test(t))) {
                        for ((c = nt.test(t) && mt(e.parentNode) || e) === e && p.scope || ((s = e.getAttribute("id")) ? s = s.replace(ot, rt) : e.setAttribute("id", s = T)), o = (l = d(t)).length; o--;) l[o] = (s ? "#" + s : ":scope") + " " + vt(l[o]);
                        u = l.join(",")
                    }
                    try {
                        return j.apply(n, c.querySelectorAll(u)), n
                    } catch (e) {
                        W(t, !0)
                    } finally {
                        s === T && e.removeAttribute("id")
                    }
                }
            }
            return m(t.replace(B, "$1"), e, n, i)
        }

        function lt() {
            var i = [];
            return function t(e, n) {
                return i.push(e + " ") > x.cacheLength && delete t[i.shift()], t[e + " "] = n
            }
        }

        function ut(t) {
            return t[T] = !0, t
        }

        function ct(t) {
            var e = C.createElement("fieldset");
            try {
                return !!t(e)
            } catch (t) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e), e = null
            }
        }

        function ht(t, e) {
            for (var n = t.split("|"), i = n.length; i--;) x.attrHandle[n[i]] = e
        }

        function pt(t, e) {
            var n = e && t, i = n && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
            if (i) return i;
            if (n) for (; n = n.nextSibling;) if (n === e) return -1;
            return t ? 1 : -1
        }

        function dt(e) {
            return function (t) {
                return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && st(t) === e : t.disabled === e : "label" in t && t.disabled === e
            }
        }

        function ft(s) {
            return ut(function (r) {
                return r = +r, ut(function (t, e) {
                    for (var n, i = s([], t.length, r), o = i.length; o--;) t[n = i[o]] && (t[n] = !(e[n] = t[n]))
                })
            })
        }

        function mt(t) {
            return t && void 0 !== t.getElementsByTagName && t
        }

        for (t in p = at.support = {}, o = at.isXML = function (t) {
            var e = t.namespaceURI, t = (t.ownerDocument || t).documentElement;
            return !Q.test(e || t && t.nodeName || "HTML")
        }, _ = at.setDocument = function (t) {
            var e, t = t ? t.ownerDocument || t : y;
            return t != C && 9 === t.nodeType && t.documentElement && (s = (C = t).documentElement, z = !o(C), y != C && (e = C.defaultView) && e.top !== e && (e.addEventListener ? e.addEventListener("unload", i, !1) : e.attachEvent && e.attachEvent("onunload", i)), p.scope = ct(function (t) {
                return s.appendChild(t).appendChild(C.createElement("div")), void 0 !== t.querySelectorAll && !t.querySelectorAll(":scope fieldset div").length
            }), p.attributes = ct(function (t) {
                return t.className = "i", !t.getAttribute("className")
            }), p.getElementsByTagName = ct(function (t) {
                return t.appendChild(C.createComment("")), !t.getElementsByTagName("*").length
            }), p.getElementsByClassName = tt.test(C.getElementsByClassName), p.getById = ct(function (t) {
                return s.appendChild(t).id = T, !C.getElementsByName || !C.getElementsByName(T).length
            }), p.getById ? (x.filter.ID = function (t) {
                var e = t.replace(it, h);
                return function (t) {
                    return t.getAttribute("id") === e
                }
            }, x.find.ID = function (t, e) {
                if (void 0 !== e.getElementById && z) {
                    t = e.getElementById(t);
                    return t ? [t] : []
                }
            }) : (x.filter.ID = function (t) {
                var e = t.replace(it, h);
                return function (t) {
                    t = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                    return t && t.value === e
                }
            }, x.find.ID = function (t, e) {
                if (void 0 !== e.getElementById && z) {
                    var n, i, o, r = e.getElementById(t);
                    if (r) {
                        if ((n = r.getAttributeNode("id")) && n.value === t) return [r];
                        for (o = e.getElementsByName(t), i = 0; r = o[i++];) if ((n = r.getAttributeNode("id")) && n.value === t) return [r]
                    }
                    return []
                }
            }), x.find.TAG = p.getElementsByTagName ? function (t, e) {
                return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : p.qsa ? e.querySelectorAll(t) : void 0
            } : function (t, e) {
                var n, i = [], o = 0, r = e.getElementsByTagName(t);
                if ("*" !== t) return r;
                for (; n = r[o++];) 1 === n.nodeType && i.push(n);
                return i
            }, x.find.CLASS = p.getElementsByClassName && function (t, e) {
                if (void 0 !== e.getElementsByClassName && z) return e.getElementsByClassName(t)
            }, a = [], g = [], (p.qsa = tt.test(C.querySelectorAll)) && (ct(function (t) {
                var e;
                s.appendChild(t).innerHTML = "<a id='" + T + "'></a><select id='" + T + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + M + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || g.push("\\[" + M + "*(?:value|" + P + ")"), t.querySelectorAll("[id~=" + T + "-]").length || g.push("~="), (e = C.createElement("input")).setAttribute("name", ""), t.appendChild(e), t.querySelectorAll("[name='']").length || g.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"), t.querySelectorAll(":checked").length || g.push(":checked"), t.querySelectorAll("a#" + T + "+*").length || g.push(".#.+[+~]"), t.querySelectorAll("\\\f"), g.push("[\\r\\n\\f]")
            }), ct(function (t) {
                t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var e = C.createElement("input");
                e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && g.push("name" + M + "*[*^$|!~]?="), 2 !== t.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), s.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), g.push(",.*:")
            })), (p.matchesSelector = tt.test(c = s.matches || s.webkitMatchesSelector || s.mozMatchesSelector || s.oMatchesSelector || s.msMatchesSelector)) && ct(function (t) {
                p.disconnectedMatch = c.call(t, "*"), c.call(t, "[s!='']:x"), a.push("!=", q)
            }), g = g.length && new RegExp(g.join("|")), a = a.length && new RegExp(a.join("|")), e = tt.test(s.compareDocumentPosition), v = e || tt.test(s.contains) ? function (t, e) {
                var n = 9 === t.nodeType ? t.documentElement : t, e = e && e.parentNode;
                return t === e || !(!e || 1 !== e.nodeType || !(n.contains ? n.contains(e) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(e)))
            } : function (t, e) {
                if (e) for (; e = e.parentNode;) if (e === t) return !0;
                return !1
            }, I = e ? function (t, e) {
                if (t === e) return u = !0, 0;
                var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                return n || (1 & (n = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !p.sortDetached && e.compareDocumentPosition(t) === n ? t == C || t.ownerDocument == y && v(y, t) ? -1 : e == C || e.ownerDocument == y && v(y, e) ? 1 : l ? N(l, t) - N(l, e) : 0 : 4 & n ? -1 : 1)
            } : function (t, e) {
                if (t === e) return u = !0, 0;
                var n, i = 0, o = t.parentNode, r = e.parentNode, s = [t], a = [e];
                if (!o || !r) return t == C ? -1 : e == C ? 1 : o ? -1 : r ? 1 : l ? N(l, t) - N(l, e) : 0;
                if (o === r) return pt(t, e);
                for (n = t; n = n.parentNode;) s.unshift(n);
                for (n = e; n = n.parentNode;) a.unshift(n);
                for (; s[i] === a[i];) i++;
                return i ? pt(s[i], a[i]) : s[i] == y ? -1 : a[i] == y ? 1 : 0
            }), C
        }, at.matches = function (t, e) {
            return at(t, null, null, e)
        }, at.matchesSelector = function (t, e) {
            if (_(t), p.matchesSelector && z && !W[e + " "] && (!a || !a.test(e)) && (!g || !g.test(e))) try {
                var n = c.call(t, e);
                if (n || p.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n
            } catch (t) {
                W(e, !0)
            }
            return 0 < at(e, C, null, [t]).length
        }, at.contains = function (t, e) {
            return (t.ownerDocument || t) != C && _(t), v(t, e)
        }, at.attr = function (t, e) {
            (t.ownerDocument || t) != C && _(t);
            var n = x.attrHandle[e.toLowerCase()],
                n = n && D.call(x.attrHandle, e.toLowerCase()) ? n(t, e, !z) : void 0;
            return void 0 !== n ? n : p.attributes || !z ? t.getAttribute(e) : (n = t.getAttributeNode(e)) && n.specified ? n.value : null
        }, at.escape = function (t) {
            return (t + "").replace(ot, rt)
        }, at.error = function (t) {
            throw new Error("Syntax error, unrecognized expression: " + t)
        }, at.uniqueSort = function (t) {
            var e, n = [], i = 0, o = 0;
            if (u = !p.detectDuplicates, l = !p.sortStable && t.slice(0), t.sort(I), u) {
                for (; e = t[o++];) e === t[o] && (i = n.push(o));
                for (; i--;) t.splice(n[i], 1)
            }
            return l = null, t
        }, r = at.getText = function (t) {
            var e, n = "", i = 0, o = t.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof t.textContent) return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling) n += r(t)
                } else if (3 === o || 4 === o) return t.nodeValue
            } else for (; e = t[i++];) n += r(e);
            return n
        }, (x = at.selectors = {
            cacheLength: 50,
            createPseudo: ut,
            match: G,
            attrHandle: {},
            find: {},
            relative: {
                ">": {dir: "parentNode", first: !0},
                " ": {dir: "parentNode"},
                "+": {dir: "previousSibling", first: !0},
                "~": {dir: "previousSibling"}
            },
            preFilter: {
                ATTR: function (t) {
                    return t[1] = t[1].replace(it, h), t[3] = (t[3] || t[4] || t[5] || "").replace(it, h), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                }, CHILD: function (t) {
                    return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || at.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && at.error(t[0]), t
                }, PSEUDO: function (t) {
                    var e, n = !t[6] && t[2];
                    return G.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && X.test(n) && (e = d(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3))
                }
            },
            filter: {
                TAG: function (t) {
                    var e = t.replace(it, h).toLowerCase();
                    return "*" === t ? function () {
                        return !0
                    } : function (t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e
                    }
                }, CLASS: function (t) {
                    var e = E[t + " "];
                    return e || (e = new RegExp("(^|" + M + ")" + t + "(" + M + "|$)")) && E(t, function (t) {
                        return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                    })
                }, ATTR: function (e, n, i) {
                    return function (t) {
                        t = at.attr(t, e);
                        return null == t ? "!=" === n : !n || (t += "", "=" === n ? t === i : "!=" === n ? t !== i : "^=" === n ? i && 0 === t.indexOf(i) : "*=" === n ? i && -1 < t.indexOf(i) : "$=" === n ? i && t.slice(-i.length) === i : "~=" === n ? -1 < (" " + t.replace(F, " ") + " ").indexOf(i) : "|=" === n && (t === i || t.slice(0, i.length + 1) === i + "-"))
                    }
                }, CHILD: function (f, t, e, m, g) {
                    var v = "nth" !== f.slice(0, 3), y = "last" !== f.slice(-4), w = "of-type" === t;
                    return 1 === m && 0 === g ? function (t) {
                        return !!t.parentNode
                    } : function (t, e, n) {
                        var i, o, r, s, a, l, u = v != y ? "nextSibling" : "previousSibling", c = t.parentNode,
                            h = w && t.nodeName.toLowerCase(), p = !n && !w, d = !1;
                        if (c) {
                            if (v) {
                                for (; u;) {
                                    for (s = t; s = s[u];) if (w ? s.nodeName.toLowerCase() === h : 1 === s.nodeType) return !1;
                                    l = u = "only" === f && !l && "nextSibling"
                                }
                                return !0
                            }
                            if (l = [y ? c.firstChild : c.lastChild], y && p) {
                                for (d = (a = (i = (o = (r = (s = c)[T] || (s[T] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[f] || [])[0] === S && i[1]) && i[2], s = a && c.childNodes[a]; s = ++a && s && s[u] || (d = a = 0) || l.pop();) if (1 === s.nodeType && ++d && s === t) {
                                    o[f] = [S, a, d];
                                    break
                                }
                            } else if (!1 === (d = p ? a = (i = (o = (r = (s = t)[T] || (s[T] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[f] || [])[0] === S && i[1] : d)) for (; (s = ++a && s && s[u] || (d = a = 0) || l.pop()) && ((w ? s.nodeName.toLowerCase() !== h : 1 !== s.nodeType) || !++d || (p && ((o = (r = s[T] || (s[T] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[f] = [S, d]), s !== t));) ;
                            return (d -= g) === m || d % m == 0 && 0 <= d / m
                        }
                    }
                }, PSEUDO: function (t, r) {
                    var e, s = x.pseudos[t] || x.setFilters[t.toLowerCase()] || at.error("unsupported pseudo: " + t);
                    return s[T] ? s(r) : 1 < s.length ? (e = [t, t, "", r], x.setFilters.hasOwnProperty(t.toLowerCase()) ? ut(function (t, e) {
                        for (var n, i = s(t, r), o = i.length; o--;) t[n = N(t, i[o])] = !(e[n] = i[o])
                    }) : function (t) {
                        return s(t, 0, e)
                    }) : s
                }
            },
            pseudos: {
                not: ut(function (t) {
                    var i = [], o = [], a = f(t.replace(B, "$1"));
                    return a[T] ? ut(function (t, e, n, i) {
                        for (var o, r = a(t, null, i, []), s = t.length; s--;) (o = r[s]) && (t[s] = !(e[s] = o))
                    }) : function (t, e, n) {
                        return i[0] = t, a(i, null, n, o), i[0] = null, !o.pop()
                    }
                }), has: ut(function (e) {
                    return function (t) {
                        return 0 < at(e, t).length
                    }
                }), contains: ut(function (e) {
                    return e = e.replace(it, h), function (t) {
                        return -1 < (t.textContent || r(t)).indexOf(e)
                    }
                }), lang: ut(function (n) {
                    return V.test(n || "") || at.error("unsupported lang: " + n), n = n.replace(it, h).toLowerCase(), function (t) {
                        var e;
                        do {
                            if (e = z ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (e = e.toLowerCase()) === n || 0 === e.indexOf(n + "-")
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1
                    }
                }), target: function (t) {
                    var e = n.location && n.location.hash;
                    return e && e.slice(1) === t.id
                }, root: function (t) {
                    return t === s
                }, focus: function (t) {
                    return t === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                }, enabled: dt(!1), disabled: dt(!0), checked: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && !!t.checked || "option" === e && !!t.selected
                }, selected: function (t) {
                    return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                }, empty: function (t) {
                    for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
                    return !0
                }, parent: function (t) {
                    return !x.pseudos.empty(t)
                }, header: function (t) {
                    return K.test(t.nodeName)
                }, input: function (t) {
                    return J.test(t.nodeName)
                }, button: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && "button" === t.type || "button" === e
                }, text: function (t) {
                    return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (t = t.getAttribute("type")) || "text" === t.toLowerCase())
                }, first: ft(function () {
                    return [0]
                }), last: ft(function (t, e) {
                    return [e - 1]
                }), eq: ft(function (t, e, n) {
                    return [n < 0 ? n + e : n]
                }), even: ft(function (t, e) {
                    for (var n = 0; n < e; n += 2) t.push(n);
                    return t
                }), odd: ft(function (t, e) {
                    for (var n = 1; n < e; n += 2) t.push(n);
                    return t
                }), lt: ft(function (t, e, n) {
                    for (var i = n < 0 ? n + e : e < n ? e : n; 0 <= --i;) t.push(i);
                    return t
                }), gt: ft(function (t, e, n) {
                    for (var i = n < 0 ? n + e : n; ++i < e;) t.push(i);
                    return t
                })
            }
        }).pseudos.nth = x.pseudos.eq, {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        }) x.pseudos[t] = function (e) {
            return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }(t);
        for (t in {submit: !0, reset: !0}) x.pseudos[t] = function (n) {
            return function (t) {
                var e = t.nodeName.toLowerCase();
                return ("input" === e || "button" === e) && t.type === n
            }
        }(t);

        function gt() {
        }

        function vt(t) {
            for (var e = 0, n = t.length, i = ""; e < n; e++) i += t[e].value;
            return i
        }

        function yt(s, t, e) {
            var a = t.dir, l = t.next, u = l || a, c = e && "parentNode" === u, h = w++;
            return t.first ? function (t, e, n) {
                for (; t = t[a];) if (1 === t.nodeType || c) return s(t, e, n);
                return !1
            } : function (t, e, n) {
                var i, o, r = [S, h];
                if (n) {
                    for (; t = t[a];) if ((1 === t.nodeType || c) && s(t, e, n)) return !0
                } else for (; t = t[a];) if (1 === t.nodeType || c) if (i = (o = t[T] || (t[T] = {}))[t.uniqueID] || (o[t.uniqueID] = {}), l && l === t.nodeName.toLowerCase()) t = t[a] || t; else {
                    if ((o = i[u]) && o[0] === S && o[1] === h) return r[2] = o[2];
                    if ((i[u] = r)[2] = s(t, e, n)) return !0
                }
                return !1
            }
        }

        function wt(o) {
            return 1 < o.length ? function (t, e, n) {
                for (var i = o.length; i--;) if (!o[i](t, e, n)) return !1;
                return !0
            } : o[0]
        }

        function xt(t, e, n, i, o) {
            for (var r, s = [], a = 0, l = t.length, u = null != e; a < l; a++) (r = t[a]) && (n && !n(r, i, o) || (s.push(r), u && e.push(a)));
            return s
        }

        function bt(t) {
            for (var i, e, n, o = t.length, r = x.relative[t[0].type], s = r || x.relative[" "], a = r ? 1 : 0, l = yt(function (t) {
                return t === i
            }, s, !0), u = yt(function (t) {
                return -1 < N(i, t)
            }, s, !0), c = [function (t, e, n) {
                n = !r && (n || e !== b) || ((i = e).nodeType ? l : u)(t, e, n);
                return i = null, n
            }]; a < o; a++) if (e = x.relative[t[a].type]) c = [yt(wt(c), e)]; else {
                if ((e = x.filter[t[a].type].apply(null, t[a].matches))[T]) {
                    for (n = ++a; n < o && !x.relative[t[n].type]; n++) ;
                    return function t(d, f, m, g, v, e) {
                        return g && !g[T] && (g = t(g)), v && !v[T] && (v = t(v, e)), ut(function (t, e, n, i) {
                            var o, r, s, a = [], l = [], u = e.length, c = t || function (t, e, n) {
                                    for (var i = 0, o = e.length; i < o; i++) at(t, e[i], n);
                                    return n
                                }(f || "*", n.nodeType ? [n] : n, []), h = !d || !t && f ? c : xt(c, a, d, n, i),
                                p = m ? v || (t ? d : u || g) ? [] : e : h;
                            if (m && m(h, p, n, i), g) for (o = xt(p, l), g(o, [], n, i), r = o.length; r--;) (s = o[r]) && (p[l[r]] = !(h[l[r]] = s));
                            if (t) {
                                if (v || d) {
                                    if (v) {
                                        for (o = [], r = p.length; r--;) (s = p[r]) && o.push(h[r] = s);
                                        v(null, p = [], o, i)
                                    }
                                    for (r = p.length; r--;) (s = p[r]) && -1 < (o = v ? N(t, s) : a[r]) && (t[o] = !(e[o] = s))
                                }
                            } else p = xt(p === e ? p.splice(u, p.length) : p), v ? v(null, e, p, i) : j.apply(e, p)
                        })
                    }(1 < a && wt(c), 1 < a && vt(t.slice(0, a - 1).concat({value: " " === t[a - 2].type ? "*" : ""})).replace(B, "$1"), e, a < n && bt(t.slice(a, n)), n < o && bt(t = t.slice(n)), n < o && vt(t))
                }
                c.push(e)
            }
            return wt(c)
        }

        return gt.prototype = x.filters = x.pseudos, x.setFilters = new gt, d = at.tokenize = function (t, e) {
            var n, i, o, r, s, a, l, u = k[t + " "];
            if (u) return e ? 0 : u.slice(0);
            for (s = t, a = [], l = x.preFilter; s;) {
                for (r in n && !(i = Z.exec(s)) || (i && (s = s.slice(i[0].length) || s), a.push(o = [])), n = !1, (i = U.exec(s)) && (n = i.shift(), o.push({
                    value: n,
                    type: i[0].replace(B, " ")
                }), s = s.slice(n.length)), x.filter) !(i = G[r].exec(s)) || l[r] && !(i = l[r](i)) || (n = i.shift(), o.push({
                    value: n,
                    type: r,
                    matches: i
                }), s = s.slice(n.length));
                if (!n) break
            }
            return e ? s.length : s ? at.error(t) : k(t, a).slice(0)
        }, f = at.compile = function (t, e) {
            var n, g, v, y, w, i, o = [], r = [], s = L[t + " "];
            if (!s) {
                for (n = (e = e || d(t)).length; n--;) ((s = bt(e[n]))[T] ? o : r).push(s);
                (s = L(t, (y = 0 < (v = o).length, w = 0 < (g = r).length, i = function (t, e, n, i, o) {
                    var r, s, a, l = 0, u = "0", c = t && [], h = [], p = b, d = t || w && x.find.TAG("*", o),
                        f = S += null == p ? 1 : Math.random() || .1, m = d.length;
                    for (o && (b = e == C || e || o); u !== m && null != (r = d[u]); u++) {
                        if (w && r) {
                            for (s = 0, e || r.ownerDocument == C || (_(r), n = !z); a = g[s++];) if (a(r, e || C, n)) {
                                i.push(r);
                                break
                            }
                            o && (S = f)
                        }
                        y && ((r = !a && r) && l--, t && c.push(r))
                    }
                    if (l += u, y && u !== l) {
                        for (s = 0; a = v[s++];) a(c, h, e, n);
                        if (t) {
                            if (0 < l) for (; u--;) c[u] || h[u] || (h[u] = O.call(i));
                            h = xt(h)
                        }
                        j.apply(i, h), o && !t && 0 < h.length && 1 < l + v.length && at.uniqueSort(i)
                    }
                    return o && (S = f, b = p), c
                }, y ? ut(i) : i))).selector = t
            }
            return s
        }, m = at.select = function (t, e, n, i) {
            var o, r, s, a, l, u = "function" == typeof t && t, c = !i && d(t = u.selector || t);
            if (n = n || [], 1 === c.length) {
                if (2 < (r = c[0] = c[0].slice(0)).length && "ID" === (s = r[0]).type && 9 === e.nodeType && z && x.relative[r[1].type]) {
                    if (!(e = (x.find.ID(s.matches[0].replace(it, h), e) || [])[0])) return n;
                    u && (e = e.parentNode), t = t.slice(r.shift().value.length)
                }
                for (o = G.needsContext.test(t) ? 0 : r.length; o-- && (s = r[o], !x.relative[a = s.type]);) if ((l = x.find[a]) && (i = l(s.matches[0].replace(it, h), nt.test(r[0].type) && mt(e.parentNode) || e))) {
                    if (r.splice(o, 1), !(t = i.length && vt(r))) return j.apply(n, i), n;
                    break
                }
            }
            return (u || f(t, c))(i, e, !z, n, !e || nt.test(t) && mt(e.parentNode) || e), n
        }, p.sortStable = T.split("").sort(I).join("") === T, p.detectDuplicates = !!u, _(), p.sortDetached = ct(function (t) {
            return 1 & t.compareDocumentPosition(C.createElement("fieldset"))
        }), ct(function (t) {
            return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
        }) || ht("type|href|height|width", function (t, e, n) {
            if (!n) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }), p.attributes && ct(function (t) {
            return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
        }) || ht("value", function (t, e, n) {
            if (!n && "input" === t.nodeName.toLowerCase()) return t.defaultValue
        }), ct(function (t) {
            return null == t.getAttribute("disabled")
        }) || ht(P, function (t, e, n) {
            if (!n) return !0 === t[e] ? e.toLowerCase() : (e = t.getAttributeNode(e)) && e.specified ? e.value : null
        }), at
    }(_);
    z.find = p, z.expr = p.selectors, z.expr[":"] = z.expr.pseudos, z.uniqueSort = z.unique = p.uniqueSort, z.text = p.getText, z.isXMLDoc = p.isXML, z.contains = p.contains, z.escapeSelector = p.escape;

    function d(t, e, n) {
        for (var i = [], o = void 0 !== n; (t = t[e]) && 9 !== t.nodeType;) if (1 === t.nodeType) {
            if (o && z(t).is(n)) break;
            i.push(t)
        }
        return i
    }

    function b(t, e) {
        for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
        return n
    }

    var T = z.expr.match.needsContext;

    function S(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
    }

    var E = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function k(t, n, i) {
        return w(n) ? z.grep(t, function (t, e) {
            return !!n.call(t, e, t) !== i
        }) : n.nodeType ? z.grep(t, function (t) {
            return t === n !== i
        }) : "string" != typeof n ? z.grep(t, function (t) {
            return -1 < o.call(n, t) !== i
        }) : z.filter(n, t, i)
    }

    z.filter = function (t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === i.nodeType ? z.find.matchesSelector(i, t) ? [i] : [] : z.find.matches(t, z.grep(e, function (t) {
            return 1 === t.nodeType
        }))
    }, z.fn.extend({
        find: function (t) {
            var e, n, i = this.length, o = this;
            if ("string" != typeof t) return this.pushStack(z(t).filter(function () {
                for (e = 0; e < i; e++) if (z.contains(o[e], this)) return !0
            }));
            for (n = this.pushStack([]), e = 0; e < i; e++) z.find(t, o[e], n);
            return 1 < i ? z.uniqueSort(n) : n
        }, filter: function (t) {
            return this.pushStack(k(this, t || [], !1))
        }, not: function (t) {
            return this.pushStack(k(this, t || [], !0))
        }, is: function (t) {
            return !!k(this, "string" == typeof t && T.test(t) ? z(t) : t || [], !1).length
        }
    });
    var L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (z.fn.init = function (t, e, n) {
        if (!t) return this;
        if (n = n || W, "string" != typeof t) return t.nodeType ? (this[0] = t, this.length = 1, this) : w(t) ? void 0 !== n.ready ? n.ready(t) : t(z) : z.makeArray(t, this);
        if (!(i = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : L.exec(t)) || !i[1] && e) return (!e || e.jquery ? e || n : this.constructor(e)).find(t);
        if (i[1]) {
            if (e = e instanceof z ? e[0] : e, z.merge(this, z.parseHTML(i[1], e && e.nodeType ? e.ownerDocument || e : C, !0)), E.test(i[1]) && z.isPlainObject(e)) for (var i in e) w(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
            return this
        }
        return (t = C.getElementById(i[2])) && (this[0] = t, this.length = 1), this
    }).prototype = z.fn;
    var W = z(C), I = /^(?:parents|prev(?:Until|All))/, D = {children: !0, contents: !0, next: !0, prev: !0};

    function O(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType;) ;
        return t
    }

    z.fn.extend({
        has: function (t) {
            var e = z(t, this), n = e.length;
            return this.filter(function () {
                for (var t = 0; t < n; t++) if (z.contains(this, e[t])) return !0
            })
        }, closest: function (t, e) {
            var n, i = 0, o = this.length, r = [], s = "string" != typeof t && z(t);
            if (!T.test(t)) for (; i < o; i++) for (n = this[i]; n && n !== e; n = n.parentNode) if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && z.find.matchesSelector(n, t))) {
                r.push(n);
                break
            }
            return this.pushStack(1 < r.length ? z.uniqueSort(r) : r)
        }, index: function (t) {
            return t ? "string" == typeof t ? o.call(z(t), this[0]) : o.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        }, add: function (t, e) {
            return this.pushStack(z.uniqueSort(z.merge(this.get(), z(t, e))))
        }, addBack: function (t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }), z.each({
        parent: function (t) {
            t = t.parentNode;
            return t && 11 !== t.nodeType ? t : null
        }, parents: function (t) {
            return d(t, "parentNode")
        }, parentsUntil: function (t, e, n) {
            return d(t, "parentNode", n)
        }, next: function (t) {
            return O(t, "nextSibling")
        }, prev: function (t) {
            return O(t, "previousSibling")
        }, nextAll: function (t) {
            return d(t, "nextSibling")
        }, prevAll: function (t) {
            return d(t, "previousSibling")
        }, nextUntil: function (t, e, n) {
            return d(t, "nextSibling", n)
        }, prevUntil: function (t, e, n) {
            return d(t, "previousSibling", n)
        }, siblings: function (t) {
            return b((t.parentNode || {}).firstChild, t)
        }, children: function (t) {
            return b(t.firstChild)
        }, contents: function (t) {
            return null != t.contentDocument && n(t.contentDocument) ? t.contentDocument : (S(t, "template") && (t = t.content || t), z.merge([], t.childNodes))
        }
    }, function (i, o) {
        z.fn[i] = function (t, e) {
            var n = z.map(this, o, t);
            return (e = "Until" !== i.slice(-5) ? t : e) && "string" == typeof e && (n = z.filter(e, n)), 1 < this.length && (D[i] || z.uniqueSort(n), I.test(i) && n.reverse()), this.pushStack(n)
        }
    });
    var A = /[^\x20\t\r\n\f]+/g;

    function j(t) {
        return t
    }

    function H(t) {
        throw t
    }

    function N(t, e, n, i) {
        var o;
        try {
            t && w(o = t.promise) ? o.call(t).done(e).fail(n) : t && w(o = t.then) ? o.call(t, e, n) : e.apply(void 0, [t].slice(i))
        } catch (t) {
            n.apply(void 0, [t])
        }
    }

    z.Callbacks = function (i) {
        var n;
        i = "string" == typeof i ? (n = {}, z.each(i.match(A) || [], function (t, e) {
            n[e] = !0
        }), n) : z.extend({}, i);

        function o() {
            for (s = s || i.once, e = r = !0; l.length; u = -1) for (t = l.shift(); ++u < a.length;) !1 === a[u].apply(t[0], t[1]) && i.stopOnFalse && (u = a.length, t = !1);
            i.memory || (t = !1), r = !1, s && (a = t ? [] : "")
        }

        var r, t, e, s, a = [], l = [], u = -1, c = {
            add: function () {
                return a && (t && !r && (u = a.length - 1, l.push(t)), function n(t) {
                    z.each(t, function (t, e) {
                        w(e) ? i.unique && c.has(e) || a.push(e) : e && e.length && "string" !== f(e) && n(e)
                    })
                }(arguments), t && !r && o()), this
            }, remove: function () {
                return z.each(arguments, function (t, e) {
                    for (var n; -1 < (n = z.inArray(e, a, n));) a.splice(n, 1), n <= u && u--
                }), this
            }, has: function (t) {
                return t ? -1 < z.inArray(t, a) : 0 < a.length
            }, empty: function () {
                return a = a && [], this
            }, disable: function () {
                return s = l = [], a = t = "", this
            }, disabled: function () {
                return !a
            }, lock: function () {
                return s = l = [], t || r || (a = t = ""), this
            }, locked: function () {
                return !!s
            }, fireWith: function (t, e) {
                return s || (e = [t, (e = e || []).slice ? e.slice() : e], l.push(e), r || o()), this
            }, fire: function () {
                return c.fireWith(this, arguments), this
            }, fired: function () {
                return !!e
            }
        };
        return c
    }, z.extend({
        Deferred: function (t) {
            var r = [["notify", "progress", z.Callbacks("memory"), z.Callbacks("memory"), 2], ["resolve", "done", z.Callbacks("once memory"), z.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", z.Callbacks("once memory"), z.Callbacks("once memory"), 1, "rejected"]],
                o = "pending", s = {
                    state: function () {
                        return o
                    }, always: function () {
                        return a.done(arguments).fail(arguments), this
                    }, catch: function (t) {
                        return s.then(null, t)
                    }, pipe: function () {
                        var o = arguments;
                        return z.Deferred(function (i) {
                            z.each(r, function (t, e) {
                                var n = w(o[e[4]]) && o[e[4]];
                                a[e[1]](function () {
                                    var t = n && n.apply(this, arguments);
                                    t && w(t.promise) ? t.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[e[0] + "With"](this, n ? [t] : arguments)
                                })
                            }), o = null
                        }).promise()
                    }, then: function (e, n, i) {
                        var l = 0;

                        function u(o, r, s, a) {
                            return function () {
                                function t() {
                                    var t, e;
                                    if (!(o < l)) {
                                        if ((t = s.apply(n, i)) === r.promise()) throw new TypeError("Thenable self-resolution");
                                        e = t && ("object" == typeof t || "function" == typeof t) && t.then, w(e) ? a ? e.call(t, u(l, r, j, a), u(l, r, H, a)) : (l++, e.call(t, u(l, r, j, a), u(l, r, H, a), u(l, r, j, r.notifyWith))) : (s !== j && (n = void 0, i = [t]), (a || r.resolveWith)(n, i))
                                    }
                                }

                                var n = this, i = arguments, e = a ? t : function () {
                                    try {
                                        t()
                                    } catch (t) {
                                        z.Deferred.exceptionHook && z.Deferred.exceptionHook(t, e.stackTrace), l <= o + 1 && (s !== H && (n = void 0, i = [t]), r.rejectWith(n, i))
                                    }
                                };
                                o ? e() : (z.Deferred.getStackHook && (e.stackTrace = z.Deferred.getStackHook()), _.setTimeout(e))
                            }
                        }

                        return z.Deferred(function (t) {
                            r[0][3].add(u(0, t, w(i) ? i : j, t.notifyWith)), r[1][3].add(u(0, t, w(e) ? e : j)), r[2][3].add(u(0, t, w(n) ? n : H))
                        }).promise()
                    }, promise: function (t) {
                        return null != t ? z.extend(t, s) : s
                    }
                }, a = {};
            return z.each(r, function (t, e) {
                var n = e[2], i = e[5];
                s[e[1]] = n.add, i && n.add(function () {
                    o = i
                }, r[3 - t][2].disable, r[3 - t][3].disable, r[0][2].lock, r[0][3].lock), n.add(e[3].fire), a[e[0]] = function () {
                    return a[e[0] + "With"](this === a ? void 0 : this, arguments), this
                }, a[e[0] + "With"] = n.fireWith
            }), s.promise(a), t && t.call(a, a), a
        }, when: function (t) {
            function e(e) {
                return function (t) {
                    o[e] = this, r[e] = 1 < arguments.length ? a.call(arguments) : t, --n || s.resolveWith(o, r)
                }
            }

            var n = arguments.length, i = n, o = Array(i), r = a.call(arguments), s = z.Deferred();
            if (n <= 1 && (N(t, s.done(e(i)).resolve, s.reject, !n), "pending" === s.state() || w(r[i] && r[i].then))) return s.then();
            for (; i--;) N(r[i], e(i), s.reject);
            return s.promise()
        }
    });
    var P = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    z.Deferred.exceptionHook = function (t, e) {
        _.console && _.console.warn && t && P.test(t.name) && _.console.warn("jQuery.Deferred exception: " + t.message, t.stack, e)
    }, z.readyException = function (t) {
        _.setTimeout(function () {
            throw t
        })
    };
    var M = z.Deferred();

    function R() {
        C.removeEventListener("DOMContentLoaded", R), _.removeEventListener("load", R), z.ready()
    }

    z.fn.ready = function (t) {
        return M.then(t).catch(function (t) {
            z.readyException(t)
        }), this
    }, z.extend({
        isReady: !1, readyWait: 1, ready: function (t) {
            (!0 === t ? --z.readyWait : z.isReady) || (z.isReady = !0) !== t && 0 < --z.readyWait || M.resolveWith(C, [z])
        }
    }), z.ready.then = M.then, "complete" === C.readyState || "loading" !== C.readyState && !C.documentElement.doScroll ? _.setTimeout(z.ready) : (C.addEventListener("DOMContentLoaded", R), _.addEventListener("load", R));
    var $ = function (t, e, n, i, o, r, s) {
        var a = 0, l = t.length, u = null == n;
        if ("object" === f(n)) for (a in o = !0, n) $(t, e, a, n[a], !0, r, s); else if (void 0 !== i && (o = !0, w(i) || (s = !0), e = u ? s ? (e.call(t, i), null) : (u = e, function (t, e, n) {
            return u.call(z(t), n)
        }) : e)) for (; a < l; a++) e(t[a], n, s ? i : i.call(t[a], a, e(t[a], n)));
        return o ? t : u ? e.call(t) : l ? e(t[0], n) : r
    }, q = /^-ms-/, F = /-([a-z])/g;

    function B(t, e) {
        return e.toUpperCase()
    }

    function Z(t) {
        return t.replace(q, "ms-").replace(F, B)
    }

    function U(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    }

    function Y() {
        this.expando = z.expando + Y.uid++
    }

    Y.uid = 1, Y.prototype = {
        cache: function (t) {
            var e = t[this.expando];
            return e || (e = {}, U(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))), e
        }, set: function (t, e, n) {
            var i, o = this.cache(t);
            if ("string" == typeof e) o[Z(e)] = n; else for (i in e) o[Z(i)] = e[i];
            return o
        }, get: function (t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][Z(e)]
        }, access: function (t, e, n) {
            return void 0 === e || e && "string" == typeof e && void 0 === n ? this.get(t, e) : (this.set(t, e, n), void 0 !== n ? n : e)
        }, remove: function (t, e) {
            var n, i = t[this.expando];
            if (void 0 !== i) {
                if (void 0 !== e) {
                    n = (e = Array.isArray(e) ? e.map(Z) : (e = Z(e)) in i ? [e] : e.match(A) || []).length;
                    for (; n--;) delete i[e[n]]
                }
                void 0 !== e && !z.isEmptyObject(i) || (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        }, hasData: function (t) {
            t = t[this.expando];
            return void 0 !== t && !z.isEmptyObject(t)
        }
    };
    var X = new Y, V = new Y, G = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, Q = /[A-Z]/g;

    function J(t, e, n) {
        var i, o;
        if (void 0 === n && 1 === t.nodeType) if (i = "data-" + e.replace(Q, "-$&").toLowerCase(), "string" == typeof (n = t.getAttribute(i))) {
            try {
                n = "true" === (o = n) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : G.test(o) ? JSON.parse(o) : o)
            } catch (t) {
            }
            V.set(t, e, n)
        } else n = void 0;
        return n
    }

    z.extend({
        hasData: function (t) {
            return V.hasData(t) || X.hasData(t)
        }, data: function (t, e, n) {
            return V.access(t, e, n)
        }, removeData: function (t, e) {
            V.remove(t, e)
        }, _data: function (t, e, n) {
            return X.access(t, e, n)
        }, _removeData: function (t, e) {
            X.remove(t, e)
        }
    }), z.fn.extend({
        data: function (n, t) {
            var e, i, o, r = this[0], s = r && r.attributes;
            if (void 0 !== n) return "object" == typeof n ? this.each(function () {
                V.set(this, n)
            }) : $(this, function (t) {
                var e;
                return r && void 0 === t ? void 0 !== (e = V.get(r, n)) || void 0 !== (e = J(r, n)) ? e : void 0 : void this.each(function () {
                    V.set(this, n, t)
                })
            }, null, t, 1 < arguments.length, null, !0);
            if (this.length && (o = V.get(r), 1 === r.nodeType && !X.get(r, "hasDataAttrs"))) {
                for (e = s.length; e--;) s[e] && 0 === (i = s[e].name).indexOf("data-") && (i = Z(i.slice(5)), J(r, i, o[i]));
                X.set(r, "hasDataAttrs", !0)
            }
            return o
        }, removeData: function (t) {
            return this.each(function () {
                V.remove(this, t)
            })
        }
    }), z.extend({
        queue: function (t, e, n) {
            var i;
            if (t) return i = X.get(t, e = (e || "fx") + "queue"), n && (!i || Array.isArray(n) ? i = X.access(t, e, z.makeArray(n)) : i.push(n)), i || []
        }, dequeue: function (t, e) {
            var n = z.queue(t, e = e || "fx"), i = n.length, o = n.shift(), r = z._queueHooks(t, e);
            "inprogress" === o && (o = n.shift(), i--), o && ("fx" === e && n.unshift("inprogress"), delete r.stop, o.call(t, function () {
                z.dequeue(t, e)
            }, r)), !i && r && r.empty.fire()
        }, _queueHooks: function (t, e) {
            var n = e + "queueHooks";
            return X.get(t, n) || X.access(t, n, {
                empty: z.Callbacks("once memory").add(function () {
                    X.remove(t, [e + "queue", n])
                })
            })
        }
    }), z.fn.extend({
        queue: function (e, n) {
            var t = 2;
            return "string" != typeof e && (n = e, e = "fx", t--), arguments.length < t ? z.queue(this[0], e) : void 0 === n ? this : this.each(function () {
                var t = z.queue(this, e, n);
                z._queueHooks(this, e), "fx" === e && "inprogress" !== t[0] && z.dequeue(this, e)
            })
        }, dequeue: function (t) {
            return this.each(function () {
                z.dequeue(this, t)
            })
        }, clearQueue: function (t) {
            return this.queue(t || "fx", [])
        }, promise: function (t, e) {
            function n() {
                --o || r.resolveWith(s, [s])
            }

            var i, o = 1, r = z.Deferred(), s = this, a = this.length;
            for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; a--;) (i = X.get(s[a], t + "queueHooks")) && i.empty && (o++, i.empty.add(n));
            return n(), r.promise(e)
        }
    });
    var K = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, tt = new RegExp("^(?:([+-])=|)(" + K + ")([a-z%]*)$", "i"),
        et = ["Top", "Right", "Bottom", "Left"], nt = C.documentElement, it = function (t) {
            return z.contains(t.ownerDocument, t)
        }, ot = {composed: !0};
    nt.getRootNode && (it = function (t) {
        return z.contains(t.ownerDocument, t) || t.getRootNode(ot) === t.ownerDocument
    });

    function rt(t, e) {
        return "none" === (t = e || t).style.display || "" === t.style.display && it(t) && "none" === z.css(t, "display")
    }

    function st(t, e, n, i) {
        var o, r, s = 20, a = i ? function () {
                return i.cur()
            } : function () {
                return z.css(t, e, "")
            }, l = a(), u = n && n[3] || (z.cssNumber[e] ? "" : "px"),
            c = t.nodeType && (z.cssNumber[e] || "px" !== u && +l) && tt.exec(z.css(t, e));
        if (c && c[3] !== u) {
            for (u = u || c[3], c = +(l /= 2) || 1; s--;) z.style(t, e, c + u), (1 - r) * (1 - (r = a() / l || .5)) <= 0 && (s = 0), c /= r;
            z.style(t, e, (c *= 2) + u), n = n || []
        }
        return n && (c = +c || +l || 0, o = n[1] ? c + (n[1] + 1) * n[2] : +n[2], i && (i.unit = u, i.start = c, i.end = o)), o
    }

    var at = {};

    function lt(t, e) {
        for (var n, i, o, r, s, a, l = [], u = 0, c = t.length; u < c; u++) (i = t[u]).style && (n = i.style.display, e ? ("none" === n && (l[u] = X.get(i, "display") || null, l[u] || (i.style.display = "")), "" === i.style.display && rt(i) && (l[u] = (a = r = o = void 0, r = i.ownerDocument, s = i.nodeName, (a = at[s]) || (o = r.body.appendChild(r.createElement(s)), a = z.css(o, "display"), o.parentNode.removeChild(o), at[s] = a = "none" === a ? "block" : a)))) : "none" !== n && (l[u] = "none", X.set(i, "display", n)));
        for (u = 0; u < c; u++) null != l[u] && (t[u].style.display = l[u]);
        return t
    }

    z.fn.extend({
        show: function () {
            return lt(this, !0)
        }, hide: function () {
            return lt(this)
        }, toggle: function (t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function () {
                rt(this) ? z(this).show() : z(this).hide()
            })
        }
    });
    var ut = /^(?:checkbox|radio)$/i, ct = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, ht = /^$|^module$|\/(?:java|ecma)script/i,
        pt = C.createDocumentFragment().appendChild(C.createElement("div"));
    (p = C.createElement("input")).setAttribute("type", "radio"), p.setAttribute("checked", "checked"), p.setAttribute("name", "t"), pt.appendChild(p), y.checkClone = pt.cloneNode(!0).cloneNode(!0).lastChild.checked, pt.innerHTML = "<textarea>x</textarea>", y.noCloneChecked = !!pt.cloneNode(!0).lastChild.defaultValue, pt.innerHTML = "<option></option>", y.option = !!pt.lastChild;
    var dt = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };

    function ft(t, e) {
        var n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
        return void 0 === e || e && S(t, e) ? z.merge([t], n) : n
    }

    function mt(t, e) {
        for (var n = 0, i = t.length; n < i; n++) X.set(t[n], "globalEval", !e || X.get(e[n], "globalEval"))
    }

    dt.tbody = dt.tfoot = dt.colgroup = dt.caption = dt.thead, dt.th = dt.td, y.option || (dt.optgroup = dt.option = [1, "<select multiple='multiple'>", "</select>"]);
    var gt = /<|&#?\w+;/;

    function vt(t, e, n, i, o) {
        for (var r, s, a, l, u, c = e.createDocumentFragment(), h = [], p = 0, d = t.length; p < d; p++) if ((r = t[p]) || 0 === r) if ("object" === f(r)) z.merge(h, r.nodeType ? [r] : r); else if (gt.test(r)) {
            for (s = s || c.appendChild(e.createElement("div")), a = (ct.exec(r) || ["", ""])[1].toLowerCase(), a = dt[a] || dt._default, s.innerHTML = a[1] + z.htmlPrefilter(r) + a[2], u = a[0]; u--;) s = s.lastChild;
            z.merge(h, s.childNodes), (s = c.firstChild).textContent = ""
        } else h.push(e.createTextNode(r));
        for (c.textContent = "", p = 0; r = h[p++];) if (i && -1 < z.inArray(r, i)) o && o.push(r); else if (l = it(r), s = ft(c.appendChild(r), "script"), l && mt(s), n) for (u = 0; r = s[u++];) ht.test(r.type || "") && n.push(r);
        return c
    }

    var yt = /^key/, wt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, xt = /^([^.]*)(?:\.(.+)|)/;

    function bt() {
        return !0
    }

    function _t() {
        return !1
    }

    function Ct(t, e) {
        return t === function () {
            try {
                return C.activeElement
            } catch (t) {
            }
        }() == ("focus" === e)
    }

    function zt(t, e, n, i, o, r) {
        var s, a;
        if ("object" == typeof e) {
            for (a in "string" != typeof n && (i = i || n, n = void 0), e) zt(t, a, n, i, e[a], r);
            return t
        }
        if (null == i && null == o ? (o = n, i = n = void 0) : null == o && ("string" == typeof n ? (o = i, i = void 0) : (o = i, i = n, n = void 0)), !1 === o) o = _t; else if (!o) return t;
        return 1 === r && (s = o, (o = function (t) {
            return z().off(t), s.apply(this, arguments)
        }).guid = s.guid || (s.guid = z.guid++)), t.each(function () {
            z.event.add(this, e, o, i, n)
        })
    }

    function Tt(t, o, r) {
        r ? (X.set(t, o, !1), z.event.add(t, o, {
            namespace: !1, handler: function (t) {
                var e, n, i = X.get(this, o);
                if (1 & t.isTrigger && this[o]) {
                    if (i.length) (z.event.special[o] || {}).delegateType && t.stopPropagation(); else if (i = a.call(arguments), X.set(this, o, i), e = r(this, o), this[o](), i !== (n = X.get(this, o)) || e ? X.set(this, o, !1) : n = {}, i !== n) return t.stopImmediatePropagation(), t.preventDefault(), n.value
                } else i.length && (X.set(this, o, {value: z.event.trigger(z.extend(i[0], z.Event.prototype), i.slice(1), this)}), t.stopImmediatePropagation())
            }
        })) : void 0 === X.get(t, o) && z.event.add(t, o, bt)
    }

    z.event = {
        global: {}, add: function (e, t, n, i, o) {
            var r, s, a, l, u, c, h, p, d, f = X.get(e);
            if (U(e)) for (n.handler && (n = (r = n).handler, o = r.selector), o && z.find.matchesSelector(nt, o), n.guid || (n.guid = z.guid++), (a = f.events) || (a = f.events = Object.create(null)), (s = f.handle) || (s = f.handle = function (t) {
                return void 0 !== z && z.event.triggered !== t.type ? z.event.dispatch.apply(e, arguments) : void 0
            }), l = (t = (t || "").match(A) || [""]).length; l--;) h = d = (u = xt.exec(t[l]) || [])[1], p = (u[2] || "").split(".").sort(), h && (c = z.event.special[h] || {}, h = (o ? c.delegateType : c.bindType) || h, c = z.event.special[h] || {}, u = z.extend({
                type: h,
                origType: d,
                data: i,
                handler: n,
                guid: n.guid,
                selector: o,
                needsContext: o && z.expr.match.needsContext.test(o),
                namespace: p.join(".")
            }, r), (d = a[h]) || ((d = a[h] = []).delegateCount = 0, c.setup && !1 !== c.setup.call(e, i, p, s) || e.addEventListener && e.addEventListener(h, s)), c.add && (c.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)), o ? d.splice(d.delegateCount++, 0, u) : d.push(u), z.event.global[h] = !0)
        }, remove: function (t, e, n, i, o) {
            var r, s, a, l, u, c, h, p, d, f, m, g = X.hasData(t) && X.get(t);
            if (g && (l = g.events)) {
                for (u = (e = (e || "").match(A) || [""]).length; u--;) if (d = m = (a = xt.exec(e[u]) || [])[1], f = (a[2] || "").split(".").sort(), d) {
                    for (h = z.event.special[d] || {}, p = l[d = (i ? h.delegateType : h.bindType) || d] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--;) c = p[r], !o && m !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (p.splice(r, 1), c.selector && p.delegateCount--, h.remove && h.remove.call(t, c));
                    s && !p.length && (h.teardown && !1 !== h.teardown.call(t, f, g.handle) || z.removeEvent(t, d, g.handle), delete l[d])
                } else for (d in l) z.event.remove(t, d + e[u], n, i, !0);
                z.isEmptyObject(l) && X.remove(t, "handle events")
            }
        }, dispatch: function (t) {
            var e, n, i, o, r, s = new Array(arguments.length), a = z.event.fix(t),
                l = (X.get(this, "events") || Object.create(null))[a.type] || [], t = z.event.special[a.type] || {};
            for (s[0] = a, e = 1; e < arguments.length; e++) s[e] = arguments[e];
            if (a.delegateTarget = this, !t.preDispatch || !1 !== t.preDispatch.call(this, a)) {
                for (r = z.event.handlers.call(this, a, l), e = 0; (i = r[e++]) && !a.isPropagationStopped();) for (a.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !a.isImmediatePropagationStopped();) a.rnamespace && !1 !== o.namespace && !a.rnamespace.test(o.namespace) || (a.handleObj = o, a.data = o.data, void 0 !== (o = ((z.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (a.result = o) && (a.preventDefault(), a.stopPropagation()));
                return t.postDispatch && t.postDispatch.call(this, a), a.result
            }
        }, handlers: function (t, e) {
            var n, i, o, r, s, a = [], l = e.delegateCount, u = t.target;
            if (l && u.nodeType && !("click" === t.type && 1 <= t.button)) for (; u !== this; u = u.parentNode || this) if (1 === u.nodeType && ("click" !== t.type || !0 !== u.disabled)) {
                for (r = [], s = {}, n = 0; n < l; n++) void 0 === s[o = (i = e[n]).selector + " "] && (s[o] = i.needsContext ? -1 < z(o, this).index(u) : z.find(o, this, null, [u]).length), s[o] && r.push(i);
                r.length && a.push({elem: u, handlers: r})
            }
            return u = this, l < e.length && a.push({elem: u, handlers: e.slice(l)}), a
        }, addProp: function (e, t) {
            Object.defineProperty(z.Event.prototype, e, {
                enumerable: !0, configurable: !0, get: w(t) ? function () {
                    if (this.originalEvent) return t(this.originalEvent)
                } : function () {
                    if (this.originalEvent) return this.originalEvent[e]
                }, set: function (t) {
                    Object.defineProperty(this, e, {enumerable: !0, configurable: !0, writable: !0, value: t})
                }
            })
        }, fix: function (t) {
            return t[z.expando] ? t : new z.Event(t)
        }, special: {
            load: {noBubble: !0}, click: {
                setup: function (t) {
                    t = this || t;
                    return ut.test(t.type) && t.click && S(t, "input") && Tt(t, "click", bt), !1
                }, trigger: function (t) {
                    t = this || t;
                    return ut.test(t.type) && t.click && S(t, "input") && Tt(t, "click"), !0
                }, _default: function (t) {
                    t = t.target;
                    return ut.test(t.type) && t.click && S(t, "input") && X.get(t, "click") || S(t, "a")
                }
            }, beforeunload: {
                postDispatch: function (t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    }, z.removeEvent = function (t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n)
    }, z.Event = function (t, e) {
        if (!(this instanceof z.Event)) return new z.Event(t, e);
        t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? bt : _t, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && z.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[z.expando] = !0
    }, z.Event.prototype = {
        constructor: z.Event,
        isDefaultPrevented: _t,
        isPropagationStopped: _t,
        isImmediatePropagationStopped: _t,
        isSimulated: !1,
        preventDefault: function () {
            var t = this.originalEvent;
            this.isDefaultPrevented = bt, t && !this.isSimulated && t.preventDefault()
        },
        stopPropagation: function () {
            var t = this.originalEvent;
            this.isPropagationStopped = bt, t && !this.isSimulated && t.stopPropagation()
        },
        stopImmediatePropagation: function () {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = bt, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
        }
    }, z.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (t) {
            var e = t.button;
            return null == t.which && yt.test(t.type) ? null != t.charCode ? t.charCode : t.keyCode : !t.which && void 0 !== e && wt.test(t.type) ? 1 & e ? 1 : 2 & e ? 3 : 4 & e ? 2 : 0 : t.which
        }
    }, z.event.addProp), z.each({focus: "focusin", blur: "focusout"}, function (t, e) {
        z.event.special[t] = {
            setup: function () {
                return Tt(this, t, Ct), !1
            }, trigger: function () {
                return Tt(this, t), !0
            }, delegateType: e
        }
    }), z.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function (t, o) {
        z.event.special[t] = {
            delegateType: o, bindType: o, handle: function (t) {
                var e, n = t.relatedTarget, i = t.handleObj;
                return n && (n === this || z.contains(this, n)) || (t.type = i.origType, e = i.handler.apply(this, arguments), t.type = o), e
            }
        }
    }), z.fn.extend({
        on: function (t, e, n, i) {
            return zt(this, t, e, n, i)
        }, one: function (t, e, n, i) {
            return zt(this, t, e, n, i, 1)
        }, off: function (t, e, n) {
            var i, o;
            if (t && t.preventDefault && t.handleObj) return i = t.handleObj, z(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" != typeof t) return !1 !== e && "function" != typeof e || (n = e, e = void 0), !1 === n && (n = _t), this.each(function () {
                z.event.remove(this, t, n, e)
            });
            for (o in t) this.off(o, e, t[o]);
            return this
        }
    });
    var St = /<script|<style|<link/i, Et = /checked\s*(?:[^=]|=\s*.checked.)/i,
        kt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function Lt(t, e) {
        return S(t, "table") && S(11 !== e.nodeType ? e : e.firstChild, "tr") && z(t).children("tbody")[0] || t
    }

    function Wt(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
    }

    function It(t) {
        return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t
    }

    function Dt(t, e) {
        var n, i, o, r;
        if (1 === e.nodeType) {
            if (X.hasData(t) && (r = X.get(t).events)) for (o in X.remove(e, "handle events"), r) for (n = 0, i = r[o].length; n < i; n++) z.event.add(e, o, r[o][n]);
            V.hasData(t) && (t = V.access(t), t = z.extend({}, t), V.set(e, t))
        }
    }

    function Ot(n, i, o, r) {
        i = g(i);
        var t, e, s, a, l, u, c = 0, h = n.length, p = h - 1, d = i[0], f = w(d);
        if (f || 1 < h && "string" == typeof d && !y.checkClone && Et.test(d)) return n.each(function (t) {
            var e = n.eq(t);
            f && (i[0] = d.call(this, t, e.html())), Ot(e, i, o, r)
        });
        if (h && (e = (t = vt(i, n[0].ownerDocument, !1, n, r)).firstChild, 1 === t.childNodes.length && (t = e), e || r)) {
            for (a = (s = z.map(ft(t, "script"), Wt)).length; c < h; c++) l = t, c !== p && (l = z.clone(l, !0, !0), a && z.merge(s, ft(l, "script"))), o.call(n[c], l, c);
            if (a) for (u = s[s.length - 1].ownerDocument, z.map(s, It), c = 0; c < a; c++) l = s[c], ht.test(l.type || "") && !X.access(l, "globalEval") && z.contains(u, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? z._evalUrl && !l.noModule && z._evalUrl(l.src, {nonce: l.nonce || l.getAttribute("nonce")}, u) : x(l.textContent.replace(kt, ""), l, u))
        }
        return n
    }

    function At(t, e, n) {
        for (var i, o = e ? z.filter(e, t) : t, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || z.cleanData(ft(i)), i.parentNode && (n && it(i) && mt(ft(i, "script")), i.parentNode.removeChild(i));
        return t
    }

    z.extend({
        htmlPrefilter: function (t) {
            return t
        }, clone: function (t, e, n) {
            var i, o, r, s, a, l, u, c = t.cloneNode(!0), h = it(t);
            if (!(y.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || z.isXMLDoc(t))) for (s = ft(c), i = 0, o = (r = ft(t)).length; i < o; i++) a = r[i], "input" === (u = (l = s[i]).nodeName.toLowerCase()) && ut.test(a.type) ? l.checked = a.checked : "input" !== u && "textarea" !== u || (l.defaultValue = a.defaultValue);
            if (e) if (n) for (r = r || ft(t), s = s || ft(c), i = 0, o = r.length; i < o; i++) Dt(r[i], s[i]); else Dt(t, c);
            return 0 < (s = ft(c, "script")).length && mt(s, !h && ft(t, "script")), c
        }, cleanData: function (t) {
            for (var e, n, i, o = z.event.special, r = 0; void 0 !== (n = t[r]); r++) if (U(n)) {
                if (e = n[X.expando]) {
                    if (e.events) for (i in e.events) o[i] ? z.event.remove(n, i) : z.removeEvent(n, i, e.handle);
                    n[X.expando] = void 0
                }
                n[V.expando] && (n[V.expando] = void 0)
            }
        }
    }), z.fn.extend({
        detach: function (t) {
            return At(this, t, !0)
        }, remove: function (t) {
            return At(this, t)
        }, text: function (t) {
            return $(this, function (t) {
                return void 0 === t ? z.text(this) : this.empty().each(function () {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        }, append: function () {
            return Ot(this, arguments, function (t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Lt(this, t).appendChild(t)
            })
        }, prepend: function () {
            return Ot(this, arguments, function (t) {
                var e;
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (e = Lt(this, t)).insertBefore(t, e.firstChild)
            })
        }, before: function () {
            return Ot(this, arguments, function (t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        }, after: function () {
            return Ot(this, arguments, function (t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        }, empty: function () {
            for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (z.cleanData(ft(t, !1)), t.textContent = "");
            return this
        }, clone: function (t, e) {
            return t = null != t && t, e = null == e ? t : e, this.map(function () {
                return z.clone(this, t, e)
            })
        }, html: function (t) {
            return $(this, function (t) {
                var e = this[0] || {}, n = 0, i = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if ("string" == typeof t && !St.test(t) && !dt[(ct.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = z.htmlPrefilter(t);
                    try {
                        for (; n < i; n++) 1 === (e = this[n] || {}).nodeType && (z.cleanData(ft(e, !1)), e.innerHTML = t);
                        e = 0
                    } catch (t) {
                    }
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        }, replaceWith: function () {
            var n = [];
            return Ot(this, arguments, function (t) {
                var e = this.parentNode;
                z.inArray(this, n) < 0 && (z.cleanData(ft(this)), e && e.replaceChild(t, this))
            }, n)
        }
    }), z.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function (t, s) {
        z.fn[t] = function (t) {
            for (var e, n = [], i = z(t), o = i.length - 1, r = 0; r <= o; r++) e = r === o ? this : this.clone(!0), z(i[r])[s](e), l.apply(n, e.get());
            return this.pushStack(n)
        }
    });

    function jt(t, e, n) {
        var i, o = {};
        for (i in e) o[i] = t.style[i], t.style[i] = e[i];
        for (i in n = n.call(t), e) t.style[i] = o[i];
        return n
    }

    var Ht, Nt, Pt, Mt, Rt, $t, qt, Ft, Bt = new RegExp("^(" + K + ")(?!px)[a-z%]+$", "i"), Zt = function (t) {
        var e = t.ownerDocument.defaultView;
        return (e = !e || !e.opener ? _ : e).getComputedStyle(t)
    }, Ut = new RegExp(et.join("|"), "i");

    function Yt(t, e, n) {
        var i, o, r = t.style;
        return (n = n || Zt(t)) && ("" !== (o = n.getPropertyValue(e) || n[e]) || it(t) || (o = z.style(t, e)), !y.pixelBoxStyles() && Bt.test(o) && Ut.test(e) && (i = r.width, t = r.minWidth, e = r.maxWidth, r.minWidth = r.maxWidth = r.width = o, o = n.width, r.width = i, r.minWidth = t, r.maxWidth = e)), void 0 !== o ? o + "" : o
    }

    function Xt(t, e) {
        return {
            get: function () {
                if (!t()) return (this.get = e).apply(this, arguments);
                delete this.get
            }
        }
    }

    function Vt() {
        var t;
        Ft && (qt.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Ft.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", nt.appendChild(qt).appendChild(Ft), t = _.getComputedStyle(Ft), Ht = "1%" !== t.top, $t = 12 === Gt(t.marginLeft), Ft.style.right = "60%", Mt = 36 === Gt(t.right), Nt = 36 === Gt(t.width), Ft.style.position = "absolute", Pt = 12 === Gt(Ft.offsetWidth / 3), nt.removeChild(qt), Ft = null)
    }

    function Gt(t) {
        return Math.round(parseFloat(t))
    }

    qt = C.createElement("div"), (Ft = C.createElement("div")).style && (Ft.style.backgroundClip = "content-box", Ft.cloneNode(!0).style.backgroundClip = "", y.clearCloneStyle = "content-box" === Ft.style.backgroundClip, z.extend(y, {
        boxSizingReliable: function () {
            return Vt(), Nt
        }, pixelBoxStyles: function () {
            return Vt(), Mt
        }, pixelPosition: function () {
            return Vt(), Ht
        }, reliableMarginLeft: function () {
            return Vt(), $t
        }, scrollboxSize: function () {
            return Vt(), Pt
        }, reliableTrDimensions: function () {
            var t, e, n;
            return null == Rt && (t = C.createElement("table"), n = C.createElement("tr"), e = C.createElement("div"), t.style.cssText = "position:absolute;left:-11111px", n.style.height = "1px", e.style.height = "9px", nt.appendChild(t).appendChild(n).appendChild(e), n = _.getComputedStyle(n), Rt = 3 < parseInt(n.height), nt.removeChild(t)), Rt
        }
    }));
    var Qt = ["Webkit", "Moz", "ms"], Jt = C.createElement("div").style, Kt = {};

    function te(t) {
        return z.cssProps[t] || Kt[t] || (t in Jt ? t : Kt[t] = function (t) {
            for (var e = t[0].toUpperCase() + t.slice(1), n = Qt.length; n--;) if ((t = Qt[n] + e) in Jt) return t
        }(t) || t)
    }

    var ee = /^(none|table(?!-c[ea]).+)/, ne = /^--/,
        ie = {position: "absolute", visibility: "hidden", display: "block"},
        oe = {letterSpacing: "0", fontWeight: "400"};

    function re(t, e, n) {
        var i = tt.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e
    }

    function se(t, e, n, i, o, r) {
        var s = "width" === e ? 1 : 0, a = 0, l = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; s < 4; s += 2) "margin" === n && (l += z.css(t, n + et[s], !0, o)), i ? ("content" === n && (l -= z.css(t, "padding" + et[s], !0, o)), "margin" !== n && (l -= z.css(t, "border" + et[s] + "Width", !0, o))) : (l += z.css(t, "padding" + et[s], !0, o), "padding" !== n ? l += z.css(t, "border" + et[s] + "Width", !0, o) : a += z.css(t, "border" + et[s] + "Width", !0, o));
        return !i && 0 <= r && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - r - l - a - .5)) || 0), l
    }

    function ae(t, e, n) {
        var i = Zt(t), o = (!y.boxSizingReliable() || n) && "border-box" === z.css(t, "boxSizing", !1, i), r = o,
            s = Yt(t, e, i), a = "offset" + e[0].toUpperCase() + e.slice(1);
        if (Bt.test(s)) {
            if (!n) return s;
            s = "auto"
        }
        return (!y.boxSizingReliable() && o || !y.reliableTrDimensions() && S(t, "tr") || "auto" === s || !parseFloat(s) && "inline" === z.css(t, "display", !1, i)) && t.getClientRects().length && (o = "border-box" === z.css(t, "boxSizing", !1, i), (r = a in t) && (s = t[a])), (s = parseFloat(s) || 0) + se(t, e, n || (o ? "border" : "content"), r, i, s) + "px"
    }

    function le(t, e, n, i, o) {
        return new le.prototype.init(t, e, n, i, o)
    }

    z.extend({
        cssHooks: {
            opacity: {
                get: function (t, e) {
                    if (e) {
                        t = Yt(t, "opacity");
                        return "" === t ? "1" : t
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function (t, e, n, i) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var o, r, s, a = Z(e), l = ne.test(e), u = t.style;
                if (l || (e = te(a)), s = z.cssHooks[e] || z.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (o = s.get(t, !1, i)) ? o : u[e];
                "string" == (r = typeof n) && (o = tt.exec(n)) && o[1] && (n = st(t, e, o), r = "number"), null != n && n == n && ("number" !== r || l || (n += o && o[3] || (z.cssNumber[a] ? "" : "px")), y.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (u[e] = "inherit"), s && "set" in s && void 0 === (n = s.set(t, n, i)) || (l ? u.setProperty(e, n) : u[e] = n))
            }
        },
        css: function (t, e, n, i) {
            var o, r = Z(e);
            return ne.test(e) || (e = te(r)), "normal" === (o = void 0 === (o = (r = z.cssHooks[e] || z.cssHooks[r]) && "get" in r ? r.get(t, !0, n) : o) ? Yt(t, e, i) : o) && e in oe && (o = oe[e]), "" === n || n ? (e = parseFloat(o), !0 === n || isFinite(e) ? e || 0 : o) : o
        }
    }), z.each(["height", "width"], function (t, a) {
        z.cssHooks[a] = {
            get: function (t, e, n) {
                if (e) return !ee.test(z.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? ae(t, a, n) : jt(t, ie, function () {
                    return ae(t, a, n)
                })
            }, set: function (t, e, n) {
                var i, o = Zt(t), r = !y.scrollboxSize() && "absolute" === o.position,
                    s = (r || n) && "border-box" === z.css(t, "boxSizing", !1, o), n = n ? se(t, a, n, s, o) : 0;
                return s && r && (n -= Math.ceil(t["offset" + a[0].toUpperCase() + a.slice(1)] - parseFloat(o[a]) - se(t, a, "border", !1, o) - .5)), n && (i = tt.exec(e)) && "px" !== (i[3] || "px") && (t.style[a] = e, e = z.css(t, a)), re(0, e, n)
            }
        }
    }), z.cssHooks.marginLeft = Xt(y.reliableMarginLeft, function (t, e) {
        if (e) return (parseFloat(Yt(t, "marginLeft")) || t.getBoundingClientRect().left - jt(t, {marginLeft: 0}, function () {
            return t.getBoundingClientRect().left
        })) + "px"
    }), z.each({margin: "", padding: "", border: "Width"}, function (o, r) {
        z.cssHooks[o + r] = {
            expand: function (t) {
                for (var e = 0, n = {}, i = "string" == typeof t ? t.split(" ") : [t]; e < 4; e++) n[o + et[e] + r] = i[e] || i[e - 2] || i[0];
                return n
            }
        }, "margin" !== o && (z.cssHooks[o + r].set = re)
    }), z.fn.extend({
        css: function (t, e) {
            return $(this, function (t, e, n) {
                var i, o, r = {}, s = 0;
                if (Array.isArray(e)) {
                    for (i = Zt(t), o = e.length; s < o; s++) r[e[s]] = z.css(t, e[s], !1, i);
                    return r
                }
                return void 0 !== n ? z.style(t, e, n) : z.css(t, e)
            }, t, e, 1 < arguments.length)
        }
    }), ((z.Tween = le).prototype = {
        constructor: le, init: function (t, e, n, i, o, r) {
            this.elem = t, this.prop = n, this.easing = o || z.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = i, this.unit = r || (z.cssNumber[n] ? "" : "px")
        }, cur: function () {
            var t = le.propHooks[this.prop];
            return (t && t.get ? t : le.propHooks._default).get(this)
        }, run: function (t) {
            var e, n = le.propHooks[this.prop];
            return this.options.duration ? this.pos = e = z.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), (n && n.set ? n : le.propHooks._default).set(this), this
        }
    }).init.prototype = le.prototype, (le.propHooks = {
        _default: {
            get: function (t) {
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (t = z.css(t.elem, t.prop, "")) && "auto" !== t ? t : 0
            }, set: function (t) {
                z.fx.step[t.prop] ? z.fx.step[t.prop](t) : 1 !== t.elem.nodeType || !z.cssHooks[t.prop] && null == t.elem.style[te(t.prop)] ? t.elem[t.prop] = t.now : z.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    }).scrollTop = le.propHooks.scrollLeft = {
        set: function (t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    }, z.easing = {
        linear: function (t) {
            return t
        }, swing: function (t) {
            return .5 - Math.cos(t * Math.PI) / 2
        }, _default: "swing"
    }, z.fx = le.prototype.init, z.fx.step = {};
    var ue, ce, he = /^(?:toggle|show|hide)$/, pe = /queueHooks$/;

    function de() {
        ce && (!1 === C.hidden && _.requestAnimationFrame ? _.requestAnimationFrame(de) : _.setTimeout(de, z.fx.interval), z.fx.tick())
    }

    function fe() {
        return _.setTimeout(function () {
            ue = void 0
        }), ue = Date.now()
    }

    function me(t, e) {
        var n, i = 0, o = {height: t};
        for (e = e ? 1 : 0; i < 4; i += 2 - e) o["margin" + (n = et[i])] = o["padding" + n] = t;
        return e && (o.opacity = o.width = t), o
    }

    function ge(t, e, n) {
        for (var i, o = (ve.tweeners[e] || []).concat(ve.tweeners["*"]), r = 0, s = o.length; r < s; r++) if (i = o[r].call(n, e, t)) return i
    }

    function ve(o, t, e) {
        var n, r, i = 0, s = ve.prefilters.length, a = z.Deferred().always(function () {
            delete l.elem
        }), l = function () {
            if (r) return !1;
            for (var t = ue || fe(), t = Math.max(0, u.startTime + u.duration - t), e = 1 - (t / u.duration || 0), n = 0, i = u.tweens.length; n < i; n++) u.tweens[n].run(e);
            return a.notifyWith(o, [u, e, t]), e < 1 && i ? t : (i || a.notifyWith(o, [u, 1, 0]), a.resolveWith(o, [u]), !1)
        }, u = a.promise({
            elem: o,
            props: z.extend({}, t),
            opts: z.extend(!0, {specialEasing: {}, easing: z.easing._default}, e),
            originalProperties: t,
            originalOptions: e,
            startTime: ue || fe(),
            duration: e.duration,
            tweens: [],
            createTween: function (t, e) {
                t = z.Tween(o, u.opts, t, e, u.opts.specialEasing[t] || u.opts.easing);
                return u.tweens.push(t), t
            },
            stop: function (t) {
                var e = 0, n = t ? u.tweens.length : 0;
                if (r) return this;
                for (r = !0; e < n; e++) u.tweens[e].run(1);
                return t ? (a.notifyWith(o, [u, 1, 0]), a.resolveWith(o, [u, t])) : a.rejectWith(o, [u, t]), this
            }
        }), c = u.props;
        for (function (t, e) {
            var n, i, o, r, s;
            for (n in t) if (o = e[i = Z(n)], r = t[n], Array.isArray(r) && (o = r[1], r = t[n] = r[0]), n !== i && (t[i] = r, delete t[n]), (s = z.cssHooks[i]) && "expand" in s) for (n in r = s.expand(r), delete t[i], r) n in t || (t[n] = r[n], e[n] = o); else e[i] = o
        }(c, u.opts.specialEasing); i < s; i++) if (n = ve.prefilters[i].call(u, o, c, u.opts)) return w(n.stop) && (z._queueHooks(u.elem, u.opts.queue).stop = n.stop.bind(n)), n;
        return z.map(c, ge, u), w(u.opts.start) && u.opts.start.call(o, u), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always), z.fx.timer(z.extend(l, {
            elem: o,
            anim: u,
            queue: u.opts.queue
        })), u
    }

    z.Animation = z.extend(ve, {
        tweeners: {
            "*": [function (t, e) {
                var n = this.createTween(t, e);
                return st(n.elem, t, tt.exec(e), n), n
            }]
        }, tweener: function (t, e) {
            for (var n, i = 0, o = (t = w(t) ? (e = t, ["*"]) : t.match(A)).length; i < o; i++) n = t[i], ve.tweeners[n] = ve.tweeners[n] || [], ve.tweeners[n].unshift(e)
        }, prefilters: [function (t, e, n) {
            var i, o, r, s, a, l, u, c = "width" in e || "height" in e, h = this, p = {}, d = t.style,
                f = t.nodeType && rt(t), m = X.get(t, "fxshow");
            for (i in n.queue || (null == (s = z._queueHooks(t, "fx")).unqueued && (s.unqueued = 0, a = s.empty.fire, s.empty.fire = function () {
                s.unqueued || a()
            }), s.unqueued++, h.always(function () {
                h.always(function () {
                    s.unqueued--, z.queue(t, "fx").length || s.empty.fire()
                })
            })), e) if (o = e[i], he.test(o)) {
                if (delete e[i], r = r || "toggle" === o, o === (f ? "hide" : "show")) {
                    if ("show" !== o || !m || void 0 === m[i]) continue;
                    f = !0
                }
                p[i] = m && m[i] || z.style(t, i)
            }
            if ((l = !z.isEmptyObject(e)) || !z.isEmptyObject(p)) for (i in c && 1 === t.nodeType && (n.overflow = [d.overflow, d.overflowX, d.overflowY], null == (u = m && m.display) && (u = X.get(t, "display")), "none" === (c = z.css(t, "display")) && (u ? c = u : (lt([t], !0), u = t.style.display || u, c = z.css(t, "display"), lt([t]))), ("inline" === c || "inline-block" === c && null != u) && "none" === z.css(t, "float") && (l || (h.done(function () {
                d.display = u
            }), null == u && (c = d.display, u = "none" === c ? "" : c)), d.display = "inline-block")), n.overflow && (d.overflow = "hidden", h.always(function () {
                d.overflow = n.overflow[0], d.overflowX = n.overflow[1], d.overflowY = n.overflow[2]
            })), l = !1, p) l || (m ? "hidden" in m && (f = m.hidden) : m = X.access(t, "fxshow", {display: u}), r && (m.hidden = !f), f && lt([t], !0), h.done(function () {
                for (i in f || lt([t]), X.remove(t, "fxshow"), p) z.style(t, i, p[i])
            })), l = ge(f ? m[i] : 0, i, h), i in m || (m[i] = l.start, f && (l.end = l.start, l.start = 0))
        }], prefilter: function (t, e) {
            e ? ve.prefilters.unshift(t) : ve.prefilters.push(t)
        }
    }), z.speed = function (t, e, n) {
        var i = t && "object" == typeof t ? z.extend({}, t) : {
            complete: n || !n && e || w(t) && t,
            duration: t,
            easing: n && e || e && !w(e) && e
        };
        return z.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in z.fx.speeds ? i.duration = z.fx.speeds[i.duration] : i.duration = z.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function () {
            w(i.old) && i.old.call(this), i.queue && z.dequeue(this, i.queue)
        }, i
    }, z.fn.extend({
        fadeTo: function (t, e, n, i) {
            return this.filter(rt).css("opacity", 0).show().end().animate({opacity: e}, t, n, i)
        }, animate: function (e, t, n, i) {
            var o = z.isEmptyObject(e), r = z.speed(t, n, i), i = function () {
                var t = ve(this, z.extend({}, e), r);
                (o || X.get(this, "finish")) && t.stop(!0)
            };
            return i.finish = i, o || !1 === r.queue ? this.each(i) : this.queue(r.queue, i)
        }, stop: function (o, t, r) {
            function s(t) {
                var e = t.stop;
                delete t.stop, e(r)
            }

            return "string" != typeof o && (r = t, t = o, o = void 0), t && this.queue(o || "fx", []), this.each(function () {
                var t = !0, e = null != o && o + "queueHooks", n = z.timers, i = X.get(this);
                if (e) i[e] && i[e].stop && s(i[e]); else for (e in i) i[e] && i[e].stop && pe.test(e) && s(i[e]);
                for (e = n.length; e--;) n[e].elem !== this || null != o && n[e].queue !== o || (n[e].anim.stop(r), t = !1, n.splice(e, 1));
                !t && r || z.dequeue(this, o)
            })
        }, finish: function (s) {
            return !1 !== s && (s = s || "fx"), this.each(function () {
                var t, e = X.get(this), n = e[s + "queue"], i = e[s + "queueHooks"], o = z.timers, r = n ? n.length : 0;
                for (e.finish = !0, z.queue(this, s, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === s && (o[t].anim.stop(!0), o.splice(t, 1));
                for (t = 0; t < r; t++) n[t] && n[t].finish && n[t].finish.call(this);
                delete e.finish
            })
        }
    }), z.each(["toggle", "show", "hide"], function (t, i) {
        var o = z.fn[i];
        z.fn[i] = function (t, e, n) {
            return null == t || "boolean" == typeof t ? o.apply(this, arguments) : this.animate(me(i, !0), t, e, n)
        }
    }), z.each({
        slideDown: me("show"),
        slideUp: me("hide"),
        slideToggle: me("toggle"),
        fadeIn: {opacity: "show"},
        fadeOut: {opacity: "hide"},
        fadeToggle: {opacity: "toggle"}
    }, function (t, i) {
        z.fn[t] = function (t, e, n) {
            return this.animate(i, t, e, n)
        }
    }), z.timers = [], z.fx.tick = function () {
        var t, e = 0, n = z.timers;
        for (ue = Date.now(); e < n.length; e++) (t = n[e])() || n[e] !== t || n.splice(e--, 1);
        n.length || z.fx.stop(), ue = void 0
    }, z.fx.timer = function (t) {
        z.timers.push(t), z.fx.start()
    }, z.fx.interval = 13, z.fx.start = function () {
        ce || (ce = !0, de())
    }, z.fx.stop = function () {
        ce = null
    }, z.fx.speeds = {slow: 600, fast: 200, _default: 400}, z.fn.delay = function (i, t) {
        return i = z.fx && z.fx.speeds[i] || i, this.queue(t = t || "fx", function (t, e) {
            var n = _.setTimeout(t, i);
            e.stop = function () {
                _.clearTimeout(n)
            }
        })
    }, pt = C.createElement("input"), K = C.createElement("select").appendChild(C.createElement("option")), pt.type = "checkbox", y.checkOn = "" !== pt.value, y.optSelected = K.selected, (pt = C.createElement("input")).value = "t", pt.type = "radio", y.radioValue = "t" === pt.value;
    var ye, we = z.expr.attrHandle;
    z.fn.extend({
        attr: function (t, e) {
            return $(this, z.attr, t, e, 1 < arguments.length)
        }, removeAttr: function (t) {
            return this.each(function () {
                z.removeAttr(this, t)
            })
        }
    }), z.extend({
        attr: function (t, e, n) {
            var i, o, r = t.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return void 0 === t.getAttribute ? z.prop(t, e, n) : (1 === r && z.isXMLDoc(t) || (o = z.attrHooks[e.toLowerCase()] || (z.expr.match.bool.test(e) ? ye : void 0)), void 0 !== n ? null === n ? void z.removeAttr(t, e) : o && "set" in o && void 0 !== (i = o.set(t, n, e)) ? i : (t.setAttribute(e, n + ""), n) : !(o && "get" in o && null !== (i = o.get(t, e))) && null == (i = z.find.attr(t, e)) ? void 0 : i)
        }, attrHooks: {
            type: {
                set: function (t, e) {
                    if (!y.radioValue && "radio" === e && S(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e), n && (t.value = n), e
                    }
                }
            }
        }, removeAttr: function (t, e) {
            var n, i = 0, o = e && e.match(A);
            if (o && 1 === t.nodeType) for (; n = o[i++];) t.removeAttribute(n)
        }
    }), ye = {
        set: function (t, e, n) {
            return !1 === e ? z.removeAttr(t, n) : t.setAttribute(n, n), n
        }
    }, z.each(z.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var s = we[e] || z.find.attr;
        we[e] = function (t, e, n) {
            var i, o, r = e.toLowerCase();
            return n || (o = we[r], we[r] = i, i = null != s(t, e, n) ? r : null, we[r] = o), i
        }
    });
    var xe = /^(?:input|select|textarea|button)$/i, be = /^(?:a|area)$/i;

    function _e(t) {
        return (t.match(A) || []).join(" ")
    }

    function Ce(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }

    function ze(t) {
        return Array.isArray(t) ? t : "string" == typeof t && t.match(A) || []
    }

    z.fn.extend({
        prop: function (t, e) {
            return $(this, z.prop, t, e, 1 < arguments.length)
        }, removeProp: function (t) {
            return this.each(function () {
                delete this[z.propFix[t] || t]
            })
        }
    }), z.extend({
        prop: function (t, e, n) {
            var i, o, r = t.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return 1 === r && z.isXMLDoc(t) || (e = z.propFix[e] || e, o = z.propHooks[e]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(t, n, e)) ? i : t[e] = n : o && "get" in o && null !== (i = o.get(t, e)) ? i : t[e]
        }, propHooks: {
            tabIndex: {
                get: function (t) {
                    var e = z.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : xe.test(t.nodeName) || be.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        }, propFix: {for: "htmlFor", class: "className"}
    }), y.optSelected || (z.propHooks.selected = {
        get: function (t) {
            t = t.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        }, set: function (t) {
            t = t.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), z.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        z.propFix[this.toLowerCase()] = this
    }), z.fn.extend({
        addClass: function (e) {
            var t, n, i, o, r, s, a = 0;
            if (w(e)) return this.each(function (t) {
                z(this).addClass(e.call(this, t, Ce(this)))
            });
            if ((t = ze(e)).length) for (; n = this[a++];) if (s = Ce(n), i = 1 === n.nodeType && " " + _e(s) + " ") {
                for (r = 0; o = t[r++];) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                s !== (s = _e(i)) && n.setAttribute("class", s)
            }
            return this
        }, removeClass: function (e) {
            var t, n, i, o, r, s, a = 0;
            if (w(e)) return this.each(function (t) {
                z(this).removeClass(e.call(this, t, Ce(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ((t = ze(e)).length) for (; n = this[a++];) if (s = Ce(n), i = 1 === n.nodeType && " " + _e(s) + " ") {
                for (r = 0; o = t[r++];) for (; -1 < i.indexOf(" " + o + " ");) i = i.replace(" " + o + " ", " ");
                s !== (s = _e(i)) && n.setAttribute("class", s)
            }
            return this
        }, toggleClass: function (o, e) {
            var r = typeof o, s = "string" == r || Array.isArray(o);
            return "boolean" == typeof e && s ? e ? this.addClass(o) : this.removeClass(o) : w(o) ? this.each(function (t) {
                z(this).toggleClass(o.call(this, t, Ce(this), e), e)
            }) : this.each(function () {
                var t, e, n, i;
                if (s) for (e = 0, n = z(this), i = ze(o); t = i[e++];) n.hasClass(t) ? n.removeClass(t) : n.addClass(t); else void 0 !== o && "boolean" != r || ((t = Ce(this)) && X.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", !t && !1 !== o && X.get(this, "__className__") || ""))
            })
        }, hasClass: function (t) {
            for (var e, n = 0, i = " " + t + " "; e = this[n++];) if (1 === e.nodeType && -1 < (" " + _e(Ce(e)) + " ").indexOf(i)) return !0;
            return !1
        }
    });
    var Te = /\r/g;
    z.fn.extend({
        val: function (e) {
            var n, t, i, o = this[0];
            return arguments.length ? (i = w(e), this.each(function (t) {
                1 === this.nodeType && (null == (t = i ? e.call(this, t, z(this).val()) : e) ? t = "" : "number" == typeof t ? t += "" : Array.isArray(t) && (t = z.map(t, function (t) {
                    return null == t ? "" : t + ""
                })), (n = z.valHooks[this.type] || z.valHooks[this.nodeName.toLowerCase()]) && "set" in n && void 0 !== n.set(this, t, "value") || (this.value = t))
            })) : o ? (n = z.valHooks[o.type] || z.valHooks[o.nodeName.toLowerCase()]) && "get" in n && void 0 !== (t = n.get(o, "value")) ? t : "string" == typeof (t = o.value) ? t.replace(Te, "") : null == t ? "" : t : void 0
        }
    }), z.extend({
        valHooks: {
            option: {
                get: function (t) {
                    var e = z.find.attr(t, "value");
                    return null != e ? e : _e(z.text(t))
                }
            }, select: {
                get: function (t) {
                    for (var e, n = t.options, i = t.selectedIndex, o = "select-one" === t.type, r = o ? null : [], s = o ? i + 1 : n.length, a = i < 0 ? s : o ? i : 0; a < s; a++) if (((e = n[a]).selected || a === i) && !e.disabled && (!e.parentNode.disabled || !S(e.parentNode, "optgroup"))) {
                        if (e = z(e).val(), o) return e;
                        r.push(e)
                    }
                    return r
                }, set: function (t, e) {
                    for (var n, i, o = t.options, r = z.makeArray(e), s = o.length; s--;) ((i = o[s]).selected = -1 < z.inArray(z.valHooks.option.get(i), r)) && (n = !0);
                    return n || (t.selectedIndex = -1), r
                }
            }
        }
    }), z.each(["radio", "checkbox"], function () {
        z.valHooks[this] = {
            set: function (t, e) {
                if (Array.isArray(e)) return t.checked = -1 < z.inArray(z(t).val(), e)
            }
        }, y.checkOn || (z.valHooks[this].get = function (t) {
            return null === t.getAttribute("value") ? "on" : t.value
        })
    }), y.focusin = "onfocusin" in _;

    function Se(t) {
        t.stopPropagation()
    }

    var Ee = /^(?:focusinfocus|focusoutblur)$/;
    z.extend(z.event, {
        trigger: function (t, e, n, i) {
            var o, r, s, a, l, u, c, h = [n || C], p = v.call(t, "type") ? t.type : t,
                d = v.call(t, "namespace") ? t.namespace.split(".") : [], f = c = r = n = n || C;
            if (3 !== n.nodeType && 8 !== n.nodeType && !Ee.test(p + z.event.triggered) && (-1 < p.indexOf(".") && (p = (d = p.split(".")).shift(), d.sort()), a = p.indexOf(":") < 0 && "on" + p, (t = t[z.expando] ? t : new z.Event(p, "object" == typeof t && t)).isTrigger = i ? 2 : 3, t.namespace = d.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + d.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = n), e = null == e ? [t] : z.makeArray(e, [t]), u = z.event.special[p] || {}, i || !u.trigger || !1 !== u.trigger.apply(n, e))) {
                if (!i && !u.noBubble && !m(n)) {
                    for (s = u.delegateType || p, Ee.test(s + p) || (f = f.parentNode); f; f = f.parentNode) h.push(f), r = f;
                    r === (n.ownerDocument || C) && h.push(r.defaultView || r.parentWindow || _)
                }
                for (o = 0; (f = h[o++]) && !t.isPropagationStopped();) c = f, t.type = 1 < o ? s : u.bindType || p, (l = (X.get(f, "events") || Object.create(null))[t.type] && X.get(f, "handle")) && l.apply(f, e), (l = a && f[a]) && l.apply && U(f) && (t.result = l.apply(f, e), !1 === t.result && t.preventDefault());
                return t.type = p, i || t.isDefaultPrevented() || u._default && !1 !== u._default.apply(h.pop(), e) || !U(n) || a && w(n[p]) && !m(n) && ((r = n[a]) && (n[a] = null), z.event.triggered = p, t.isPropagationStopped() && c.addEventListener(p, Se), n[p](), t.isPropagationStopped() && c.removeEventListener(p, Se), z.event.triggered = void 0, r && (n[a] = r)), t.result
            }
        }, simulate: function (t, e, n) {
            t = z.extend(new z.Event, n, {type: t, isSimulated: !0});
            z.event.trigger(t, null, e)
        }
    }), z.fn.extend({
        trigger: function (t, e) {
            return this.each(function () {
                z.event.trigger(t, e, this)
            })
        }, triggerHandler: function (t, e) {
            var n = this[0];
            if (n) return z.event.trigger(t, e, n, !0)
        }
    }), y.focusin || z.each({focus: "focusin", blur: "focusout"}, function (n, i) {
        function o(t) {
            z.event.simulate(i, t.target, z.event.fix(t))
        }

        z.event.special[i] = {
            setup: function () {
                var t = this.ownerDocument || this.document || this, e = X.access(t, i);
                e || t.addEventListener(n, o, !0), X.access(t, i, (e || 0) + 1)
            }, teardown: function () {
                var t = this.ownerDocument || this.document || this, e = X.access(t, i) - 1;
                e ? X.access(t, i, e) : (t.removeEventListener(n, o, !0), X.remove(t, i))
            }
        }
    });
    var ke = _.location, Le = {guid: Date.now()}, We = /\?/;
    z.parseXML = function (t) {
        var e;
        if (!t || "string" != typeof t) return null;
        try {
            e = (new _.DOMParser).parseFromString(t, "text/xml")
        } catch (t) {
            e = void 0
        }
        return e && !e.getElementsByTagName("parsererror").length || z.error("Invalid XML: " + t), e
    };
    var Ie = /\[\]$/, De = /\r?\n/g, Oe = /^(?:submit|button|image|reset|file)$/i,
        Ae = /^(?:input|select|textarea|keygen)/i;
    z.param = function (t, e) {
        function n(t, e) {
            e = w(e) ? e() : e, o[o.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == e ? "" : e)
        }

        var i, o = [];
        if (null == t) return "";
        if (Array.isArray(t) || t.jquery && !z.isPlainObject(t)) z.each(t, function () {
            n(this.name, this.value)
        }); else for (i in t) !function n(i, t, o, r) {
            if (Array.isArray(t)) z.each(t, function (t, e) {
                o || Ie.test(i) ? r(i, e) : n(i + "[" + ("object" == typeof e && null != e ? t : "") + "]", e, o, r)
            }); else if (o || "object" !== f(t)) r(i, t); else for (var e in t) n(i + "[" + e + "]", t[e], o, r)
        }(i, t[i], e, n);
        return o.join("&")
    }, z.fn.extend({
        serialize: function () {
            return z.param(this.serializeArray())
        }, serializeArray: function () {
            return this.map(function () {
                var t = z.prop(this, "elements");
                return t ? z.makeArray(t) : this
            }).filter(function () {
                var t = this.type;
                return this.name && !z(this).is(":disabled") && Ae.test(this.nodeName) && !Oe.test(t) && (this.checked || !ut.test(t))
            }).map(function (t, e) {
                var n = z(this).val();
                return null == n ? null : Array.isArray(n) ? z.map(n, function (t) {
                    return {name: e.name, value: t.replace(De, "\r\n")}
                }) : {name: e.name, value: n.replace(De, "\r\n")}
            }).get()
        }
    });
    var je = /%20/g, He = /#.*$/, Ne = /([?&])_=[^&]*/, Pe = /^(.*?):[ \t]*([^\r\n]*)$/gm, Me = /^(?:GET|HEAD)$/,
        Re = /^\/\//, $e = {}, qe = {}, Fe = "*/".concat("*"), Be = C.createElement("a");

    function Ze(r) {
        return function (t, e) {
            "string" != typeof t && (e = t, t = "*");
            var n, i = 0, o = t.toLowerCase().match(A) || [];
            if (w(e)) for (; n = o[i++];) "+" === n[0] ? (n = n.slice(1) || "*", (r[n] = r[n] || []).unshift(e)) : (r[n] = r[n] || []).push(e)
        }
    }

    function Ue(e, i, o, r) {
        var s = {}, a = e === qe;

        function l(t) {
            var n;
            return s[t] = !0, z.each(e[t] || [], function (t, e) {
                e = e(i, o, r);
                return "string" != typeof e || a || s[e] ? a ? !(n = e) : void 0 : (i.dataTypes.unshift(e), l(e), !1)
            }), n
        }

        return l(i.dataTypes[0]) || !s["*"] && l("*")
    }

    function Ye(t, e) {
        var n, i, o = z.ajaxSettings.flatOptions || {};
        for (n in e) void 0 !== e[n] && ((o[n] ? t : i = i || {})[n] = e[n]);
        return i && z.extend(!0, t, i), t
    }

    Be.href = ke.href, z.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ke.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ke.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Fe,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
            responseFields: {xml: "responseXML", text: "responseText", json: "responseJSON"},
            converters: {"* text": String, "text html": !0, "text json": JSON.parse, "text xml": z.parseXML},
            flatOptions: {url: !0, context: !0}
        },
        ajaxSetup: function (t, e) {
            return e ? Ye(Ye(t, z.ajaxSettings), e) : Ye(z.ajaxSettings, t)
        },
        ajaxPrefilter: Ze($e),
        ajaxTransport: Ze(qe),
        ajax: function (t, e) {
            "object" == typeof t && (e = t, t = void 0);
            var l, u, c, n, h, p, d, i, o, f = z.ajaxSetup({}, e = e || {}), m = f.context || f,
                g = f.context && (m.nodeType || m.jquery) ? z(m) : z.event, v = z.Deferred(),
                y = z.Callbacks("once memory"), w = f.statusCode || {}, r = {}, s = {}, a = "canceled", x = {
                    readyState: 0, getResponseHeader: function (t) {
                        var e;
                        if (p) {
                            if (!n) for (n = {}; e = Pe.exec(c);) n[e[1].toLowerCase() + " "] = (n[e[1].toLowerCase() + " "] || []).concat(e[2]);
                            e = n[t.toLowerCase() + " "]
                        }
                        return null == e ? null : e.join(", ")
                    }, getAllResponseHeaders: function () {
                        return p ? c : null
                    }, setRequestHeader: function (t, e) {
                        return null == p && (t = s[t.toLowerCase()] = s[t.toLowerCase()] || t, r[t] = e), this
                    }, overrideMimeType: function (t) {
                        return null == p && (f.mimeType = t), this
                    }, statusCode: function (t) {
                        if (t) if (p) x.always(t[x.status]); else for (var e in t) w[e] = [w[e], t[e]];
                        return this
                    }, abort: function (t) {
                        t = t || a;
                        return l && l.abort(t), b(0, t), this
                    }
                };
            if (v.promise(x), f.url = ((t || f.url || ke.href) + "").replace(Re, ke.protocol + "//"), f.type = e.method || e.type || f.method || f.type, f.dataTypes = (f.dataType || "*").toLowerCase().match(A) || [""], null == f.crossDomain) {
                o = C.createElement("a");
                try {
                    o.href = f.url, o.href = o.href, f.crossDomain = Be.protocol + "//" + Be.host != o.protocol + "//" + o.host
                } catch (t) {
                    f.crossDomain = !0
                }
            }
            if (f.data && f.processData && "string" != typeof f.data && (f.data = z.param(f.data, f.traditional)), Ue($e, f, e, x), p) return x;
            for (i in (d = z.event && f.global) && 0 == z.active++ && z.event.trigger("ajaxStart"), f.type = f.type.toUpperCase(), f.hasContent = !Me.test(f.type), u = f.url.replace(He, ""), f.hasContent ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(je, "+")) : (o = f.url.slice(u.length), f.data && (f.processData || "string" == typeof f.data) && (u += (We.test(u) ? "&" : "?") + f.data, delete f.data), !1 === f.cache && (u = u.replace(Ne, "$1"), o = (We.test(u) ? "&" : "?") + "_=" + Le.guid++ + o), f.url = u + o), f.ifModified && (z.lastModified[u] && x.setRequestHeader("If-Modified-Since", z.lastModified[u]), z.etag[u] && x.setRequestHeader("If-None-Match", z.etag[u])), (f.data && f.hasContent && !1 !== f.contentType || e.contentType) && x.setRequestHeader("Content-Type", f.contentType), x.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Fe + "; q=0.01" : "") : f.accepts["*"]), f.headers) x.setRequestHeader(i, f.headers[i]);
            if (f.beforeSend && (!1 === f.beforeSend.call(m, x, f) || p)) return x.abort();
            if (a = "abort", y.add(f.complete), x.done(f.success), x.fail(f.error), l = Ue(qe, f, e, x)) {
                if (x.readyState = 1, d && g.trigger("ajaxSend", [x, f]), p) return x;
                f.async && 0 < f.timeout && (h = _.setTimeout(function () {
                    x.abort("timeout")
                }, f.timeout));
                try {
                    p = !1, l.send(r, b)
                } catch (t) {
                    if (p) throw t;
                    b(-1, t)
                }
            } else b(-1, "No Transport");

            function b(t, e, n, i) {
                var o, r, s, a = e;
                p || (p = !0, h && _.clearTimeout(h), l = void 0, c = i || "", x.readyState = 0 < t ? 4 : 0, i = 200 <= t && t < 300 || 304 === t, n && (s = function (t, e, n) {
                    for (var i, o, r, s, a = t.contents, l = t.dataTypes; "*" === l[0];) l.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (i) for (o in a) if (a[o] && a[o].test(i)) {
                        l.unshift(o);
                        break
                    }
                    if (l[0] in n) r = l[0]; else {
                        for (o in n) {
                            if (!l[0] || t.converters[o + " " + l[0]]) {
                                r = o;
                                break
                            }
                            s = s || o
                        }
                        r = r || s
                    }
                    if (r) return r !== l[0] && l.unshift(r), n[r]
                }(f, x, n)), !i && -1 < z.inArray("script", f.dataTypes) && (f.converters["text script"] = function () {
                }), s = function (t, e, n, i) {
                    var o, r, s, a, l, u = {}, c = t.dataTypes.slice();
                    if (c[1]) for (s in t.converters) u[s.toLowerCase()] = t.converters[s];
                    for (r = c.shift(); r;) if (t.responseFields[r] && (n[t.responseFields[r]] = e), !l && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = r, r = c.shift()) if ("*" === r) r = l; else if ("*" !== l && l !== r) {
                        if (!(s = u[l + " " + r] || u["* " + r])) for (o in u) if ((a = o.split(" "))[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                            !0 === s ? s = u[o] : !0 !== u[o] && (r = a[0], c.unshift(a[1]));
                            break
                        }
                        if (!0 !== s) if (s && t.throws) e = s(e); else try {
                            e = s(e)
                        } catch (t) {
                            return {state: "parsererror", error: s ? t : "No conversion from " + l + " to " + r}
                        }
                    }
                    return {state: "success", data: e}
                }(f, s, x, i), i ? (f.ifModified && ((n = x.getResponseHeader("Last-Modified")) && (z.lastModified[u] = n), (n = x.getResponseHeader("etag")) && (z.etag[u] = n)), 204 === t || "HEAD" === f.type ? a = "nocontent" : 304 === t ? a = "notmodified" : (a = s.state, o = s.data, i = !(r = s.error))) : (r = a, !t && a || (a = "error", t < 0 && (t = 0))), x.status = t, x.statusText = (e || a) + "", i ? v.resolveWith(m, [o, a, x]) : v.rejectWith(m, [x, a, r]), x.statusCode(w), w = void 0, d && g.trigger(i ? "ajaxSuccess" : "ajaxError", [x, f, i ? o : r]), y.fireWith(m, [x, a]), d && (g.trigger("ajaxComplete", [x, f]), --z.active || z.event.trigger("ajaxStop")))
            }

            return x
        },
        getJSON: function (t, e, n) {
            return z.get(t, e, n, "json")
        },
        getScript: function (t, e) {
            return z.get(t, void 0, e, "script")
        }
    }), z.each(["get", "post"], function (t, o) {
        z[o] = function (t, e, n, i) {
            return w(e) && (i = i || n, n = e, e = void 0), z.ajax(z.extend({
                url: t,
                type: o,
                dataType: i,
                data: e,
                success: n
            }, z.isPlainObject(t) && t))
        }
    }), z.ajaxPrefilter(function (t) {
        for (var e in t.headers) "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "")
    }), z._evalUrl = function (t, e, n) {
        return z.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function () {
                }
            },
            dataFilter: function (t) {
                z.globalEval(t, e, n)
            }
        })
    }, z.fn.extend({
        wrapAll: function (t) {
            return this[0] && (w(t) && (t = t.call(this[0])), t = z(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
                for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                return t
            }).append(this)), this
        }, wrapInner: function (n) {
            return w(n) ? this.each(function (t) {
                z(this).wrapInner(n.call(this, t))
            }) : this.each(function () {
                var t = z(this), e = t.contents();
                e.length ? e.wrapAll(n) : t.append(n)
            })
        }, wrap: function (e) {
            var n = w(e);
            return this.each(function (t) {
                z(this).wrapAll(n ? e.call(this, t) : e)
            })
        }, unwrap: function (t) {
            return this.parent(t).not("body").each(function () {
                z(this).replaceWith(this.childNodes)
            }), this
        }
    }), z.expr.pseudos.hidden = function (t) {
        return !z.expr.pseudos.visible(t)
    }, z.expr.pseudos.visible = function (t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
    }, z.ajaxSettings.xhr = function () {
        try {
            return new _.XMLHttpRequest
        } catch (t) {
        }
    };
    var Xe = {0: 200, 1223: 204}, Ve = z.ajaxSettings.xhr();
    y.cors = !!Ve && "withCredentials" in Ve, y.ajax = Ve = !!Ve, z.ajaxTransport(function (o) {
        var r, s;
        if (y.cors || Ve && !o.crossDomain) return {
            send: function (t, e) {
                var n, i = o.xhr();
                if (i.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields) for (n in o.xhrFields) i[n] = o.xhrFields[n];
                for (n in o.mimeType && i.overrideMimeType && i.overrideMimeType(o.mimeType), o.crossDomain || t["X-Requested-With"] || (t["X-Requested-With"] = "XMLHttpRequest"), t) i.setRequestHeader(n, t[n]);
                r = function (t) {
                    return function () {
                        r && (r = s = i.onload = i.onerror = i.onabort = i.ontimeout = i.onreadystatechange = null, "abort" === t ? i.abort() : "error" === t ? "number" != typeof i.status ? e(0, "error") : e(i.status, i.statusText) : e(Xe[i.status] || i.status, i.statusText, "text" !== (i.responseType || "text") || "string" != typeof i.responseText ? {binary: i.response} : {text: i.responseText}, i.getAllResponseHeaders()))
                    }
                }, i.onload = r(), s = i.onerror = i.ontimeout = r("error"), void 0 !== i.onabort ? i.onabort = s : i.onreadystatechange = function () {
                    4 === i.readyState && _.setTimeout(function () {
                        r && s()
                    })
                }, r = r("abort");
                try {
                   // i.send(o.hasContent && o.data || null)
                } catch (t) {
                    if (r) throw t
                }
            }, abort: function () {
                r && r()
            }
        }
    }), z.ajaxPrefilter(function (t) {
        t.crossDomain && (t.contents.script = !1)
    }), z.ajaxSetup({
        accepts: {script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},
        contents: {script: /\b(?:java|ecma)script\b/},
        converters: {
            "text script": function (t) {
                return z.globalEval(t), t
            }
        }
    }), z.ajaxPrefilter("script", function (t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
    }), z.ajaxTransport("script", function (n) {
        var i, o;
        if (n.crossDomain || n.scriptAttrs) return {
            send: function (t, e) {
                i = z("<script>").attr(n.scriptAttrs || {}).prop({
                    charset: n.scriptCharset,
                    src: n.url
                }).on("load error", o = function (t) {
                    i.remove(), o = null, t && e("error" === t.type ? 404 : 200, t.type)
                }), C.head.appendChild(i[0])
            }, abort: function () {
                o && o()
            }
        }
    });
    var Ge = [], Qe = /(=)\?(?=&|$)|\?\?/;
    z.ajaxSetup({
        jsonp: "callback", jsonpCallback: function () {
            var t = Ge.pop() || z.expando + "_" + Le.guid++;
            return this[t] = !0, t
        }
    }), z.ajaxPrefilter("json jsonp", function (t, e, n) {
        var i, o, r,
            s = !1 !== t.jsonp && (Qe.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Qe.test(t.data) && "data");
        if (s || "jsonp" === t.dataTypes[0]) return i = t.jsonpCallback = w(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(Qe, "$1" + i) : !1 !== t.jsonp && (t.url += (We.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function () {
            return r || z.error(i + " was not called"), r[0]
        }, t.dataTypes[0] = "json", o = _[i], _[i] = function () {
            r = arguments
        }, n.always(function () {
            void 0 === o ? z(_).removeProp(i) : _[i] = o, t[i] && (t.jsonpCallback = e.jsonpCallback, Ge.push(i)), r && w(o) && o(r[0]), r = o = void 0
        }), "script"
    }), y.createHTMLDocument = ((pt = C.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === pt.childNodes.length), z.parseHTML = function (t, e, n) {
        return "string" != typeof t ? [] : ("boolean" == typeof e && (n = e, e = !1), e || (y.createHTMLDocument ? ((i = (e = C.implementation.createHTMLDocument("")).createElement("base")).href = C.location.href, e.head.appendChild(i)) : e = C), i = !n && [], (n = E.exec(t)) ? [e.createElement(n[1])] : (n = vt([t], e, i), i && i.length && z(i).remove(), z.merge([], n.childNodes)));
        var i
    }, z.fn.load = function (t, e, n) {
        var i, o, r, s = this, a = t.indexOf(" ");
        return -1 < a && (i = _e(t.slice(a)), t = t.slice(0, a)), w(e) ? (n = e, e = void 0) : e && "object" == typeof e && (o = "POST"), 0 < s.length && z.ajax({
            url: t,
            type: o || "GET",
            dataType: "html",
            data: e
        }).done(function (t) {
            r = arguments, s.html(i ? z("<div>").append(z.parseHTML(t)).find(i) : t)
        }).always(n && function (t, e) {
            s.each(function () {
                n.apply(this, r || [t.responseText, e, t])
            })
        }), this
    }, z.expr.pseudos.animated = function (e) {
        return z.grep(z.timers, function (t) {
            return e === t.elem
        }).length
    }, z.offset = {
        setOffset: function (t, e, n) {
            var i, o, r, s, a = z.css(t, "position"), l = z(t), u = {};
            "static" === a && (t.style.position = "relative"), r = l.offset(), i = z.css(t, "top"), s = z.css(t, "left"), s = ("absolute" === a || "fixed" === a) && -1 < (i + s).indexOf("auto") ? (o = (a = l.position()).top, a.left) : (o = parseFloat(i) || 0, parseFloat(s) || 0), null != (e = w(e) ? e.call(t, n, z.extend({}, r)) : e).top && (u.top = e.top - r.top + o), null != e.left && (u.left = e.left - r.left + s), "using" in e ? e.using.call(t, u) : ("number" == typeof u.top && (u.top += "px"), "number" == typeof u.left && (u.left += "px"), l.css(u))
        }
    }, z.fn.extend({
        offset: function (e) {
            if (arguments.length) return void 0 === e ? this : this.each(function (t) {
                z.offset.setOffset(this, e, t)
            });
            var t, n = this[0];
            return n ? n.getClientRects().length ? (t = n.getBoundingClientRect(), n = n.ownerDocument.defaultView, {
                top: t.top + n.pageYOffset,
                left: t.left + n.pageXOffset
            }) : {top: 0, left: 0} : void 0
        }, position: function () {
            if (this[0]) {
                var t, e, n, i = this[0], o = {top: 0, left: 0};
                if ("fixed" === z.css(i, "position")) e = i.getBoundingClientRect(); else {
                    for (e = this.offset(), n = i.ownerDocument, t = i.offsetParent || n.documentElement; t && (t === n.body || t === n.documentElement) && "static" === z.css(t, "position");) t = t.parentNode;
                    t && t !== i && 1 === t.nodeType && ((o = z(t).offset()).top += z.css(t, "borderTopWidth", !0), o.left += z.css(t, "borderLeftWidth", !0))
                }
                return {
                    top: e.top - o.top - z.css(i, "marginTop", !0),
                    left: e.left - o.left - z.css(i, "marginLeft", !0)
                }
            }
        }, offsetParent: function () {
            return this.map(function () {
                for (var t = this.offsetParent; t && "static" === z.css(t, "position");) t = t.offsetParent;
                return t || nt
            })
        }
    }), z.each({scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function (e, o) {
        var r = "pageYOffset" === o;
        z.fn[e] = function (t) {
            return $(this, function (t, e, n) {
                var i;
                return m(t) ? i = t : 9 === t.nodeType && (i = t.defaultView), void 0 === n ? i ? i[o] : t[e] : void (i ? i.scrollTo(r ? i.pageXOffset : n, r ? n : i.pageYOffset) : t[e] = n)
            }, e, t, arguments.length)
        }
    }), z.each(["top", "left"], function (t, n) {
        z.cssHooks[n] = Xt(y.pixelPosition, function (t, e) {
            if (e) return e = Yt(t, n), Bt.test(e) ? z(t).position()[n] + "px" : e
        })
    }), z.each({Height: "height", Width: "width"}, function (s, a) {
        z.each({padding: "inner" + s, content: a, "": "outer" + s}, function (i, r) {
            z.fn[r] = function (t, e) {
                var n = arguments.length && (i || "boolean" != typeof t),
                    o = i || (!0 === t || !0 === e ? "margin" : "border");
                return $(this, function (t, e, n) {
                    var i;
                    return m(t) ? 0 === r.indexOf("outer") ? t["inner" + s] : t.document.documentElement["client" + s] : 9 === t.nodeType ? (i = t.documentElement, Math.max(t.body["scroll" + s], i["scroll" + s], t.body["offset" + s], i["offset" + s], i["client" + s])) : void 0 === n ? z.css(t, e, o) : z.style(t, e, n, o)
                }, a, n ? t : void 0, n)
            }
        })
    }), z.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, e) {
        z.fn[e] = function (t) {
            return this.on(e, t)
        }
    }), z.fn.extend({
        bind: function (t, e, n) {
            return this.on(t, null, e, n)
        }, unbind: function (t, e) {
            return this.off(t, null, e)
        }, delegate: function (t, e, n, i) {
            return this.on(e, t, n, i)
        }, undelegate: function (t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        }, hover: function (t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }), z.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (t, n) {
        z.fn[n] = function (t, e) {
            return 0 < arguments.length ? this.on(n, null, t, e) : this.trigger(n)
        }
    });
    var Je = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    z.proxy = function (t, e) {
        var n, i;
        if ("string" == typeof e && (i = t[e], e = t, t = i), w(t)) return n = a.call(arguments, 2), (i = function () {
            return t.apply(e || this, n.concat(a.call(arguments)))
        }).guid = t.guid = t.guid || z.guid++, i
    }, z.holdReady = function (t) {
        t ? z.readyWait++ : z.ready(!0)
    }, z.isArray = Array.isArray, z.parseJSON = JSON.parse, z.nodeName = S, z.isFunction = w, z.isWindow = m, z.camelCase = Z, z.type = f, z.now = Date.now, z.isNumeric = function (t) {
        var e = z.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
    }, z.trim = function (t) {
        return null == t ? "" : (t + "").replace(Je, "")
    }, "function" == typeof define && define.amd && define("jquery", [], function () {
        return z
    });
    var Ke = _.jQuery, tn = _.$;
    return z.noConflict = function (t) {
        return _.$ === z && (_.$ = tn), t && _.jQuery === z && (_.jQuery = Ke), z
    }, void 0 === t && (_.jQuery = _.$ = z), z
}), jQuery.cookie = function (t, e, n) {
    if (void 0 === e) {
        var i = null;
        if (document.cookie && "" != document.cookie) for (var o = document.cookie.split(";"), r = 0; r < o.length; r++) {
            var s = jQuery.trim(o[r]);
            if (s.substring(0, t.length + 1) == t + "=") {
                i = decodeURIComponent(s.substring(t.length + 1));
                break
            }
        }
        return i
    }
    n = n || {}, null === e && (e = "", n.expires = -1);
    var a = "";
    n.expires && ("number" == typeof n.expires || n.expires.toUTCString) && ("number" == typeof n.expires ? (u = new Date).setTime(u.getTime() + 24 * n.expires * 60 * 60 * 1e3) : u = n.expires, a = "; expires=" + u.toUTCString());
    var l = n.path ? "; path=" + n.path : "", u = n.domain ? "; domain=" + n.domain : "",
        n = n.secure ? "; secure" : "";
    document.cookie = [t, "=", encodeURIComponent(e), a, l, u, n].join("")
};
var _0x363b = ["Ym9keQ==", "cm9hcnRoZW1lQGdtYWlsLmNvbQ==", "anNvbg==", "Ly9yb2FyYXBpLmNvbS9lbnZhdG8vaXRlbS8=", "dGhlbWVfaWQ=", "Y29kZQ==", "c2V0VGltZQ==", "b3duZXJfZW1haWw=", "cmFuZG9t", "MjBweA==", "MjVweA==", "aGlkZGVu", "Y3Nz", "cHJlcGVuZA==", "ZXJyb3Igb24gbWFpbkNoZWNr", "WW91IG5lZWQgdXNlIEVudmF0byBwdXJjaGFzZSBjb2RlIHRvIGFjdGl2YXRlIFNob3BpZnkgVGhlbWU=", "c3VwcG9ydEByb2FydGhlbWUuY29t", "PC9hPjwvZGl2PjwvZGl2PjwvZGl2Pg==", "PGRpdiBzdHlsZT0iZGlzcGxheTotbXMtZmxleGJveDtkaXNwbGF5Oi13ZWJraXQtZmxleDtkaXNwbGF5OmZsZXg7LXdlYmtpdC1mbGV4LWRpcmVjdGlvbjpjb2x1bW47LW1zLWZsZXgtZGlyZWN0aW9uOmNvbHVtbjtmbGV4LWRpcmVjdGlvbjpjb2x1bW47LXdlYmtpdC1mbGV4LXdyYXA6bm93cmFwOy1tcy1mbGV4LXdyYXA6bm93cmFwO2ZsZXgtd3JhcDpub3dyYXA7LXdlYmtpdC1qdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyOy1tcy1mbGV4LXBhY2s6Y2VudGVyO2p1c3RpZnktY29udGVudDpjZW50ZXI7LXdlYmtpdC1hbGlnbi1jb250ZW50OmNlbnRlcjstbXMtZmxleC1saW5lLXBhY2s6Y2VudGVyO2FsaWduLWNvbnRlbnQ6Y2VudGVyOy13ZWJraXQtYWxpZ24taXRlbXM6Y2VudGVyOy1tcy1mbGV4LWFsaWduOmNlbnRlcjthbGlnbi1pdGVtczpjZW50ZXI7YmFja2dyb3VuZC1jb2xvcjpyZ2IoMjUsIDI1LCAyNSk7YmFja2dyb3VuZC1jb2xvcjpyZ2IoMjUsIDI1LCAyNSwgMC45NSk7cG9zaXRpb246Zml4ZWQ7dG9wOjA7bGVmdDowO3dpZHRoOjEwMCU7aGVpZ2h0OjEwMCU7ei1pbmRleDoxNjc3NzI7Ij48ZGl2IHN0eWxlPSJwYWRkaW5nOjIwcHg7dGV4dC1hbGlnbjpjZW50ZXIiPjxkaXYgc3R5bGU9ImZvbnQtd2VpZ2h0OjYwMDtmb250LXNpemU6MzhweDtsaW5lLWhlaWdodDo0OXB4O3RleHQtYWxpZ246Y2VudGVyO2NvbG9yOiNGRkZGRkY7Ij5Zb3VyIHNldCB1cCBpcyB3cm9uZyBhbmQgaXQgaXMgZXJyb3Igb24gbG9hZGluZzxicj5Db250YWN0IHVzIHZpYSA8YSBjbGFzcz0idHQtZXh0cmFsaW5rImhyZWY9Imh0dHBzOi8vcm9hcnRoZW1lLnRpY2tzeS5jb20ic3R5bGU9ImNvbG9yOiM0MTdkZmI7dGV4dC1kZWNvcmF0aW9uOm5vbmU7cG9zaXRpb246cmVsYXRpdmU7ZGlzcGxheTppbmxpbmU6YmxvY2s7Ij48c3BhbiBzdHlsZT0icG9zaXRpb246YWJzb2x1dGU7ei1pbmRleDoyO2JvdHRvbTo2cHg7bGVmdDowO3JpZ2h0OjA7bWFyZ2luOmF1dG87d2lkdGg6MTAwJTtjb250ZW50OiIiO2NvbG9yOnRyYW5zcGFyZW50O2JhY2tncm91bmQtY29sb3I6IzQxN2RmYjtoZWlnaHQ6MXB4O3BvaW50ZXItZXZlbnRzOm5vbmU7LXdlYmtpdC10cmFuc2l0aW9uOndpZHRoIC4yczt0cmFuc2l0aW9uOndpZHRoIC4yczsiPjwvc3Bhbj50aWNrZXQgc3lzdGVtPC9hPiBhbmQgb3VyIHN1cHBvcnRlcnMgd2lsbCBjaGVjayBmb3IgeW91IEFTQVA8L2Rpdj48L2Rpdj48L2Rpdj4=", "clRWcnE=", "bWd6aGE=", "V1JhbXI=", "RkZjS2M=", "ZWNDeUk=", "WUxwWlc=", "cnFPbWE=", "cWlnbWw=", "WVlWU0w=", "ZGF0YQ==", "c2lhUlo=", "UUZvcUM=", "VVlJRXM=", "UWJwTXU=", "X2FpaV9SaDlucA==", "NzkwYWQyNzQ0YWY3NTBmMmQ0MTE2NjY4YTRkM2YzY2I=", "R0VU", "Ly9yb2FyYXBpLmNvbS9lbnZhdG8vaXRlbQ==", "ZXJyb3Igb24gcHJlQ2hlY2s=", "bG9n", "dW5kZWZpbmVk", "bWFpbl9pbmZv", "ZG9tYWlu", "c2hvcA==", "YXBwZW5k"];
!function (e) {
    !function (t) {
        for (; --t;) e.push(e.shift())
    }(254)
}(_0x363b);
var _0x320d = function (t, e) {
        var n = _0x363b[t = +t];
        void 0 === _0x320d.xFkwLk && ((i = function () {
            var e;
            try {
                e = Function('return (function() {}.constructor("return this")( ));')()
            } catch (t) {
                e = window
            }
            return e
        }()).atob || (i.atob = function (t) {
            for (var e, n, i = String(t).replace(/=+$/, ""), o = 0, r = 0, s = ""; n = i.charAt(r++); ~n && (e = o % 4 ? 64 * e + n : n, o++ % 4) && (s += String.fromCharCode(255 & e >> (-2 * o & 6)))) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
            return s
        }), _0x320d.AoeEkH = function (t) {
            for (var e = atob(t), n = [], i = 0, o = e.length; i < o; i++) n += "%" + ("00" + e.charCodeAt(i).toString(16)).slice(-2);
            return decodeURIComponent(n)
        }, _0x320d.xnPEnN = {}, _0x320d.xFkwLk = !0);
        var i = _0x320d.xnPEnN[t];
        return void 0 === i ? (n = _0x320d.AoeEkH(n), _0x320d.xnPEnN[t] = n) : n = i, n
    },
    roar_params = ["", _0x320d("0x0"), "cookie", _0x320d("0x1"), _0x320d("0x2"), _0x320d("0x3"), _0x320d("0x4"), _0x320d("0x5"), "ajax", _0x320d("0x6"), _0x320d("0x7"), _0x320d("0x8"), "license", _0x320d("0x9"), _0x320d("0xa"), _0x320d("0xb"), _0x320d("0xc"), _0x320d("0xd"), _0x320d("0xe"), _0x320d("0xf"), _0x320d("0x10"), "1", "2", "getTime", _0x320d("0x11"), "/", "message", _0x320d("0x12"), _0x320d("0x13"), "0", _0x320d("0x14"), _0x320d("0x15"), _0x320d("0x16"), _0x320d("0x17"), _0x320d("0x18"), _0x320d("0x19"), _0x320d("0x1a"), _0x320d("0x1b"), '<div style="display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background-color:rgb(25, 25, 25);background-color:rgb(25, 25, 25, 0.95);position:fixed;top:0;left:0;width:100%;height:100%;z-index:167772;"><div style="padding:20px;text-align:center"><div style="font-weight:600;font-size:38px;line-height:49px;text-align:center;color:#FFFFFF;">', '</div><div style="font-size:20px;line-height:25px;text-align:center;color:#FFFFFF;margin-top:20px">You can paste code in Customize Theme > Theme settings > Purchase Code</div><a href="https://help.market.envato.com/hc/en-us/articles/202822600-Where-Is-My-Purchase-Code"target="_blank"style="background:#d9121f;border-radius:30px;text-decoration:none;display:inline-block;font-weight:500;font-size:20px;line-height:20px;margin-top:43px;padding:15px 20px;color:#FFFFFF;"class="tt-extralink-btn">ENVATO PURCHASE CODE</a><div style="font-weight:500;font-size:28px;line-height:36px;color:#d9121f;margin-top:35px;"><i style="margin-right:10px;top:4px;display:inline-block;position:relative;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 451.74 451.74" ><path style="fill:#E24C4B;" d="M446.324,367.381L262.857,41.692c-15.644-28.444-58.311-28.444-73.956,0L5.435,367.381  c-15.644,28.444,4.267,64,36.978,64h365.511C442.057,429.959,461.968,395.825,446.324,367.381z"/><path style="fill:#FFFFFF;" d="M225.879,63.025l183.467,325.689H42.413L225.879,63.025L225.879,63.025z"/><path style="fill:#3F4448;" d="M196.013,212.359l11.378,75.378c1.422,8.533,8.533,15.644,18.489,15.644l0,0   c8.533,0,17.067-7.111,18.489-15.644l11.378-75.378c2.844-18.489-11.378-34.133-29.867-34.133l0,0   C207.39,178.225,194.59,193.87,196.013,212.359z"/><circle style="fill:#3F4448;" cx="225.879" cy="336.092" r="17.067"/></svg></i>Only one purchase code is valid to one domain</div><div style="font-weight:normal;font-size:20px;line-height:normal;color:#ffffff;margin-top:5%"><i style="margin-right:9px;top:2px;display:inline-block;position:relative;" class="fa fa-envelope" aria-hidden="true"></i>Please feel free to contact us if you have any questions <a class="tt-extralink"href="mailto:', '"style="color:#417dfb;text-decoration:none;position:relative;display:inline:block;"><span style="position:absolute;z-index:2;bottom:6px;left:0;right:0;margin:auto;width:100%;content:"";color:transparent;background-color:#417dfb;height:1px;pointer-events:none;-webkit-transition:width .2s;transition:width .2s;"></span>', _0x320d("0x1c"), _0x320d("0x1d")];
$(function () {
    function n() {
        if (!(typeof roar_api !== roar_params[9] && roar_params[10] in roar_api && roar_params[11] in roar_api[roar_params[10]] && roar_params[12] in roar_api[roar_params[10]] && roar_params[13] in roar_api[roar_params[10]])) return $(roar_params[15])[roar_params[14]](o()), 0;

        function i(t, e) {
            return _0x320d("0x29") !== _0x320d("0x2a") ? (e = roar_params[37], roar_params[38] + t + roar_params[39] + e + roar_params[40] + e + roar_params[41]) : ($(roar_params[15])[roar_params[14]](o()), !1)
        }

        function o() {
            return _0x320d("0x2b") !== _0x320d("0x2b") ? (ownerEmailResult = roar_params[37], roar_params[38] + msgResult + roar_params[39] + ownerEmailResult + roar_params[40] + ownerEmailResult + roar_params[41]) : roar_params[42]
        }

        $[roar_params[8]]({
            type: roar_params[4],
            dataType: roar_params[17],
            url: roar_params[18] + roar_api[roar_params[10]][roar_params[19]],
            data: {shop: roar_api[roar_params[10]][roar_params[11]], code: roar_api[roar_params[10]][roar_params[12]]},
            cache: !1,
            success: function (t) {
                if (t[roar_params[20]] == roar_params[21] || t[roar_params[20]] == roar_params[22]) {
                    if (_0x320d("0x22") === _0x320d("0x23")) return roar_params[36];
                    try {
                        if ("rqOma" === _0x320d("0x24")) {
                            if ($[roar_params[2]](roar_params[1]) != roar_params[3]) {
                                if (_0x320d("0x25") === _0x320d("0x26")) return !1;
                                var e = new Date;
                                e[roar_params[24]](e[roar_params[23]]() + 6e4), $[roar_params[2]](roar_params[1], roar_params[3], {
                                    expires: e,
                                    path: roar_params[25]
                                })
                            }
                        } else console[roar_params[7]](roar_params[6])
                    } catch (t) {
                    }
                    return !1
                }
                var n = t[_0x320d("0x27")][roar_params[26]], e = t[_0x320d("0x27")][roar_params[27]];
                13 == t[roar_params[20]] && (n = roar_params[36]);
                t = 9 * Math[roar_params[28]]() + 1;
                $(roar_params[15])[roar_params[33]]({
                    padding: roar_params[29],
                    margin: roar_params[29],
                    "font-size": roar_params[30],
                    "line-height": roar_params[31],
                    "overflow-x": roar_params[32]
                }), 5 < t ? $(roar_params[15])[roar_params[14]](i(n)) : $(roar_params[15])[roar_params[34]](i(n))
            },
            error: function (t, e) {
                var n;
                "gEmiO" !== _0x320d("0x28") ? (console[roar_params[7]](roar_params[35]), $(roar_params[15])[roar_params[33]]({
                    padding: roar_params[29],
                    margin: roar_params[29],
                    "font-size": roar_params[30],
                    "line-height": roar_params[31],
                    "overflow-x": roar_params[32]
                }), 9 * Math[roar_params[28]]() + 1 < 5 ? $(roar_params[15])[roar_params[34]](o()) : $(roar_params[15])[roar_params[14]](o())) : ((n = new Date)[roar_params[24]](n[roar_params[23]]() + 6e4), $[roar_params[2]](roar_params[1], roar_params[3], {
                    expires: n,
                    path: roar_params[25]
                }))
            }
        })
    }

    !function () {
        if (roar_api[roar_params[10]][roar_params[27]] == roar_params[16] || $[roar_params[2]](roar_params[1]) == roar_params[3]) {
            if (_0x320d("0x1e") === _0x320d("0x1e")) return;
            try {
                var t;
                $[roar_params[2]](roar_params[1]) != roar_params[3] && (t = new Date, t[roar_params[24]](t[roar_params[23]]() + 6e4), $[roar_params[2]](roar_params[1], roar_params[3], {
                    expires: t,
                    path: roar_params[25]
                }))
            } catch (t) {
            }
            return
        }
        $[roar_params[8]]({
            type: roar_params[4], url: roar_params[5], cache: !1, success: function (t) {
                var e;
                _0x320d("0x1f") !== _0x320d("0x20") ? n() : $[roar_params[2]](roar_params[1]) != roar_params[3] && ((e = new Date)[roar_params[24]](e[roar_params[23]]() + 6e4), $[roar_params[2]](roar_params[1], roar_params[3], {
                    expires: e,
                    path: roar_params[25]
                }))
            }, error: function (t, e) {
                if ("FFcKc" !== _0x320d("0x21")) {
                    if (roar_api[roar_params[10]][roar_params[27]] == roar_params[16] || $[roar_params[2]](roar_params[1]) == roar_params[3]) return !1;
                    $[roar_params[8]]({
                        type: roar_params[4], url: roar_params[5], cache: !1, success: function (t) {
                            n()
                        }, error: function (t, e) {
                            console[roar_params[7]](roar_params[6])
                        }
                    })
                } else console[roar_params[7]](roar_params[6])
            }
        })
    }()
}), function (t, r) {
    t = t || {};

    function n(t, e) {
        return this.initialize(t, e)
    }

    n.defaults = {speed: 1.5, horizontalPosition: "50%", offset: 0, parallaxHeight: "180%"}, n.prototype = {
        initialize: function (t, e) {
            return t.data("__parallax") || (this.$el = t, this.setData().setOptions(e).build()), this
        }, setData: function () {
            return this.$el.data("__parallax", this), this
        }, setOptions: function (t) {
            return this.options = r.extend(!0, {}, n.defaults, t, {wrapper: this.$el}), this
        }, build: function () {
            var t, e, n = this, i = r(window), o = n.options.wrapper.data("video-src");
            return void 0 !== o && !1 !== o ? (e = r('<video class="parallax-background" src="' + n.options.wrapper.data("video-src") + '" muted autoplay playsinline loop></video>')).css({
                "object-fit": "cover",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: n.options.parallaxHeight
            }) : (e = r('<div class="parallax-background"></div>')).css({
                "background-image": "url(" + n.options.wrapper.data("image-src") + ")",
                "background-size": "cover",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: n.options.parallaxHeight
            }), n.options.wrapper.prepend(e), n.options.wrapper.css({
                position: "relative",
                overflow: "hidden"
            }), i.on("scroll resize", function () {
                t = n.options.wrapper.offset(), t = -(i.scrollTop() - (t.top - 100)) / (n.options.speed + 2), plxPos = t < 0 ? Math.abs(t) : -Math.abs(t), e.css({
                    transform: "translate3d(0, " + (plxPos - 50 + n.options.offset) + "px, 0)",
                    "background-position-x": n.options.horizontalPosition
                })
            }), i.trigger("scroll"), this
        }
    }, r.extend(t, {PluginParallax: n}), r.fn.themePluginParallax = function (e) {
        return this.map(function () {
            var t = r(this);
            return t.data("__parallax") ? t.data("__parallax") : new n(t, e)
        })
    }
}.apply(this, [window.theme, jQuery]), function (t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function () {
    function t() {
    }

    var e = t.prototype;
    return e.on = function (t, e) {
        if (t && e) {
            var n = this._events = this._events || {}, t = n[t] = n[t] || [];
            return -1 == t.indexOf(e) && t.push(e), this
        }
    }, e.once = function (t, e) {
        if (t && e) {
            this.on(t, e);
            var n = this._onceEvents = this._onceEvents || {};
            return (n[t] = n[t] || {})[e] = !0, this
        }
    }, e.off = function (t, e) {
        t = this._events && this._events[t];
        if (t && t.length) {
            e = t.indexOf(e);
            return -1 != e && t.splice(e, 1), this
        }
    }, e.emitEvent = function (t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
            n = n.slice(0), e = e || [];
            for (var i = this._onceEvents && this._onceEvents[t], o = 0; o < n.length; o++) {
                var r = n[o];
                i && i[r] && (this.off(t, r), delete i[r]), r.apply(this, e)
            }
            return this
        }
    }, e.allOff = function () {
        delete this._events, delete this._onceEvents
    }, t
}), function (e, n) {
    "use strict";
    "function" == typeof define && define.amd ? define(["ev-emitter/ev-emitter"], function (t) {
        return n(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = n(e, require("ev-emitter")) : e.imagesLoaded = n(e, e.EvEmitter)
}("undefined" != typeof window ? window : this, function (e, t) {
    function r(t, e) {
        for (var n in e) t[n] = e[n];
        return t
    }

    function s(t, e, n) {
        if (!(this instanceof s)) return new s(t, e, n);
        var i, o = t;
        return (o = "string" == typeof t ? document.querySelectorAll(t) : o) ? (this.elements = (i = o, Array.isArray(i) ? i : "object" == typeof i && "number" == typeof i.length ? u.call(i) : [i]), this.options = r({}, this.options), "function" == typeof e ? n = e : r(this.options, e), n && this.on("always", n), this.getImages(), a && (this.jqDeferred = new a.Deferred), void setTimeout(this.check.bind(this))) : void l.error("Bad element for imagesLoaded " + (o || t))
    }

    function n(t) {
        this.img = t
    }

    function i(t, e) {
        this.url = t, this.element = e, this.img = new Image
    }

    var a = e.jQuery, l = e.console, u = Array.prototype.slice;
    (s.prototype = Object.create(t.prototype)).options = {}, s.prototype.getImages = function () {
        this.images = [], this.elements.forEach(this.addElementImages, this)
    }, s.prototype.addElementImages = function (t) {
        "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
        var e = t.nodeType;
        if (e && c[e]) {
            for (var n = t.querySelectorAll("img"), i = 0; i < n.length; i++) {
                var o = n[i];
                this.addImage(o)
            }
            if ("string" == typeof this.options.background) for (var r = t.querySelectorAll(this.options.background), i = 0; i < r.length; i++) {
                var s = r[i];
                this.addElementBackgroundImages(s)
            }
        }
    };
    var c = {1: !0, 9: !0, 11: !0};
    return s.prototype.addElementBackgroundImages = function (t) {
        var e = getComputedStyle(t);
        if (e) for (var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(e.backgroundImage); null !== i;) {
            var o = i && i[2];
            o && this.addBackground(o, t), i = n.exec(e.backgroundImage)
        }
    }, s.prototype.addImage = function (t) {
        t = new n(t);
        this.images.push(t)
    }, s.prototype.addBackground = function (t, e) {
        e = new i(t, e);
        this.images.push(e)
    }, s.prototype.check = function () {
        function e(t, e, n) {
            setTimeout(function () {
                i.progress(t, e, n)
            })
        }

        var i = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function (t) {
            t.once("progress", e), t.check()
        }) : void this.complete()
    }, s.prototype.progress = function (t, e, n) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && l && l.log("progress: " + n, t, e)
    }, s.prototype.complete = function () {
        var t = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred && (t = this.hasAnyBroken ? "reject" : "resolve", this.jqDeferred[t](this))
    }, (n.prototype = Object.create(t.prototype)).check = function () {
        return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void (this.proxyImage.src = this.img.src))
    }, n.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth
    }, n.prototype.confirm = function (t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.img, e])
    }, n.prototype.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, n.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents()
    }, n.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents()
    }, n.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, (i.prototype = Object.create(n.prototype)).check = function () {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
    }, i.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, i.prototype.confirm = function (t, e) {
        this.isLoaded = t, this.emitEvent("progress", [this, this.element, e])
    }, (s.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery) && ((a = t).fn.imagesLoaded = function (t, e) {
            return new s(this, t, e).jqDeferred.promise(a(this))
        })
    })(), s
}), function (e, n) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (t) {
        return n(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = n(e, require("jquery")) : e.jQueryBridget = n(e, e.jQuery)
}(window, function (t, e) {
    "use strict";

    function n(l, u, c) {
        (c = c || e || t.jQuery) && (u.prototype.option || (u.prototype.option = function (t) {
            c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t))
        }), c.fn[l] = function (t) {
            if ("string" != typeof t) return a = t, this.each(function (t, e) {
                var n = c.data(e, l);
                n ? (n.option(a), n._init()) : (n = new u(e, a), c.data(e, l, n))
            }), this;
            var i, o, r, s, a, e = h.call(arguments, 1);
            return o = e, s = "$()." + l + '("' + (i = t) + '")', (t = this).each(function (t, e) {
                var n = c.data(e, l);
                n ? (e = n[i]) && "_" != i.charAt(0) ? (n = e.apply(n, o), r = void 0 === r ? n : r) : p(s + " is not a valid method") : p(l + " not initialized. Cannot call methods, i.e. " + s)
            }), void 0 !== r ? r : t
        }, i(c))
    }

    function i(t) {
        !t || t && t.bridget || (t.bridget = n)
    }

    var h = Array.prototype.slice, o = t.console, p = void 0 === o ? function () {
    } : function (t) {
        o.error(t)
    };
    return i(e || t.jQuery), n
}), function (t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function () {
    function t() {
    }

    var e = t.prototype;
    return e.on = function (t, e) {
        if (t && e) {
            var n = this._events = this._events || {}, t = n[t] = n[t] || [];
            return -1 == t.indexOf(e) && t.push(e), this
        }
    }, e.once = function (t, e) {
        if (t && e) {
            this.on(t, e);
            var n = this._onceEvents = this._onceEvents || {};
            return (n[t] = n[t] || {})[e] = !0, this
        }
    }, e.off = function (t, e) {
        t = this._events && this._events[t];
        if (t && t.length) {
            e = t.indexOf(e);
            return -1 != e && t.splice(e, 1), this
        }
    }, e.emitEvent = function (t, e) {
        var n = this._events && this._events[t];
        if (n && n.length) {
            n = n.slice(0), e = e || [];
            for (var i = this._onceEvents && this._onceEvents[t], o = 0; o < n.length; o++) {
                var r = n[o];
                i && i[r] && (this.off(t, r), delete i[r]), r.apply(this, e)
            }
            return this
        }
    }, e.allOff = function () {
        delete this._events, delete this._onceEvents
    }, t
}), function (t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function () {
    "use strict";

    function d(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }

    function f(t) {
        t = getComputedStyle(t);
        return t || e("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), t
    }

    function m(t) {
        if (w || (w = !0, (p = document.createElement("div")).style.width = "200px", p.style.padding = "1px 2px 3px 4px", p.style.borderStyle = "solid", p.style.borderWidth = "1px 2px 3px 4px", p.style.boxSizing = "border-box", (h = document.body || document.documentElement).appendChild(p), c = f(p), g = 200 == Math.round(d(c.width)), m.isBoxSizeOuter = g, h.removeChild(p)), (t = "string" == typeof t ? document.querySelector(t) : t) && "object" == typeof t && t.nodeType) {
            var e = f(t);
            if ("none" == e.display) return function () {
                for (var t = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                }, e = 0; e < y; e++) t[v[e]] = 0;
                return t
            }();
            var n = {};
            n.width = t.offsetWidth, n.height = t.offsetHeight;
            for (var i = n.isBorderBox = "border-box" == e.boxSizing, o = 0; o < y; o++) {
                var r = v[o], s = e[r], s = parseFloat(s);
                n[r] = isNaN(s) ? 0 : s
            }
            var a = n.paddingLeft + n.paddingRight, l = n.paddingTop + n.paddingBottom,
                u = n.marginLeft + n.marginRight, c = n.marginTop + n.marginBottom,
                h = n.borderLeftWidth + n.borderRightWidth, p = n.borderTopWidth + n.borderBottomWidth, t = i && g,
                i = d(e.width);
            !1 !== i && (n.width = i + (t ? 0 : a + h));
            i = d(e.height);
            return !1 !== i && (n.height = i + (t ? 0 : l + p)), n.innerWidth = n.width - (a + h), n.innerHeight = n.height - (l + p), n.outerWidth = n.width + u, n.outerHeight = n.height + c, n
        }
        var p, h, c
    }

    var g, e = "undefined" == typeof console ? function () {
        } : function (t) {
            console.error(t)
        },
        v = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        y = v.length, w = !1;
    return m
}), function (t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function () {
    "use strict";
    var n = function () {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], n = 0; n < e.length; n++) {
            var i = e[n] + "MatchesSelector";
            if (t[i]) return i
        }
    }();
    return function (t, e) {
        return t[n](e)
    }
}), function (e, n) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (t) {
        return n(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = n(e, require("desandro-matches-selector")) : e.fizzyUIUtils = n(e, e.matchesSelector)
}(window, function (n, r) {
    var l = {
        extend: function (t, e) {
            for (var n in e) t[n] = e[n];
            return t
        }, modulo: function (t, e) {
            return (t % e + e) % e
        }
    }, e = Array.prototype.slice;
    l.makeArray = function (t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call(t) : [t]
    }, l.removeFrom = function (t, e) {
        e = t.indexOf(e);
        -1 != e && t.splice(e, 1)
    }, l.getParent = function (t, e) {
        for (; t.parentNode && t != document.body;) if (t = t.parentNode, r(t, e)) return t
    }, l.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }, l.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, l.filterFindElements = function (t, i) {
        t = l.makeArray(t);
        var o = [];
        return t.forEach(function (t) {
            if (t instanceof HTMLElement) if (i) {
                r(t, i) && o.push(t);
                for (var e = t.querySelectorAll(i), n = 0; n < e.length; n++) o.push(e[n])
            } else o.push(t)
        }), o
    }, l.debounceMethod = function (t, e, i) {
        i = i || 100;
        var o = t.prototype[e], r = e + "Timeout";
        t.prototype[e] = function () {
            var t = this[r];
            clearTimeout(t);
            var e = arguments, n = this;
            this[r] = setTimeout(function () {
                o.apply(n, e), delete n[r]
            }, i)
        }
    }, l.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }, l.toDashed = function (t) {
        return t.replace(/(.)([A-Z])/g, function (t, e, n) {
            return e + "-" + n
        }).toLowerCase()
    };
    var u = n.console;
    return l.htmlInit = function (s, a) {
        l.docReady(function () {
            var t = l.toDashed(a), i = "data-" + t, e = document.querySelectorAll("[" + i + "]"),
                t = document.querySelectorAll(".js-" + t), t = l.makeArray(e).concat(l.makeArray(t)),
                o = i + "-options", r = n.jQuery;
            t.forEach(function (e) {
                var t = e.getAttribute(i) || e.getAttribute(o);
                try {
                    n = t && JSON.parse(t)
                } catch (t) {
                    return void (u && u.error("Error parsing " + i + " on " + e.className + ": " + t))
                }
                var n = new s(e, n);
                r && r.data(e, a, n)
            })
        })
    }, l
}), function (t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function (t, e) {
    "use strict";

    function n(t, e) {
        t && (this.element = t, this.layout = e, this.position = {x: 0, y: 0}, this._create())
    }

    var i = document.documentElement.style, o = "string" == typeof i.transition ? "transition" : "WebkitTransition",
        r = "string" == typeof i.transform ? "transform" : "WebkitTransform",
        s = {WebkitTransition: "webkitTransitionEnd", transition: "transitionend"}[o], a = {
            transform: r,
            transition: o,
            transitionDuration: o + "Duration",
            transitionProperty: o + "Property",
            transitionDelay: o + "Delay"
        }, t = n.prototype = Object.create(t.prototype);
    t.constructor = n, t._create = function () {
        this._transn = {ingProperties: {}, clean: {}, onEnd: {}}, this.css({position: "absolute"})
    }, t.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, t.getSize = function () {
        this.size = e(this.element)
    }, t.css = function (t) {
        var e, n = this.element.style;
        for (e in t) n[a[e] || e] = t[e]
    }, t.getPosition = function () {
        var t = getComputedStyle(this.element), e = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"), i = t[e ? "left" : "right"], o = t[n ? "top" : "bottom"],
            r = parseFloat(i), s = parseFloat(o), t = this.layout.size;
        -1 != i.indexOf("%") && (r = r / 100 * t.width), -1 != o.indexOf("%") && (s = s / 100 * t.height), r = isNaN(r) ? 0 : r, s = isNaN(s) ? 0 : s, r -= e ? t.paddingLeft : t.paddingRight, s -= n ? t.paddingTop : t.paddingBottom, this.position.x = r, this.position.y = s
    }, t.layoutPosition = function () {
        var t = this.layout.size, e = {}, n = this.layout._getOption("originLeft"),
            i = this.layout._getOption("originTop"), o = n ? "right" : "left",
            r = this.position.x + t[n ? "paddingLeft" : "paddingRight"];
        e[n ? "left" : "right"] = this.getXValue(r), e[o] = "";
        o = i ? "bottom" : "top", t = this.position.y + t[i ? "paddingTop" : "paddingBottom"];
        e[i ? "top" : "bottom"] = this.getYValue(t), e[o] = "", this.css(e), this.emitEvent("layout", [this])
    }, t.getXValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }, t.getYValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }, t._transitionTo = function (t, e) {
        this.getPosition();
        var n = this.position.x, i = this.position.y, o = t == this.position.x && e == this.position.y;
        this.setPosition(t, e), !o || this.isTransitioning ? ((o = {}).transform = this.getTranslate(t - n, e - i), this.transition({
            to: o,
            onTransitionEnd: {transform: this.layoutPosition},
            isCleaning: !0
        })) : this.layoutPosition()
    }, t.getTranslate = function (t, e) {
        return "translate3d(" + (t = this.layout._getOption("originLeft") ? t : -t) + "px, " + (e = this.layout._getOption("originTop") ? e : -e) + "px, 0)"
    }, t.goTo = function (t, e) {
        this.setPosition(t, e), this.layoutPosition()
    }, t.moveTo = t._transitionTo, t.setPosition = function (t, e) {
        this.position.x = parseFloat(t), this.position.y = parseFloat(e)
    }, t._nonTransition = function (t) {
        for (var e in this.css(t.to), t.isCleaning && this._removeStyles(t.to), t.onTransitionEnd) t.onTransitionEnd[e].call(this)
    }, t.transition = function (t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
            var e, n = this._transn;
            for (e in t.onTransitionEnd) n.onEnd[e] = t.onTransitionEnd[e];
            for (e in t.to) n.ingProperties[e] = !0, t.isCleaning && (n.clean[e] = !0);
            t.from && (this.css(t.from), this.element.offsetHeight, 0), this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
        } else this._nonTransition(t)
    };
    var l = "opacity," + r.replace(/([A-Z])/g, function (t) {
        return "-" + t.toLowerCase()
    });
    t.enableTransition = function () {
        var t;
        this.isTransitioning || (t = this.layout.options.transitionDuration, this.css({
            transitionProperty: l,
            transitionDuration: t = "number" == typeof t ? t + "ms" : t,
            transitionDelay: this.staggerDelay || 0
        }), this.element.addEventListener(s, this, !1))
    }, t.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t)
    }, t.onotransitionend = function (t) {
        this.ontransitionend(t)
    };
    var u = {"-webkit-transform": "transform"};
    t.ontransitionend = function (t) {
        var e, n;
        t.target === this.element && (e = this._transn, n = u[t.propertyName] || t.propertyName, delete e.ingProperties[n], function (t) {
            for (var e in t) return;
            return 1
        }(e.ingProperties) && this.disableTransition(), n in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[n]), n in e.onEnd && (e.onEnd[n].call(this), delete e.onEnd[n]), this.emitEvent("transitionEnd", [this]))
    }, t.disableTransition = function () {
        this.removeTransitionStyles(), this.element.removeEventListener(s, this, !1), this.isTransitioning = !1
    }, t._removeStyles = function (t) {
        var e, n = {};
        for (e in t) n[e] = "";
        this.css(n)
    };
    var c = {transitionProperty: "", transitionDuration: "", transitionDelay: ""};
    return t.removeTransitionStyles = function () {
        this.css(c)
    }, t.stagger = function (t) {
        t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
    }, t.removeElem = function () {
        this.element.parentNode.removeChild(this.element), this.css({display: ""}), this.emitEvent("remove", [this])
    }, t.remove = function () {
        return o && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function () {
            this.removeElem()
        }), void this.hide()) : void this.removeElem()
    }, t.reveal = function () {
        delete this.isHidden, this.css({display: ""});
        var t = this.layout.options, e = {};
        e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, t.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent("reveal")
    }, t.getHideRevealTransitionEndProperty = function (t) {
        var e, t = this.layout.options[t];
        if (t.opacity) return "opacity";
        for (e in t) return e
    }, t.hide = function () {
        this.isHidden = !0, this.css({display: ""});
        var t = this.layout.options, e = {};
        e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, t.onHideTransitionEnd = function () {
        this.isHidden && (this.css({display: "none"}), this.emitEvent("hide"))
    }, t.destroy = function () {
        this.css({position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: ""})
    }, n
}), function (o, r) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (t, e, n, i) {
        return r(o, t, e, n, i)
    }) : "object" == typeof module && module.exports ? module.exports = r(o, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : o.Outlayer = r(o, o.EvEmitter, o.getSize, o.fizzyUIUtils, o.Outlayer.Item)
}(window, function (t, e, o, i, r) {
    "use strict";

    function s(t, e) {
        var n = i.getQueryElement(t);
        n ? (this.element = n, u && (this.$element = u(this.element)), this.options = i.extend({}, this.constructor.defaults), this.option(e), e = ++c, this.element.outlayerGUID = e, (h[e] = this)._create(), this._getOption("initLayout") && this.layout()) : l && l.error("Bad element for " + this.constructor.namespace + ": " + (n || t))
    }

    function a(t) {
        function e() {
            t.apply(this, arguments)
        }

        return (e.prototype = Object.create(t.prototype)).constructor = e
    }

    function n() {
    }

    var l = t.console, u = t.jQuery, c = 0, h = {};
    s.namespace = "outlayer", s.Item = r, s.defaults = {
        containerStyle: {position: "relative"},
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {opacity: 0, transform: "scale(0.001)"},
        visibleStyle: {opacity: 1, transform: "scale(1)"}
    };
    var p = s.prototype;
    i.extend(p, e.prototype), p.option = function (t) {
        i.extend(this.options, t)
    }, p._getOption = function (t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }, s.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    }, p._create = function () {
        this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), i.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize()
    }, p.reloadItems = function () {
        this.items = this._itemize(this.element.children)
    }, p._itemize = function (t) {
        for (var e = this._filterFindItemElements(t), n = this.constructor.Item, i = [], o = 0; o < e.length; o++) {
            var r = new n(e[o], this);
            i.push(r)
        }
        return i
    }, p._filterFindItemElements = function (t) {
        return i.filterFindElements(t, this.options.itemSelector)
    }, p.getItemElements = function () {
        return this.items.map(function (t) {
            return t.element
        })
    }, p.layout = function () {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"), t = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, t), this._isLayoutInited = !0
    }, p._init = p.layout, p._resetLayout = function () {
        this.getSize()
    }, p.getSize = function () {
        this.size = o(this.element)
    }, p._getMeasurement = function (t, e) {
        var n, i = this.options[t];
        i ? ("string" == typeof i ? n = this.element.querySelector(i) : i instanceof HTMLElement && (n = i), this[t] = n ? o(n)[e] : i) : this[t] = 0
    }, p.layoutItems = function (t, e) {
        t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
    }, p._getItemsForLayout = function (t) {
        return t.filter(function (t) {
            return !t.isIgnored
        })
    }, p._layoutItems = function (t, n) {
        var i;
        this._emitCompleteOnItems("layout", t), t && t.length && (i = [], t.forEach(function (t) {
            var e = this._getItemLayoutPosition(t);
            e.item = t, e.isInstant = n || t.isLayoutInstant, i.push(e)
        }, this), this._processLayoutQueue(i))
    }, p._getItemLayoutPosition = function () {
        return {x: 0, y: 0}
    }, p._processLayoutQueue = function (t) {
        this.updateStagger(), t.forEach(function (t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }, p.updateStagger = function () {
        var t = this.options.stagger;
        return null == t ? void (this.stagger = 0) : (this.stagger = function (t) {
            if ("number" == typeof t) return t;
            var t = (e = t.match(/(^\d*\.?\d*)(\w*)/)) && e[1], e = e && e[2];
            return t.length ? (t = parseFloat(t)) * (d[e] || 1) : 0
        }(t), this.stagger)
    }, p._positionItem = function (t, e, n, i, o) {
        i ? t.goTo(e, n) : (t.stagger(o * this.stagger), t.moveTo(e, n))
    }, p._postLayout = function () {
        this.resizeContainer()
    }, p.resizeContainer = function () {
        var t;
        !this._getOption("resizeContainer") || (t = this._getContainerSize()) && (this._setContainerMeasure(t.width, !0), this._setContainerMeasure(t.height, !1))
    }, p._getContainerSize = n, p._setContainerMeasure = function (t, e) {
        var n;
        void 0 !== t && ((n = this.size).isBorderBox && (t += e ? n.paddingLeft + n.paddingRight + n.borderLeftWidth + n.borderRightWidth : n.paddingBottom + n.paddingTop + n.borderTopWidth + n.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px")
    }, p._emitCompleteOnItems = function (e, t) {
        function n() {
            r.dispatchEvent(e + "Complete", null, [t])
        }

        function i() {
            ++o == s && n()
        }

        var o, r = this, s = t.length;
        t && s ? (o = 0, t.forEach(function (t) {
            t.once(e, i)
        })) : n()
    }, p.dispatchEvent = function (t, e, n) {
        var i = e ? [e].concat(n) : n;
        this.emitEvent(t, i), u && (this.$element = this.$element || u(this.element), e ? ((e = u.Event(e)).type = t, this.$element.trigger(e, n)) : this.$element.trigger(t, n))
    }, p.ignore = function (t) {
        t = this.getItem(t);
        t && (t.isIgnored = !0)
    }, p.unignore = function (t) {
        t = this.getItem(t);
        t && delete t.isIgnored
    }, p.stamp = function (t) {
        (t = this._find(t)) && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
    }, p.unstamp = function (t) {
        (t = this._find(t)) && t.forEach(function (t) {
            i.removeFrom(this.stamps, t), this.unignore(t)
        }, this)
    }, p._find = function (t) {
        if (t) return "string" == typeof t && (t = this.element.querySelectorAll(t)), i.makeArray(t)
    }, p._manageStamps = function () {
        this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
    }, p._getBoundingRect = function () {
        var t = this.element.getBoundingClientRect(), e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }, p._manageStamp = n, p._getElementOffset = function (t) {
        var e = t.getBoundingClientRect(), n = this._boundingRect, t = o(t);
        return {
            left: e.left - n.left - t.marginLeft,
            top: e.top - n.top - t.marginTop,
            right: n.right - e.right - t.marginRight,
            bottom: n.bottom - e.bottom - t.marginBottom
        }
    }, p.handleEvent = i.handleEvent, p.bindResize = function () {
        t.addEventListener("resize", this), this.isResizeBound = !0
    }, p.unbindResize = function () {
        t.removeEventListener("resize", this), this.isResizeBound = !1
    }, p.onresize = function () {
        this.resize()
    }, i.debounceMethod(s, "onresize", 100), p.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }, p.needsResizeLayout = function () {
        var t = o(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth
    }, p.addItems = function (t) {
        t = this._itemize(t);
        return t.length && (this.items = this.items.concat(t)), t
    }, p.appended = function (t) {
        t = this.addItems(t);
        t.length && (this.layoutItems(t, !0), this.reveal(t))
    }, p.prepended = function (t) {
        var e = this._itemize(t);
        e.length && (t = this.items.slice(0), this.items = e.concat(t), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(t))
    }, p.reveal = function (t) {
        var n;
        this._emitCompleteOnItems("reveal", t), t && t.length && (n = this.updateStagger(), t.forEach(function (t, e) {
            t.stagger(e * n), t.reveal()
        }))
    }, p.hide = function (t) {
        var n;
        this._emitCompleteOnItems("hide", t), t && t.length && (n = this.updateStagger(), t.forEach(function (t, e) {
            t.stagger(e * n), t.hide()
        }))
    }, p.revealItemElements = function (t) {
        t = this.getItems(t);
        this.reveal(t)
    }, p.hideItemElements = function (t) {
        t = this.getItems(t);
        this.hide(t)
    }, p.getItem = function (t) {
        for (var e = 0; e < this.items.length; e++) {
            var n = this.items[e];
            if (n.element == t) return n
        }
    }, p.getItems = function (t) {
        t = i.makeArray(t);
        var e = [];
        return t.forEach(function (t) {
            t = this.getItem(t);
            t && e.push(t)
        }, this), e
    }, p.remove = function (t) {
        t = this.getItems(t);
        this._emitCompleteOnItems("remove", t), t && t.length && t.forEach(function (t) {
            t.remove(), i.removeFrom(this.items, t)
        }, this)
    }, p.destroy = function () {
        var t = this.element.style;
        t.height = "", t.position = "", t.width = "", this.items.forEach(function (t) {
            t.destroy()
        }), this.unbindResize();
        t = this.element.outlayerGUID;
        delete h[t], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace)
    }, s.data = function (t) {
        t = (t = i.getQueryElement(t)) && t.outlayerGUID;
        return t && h[t]
    }, s.create = function (t, e) {
        var n = a(s);
        return n.defaults = i.extend({}, s.defaults), i.extend(n.defaults, e), n.compatOptions = i.extend({}, s.compatOptions), n.namespace = t, n.data = s.data, n.Item = a(r), i.htmlInit(n, t), u && u.bridget && u.bridget(t, n), n
    };
    var d = {ms: 1, s: 1e3};
    return s.Item = r, s
}), function (t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/item", ["outlayer/outlayer"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer")) : (t.Isotope = t.Isotope || {}, t.Isotope.Item = e(t.Outlayer))
}(window, function (t) {
    "use strict";

    function e() {
        t.Item.apply(this, arguments)
    }

    var n = e.prototype = Object.create(t.Item.prototype), i = n._create;
    n._create = function () {
        this.id = this.layout.itemGUID++, i.call(this), this.sortData = {}
    }, n.updateSortData = function () {
        if (!this.isIgnored) {
            this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
            var t, e = this.layout.options.getSortData, n = this.layout._sorters;
            for (t in e) {
                var i = n[t];
                this.sortData[t] = i(this.element, this)
            }
        }
    };
    var o = n.destroy;
    return n.destroy = function () {
        o.apply(this, arguments), this.css({display: ""})
    }, e
}), function (t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-mode", ["get-size/get-size", "outlayer/outlayer"], e) : "object" == typeof module && module.exports ? module.exports = e(require("get-size"), require("outlayer")) : (t.Isotope = t.Isotope || {}, t.Isotope.LayoutMode = e(t.getSize, t.Outlayer))
}(window, function (e, n) {
    "use strict";

    function i(t) {
        (this.isotope = t) && (this.options = t.options[this.namespace], this.element = t.element, this.items = t.filteredItems, this.size = t.size)
    }

    var o = i.prototype;
    return ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"].forEach(function (t) {
        o[t] = function () {
            return n.prototype[t].apply(this.isotope, arguments)
        }
    }), o.needsVerticalResizeLayout = function () {
        var t = e(this.isotope.element);
        return this.isotope.size && t && t.innerHeight != this.isotope.size.innerHeight
    }, o._getMeasurement = function () {
        this.isotope._getMeasurement.apply(this, arguments)
    }, o.getColumnWidth = function () {
        this.getSegmentSize("column", "Width")
    }, o.getRowHeight = function () {
        this.getSegmentSize("row", "Height")
    }, o.getSegmentSize = function (t, e) {
        var n = t + e, i = "outer" + e;
        this._getMeasurement(n, i), this[n] || (t = this.getFirstItemSize(), this[n] = t && t[i] || this.isotope.size["inner" + e])
    }, o.getFirstItemSize = function () {
        var t = this.isotope.filteredItems[0];
        return t && t.element && e(t.element)
    }, o.layout = function () {
        this.isotope.layout.apply(this.isotope, arguments)
    }, o.getSize = function () {
        this.isotope.getSize(), this.size = this.isotope.size
    }, i.modes = {}, i.create = function (t, e) {
        function n() {
            i.apply(this, arguments)
        }

        return (n.prototype = Object.create(o)).constructor = n, e && (n.options = e), i.modes[n.prototype.namespace = t] = n
    }, i
}), function (t, e) {
    "function" == typeof define && define.amd ? define("masonry-layout/masonry", ["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function (t, a) {
    var e = t.create("masonry");
    e.compatOptions.fitWidth = "isFitWidth";
    t = e.prototype;
    return t._resetLayout = function () {
        this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        this.maxY = 0, this.horizontalColIndex = 0
    }, t.measureColumns = function () {
        this.getContainerWidth(), this.columnWidth || (n = (e = this.items[0]) && e.element, this.columnWidth = n && a(n).outerWidth || this.containerWidth);
        var t = this.columnWidth += this.gutter, e = this.containerWidth + this.gutter, n = e / t, t = t - e % t,
            n = Math[t && t < 1 ? "round" : "floor"](n);
        this.cols = Math.max(n, 1)
    }, t.getContainerWidth = function () {
        var t = this._getOption("fitWidth") ? this.element.parentNode : this.element, t = a(t);
        this.containerWidth = t && t.innerWidth
    }, t._getItemLayoutPosition = function (t) {
        t.getSize();
        for (var e = t.size.outerWidth % this.columnWidth, n = Math[e && e < 1 ? "round" : "ceil"](t.size.outerWidth / this.columnWidth), n = Math.min(n, this.cols), i = this[this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition"](n, t), e = {
            x: this.columnWidth * i.col,
            y: i.y
        }, o = i.y + t.size.outerHeight, r = n + i.col, s = i.col; s < r; s++) this.colYs[s] = o;
        return e
    }, t._getTopColPosition = function (t) {
        var e = this._getTopColGroup(t), t = Math.min.apply(Math, e);
        return {col: e.indexOf(t), y: t}
    }, t._getTopColGroup = function (t) {
        if (t < 2) return this.colYs;
        for (var e = [], n = this.cols + 1 - t, i = 0; i < n; i++) e[i] = this._getColGroupY(i, t);
        return e
    }, t._getColGroupY = function (t, e) {
        if (e < 2) return this.colYs[t];
        e = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, e)
    }, t._getHorizontalColPosition = function (t, e) {
        var n = this.horizontalColIndex % this.cols, n = 1 < t && n + t > this.cols ? 0 : n,
            e = e.size.outerWidth && e.size.outerHeight;
        return this.horizontalColIndex = e ? n + t : this.horizontalColIndex, {col: n, y: this._getColGroupY(n, t)}
    }, t._manageStamp = function (t) {
        var e = a(t), n = this._getElementOffset(t), i = this._getOption("originLeft") ? n.left : n.right,
            t = i + e.outerWidth, i = Math.floor(i / this.columnWidth), i = Math.max(0, i),
            o = Math.floor(t / this.columnWidth);
        o -= t % this.columnWidth ? 0 : 1;
        for (var o = Math.min(this.cols - 1, o), r = (this._getOption("originTop") ? n.top : n.bottom) + e.outerHeight, s = i; s <= o; s++) this.colYs[s] = Math.max(r, this.colYs[s])
    }, t._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {height: this.maxY};
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t
    }, t._getContainerFitWidth = function () {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }, t.needsResizeLayout = function () {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth
    }, e
}), function (t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/masonry", ["../layout-mode", "masonry-layout/masonry"], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode"), require("masonry-layout")) : e(t.Isotope.LayoutMode, t.Masonry)
}(window, function (t, e) {
    "use strict";
    var n, t = t.create("masonry"), i = t.prototype, o = {_getElementOffset: !0, layout: !0, _getMeasurement: !0};
    for (n in e.prototype) o[n] || (i[n] = e.prototype[n]);
    var r = i.measureColumns;
    i.measureColumns = function () {
        this.items = this.isotope.filteredItems, r.call(this)
    };
    var s = i._getOption;
    return i._getOption = function (t) {
        return "fitWidth" == t ? void 0 !== this.options.isFitWidth ? this.options.isFitWidth : this.options.fitWidth : s.apply(this.isotope, arguments)
    }, t
}), function (t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/fit-rows", ["../layout-mode"], e) : "object" == typeof exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode)
}(window, function (t) {
    "use strict";
    var e = t.create("fitRows"), t = e.prototype;
    return t._resetLayout = function () {
        this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth")
    }, t._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth + this.gutter, n = this.isotope.size.innerWidth + this.gutter;
        0 !== this.x && e + this.x > n && (this.x = 0, this.y = this.maxY);
        n = {x: this.x, y: this.y};
        return this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight), this.x += e, n
    }, t._getContainerSize = function () {
        return {height: this.maxY}
    }, e
}), function (t, e) {
    "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/vertical", ["../layout-mode"], e) : "object" == typeof module && module.exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode)
}(window, function (t) {
    "use strict";
    var e = t.create("vertical", {horizontalAlignment: 0}), t = e.prototype;
    return t._resetLayout = function () {
        this.y = 0
    }, t._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = (this.isotope.size.innerWidth - t.size.outerWidth) * this.options.horizontalAlignment, n = this.y;
        return this.y += t.size.outerHeight, {x: e, y: n}
    }, t._getContainerSize = function () {
        return {height: this.y}
    }, e
}), function (s, a) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size", "desandro-matches-selector/matches-selector", "fizzy-ui-utils/utils", "isotope-layout/js/item", "isotope-layout/js/layout-mode", "isotope-layout/js/layout-modes/masonry", "isotope-layout/js/layout-modes/fit-rows", "isotope-layout/js/layout-modes/vertical"], function (t, e, n, i, o, r) {
        return a(s, t, e, n, i, o, r)
    }) : "object" == typeof module && module.exports ? module.exports = a(s, require("outlayer"), require("get-size"), require("desandro-matches-selector"), require("fizzy-ui-utils"), require("isotope-layout/js/item"), require("isotope-layout/js/layout-mode"), require("isotope-layout/js/layout-modes/masonry"), require("isotope-layout/js/layout-modes/fit-rows"), require("isotope-layout/js/layout-modes/vertical")) : s.Isotope = a(s, s.Outlayer, s.getSize, s.matchesSelector, s.fizzyUIUtils, s.Isotope.Item, s.Isotope.LayoutMode)
}(window, function (t, n, e, i, r, o, s) {
    var a = t.jQuery, l = String.prototype.trim ? function (t) {
        return t.trim()
    } : function (t) {
        return t.replace(/^\s+|\s+$/g, "")
    }, u = n.create("isotope", {layoutMode: "masonry", isJQueryFiltering: !0, sortAscending: !0});
    u.Item = o, u.LayoutMode = s;
    o = u.prototype;
    o._create = function () {
        for (var t in this.itemGUID = 0, this._sorters = {}, this._getSorters(), n.prototype._create.call(this), this.modes = {}, this.filteredItems = this.items, this.sortHistory = ["original-order"], s.modes) this._initLayoutMode(t)
    }, o.reloadItems = function () {
        this.itemGUID = 0, n.prototype.reloadItems.call(this)
    }, o._itemize = function () {
        for (var t = n.prototype._itemize.apply(this, arguments), e = 0; e < t.length; e++) t[e].id = this.itemGUID++;
        return this._updateItemsSortData(t), t
    }, o._initLayoutMode = function (t) {
        var e = s.modes[t], n = this.options[t] || {};
        this.options[t] = e.options ? r.extend(e.options, n) : n, this.modes[t] = new e(this)
    }, o.layout = function () {
        return !this._isLayoutInited && this._getOption("initLayout") ? void this.arrange() : void this._layout()
    }, o._layout = function () {
        var t = this._getIsInstant();
        this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, t), this._isLayoutInited = !0
    }, o.arrange = function (t) {
        this.option(t), this._getIsInstant();
        t = this._filter(this.items);
        this.filteredItems = t.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [t]) : this._hideReveal(t), this._sort(), this._layout()
    }, o._init = o.arrange, o._hideReveal = function (t) {
        this.reveal(t.needReveal), this.hide(t.needHide)
    }, o._getIsInstant = function () {
        var t = this._getOption("layoutInstant"), t = void 0 !== t ? t : !this._isLayoutInited;
        return this._isInstant = t
    }, o._bindArrangeComplete = function () {
        function t() {
            e && n && i && o.dispatchEvent("arrangeComplete", null, [o.filteredItems])
        }

        var e, n, i, o = this;
        this.once("layoutComplete", function () {
            e = !0, t()
        }), this.once("hideComplete", function () {
            n = !0, t()
        }), this.once("revealComplete", function () {
            i = !0, t()
        })
    }, o._filter = function (t) {
        for (var e = this.options.filter, n = [], i = [], o = [], r = this._getFilterTest(e = e || "*"), s = 0; s < t.length; s++) {
            var a, l = t[s];
            l.isIgnored || ((a = r(l)) && n.push(l), a && l.isHidden ? i.push(l) : a || l.isHidden || o.push(l))
        }
        return {matches: n, needReveal: i, needHide: o}
    }, o._getFilterTest = function (e) {
        return a && this.options.isJQueryFiltering ? function (t) {
            return a(t.element).is(e)
        } : "function" == typeof e ? function (t) {
            return e(t.element)
        } : function (t) {
            return i(t.element, e)
        }
    }, o.updateSortData = function (t) {
        t = t ? (t = r.makeArray(t), this.getItems(t)) : this.items;
        this._getSorters(), this._updateItemsSortData(t)
    }, o._getSorters = function () {
        var t, e = this.options.getSortData;
        for (t in e) {
            var n = e[t];
            this._sorters[t] = c(n)
        }
    }, o._updateItemsSortData = function (t) {
        for (var e = t && t.length, n = 0; e && n < e; n++) t[n].updateSortData()
    };
    var c = function (t) {
        if ("string" != typeof t) return t;
        var e, n, i = l(t).split(" "), o = i[0], t = (t = o.match(/^\[(.+)\]$/)) && t[1],
            r = (n = o, (e = t) ? function (t) {
                return t.getAttribute(e)
            } : function (t) {
                t = t.querySelector(n);
                return t && t.textContent
            }), s = u.sortDataParsers[i[1]];
        return s ? function (t) {
            return t && s(r(t))
        } : function (t) {
            return t && r(t)
        }
    };
    u.sortDataParsers = {
        parseInt: function (t) {
            return parseInt(t, 10)
        }, parseFloat: function (t) {
            return parseFloat(t)
        }
    }, o._sort = function () {
        var t, s, a;
        this.options.sortBy && (t = r.makeArray(this.options.sortBy), this._getIsSameSortBy(t) || (this.sortHistory = t.concat(this.sortHistory)), s = this.sortHistory, a = this.options.sortAscending, this.filteredItems.sort(function (t, e) {
            for (var n = 0; n < s.length; n++) {
                var i = s[n], o = t.sortData[i], r = e.sortData[i];
                if (r < o || o < r) return (r < o ? 1 : -1) * ((void 0 !== a[i] ? a[i] : a) ? 1 : -1)
            }
            return 0
        }))
    }, o._getIsSameSortBy = function (t) {
        for (var e = 0; e < t.length; e++) if (t[e] != this.sortHistory[e]) return !1;
        return !0
    }, o._mode = function () {
        var t = this.options.layoutMode, e = this.modes[t];
        if (!e) throw new Error("No layout mode: " + t);
        return e.options = this.options[t], e
    }, o._resetLayout = function () {
        n.prototype._resetLayout.call(this), this._mode()._resetLayout()
    }, o._getItemLayoutPosition = function (t) {
        return this._mode()._getItemLayoutPosition(t)
    }, o._manageStamp = function (t) {
        this._mode()._manageStamp(t)
    }, o._getContainerSize = function () {
        return this._mode()._getContainerSize()
    }, o.needsResizeLayout = function () {
        return this._mode().needsResizeLayout()
    }, o.appended = function (t) {
        t = this.addItems(t);
        t.length && (t = this._filterRevealAdded(t), this.filteredItems = this.filteredItems.concat(t))
    }, o.prepended = function (t) {
        var e = this._itemize(t);
        e.length && (this._resetLayout(), this._manageStamps(), t = this._filterRevealAdded(e), this.layoutItems(this.filteredItems), this.filteredItems = t.concat(this.filteredItems), this.items = e.concat(this.items))
    }, o._filterRevealAdded = function (t) {
        t = this._filter(t);
        return this.hide(t.needHide), this.reveal(t.matches), this.layoutItems(t.matches, !0), t.matches
    }, o.insert = function (t) {
        var e = this.addItems(t);
        if (e.length) {
            for (var n, i = e.length, o = 0; o < i; o++) n = e[o], this.element.appendChild(n.element);
            t = this._filter(e).matches;
            for (o = 0; o < i; o++) e[o].isLayoutInstant = !0;
            for (this.arrange(), o = 0; o < i; o++) delete e[o].isLayoutInstant;
            this.reveal(t)
        }
    };
    var h = o.remove;
    return o.remove = function (t) {
        t = r.makeArray(t);
        var e = this.getItems(t);
        h.call(this, t);
        for (var n = e && e.length, i = 0; n && i < n; i++) {
            var o = e[i];
            r.removeFrom(this.filteredItems, o)
        }
    }, o.shuffle = function () {
        for (var t = 0; t < this.items.length; t++) this.items[t].sortData.random = Math.random();
        this.options.sortBy = "random", this._sort(), this._layout()
    }, o._noTransition = function (t, e) {
        var n = this.options.transitionDuration;
        this.options.transitionDuration = 0;
        e = t.apply(this, e);
        return this.options.transitionDuration = n, e
    }, o.getFilteredItemElements = function () {
        return this.filteredItems.map(function (t) {
            return t.element
        })
    }, u
}), "function" != typeof Object.create && (Object.create = function (t) {
    function e() {
    }

    return e.prototype = t, new e
}), function (s) {
    var n = {
        init: function (t, e) {
            var n = this;
            n.elem = e, n.$elem = s(e), n.imageSrc = n.$elem.attr("data-zoom-image") ? n.$elem.attr("data-zoom-image") : n.$elem.attr("href") ? n.$elem.attr("href") : n.$elem.data("original") ? n.$elem.data("original") : n.$elem.attr("src"), n.options = s.extend({}, s.fn.elevateZoom.options, t), n.options.tint && (n.options.lensColour = "none", n.options.lensOpacity = "1"), "inner" == n.options.zoomType && (n.options.showLens = !1), n.options.zoomContainer ? n.$container = s(n.options.zoomContainer) : n.$container = s("body"), n.$elem.parent().removeAttr("title").removeAttr("alt"), n.zoomImage = n.imageSrc, n.refresh(1), s("#" + n.options.gallery + " a").click(function (t) {
                return n.options.galleryActiveClass && (s("#" + n.options.gallery + " a").removeClass(n.options.galleryActiveClass), s(this).addClass(n.options.galleryActiveClass)), t.preventDefault(), s(this).attr("data-zoom-image") ? n.zoomImagePre = s(this).attr("data-zoom-image") : n.zoomImagePre = s(this).data("image"), n.swaptheimage(s(this).data("image"), n.zoomImagePre), !1
            })
        }, refresh: function (t) {
            var e = this;
            setTimeout(function () {
                e.fetch(e.imageSrc)
            }, t || e.options.refresh)
        }, fetch: function (t) {
            var e = this, n = new Image;
            n.onload = function () {
                e.largeWidth = n.width, e.largeHeight = n.height, e.startZoom(), e.currentImage = e.imageSrc, e.options.onZoomedImageLoaded(e.$elem)
            }, n.src = t
        }, startZoom: function () {
            var n = this;
            n.nzWidth = n.$elem.width(), n.nzHeight = n.$elem.height(), n.isWindowActive = !1, n.isLensActive = !1, n.isTintActive = !1, n.overWindow = !1, n.options.imageCrossfade && (n.zoomWrap = n.$elem.wrap('<div style="height:' + n.nzHeight + "px;width:" + n.nzWidth + 'px;" class="zoomWrapper" />'), n.$elem.css("position", "absolute")), n.zoomLock = 1, n.scrollingLock = !1, n.changeBgSize = !1, n.currentZoomLevel = n.options.zoomLevel, n.nzOffset = n.$elem.offset(), n.ctOffset = n.$container.offset(), n.widthRatio = n.largeWidth / n.currentZoomLevel / n.nzWidth, n.heightRatio = n.largeHeight / n.currentZoomLevel / n.nzHeight, "window" == n.options.zoomType && (n.zoomWindowStyle = "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " + String(n.options.zoomWindowBgColour) + ";width: " + String(n.options.zoomWindowWidth) + "px;height: " + String(n.options.zoomWindowHeight) + "px;float: left;background-size: " + n.largeWidth / n.currentZoomLevel + "px " + n.largeHeight / n.currentZoomLevel + "px;display: none;z-index:100;border: " + String(n.options.borderSize) + "px solid " + n.options.borderColour + ";background-repeat: no-repeat;position: absolute;"), "inner" == n.options.zoomType && (n.$elem.css("border-left-width"), n.zoomWindowStyle = "overflow: hidden;margin-left: -" + String(n.options.borderSize) + "px;margin-top: -" + String(n.options.borderSize) + "px;background-position: 0px 0px;width: " + String(n.nzWidth) + "px;height: " + String(n.nzHeight) + "px;float: left;display: none;cursor:" + n.options.cursor + ";border: " + String(n.options.borderSize) + "px solid " + n.options.borderColour + ";background-repeat: no-repeat;position: absolute;"), "window" == n.options.zoomType && (lensHeight = n.nzHeight < n.options.zoomWindowWidth / n.widthRatio ? n.nzHeight : String(n.options.zoomWindowHeight / n.heightRatio), lensWidth = n.largeWidth < n.options.zoomWindowWidth ? n.nzWidth : n.options.zoomWindowWidth / n.widthRatio, n.lensStyle = "background-position: 0px 0px;width: " + String(n.options.zoomWindowWidth / n.widthRatio) + "px;height: " + String(n.options.zoomWindowHeight / n.heightRatio) + "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" + n.options.lensOpacity + ";filter: alpha(opacity = " + 100 * n.options.lensOpacity + "); zoom:1;width:" + lensWidth + "px;height:" + lensHeight + "px;background-color:" + n.options.lensColour + ";cursor:" + n.options.cursor + ";border: " + n.options.lensBorderSize + "px solid " + n.options.lensBorderColour + ";background-repeat: no-repeat;position: absolute;"), n.tintStyle = "display: block;position: absolute;background-color: " + n.options.tintColour + ";filter:alpha(opacity=0);opacity: 0;width: " + n.nzWidth + "px;height: " + n.nzHeight + "px;", n.lensRound = "", "lens" == n.options.zoomType && (n.lensStyle = "background-position: 0px 0px;float: left;display: none;border: " + String(n.options.borderSize) + "px solid " + n.options.borderColour + ";width:" + String(n.options.lensSize) + "px;height:" + String(n.options.lensSize) + "px;background-repeat: no-repeat;position: absolute;"), "round" == n.options.lensShape && (n.lensRound = "border-top-left-radius: " + String(n.options.lensSize / 2 + n.options.borderSize) + "px;border-top-right-radius: " + String(n.options.lensSize / 2 + n.options.borderSize) + "px;border-bottom-left-radius: " + String(n.options.lensSize / 2 + n.options.borderSize) + "px;border-bottom-right-radius: " + String(n.options.lensSize / 2 + n.options.borderSize) + "px;"), void 0 !== n.ctOffset && (n.$container.find(".zoomContainer").length && n.$container.find(".zoomContainer").remove(), n.zoomContainer = s('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' + (n.nzOffset.left - n.ctOffset.left) + "px;top:" + (n.nzOffset.top - n.ctOffset.top) + "px;height:" + n.nzHeight + "px;width:" + n.nzWidth + 'px;"></div>'), n.$container.append(n.zoomContainer), n.options.containLensZoom && "lens" == n.options.zoomType && n.zoomContainer.css("overflow", "hidden"), "inner" != n.options.zoomType && (n.zoomLens = s("<div class='zoomLens' style='" + n.lensStyle + n.lensRound + "'>&nbsp;</div>").appendTo(n.zoomContainer).click(function () {
                n.$elem.trigger("click")
            }), n.options.tint && (n.tintContainer = s("<div/>").addClass("tintContainer"), n.zoomTint = s("<div class='zoomTint' style='" + n.tintStyle + "'></div>"), n.zoomLens.wrap(n.tintContainer), n.zoomTintcss = n.zoomLens.after(n.zoomTint), n.zoomTintImage = s('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' + n.nzWidth + "px; height: " + n.nzHeight + 'px;" src="' + n.imageSrc + '">').appendTo(n.zoomLens).click(function () {
                n.$elem.trigger("click")
            }))), isNaN(n.options.zoomWindowPosition) ? n.zoomWindow = s("<div style='z-index:999;left:" + n.windowOffsetLeft + "px;top:" + n.windowOffsetTop + "px;" + n.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo(n.$container).click(function () {
                n.$elem.trigger("click")
            }) : n.zoomWindow = s("<div style='z-index:999;left:" + n.windowOffsetLeft + "px;top:" + n.windowOffsetTop + "px;" + n.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo(n.zoomContainer).click(function () {
                n.$elem.trigger("click")
            }), n.zoomWindowContainer = s("<div/>").addClass("zoomWindowContainer").css("width", n.options.zoomWindowWidth), n.zoomWindow.wrap(n.zoomWindowContainer), "lens" == n.options.zoomType && n.zoomLens.css({backgroundImage: "url('" + n.imageSrc + "')"}), "window" == n.options.zoomType && n.zoomWindow.css({backgroundImage: "url('" + n.imageSrc + "')"}), "inner" == n.options.zoomType && n.zoomWindow.css({backgroundImage: "url('" + n.imageSrc + "')"}), n.$elem.bind("touchmove", function (t) {
                t.preventDefault();
                t = t.originalEvent.touches[0] || t.originalEvent.changedTouches[0];
                n.setPosition(t)
            }), n.zoomContainer.bind("touchmove", function (t) {
                "inner" == n.options.zoomType && n.showHideWindow("show"), t.preventDefault();
                t = t.originalEvent.touches[0] || t.originalEvent.changedTouches[0];
                n.setPosition(t)
            }), n.zoomContainer.bind("touchend", function (t) {
                n.showHideWindow("hide"), n.options.showLens && n.showHideLens("hide"), n.options.tint && "inner" != n.options.zoomType && n.showHideTint("hide")
            }), n.$elem.bind("touchend", function (t) {
                n.showHideWindow("hide"), n.options.showLens && n.showHideLens("hide"), n.options.tint && "inner" != n.options.zoomType && n.showHideTint("hide")
            }), n.options.showLens && (n.zoomLens.bind("touchmove", function (t) {
                t.preventDefault();
                t = t.originalEvent.touches[0] || t.originalEvent.changedTouches[0];
                n.setPosition(t)
            }), n.zoomLens.bind("touchend", function (t) {
                n.showHideWindow("hide"), n.options.showLens && n.showHideLens("hide"), n.options.tint && "inner" != n.options.zoomType && n.showHideTint("hide")
            })), n.$elem.bind("mousemove", function (t) {
                0 == n.overWindow && n.setElements("show"), n.lastX === t.clientX && n.lastY === t.clientY || (n.setPosition(t), n.currentLoc = t), n.lastX = t.clientX, n.lastY = t.clientY
            }), n.zoomContainer.bind("mousemove", function (t) {
                0 == n.overWindow && n.setElements("show"), n.lastX === t.clientX && n.lastY === t.clientY || (n.setPosition(t), n.currentLoc = t), n.lastX = t.clientX, n.lastY = t.clientY
            }), "inner" != n.options.zoomType && n.zoomLens.bind("mousemove", function (t) {
                n.lastX === t.clientX && n.lastY === t.clientY || (n.setPosition(t), n.currentLoc = t), n.lastX = t.clientX, n.lastY = t.clientY
            }), n.options.tint && "inner" != n.options.zoomType && n.zoomTint.bind("mousemove", function (t) {
                n.lastX === t.clientX && n.lastY === t.clientY || (n.setPosition(t), n.currentLoc = t), n.lastX = t.clientX, n.lastY = t.clientY
            }), "inner" == n.options.zoomType && n.zoomWindow.bind("mousemove", function (t) {
                n.lastX === t.clientX && n.lastY === t.clientY || (n.setPosition(t), n.currentLoc = t), n.lastX = t.clientX, n.lastY = t.clientY
            }), n.zoomContainer.add(n.$elem).mouseenter(function () {
                0 == n.overWindow && n.setElements("show")
            }).mouseleave(function () {
                n.scrollLock || n.setElements("hide")
            }), "inner" != n.options.zoomType && n.zoomWindow.mouseenter(function () {
                n.overWindow = !0, n.setElements("hide")
            }).mouseleave(function () {
                n.overWindow = !1
            }), n.options.zoomLevel, n.options.minZoomLevel ? n.minZoomLevel = n.options.minZoomLevel : n.minZoomLevel = 2 * n.options.scrollZoomIncrement, n.options.scrollZoom && n.zoomContainer.add(n.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll", function (t) {
                n.scrollLock = !0, clearTimeout(s.data(this, "timer")), s.data(this, "timer", setTimeout(function () {
                    n.scrollLock = !1
                }, 250));
                var e = t.originalEvent.wheelDelta || -1 * t.originalEvent.detail;
                return t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault(), 0 < e / 120 ? n.currentZoomLevel >= n.minZoomLevel && n.changeZoomLevel(n.currentZoomLevel - n.options.scrollZoomIncrement) : (!n.options.maxZoomLevel || n.currentZoomLevel <= n.options.maxZoomLevel) && n.changeZoomLevel(parseFloat(n.currentZoomLevel) + n.options.scrollZoomIncrement), !1
            }))
        }, setElements: function (t) {
            if (!this.options.zoomEnabled) return !1;
            "show" == t && this.isWindowSet && ("inner" == this.options.zoomType && this.showHideWindow("show"), "window" == this.options.zoomType && this.showHideWindow("show"), this.options.showLens && this.showHideLens("show"), this.options.tint && "inner" != this.options.zoomType && this.showHideTint("show")), "hide" == t && ("window" == this.options.zoomType && this.showHideWindow("hide"), this.options.tint || this.showHideWindow("hide"), this.options.showLens && this.showHideLens("hide"), this.options.tint && this.showHideTint("hide"))
        }, setPosition: function (t) {
            if (!this.options.zoomEnabled) return !1;
            this.nzHeight = this.$elem.height(), this.nzWidth = this.$elem.width(), this.nzOffset = this.$elem.offset(), this.ctOffset = this.$container.offset(), this.options.tint && "inner" != this.options.zoomType && (this.zoomTint.css({top: 0}), this.zoomTint.css({left: 0})), this.options.responsive && !this.options.scrollZoom && this.options.showLens && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.largeWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.widthRatio = this.largeWidth / this.nzWidth, this.heightRatio = this.largeHeight / this.nzHeight, "lens" != this.options.zoomType && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.options.zoomWindowWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight), this.options.tint && (this.zoomTintImage.css("width", this.nzWidth), this.zoomTintImage.css("height", this.nzHeight))), "lens" == this.options.zoomType && this.zoomLens.css({
                width: String(this.options.lensSize) + "px",
                height: String(this.options.lensSize) + "px"
            })), this.zoomContainer.css({top: this.nzOffset.top - this.ctOffset.top}), this.zoomContainer.css({left: this.nzOffset.left - this.ctOffset.left}), this.mouseLeft = parseInt(t.pageX - this.nzOffset.left), this.mouseTop = parseInt(t.pageY - this.nzOffset.top), "window" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.zoomLens.height() / 2, this.Eboppos = this.mouseTop > this.nzHeight - this.zoomLens.height() / 2 - 2 * this.options.lensBorderSize, this.Eloppos = this.mouseLeft < 0 + this.zoomLens.width() / 2, this.Eroppos = this.mouseLeft > this.nzWidth - this.zoomLens.width() / 2 - 2 * this.options.lensBorderSize), "inner" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.nzHeight / 2 / this.heightRatio, this.Eboppos = this.mouseTop > this.nzHeight - this.nzHeight / 2 / this.heightRatio, this.Eloppos = this.mouseLeft < 0 + this.nzWidth / 2 / this.widthRatio, this.Eroppos = this.mouseLeft > this.nzWidth - this.nzWidth / 2 / this.widthRatio - 2 * this.options.lensBorderSize), this.mouseLeft <= 0 || this.mouseTop < 0 || this.mouseLeft > this.nzWidth || this.mouseTop > this.nzHeight ? this.setElements("hide") : (this.options.showLens && (this.lensLeftPos = String(this.mouseLeft - this.zoomLens.width() / 2), this.lensTopPos = String(this.mouseTop - this.zoomLens.height() / 2)), this.Etoppos && (this.lensTopPos = 0), this.Eloppos && (this.windowLeftPos = 0, this.lensLeftPos = 0, this.tintpos = 0), "window" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)), "inner" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.nzWidth - 2 * this.options.lensBorderSize)), "lens" == this.options.zoomType && (this.windowLeftPos = String(-1 * ((t.pageX - this.nzOffset.left) * this.widthRatio - this.zoomLens.width() / 2)), this.windowTopPos = String(-1 * ((t.pageY - this.nzOffset.top) * this.heightRatio - this.zoomLens.height() / 2)), this.zoomLens.css({backgroundPosition: this.windowLeftPos + "px " + this.windowTopPos + "px"}), this.changeBgSize && (this.nzHeight > this.nzWidth ? ("lens" == this.options.zoomType && this.zoomLens.css({"background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"}), this.zoomWindow.css({"background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"})) : ("lens" == this.options.zoomType && this.zoomLens.css({"background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"}), this.zoomWindow.css({"background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"})), this.changeBgSize = !1), this.setWindowPostition(t)), this.options.tint && "inner" != this.options.zoomType && this.setTintPosition(t), "window" == this.options.zoomType && this.setWindowPostition(t), "inner" == this.options.zoomType && this.setWindowPostition(t), this.options.showLens && (this.fullwidth && "lens" != this.options.zoomType && (this.lensLeftPos = 0), this.zoomLens.css({
                left: this.lensLeftPos + "px",
                top: this.lensTopPos + "px"
            })))
        }, showHideWindow: function (t) {
            "show" == t && (this.isWindowActive || (this.options.zoomWindowFadeIn ? this.zoomWindow.stop(!0, !0, !1).fadeIn(this.options.zoomWindowFadeIn) : this.zoomWindow.show(), this.isWindowActive = !0)), "hide" == t && this.isWindowActive && (this.options.zoomWindowFadeOut ? this.zoomWindow.stop(!0, !0).fadeOut(this.options.zoomWindowFadeOut) : this.zoomWindow.hide(), this.isWindowActive = !1)
        }, showHideLens: function (t) {
            "show" == t && (this.isLensActive || (this.options.lensFadeIn ? this.zoomLens.stop(!0, !0, !1).fadeIn(this.options.lensFadeIn) : this.zoomLens.show(), this.isLensActive = !0)), "hide" == t && this.isLensActive && (this.options.lensFadeOut ? this.zoomLens.stop(!0, !0).fadeOut(this.options.lensFadeOut) : this.zoomLens.hide(), this.isLensActive = !1)
        }, showHideTint: function (t) {
            "show" == t && (this.isTintActive || (this.options.zoomTintFadeIn ? this.zoomTint.css({opacity: this.options.tintOpacity}).animate().stop(!0, !0).fadeIn("slow") : (this.zoomTint.css({opacity: this.options.tintOpacity}).animate(), this.zoomTint.show()), this.isTintActive = !0)), "hide" == t && this.isTintActive && (this.options.zoomTintFadeOut ? this.zoomTint.stop(!0, !0).fadeOut(this.options.zoomTintFadeOut) : this.zoomTint.hide(), this.isTintActive = !1)
        }, setLensPostition: function (t) {
        }, setWindowPostition: function (t) {
            var e = this;
            if (isNaN(e.options.zoomWindowPosition)) e.externalContainer = s("#" + e.options.zoomWindowPosition), e.externalContainerWidth = e.externalContainer.width(), e.externalContainerHeight = e.externalContainer.height(), e.externalContainerOffset = e.externalContainer.offset(), e.windowOffsetTop = e.externalContainerOffset.top, e.windowOffsetLeft = e.externalContainerOffset.left; else switch (e.options.zoomWindowPosition) {
                case 1:
                    e.windowOffsetTop = e.options.zoomWindowOffety, e.windowOffsetLeft = +e.nzWidth;
                    break;
                case 2:
                    e.options.zoomWindowHeight > e.nzHeight && (e.windowOffsetTop = -1 * (e.options.zoomWindowHeight / 2 - e.nzHeight / 2), e.windowOffsetLeft = e.nzWidth);
                    break;
                case 3:
                    e.windowOffsetTop = e.nzHeight - e.zoomWindow.height() - 2 * e.options.borderSize, e.windowOffsetLeft = e.nzWidth;
                    break;
                case 4:
                    e.windowOffsetTop = e.nzHeight, e.windowOffsetLeft = e.nzWidth;
                    break;
                case 5:
                    e.windowOffsetTop = e.nzHeight, e.windowOffsetLeft = e.nzWidth - e.zoomWindow.width() - 2 * e.options.borderSize;
                    break;
                case 6:
                    e.options.zoomWindowHeight > e.nzHeight && (e.windowOffsetTop = e.nzHeight, e.windowOffsetLeft = -1 * (e.options.zoomWindowWidth / 2 - e.nzWidth / 2 + 2 * e.options.borderSize));
                    break;
                case 7:
                    e.windowOffsetTop = e.nzHeight, e.windowOffsetLeft = 0;
                    break;
                case 8:
                    e.windowOffsetTop = e.nzHeight, e.windowOffsetLeft = -1 * (e.zoomWindow.width() + 2 * e.options.borderSize);
                    break;
                case 9:
                    e.windowOffsetTop = e.nzHeight - e.zoomWindow.height() - 2 * e.options.borderSize, e.windowOffsetLeft = -1 * (e.zoomWindow.width() + 2 * e.options.borderSize);
                    break;
                case 10:
                    e.options.zoomWindowHeight > e.nzHeight && (e.windowOffsetTop = -1 * (e.options.zoomWindowHeight / 2 - e.nzHeight / 2), e.windowOffsetLeft = -1 * (e.zoomWindow.width() + 2 * e.options.borderSize));
                    break;
                case 11:
                    e.windowOffsetTop = e.options.zoomWindowOffety, e.windowOffsetLeft = -1 * (e.zoomWindow.width() + 2 * e.options.borderSize);
                    break;
                case 12:
                    e.windowOffsetTop = -1 * (e.zoomWindow.height() + 2 * e.options.borderSize), e.windowOffsetLeft = -1 * (e.zoomWindow.width() + 2 * e.options.borderSize);
                    break;
                case 13:
                    e.windowOffsetTop = -1 * (e.zoomWindow.height() + 2 * e.options.borderSize), e.windowOffsetLeft = 0;
                    break;
                case 14:
                    e.options.zoomWindowHeight > e.nzHeight && (e.windowOffsetTop = -1 * (e.zoomWindow.height() + 2 * e.options.borderSize), e.windowOffsetLeft = -1 * (e.options.zoomWindowWidth / 2 - e.nzWidth / 2 + 2 * e.options.borderSize));
                    break;
                case 15:
                    e.windowOffsetTop = -1 * (e.zoomWindow.height() + 2 * e.options.borderSize), e.windowOffsetLeft = e.nzWidth - e.zoomWindow.width() - 2 * e.options.borderSize;
                    break;
                case 16:
                    e.windowOffsetTop = -1 * (e.zoomWindow.height() + 2 * e.options.borderSize), e.windowOffsetLeft = e.nzWidth;
                    break;
                default:
                    e.windowOffsetTop = e.options.zoomWindowOffety, e.windowOffsetLeft = e.nzWidth
            }
            e.isWindowSet = !0, e.windowOffsetTop = e.windowOffsetTop + e.options.zoomWindowOffety, e.windowOffsetLeft = e.windowOffsetLeft + e.options.zoomWindowOffetx, e.zoomWindow.css({top: e.windowOffsetTop}), e.zoomWindow.css({left: e.windowOffsetLeft}), "inner" == e.options.zoomType && (e.zoomWindow.css({top: 0}), e.zoomWindow.css({left: 0})), e.windowLeftPos = String(-1 * ((t.pageX - e.nzOffset.left) * e.widthRatio - e.zoomWindow.width() / 2)), e.windowTopPos = String(-1 * ((t.pageY - e.nzOffset.top) * e.heightRatio - e.zoomWindow.height() / 2)), e.Etoppos && (e.windowTopPos = 0), e.Eloppos && (e.windowLeftPos = 0), e.Eboppos && (e.windowTopPos = -1 * (e.largeHeight / e.currentZoomLevel - e.zoomWindow.height())), e.Eroppos && (e.windowLeftPos = -1 * (e.largeWidth / e.currentZoomLevel - e.zoomWindow.width())), e.fullheight && (e.windowTopPos = 0), e.fullwidth && (e.windowLeftPos = 0), "window" != e.options.zoomType && "inner" != e.options.zoomType || (1 == e.zoomLock && (e.widthRatio <= 1 && (e.windowLeftPos = 0), e.heightRatio <= 1 && (e.windowTopPos = 0)), e.largeHeight < e.options.zoomWindowHeight && (e.windowTopPos = 0), e.largeWidth < e.options.zoomWindowWidth && (e.windowLeftPos = 0), e.options.easing ? (e.xp || (e.xp = 0), e.yp || (e.yp = 0), e.loop || (e.loop = setInterval(function () {
                e.xp += (e.windowLeftPos - e.xp) / e.options.easingAmount, e.yp += (e.windowTopPos - e.yp) / e.options.easingAmount, e.scrollingLock ? (clearInterval(e.loop), e.xp = e.windowLeftPos, e.yp = e.windowTopPos, e.xp = -1 * ((t.pageX - e.nzOffset.left) * e.widthRatio - e.zoomWindow.width() / 2), e.yp = -1 * ((t.pageY - e.nzOffset.top) * e.heightRatio - e.zoomWindow.height() / 2), e.changeBgSize && (e.nzHeight > e.nzWidth ? ("lens" == e.options.zoomType && e.zoomLens.css({"background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"}), e.zoomWindow.css({"background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"})) : ("lens" != e.options.zoomType && e.zoomLens.css({"background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvalueheight + "px"}), e.zoomWindow.css({"background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvaluewidth + "px"})), e.changeBgSize = !1), e.zoomWindow.css({backgroundPosition: e.windowLeftPos + "px " + e.windowTopPos + "px"}), e.scrollingLock = !1, e.loop = !1) : (e.changeBgSize && (e.nzHeight > e.nzWidth ? ("lens" == e.options.zoomType && e.zoomLens.css({"background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"}), e.zoomWindow.css({"background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"})) : ("lens" != e.options.zoomType && e.zoomLens.css({"background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvaluewidth + "px"}), e.zoomWindow.css({"background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvaluewidth + "px"})), e.changeBgSize = !1), e.zoomWindow.css({backgroundPosition: e.xp + "px " + e.yp + "px"}))
            }, 16))) : (e.changeBgSize && (e.nzHeight > e.nzWidth ? ("lens" == e.options.zoomType && e.zoomLens.css({"background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"}), e.zoomWindow.css({"background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"})) : ("lens" == e.options.zoomType && e.zoomLens.css({"background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvaluewidth + "px"}), e.largeHeight / e.newvaluewidth < e.options.zoomWindowHeight ? e.zoomWindow.css({"background-size": e.largeWidth / e.newvaluewidth + "px " + e.largeHeight / e.newvaluewidth + "px"}) : e.zoomWindow.css({"background-size": e.largeWidth / e.newvalueheight + "px " + e.largeHeight / e.newvalueheight + "px"})), e.changeBgSize = !1), e.zoomWindow.css({backgroundPosition: e.windowLeftPos + "px " + e.windowTopPos + "px"})))
        }, setTintPosition: function (t) {
            this.nzOffset = this.$elem.offset(), this.tintpos = String(-1 * (t.pageX - this.nzOffset.left - this.zoomLens.width() / 2)), this.tintposy = String(-1 * (t.pageY - this.nzOffset.top - this.zoomLens.height() / 2)), this.Etoppos && (this.tintposy = 0), this.Eloppos && (this.tintpos = 0), this.Eboppos && (this.tintposy = -1 * (this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize)), this.Eroppos && (this.tintpos = -1 * (this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)), this.options.tint && (this.fullheight && (this.tintposy = 0), this.fullwidth && (this.tintpos = 0), this.zoomTintImage.css({left: this.tintpos + "px"}), this.zoomTintImage.css({top: this.tintposy + "px"}))
        }, swaptheimage: function (t, e) {
            var n = this, i = new Image;
            n.options.loadingIcon && (n.spinner = s("<div style=\"background: url('" + n.options.loadingIcon + "') no-repeat center;height:" + n.nzHeight + "px;width:" + n.nzWidth + 'px;z-index: 2000;position: absolute; background-position: center center;"></div>'), n.$elem.after(n.spinner)), n.options.onImageSwap(n.$elem), i.onload = function () {
                n.largeWidth = i.width, n.largeHeight = i.height, n.zoomImage = e, void 0 !== n.zoomWindow && (n.zoomWindow.css({"background-size": n.largeWidth + "px " + n.largeHeight + "px"}), n.zoomWindow.css({"background-size": n.largeWidth + "px " + n.largeHeight + "px"}), n.swapAction(t, e))
            }, i.src = e
        }, swapAction: function (t, e) {
            var n, i, o = this, r = new Image;
            r.onload = function () {
                o.nzHeight = r.height, o.nzWidth = r.width, o.options.onImageSwapComplete(o.$elem), o.doneCallback()
            }, r.src = t, o.currentZoomLevel = o.options.zoomLevel, o.options.maxZoomLevel = !1, "lens" == o.options.zoomType && o.zoomLens.css({backgroundImage: "url('" + e + "')"}), "window" == o.options.zoomType && o.zoomWindow.css({backgroundImage: "url('" + e + "')"}), "inner" == o.options.zoomType && o.zoomWindow.css({backgroundImage: "url('" + e + "')"}), o.currentImage = e, o.options.imageCrossfade ? (n = (i = o.$elem).clone(), o.$elem.attr("src", t), o.$elem.after(n), n.stop(!0).fadeOut(o.options.imageCrossfade, function () {
                s(this).remove()
            }), o.$elem.width("auto").removeAttr("width"), o.$elem.height("auto").removeAttr("height"), i.fadeIn(o.options.imageCrossfade), o.options.tint && "inner" != o.options.zoomType && (i = (n = o.zoomTintImage).clone(), o.zoomTintImage.attr("src", e), o.zoomTintImage.after(i), i.stop(!0).fadeOut(o.options.imageCrossfade, function () {
                s(this).remove()
            }), n.fadeIn(o.options.imageCrossfade), o.zoomTint.css({height: o.$elem.height()}), o.zoomTint.css({width: o.$elem.width()})), o.zoomContainer.css("height", o.$elem.height()), o.zoomContainer.css("width", o.$elem.width()), "inner" == o.options.zoomType && (o.options.constrainType || (o.zoomWrap.parent().css("height", o.$elem.height()), o.zoomWrap.parent().css("width", o.$elem.width()), o.zoomWindow.css("height", o.$elem.height()), o.zoomWindow.css("width", o.$elem.width())))) : (o.$elem.attr("src", t), o.options.tint && (o.zoomTintImage.attr("src", e), o.zoomTintImage.attr("height", o.$elem.height()), o.zoomTintImage.css({height: o.$elem.height()}), o.zoomTint.css({height: o.$elem.height()})), o.zoomContainer.css("height", o.$elem.height()), o.zoomContainer.css("width", o.$elem.width())), o.options.imageCrossfade && (o.zoomWrap.css("height", o.$elem.height()), o.zoomWrap.css("width", o.$elem.width())), o.options.constrainType && ("height" == o.options.constrainType && (o.zoomContainer.css("height", o.options.constrainSize), o.zoomContainer.css("width", "auto"), o.options.imageCrossfade ? (o.zoomWrap.css("height", o.options.constrainSize), o.zoomWrap.css("width", "auto"), o.constwidth = o.zoomWrap.width()) : (o.$elem.css("height", o.options.constrainSize), o.$elem.css("width", "auto"), o.constwidth = o.$elem.width()), "inner" == o.options.zoomType && (o.zoomWrap.parent().css("height", o.options.constrainSize), o.zoomWrap.parent().css("width", o.constwidth), o.zoomWindow.css("height", o.options.constrainSize), o.zoomWindow.css("width", o.constwidth)), o.options.tint && (o.tintContainer.css("height", o.options.constrainSize), o.tintContainer.css("width", o.constwidth), o.zoomTint.css("height", o.options.constrainSize), o.zoomTint.css("width", o.constwidth), o.zoomTintImage.css("height", o.options.constrainSize), o.zoomTintImage.css("width", o.constwidth))), "width" == o.options.constrainType && (o.zoomContainer.css("height", "auto"), o.zoomContainer.css("width", o.options.constrainSize), o.options.imageCrossfade ? (o.zoomWrap.css("height", "auto"), o.zoomWrap.css("width", o.options.constrainSize), o.constheight = o.zoomWrap.height()) : (o.$elem.css("height", "auto"), o.$elem.css("width", o.options.constrainSize), o.constheight = o.$elem.height()), "inner" == o.options.zoomType && (o.zoomWrap.parent().css("height", o.constheight), o.zoomWrap.parent().css("width", o.options.constrainSize), o.zoomWindow.css("height", o.constheight), o.zoomWindow.css("width", o.options.constrainSize)), o.options.tint && (o.tintContainer.css("height", o.constheight), o.tintContainer.css("width", o.options.constrainSize), o.zoomTint.css("height", o.constheight), o.zoomTint.css("width", o.options.constrainSize), o.zoomTintImage.css("height", o.constheight), o.zoomTintImage.css("width", o.options.constrainSize))))
        }, doneCallback: function () {
            this.options.loadingIcon && this.spinner.hide(), this.nzOffset = this.$elem.offset(), this.nzWidth = this.$elem.width(), this.nzHeight = this.$elem.height(), this.currentZoomLevel = this.options.zoomLevel, this.widthRatio = this.largeWidth / this.nzWidth, this.heightRatio = this.largeHeight / this.nzHeight, "window" == this.options.zoomType && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.options.zoomWindowWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.zoomLens && (this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight)))
        }, getCurrentImage: function () {
            return this.zoomImage
        }, getGalleryList: function () {
            var e = this;
            return e.gallerylist = [], e.options.gallery ? s("#" + e.options.gallery + " a").each(function () {
                var t = "";
                s(this).attr("data-zoom-image") ? t = s(this).attr("data-zoom-image") : s(this).data("image") && (t = s(this).data("image")), t == e.zoomImage ? e.gallerylist.unshift({
                    href: "" + t,
                    title: s(this).find("img").attr("title")
                }) : e.gallerylist.push({href: "" + t, title: s(this).find("img").attr("title")})
            }) : e.gallerylist.push({href: "" + e.zoomImage, title: s(this).find("img").attr("title")}), e.gallerylist
        }, changeZoomLevel: function (t) {
            this.scrollingLock = !0, this.newvalue = parseFloat(t).toFixed(2), newvalue = parseFloat(t).toFixed(2), maxheightnewvalue = this.largeHeight / (this.options.zoomWindowHeight / this.nzHeight * this.nzHeight), maxwidthtnewvalue = this.largeWidth / (this.options.zoomWindowWidth / this.nzWidth * this.nzWidth), "inner" != this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / maxheightnewvalue / this.nzHeight, this.newvalueheight = maxheightnewvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / maxwidthtnewvalue / this.nzWidth, this.newvaluewidth = maxwidthtnewvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1), "lens" == this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.fullwidth = !0, this.newvaluewidth = maxheightnewvalue) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1))), "inner" == this.options.zoomType && (maxheightnewvalue = parseFloat(this.largeHeight / this.nzHeight).toFixed(2), maxwidthtnewvalue = parseFloat(this.largeWidth / this.nzWidth).toFixed(2), newvalue > maxheightnewvalue && (newvalue = maxheightnewvalue), newvalue > maxwidthtnewvalue && (newvalue = maxwidthtnewvalue), maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, newvalue > maxheightnewvalue ? this.newvalueheight = maxheightnewvalue : this.newvalueheight = newvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, newvalue > maxheightnewvalue ? this.newvalueheight = maxheightnewvalue : this.newvalueheight = newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, newvalue > maxwidthtnewvalue ? this.newvaluewidth = maxwidthtnewvalue : this.newvaluewidth = newvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1)), scrcontinue = !1, "inner" == this.options.zoomType && (this.nzWidth > this.nzHeight && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullheight = !0, this.fullwidth = !0)), this.nzHeight > this.nzWidth && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullheight = !0, this.fullwidth = !0))), "inner" != this.options.zoomType && (scrcontinue = !0), scrcontinue && (this.zoomLock = 0, this.changeZoom = !0, this.options.zoomWindowHeight / this.heightRatio <= this.nzHeight && (this.currentZoomLevel = this.newvalueheight, "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({height: String(this.options.zoomWindowHeight / this.heightRatio) + "px"})), "lens" != this.options.zoomType && "inner" != this.options.zoomType || (this.changeBgSize = !0)), this.options.zoomWindowWidth / this.widthRatio <= this.nzWidth && ("inner" != this.options.zoomType && this.newvaluewidth > this.newvalueheight && (this.currentZoomLevel = this.newvaluewidth), "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({width: String(this.options.zoomWindowWidth / this.widthRatio) + "px"})), "lens" != this.options.zoomType && "inner" != this.options.zoomType || (this.changeBgSize = !0)), "inner" == this.options.zoomType && (this.changeBgSize = !0, this.nzWidth > this.nzHeight && (this.currentZoomLevel = this.newvaluewidth), this.nzHeight > this.nzWidth && (this.currentZoomLevel = this.newvaluewidth))), this.setPosition(this.currentLoc)
        }, closeAll: function () {
            self.zoomWindow && self.zoomWindow.hide(), self.zoomLens && self.zoomLens.hide(), self.zoomTint && self.zoomTint.hide()
        }, changeState: function (t) {
            "enable" == t && (this.options.zoomEnabled = !0), "disable" == t && (this.options.zoomEnabled = !1)
        }
    };
    s.fn.elevateZoom = function (e) {
        return this.each(function () {
            var t = Object.create(n);
            t.init(e, this), s.data(this, "elevateZoom", t)
        })
    }, s.fn.elevateZoom.options = {
        zoomActivation: "hover",
        zoomEnabled: !0,
        preloading: 1,
        zoomLevel: 1,
        scrollZoom: !1,
        scrollZoomIncrement: .1,
        minZoomLevel: !1,
        maxZoomLevel: !1,
        easing: !1,
        easingAmount: 12,
        lensSize: 200,
        zoomWindowWidth: 400,
        zoomWindowHeight: 400,
        zoomWindowOffetx: 0,
        zoomWindowOffety: 0,
        zoomWindowPosition: 1,
        zoomWindowBgColour: "#fff",
        lensFadeIn: !1,
        lensFadeOut: !1,
        debug: !1,
        zoomWindowFadeIn: !1,
        zoomWindowFadeOut: !1,
        zoomWindowAlwaysShow: !1,
        zoomTintFadeIn: !1,
        zoomTintFadeOut: !1,
        borderSize: 4,
        showLens: !0,
        borderColour: "#888",
        lensBorderSize: 1,
        lensBorderColour: "#000",
        lensShape: "square",
        zoomType: "window",
        containLensZoom: !1,
        lensColour: "white",
        lensOpacity: .4,
        lenszoom: !1,
        tint: !1,
        tintColour: "#333",
        tintOpacity: .4,
        gallery: !1,
        galleryActiveClass: "zoomGalleryActive",
        imageCrossfade: !1,
        constrainType: !1,
        constrainSize: !1,
        loadingIcon: !1,
        cursor: "default",
        responsive: !0,
        onComplete: s.noop,
        onZoomedImageLoaded: function () {
        },
        onImageSwap: s.noop,
        onImageSwapComplete: s.noop,
        zoomContainer: "body"
    }
}(jQuery, (window, document)), function () {
    "use strict";
    var c = !1;
    window.JQClass = function () {
    }, JQClass.classes = {}, JQClass.extend = function t(e) {
        function n() {
            !c && this._init && this._init.apply(this, arguments)
        }

        var o = this.prototype;
        c = !0;
        var i, r = new this;
        for (i in c = !1, e) if ("function" == typeof e[i] && "function" == typeof o[i]) r[i] = function (n, i) {
            return function () {
                var t = this._super;
                this._super = function (t) {
                    return o[n].apply(this, t || [])
                };
                var e = i.apply(this, arguments);
                return this._super = t, e
            }
        }(i, e[i]); else if ("object" == typeof e[i] && "object" == typeof o[i] && "defaultOptions" === i) {
            var s, a = o[i], l = e[i], u = {};
            for (s in a) u[s] = a[s];
            for (s in l) u[s] = l[s];
            r[i] = u
        } else r[i] = e[i];
        return ((n.prototype = r).constructor = n).extend = t, n
    }
}(), function ($) {
    "use strict";

    function camelCase(t) {
        return t.replace(/-([a-z])/g, function (t, e) {
            return e.toUpperCase()
        })
    }

    JQClass.classes.JQPlugin = JQClass.extend({
        name: "plugin", defaultOptions: {}, regionalOptions: {}, deepMerge: !0, _getMarker: function () {
            return "is-" + this.name
        }, _init: function () {
            $.extend(this.defaultOptions, this.regionalOptions && this.regionalOptions[""] || {});
            var r = camelCase(this.name);
            $[r] = this, $.fn[r] = function (e) {
                var n = Array.prototype.slice.call(arguments, 1), i = this, o = this;
                return this.each(function () {
                    if ("string" == typeof e) {
                        if ("_" === e[0] || !$[r][e]) throw"Unknown method: " + e;
                        var t = $[r][e].apply($[r], [this].concat(n));
                        if (t !== i && void 0 !== t) return o = t, !1
                    } else $[r]._attach(this, e)
                }), o
            }
        }, setDefaults: function (t) {
            $.extend(this.defaultOptions, t || {})
        }, _attach: function (t, e) {
            var n;
            (t = $(t)).hasClass(this._getMarker()) || (t.addClass(this._getMarker()), e = $.extend(this.deepMerge, {}, this.defaultOptions, this._getMetadata(t), e || {}), n = $.extend({
                name: this.name,
                elem: t,
                options: e
            }, this._instSettings(t, e)), t.data(this.name, n), this._postAttach(t, n), this.option(t, e))
        }, _instSettings: function (t, e) {
            return {}
        }, _postAttach: function (t, e) {
        }, _getMetadata: function (elem) {
            try {
                var data = elem.data(this.name.toLowerCase()) || "", key,
                    data = data.replace(/(\\?)'/g, function (t, e) {
                        return e ? "'" : '"'
                    }).replace(/([a-zA-Z0-9]+):/g, function (t, e, n) {
                        n = data.substring(0, n).match(/"/g);
                        return n && n.length % 2 != 0 ? e + ":" : '"' + e + '":'
                    }).replace(/\\:/g, ":"), value;
                for (key in data = $.parseJSON("{" + data + "}"), data) {
                    data.hasOwnProperty(key) && (value = data[key], "string" == typeof value && value.match(/^new Date\(([-0-9,\s]*)\)$/) && (data[key] = eval(value)))
                }
                return data
            } catch (a) {
                return {}
            }
        }, _getInst: function (t) {
            return $(t).data(this.name) || {}
        }, option: function (t, e, n) {
            var i = (t = $(t)).data(this.name), o = e || {};
            return !e || "string" == typeof e && void 0 === n ? (o = (i || {}).options) && e ? o[e] : o : void (t.hasClass(this._getMarker()) && ("string" == typeof e && ((o = {})[e] = n), this._optionsChanged(t, i, o), $.extend(i.options, o)))
        }, _optionsChanged: function (t, e, n) {
        }, destroy: function (t) {
            (t = $(t)).hasClass(this._getMarker()) && (this._preDestroy(t, this._getInst(t)), t.removeData(this.name).removeClass(this._getMarker()))
        }, _preDestroy: function (t, e) {
        }
    }), $.JQPlugin = {
        createPlugin: function (t, e) {
            "object" == typeof t && (e = t, t = "JQPlugin"), t = camelCase(t);
            var n = camelCase(e.name);
            JQClass.classes[n] = JQClass.classes[t].extend(e), new JQClass.classes[n]
        }
    }
}(jQuery), function (d) {
    "use strict";
    var t = "countdown";
    d.JQPlugin.createPlugin({
        name: t,
        defaultOptions: {
            until: null,
            since: null,
            timezone: null,
            serverSync: null,
            format: "dHMS",
            layout: "",
            compact: !1,
            padZeroes: !1,
            significant: 0,
            description: "",
            expiryUrl: "",
            expiryText: "",
            alwaysExpire: !1,
            onExpiry: null,
            onTick: null,
            tickInterval: 1
        },
        regionalOptions: {
            "": {
                labels: ["Years", "Months", "Weeks", "Days", "Hours", "Minutes", "Seconds"],
                labels1: ["Year", "Month", "Week", "Day", "Hour", "Minute", "Second"],
                compactLabels: ["y", "m", "w", "d"],
                whichLabels: null,
                digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                timeSeparator: ":",
                isRTL: !1
            }
        },
        _rtlClass: t + "-rtl",
        _sectionClass: t + "-section",
        _amountClass: t + "-amount",
        _periodClass: t + "-period",
        _rowClass: t + "-row",
        _holdingClass: t + "-holding",
        _showClass: t + "-show",
        _descrClass: t + "-descr",
        _timerElems: [],
        _init: function () {
            var n = this;
            this._super(), this._serverSyncs = [];
            var i = "function" == typeof Date.now ? Date.now : function () {
                    return (new Date).getTime()
                }, o = window.performance && "function" == typeof window.performance.now,
                r = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || null,
                s = 0;
            !r || d.noRequestAnimationFrame ? (d.noRequestAnimationFrame = null, d.countdown._timer = setInterval(function () {
                n._updateElems()
            }, 1e3)) : (s = window.animationStartTime || window.webkitAnimationStartTime || window.mozAnimationStartTime || window.oAnimationStartTime || window.msAnimationStartTime || i(), r(function t(e) {
                e = e < 1e12 ? o ? window.performance.now() + window.performance.timing.navigationStart : i() : e || i();
                1e3 <= e - s && (n._updateElems(), s = e), r(t)
            }))
        },
        UTCDate: function (t, e, n, i, o, r, s, a) {
            "object" == typeof e && e instanceof Date && (a = e.getMilliseconds(), s = e.getSeconds(), r = e.getMinutes(), o = e.getHours(), i = e.getDate(), n = e.getMonth(), e = e.getFullYear());
            var l = new Date;
            return l.setUTCFullYear(e), l.setUTCDate(1), l.setUTCMonth(n || 0), l.setUTCDate(i || 1), l.setUTCHours(o || 0), l.setUTCMinutes((r || 0) - (Math.abs(t) < 30 ? 60 * t : t)), l.setUTCSeconds(s || 0), l.setUTCMilliseconds(a || 0), l
        },
        periodsToSeconds: function (t) {
            return 31557600 * t[0] + 2629800 * t[1] + 604800 * t[2] + 86400 * t[3] + 3600 * t[4] + 60 * t[5] + t[6]
        },
        resync: function () {
            var o = this;
            d("." + this._getMarker()).each(function () {
                var t = d.data(this, o.name);
                if (t.options.serverSync) {
                    for (var e, n = null, i = 0; i < o._serverSyncs.length; i++) if (o._serverSyncs[i][0] === t.options.serverSync) {
                        n = o._serverSyncs[i];
                        break
                    }
                    o._eqNull(n[2]) && (e = d.isFunction(t.options.serverSync) ? t.options.serverSync.apply(this, []) : null, n[2] = (e ? (new Date).getTime() - e.getTime() : 0) - n[1]), t._since && t._since.setMilliseconds(t._since.getMilliseconds() + n[2]), t._until.setMilliseconds(t._until.getMilliseconds() + n[2])
                }
            });
            for (var t = 0; t < o._serverSyncs.length; t++) o._eqNull(o._serverSyncs[t][2]) || (o._serverSyncs[t][1] += o._serverSyncs[t][2], delete o._serverSyncs[t][2])
        },
        _instSettings: function (t, e) {
            return {_periods: [0, 0, 0, 0, 0, 0, 0]}
        },
        _addElem: function (t) {
            this._hasElem(t) || this._timerElems.push(t)
        },
        _hasElem: function (t) {
            return -1 < d.inArray(t, this._timerElems)
        },
        _removeElem: function (e) {
            this._timerElems = d.map(this._timerElems, function (t) {
                return t === e ? null : t
            })
        },
        _updateElems: function () {
            for (var t = this._timerElems.length - 1; 0 <= t; t--) this._updateCountdown(this._timerElems[t])
        },
        _optionsChanged: function (t, e, n) {
            n.layout && (n.layout = n.layout.replace(/&lt;/g, "<").replace(/&gt;/g, ">")), this._resetExtraLabels(e.options, n);
            var i = e.options.timezone !== n.timezone;
            d.extend(e.options, n), this._adjustSettings(t, e, !this._eqNull(n.until) || !this._eqNull(n.since) || i);
            i = new Date;
            (e._since && e._since < i || e._until && e._until > i) && this._addElem(t[0]), this._updateCountdown(t, e)
        },
        _updateCountdown: function (t, e) {
            var n;
            t = t.jquery ? t : d(t), (e = e || this._getInst(t)) && (t.html(this._generateHTML(e)).toggleClass(this._rtlClass, e.options.isRTL), "pause" !== e._hold && d.isFunction(e.options.onTick) && (n = "lap" !== e._hold ? e._periods : this._calculatePeriods(e, e._show, e.options.significant, new Date), 1 !== e.options.tickInterval && this.periodsToSeconds(n) % e.options.tickInterval != 0 || e.options.onTick.apply(t[0], [n])), "pause" !== e._hold && (e._since ? e._now.getTime() < e._since.getTime() : e._now.getTime() >= e._until.getTime()) && !e._expiring ? (e._expiring = !0, (this._hasElem(t[0]) || e.options.alwaysExpire) && (this._removeElem(t[0]), d.isFunction(e.options.onExpiry) && e.options.onExpiry.apply(t[0], []), e.options.expiryText && (n = e.options.layout, e.options.layout = e.options.expiryText, this._updateCountdown(t[0], e), e.options.layout = n), e.options.expiryUrl && (window.location = e.options.expiryUrl)), e._expiring = !1) : "pause" === e._hold && this._removeElem(t[0]))
        },
        _resetExtraLabels: function (t, e) {
            var n = null;
            for (n in e) n.match(/[Ll]abels[02-9]|compactLabels1/) && (t[n] = e[n]);
            for (n in t) n.match(/[Ll]abels[02-9]|compactLabels1/) && void 0 === e[n] && (t[n] = null)
        },
        _eqNull: function (t) {
            return null == t
        },
        _adjustSettings: function (t, e, n) {
            for (var i = null, o = 0; o < this._serverSyncs.length; o++) if (this._serverSyncs[o][0] === e.options.serverSync) {
                i = this._serverSyncs[o][1];
                break
            }
            var r = null, s = null;
            this._eqNull(i) ? (a = d.isFunction(e.options.serverSync) ? e.options.serverSync.apply(t[0], []) : null, r = new Date, s = a ? r.getTime() - a.getTime() : 0, this._serverSyncs.push([e.options.serverSync, s])) : (r = new Date, s = e.options.serverSync ? i : 0);
            var a = e.options.timezone, a = this._eqNull(a) ? -r.getTimezoneOffset() : a;
            (n || !n && this._eqNull(e._until) && this._eqNull(e._since)) && (e._since = e.options.since, this._eqNull(e._since) || (e._since = this.UTCDate(a, this._determineTime(e._since, null)), e._since && s && e._since.setMilliseconds(e._since.getMilliseconds() + s)), e._until = this.UTCDate(a, this._determineTime(e.options.until, r)), s && e._until.setMilliseconds(e._until.getMilliseconds() + s)), e._show = this._determineShow(e)
        },
        _preDestroy: function (t, e) {
            this._removeElem(t[0]), t.empty()
        },
        pause: function (t) {
            this._hold(t, "pause")
        },
        lap: function (t) {
            this._hold(t, "lap")
        },
        resume: function (t) {
            this._hold(t, null)
        },
        toggle: function (t) {
            this[(d.data(t, this.name) || {})._hold ? "resume" : "pause"](t)
        },
        toggleLap: function (t) {
            this[(d.data(t, this.name) || {})._hold ? "resume" : "lap"](t)
        },
        _hold: function (t, e) {
            var n, i = d.data(t, this.name);
            i && ("pause" !== i._hold || e || (i._periods = i._savePeriods, n = i._since ? "-" : "+", i[i._since ? "_since" : "_until"] = this._determineTime(n + i._periods[0] + "y" + n + i._periods[1] + "o" + n + i._periods[2] + "w" + n + i._periods[3] + "d" + n + i._periods[4] + "h" + n + i._periods[5] + "m" + n + i._periods[6] + "s"), this._addElem(t)), i._hold = e, i._savePeriods = "pause" === e ? i._periods : null, d.data(t, this.name, i), this._updateCountdown(t, i))
        },
        getTimes: function (t) {
            t = d.data(t, this.name);
            return t ? "pause" === t._hold ? t._savePeriods : t._hold ? this._calculatePeriods(t, t._show, t.options.significant, new Date) : t._periods : null
        },
        _determineTime: function (t, e) {
            var n, i, c = this, t = this._eqNull(t) ? e : "string" == typeof t ? function (t) {
                t = t.toLowerCase();
                for (var e = new Date, n = e.getFullYear(), i = e.getMonth(), o = e.getDate(), r = e.getHours(), s = e.getMinutes(), a = e.getSeconds(), l = /([+-]?[0-9]+)\s*(s|m|h|d|w|o|y)?/g, u = l.exec(t); u;) {
                    switch (u[2] || "s") {
                        case"s":
                            a += parseInt(u[1], 10);
                            break;
                        case"m":
                            s += parseInt(u[1], 10);
                            break;
                        case"h":
                            r += parseInt(u[1], 10);
                            break;
                        case"d":
                            o += parseInt(u[1], 10);
                            break;
                        case"w":
                            o += 7 * parseInt(u[1], 10);
                            break;
                        case"o":
                            i += parseInt(u[1], 10), o = Math.min(o, c._getDaysInMonth(n, i));
                            break;
                        case"y":
                            n += parseInt(u[1], 10), o = Math.min(o, c._getDaysInMonth(n, i))
                    }
                    u = l.exec(t)
                }
                return new Date(n, i, o, r, s, a, 0)
            }(t) : "number" == typeof t ? (n = t, (i = new Date).setTime(i.getTime() + 1e3 * n), i) : t;
            return t && t.setMilliseconds(0), t
        },
        _getDaysInMonth: function (t, e) {
            return 32 - new Date(t, e, 32).getDate()
        },
        _normalLabels: function (t) {
            return t
        },
        _generateHTML: function (n) {
            var i = this;
            n._periods = n._hold ? n._periods : this._calculatePeriods(n, n._show, n.options.significant, new Date);
            for (var t = !1, e = 0, o = n.options.significant, r = d.extend({}, n._show), s = null, s = 0; s <= 6; s++) t = t || "?" === n._show[s] && 0 < n._periods[s], r[s] = "?" !== n._show[s] || t ? n._show[s] : null, e += r[s] ? 1 : 0, o -= 0 < n._periods[s] ? 1 : 0;
            var a = [!1, !1, !1, !1, !1, !1, !1];
            for (s = 6; 0 <= s; s--) n._show[s] && (n._periods[s] ? a[s] = !0 : (a[s] = 0 < o, o--));

            function l(t) {
                var e = n.options["compactLabels" + h(n._periods[t])];
                return r[t] ? i._translateDigits(n, n._periods[t]) + (e || c)[t] + " " : ""
            }

            function u(t) {
                var e = n.options["labels" + h(n._periods[t])];
                return !n.options.significant && r[t] || n.options.significant && a[t] ? '<span class="' + i._sectionClass + '"><span class="' + i._amountClass + '">' + i._minDigits(n, n._periods[t], p) + '</span><span class="' + i._periodClass + '">' + (e || c)[t] + "</span></span>" : ""
            }

            var c = n.options.compact ? n.options.compactLabels : n.options.labels,
                h = n.options.whichLabels || this._normalLabels, p = n.options.padZeroes ? 2 : 1;
            return n.options.layout ? this._buildLayout(n, r, n.options.layout, n.options.compact, n.options.significant, a) : (n.options.compact ? '<span class="' + this._rowClass + " " + this._amountClass + (n._hold ? " " + this._holdingClass : "") + '">' + l(0) + l(1) + l(2) + l(3) + (r[4] ? this._minDigits(n, n._periods[4], 2) : "") + (r[5] ? (r[4] ? n.options.timeSeparator : "") + this._minDigits(n, n._periods[5], 2) : "") + (r[6] ? (r[4] || r[5] ? n.options.timeSeparator : "") + this._minDigits(n, n._periods[6], 2) : "") : '<span class="' + this._rowClass + " " + this._showClass + (n.options.significant || e) + (n._hold ? " " + this._holdingClass : "") + '">' + u(0) + u(1) + u(2) + u(3) + u(4) + u(5) + u(6)) + "</span>" + (n.options.description ? '<span class="' + this._rowClass + " " + this._descrClass + '">' + n.options.description + "</span>" : "")
        },
        _buildLayout: function (n, t, e, i, o, r) {
            for (var s = n.options[i ? "compactLabels" : "labels"], a = n.options.whichLabels || this._normalLabels, l = function (t) {
                return (n.options[(i ? "compactLabels" : "labels") + a(n._periods[t])] || s)[t]
            }, u = function (t, e) {
                return n.options.digits[Math.floor(t / e) % 10]
            }, u = {
                desc: n.options.description,
                sep: n.options.timeSeparator,
                yl: l(0),
                yn: this._minDigits(n, n._periods[0], 1),
                ynn: this._minDigits(n, n._periods[0], 2),
                ynnn: this._minDigits(n, n._periods[0], 3),
                y1: u(n._periods[0], 1),
                y10: u(n._periods[0], 10),
                y100: u(n._periods[0], 100),
                y1000: u(n._periods[0], 1e3),
                ol: l(1),
                on: this._minDigits(n, n._periods[1], 1),
                onn: this._minDigits(n, n._periods[1], 2),
                onnn: this._minDigits(n, n._periods[1], 3),
                o1: u(n._periods[1], 1),
                o10: u(n._periods[1], 10),
                o100: u(n._periods[1], 100),
                o1000: u(n._periods[1], 1e3),
                wl: l(2),
                wn: this._minDigits(n, n._periods[2], 1),
                wnn: this._minDigits(n, n._periods[2], 2),
                wnnn: this._minDigits(n, n._periods[2], 3),
                w1: u(n._periods[2], 1),
                w10: u(n._periods[2], 10),
                w100: u(n._periods[2], 100),
                w1000: u(n._periods[2], 1e3),
                dl: l(3),
                dn: this._minDigits(n, n._periods[3], 1),
                dnn: this._minDigits(n, n._periods[3], 2),
                dnnn: this._minDigits(n, n._periods[3], 3),
                d1: u(n._periods[3], 1),
                d10: u(n._periods[3], 10),
                d100: u(n._periods[3], 100),
                d1000: u(n._periods[3], 1e3),
                hl: l(4),
                hn: this._minDigits(n, n._periods[4], 1),
                hnn: this._minDigits(n, n._periods[4], 2),
                hnnn: this._minDigits(n, n._periods[4], 3),
                h1: u(n._periods[4], 1),
                h10: u(n._periods[4], 10),
                h100: u(n._periods[4], 100),
                h1000: u(n._periods[4], 1e3),
                ml: l(5),
                mn: this._minDigits(n, n._periods[5], 1),
                mnn: this._minDigits(n, n._periods[5], 2),
                mnnn: this._minDigits(n, n._periods[5], 3),
                m1: u(n._periods[5], 1),
                m10: u(n._periods[5], 10),
                m100: u(n._periods[5], 100),
                m1000: u(n._periods[5], 1e3),
                sl: l(6),
                sn: this._minDigits(n, n._periods[6], 1),
                snn: this._minDigits(n, n._periods[6], 2),
                snnn: this._minDigits(n, n._periods[6], 3),
                s1: u(n._periods[6], 1),
                s10: u(n._periods[6], 10),
                s100: u(n._periods[6], 100),
                s1000: u(n._periods[6], 1e3)
            }, c = e, h = 0; h <= 6; h++) var p = "yowdhms".charAt(h), p = new RegExp("\\{" + p + "<\\}([\\s\\S]*)\\{" + p + ">\\}", "g"), c = c.replace(p, !o && t[h] || o && r[h] ? "$1" : "");
            return d.each(u, function (t, e) {
                t = new RegExp("\\{" + t + "\\}", "g");
                c = c.replace(t, e)
            }), c
        },
        _minDigits: function (t, e, n) {
            return (e = "" + e).length >= n ? this._translateDigits(t, e) : this._translateDigits(t, (e = "0000000000" + e).substr(e.length - n))
        },
        _translateDigits: function (e, t) {
            return ("" + t).replace(/[0-9]/g, function (t) {
                return e.options.digits[t]
            })
        },
        _determineShow: function (t) {
            var e = t.options.format, t = [];
            return t[0] = e.match("y") ? "?" : e.match("Y") ? "!" : null, t[1] = e.match("o") ? "?" : e.match("O") ? "!" : null, t[2] = e.match("w") ? "?" : e.match("W") ? "!" : null, t[3] = e.match("d") ? "?" : e.match("D") ? "!" : null, t[4] = e.match("h") ? "?" : e.match("H") ? "!" : null, t[5] = e.match("m") ? "?" : e.match("M") ? "!" : null, t[6] = e.match("s") ? "?" : e.match("S") ? "!" : null, t
        },
        _calculatePeriods: function (t, n, e, i) {
            t._now = i, t._now.setMilliseconds(0);
            var o = new Date(t._now.getTime());
            t._since ? i.getTime() < t._since.getTime() ? t._now = i = o : i = t._since : (o.setTime(t._until.getTime()), i.getTime() > t._until.getTime() && (t._now = i = o));
            var r, s, a, l = [0, 0, 0, 0, 0, 0, 0];
            (n[0] || n[1]) && (a = this._getDaysInMonth(i.getFullYear(), i.getMonth()), s = this._getDaysInMonth(o.getFullYear(), o.getMonth()), r = o.getDate() === i.getDate() || o.getDate() >= Math.min(a, s) && i.getDate() >= Math.min(a, s), s = function (t) {
                return 60 * (60 * t.getHours() + t.getMinutes()) + t.getSeconds()
            }, s = Math.max(0, 12 * (o.getFullYear() - i.getFullYear()) + o.getMonth() - i.getMonth() + (o.getDate() < i.getDate() && !r || r && s(o) < s(i) ? -1 : 0)), l[0] = n[0] ? Math.floor(s / 12) : 0, l[1] = n[1] ? s - 12 * l[0] : 0, s = (i = new Date(i.getTime())).getDate() === a, a = this._getDaysInMonth(i.getFullYear() + l[0], i.getMonth() + l[1]), i.getDate() > a && i.setDate(a), i.setFullYear(i.getFullYear() + l[0]), i.setMonth(i.getMonth() + l[1]), s && i.setDate(a));
            var u = Math.floor((o.getTime() - i.getTime()) / 1e3), c = null, i = function (t, e) {
                l[t] = n[t] ? Math.floor(u / e) : 0, u -= l[t] * e
            };
            if (i(2, 604800), i(3, 86400), i(4, 3600), i(5, 60), i(6, 1), 0 < u && !t._since) for (var h = [1, 12, 4.3482, 7, 24, 60, 60], p = 6, d = 1, c = 6; 0 <= c; c--) n[c] && (l[p] >= d && (l[p] = 0, u = 1), 0 < u && (l[c]++, u = 0, p = c, d = 1)), d *= h[c];
            if (e) for (c = 0; c <= 6; c++) e && l[c] ? e-- : e || (l[c] = 0);
            return l
        }
    })
}(jQuery), function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function (u) {
    function t() {
    }

    function c(t, e) {
        f.ev.on("mfp" + t + n, e)
    }

    function h(t, e, n, i) {
        var o = document.createElement("div");
        return o.className = "mfp-" + t, n && (o.innerHTML = n), i ? e && e.appendChild(o) : (o = u(o), e && o.appendTo(e)), o
    }

    function p(t, e) {
        f.ev.triggerHandler("mfp" + t, e), f.st.callbacks && (t = t.charAt(0).toLowerCase() + t.slice(1), f.st.callbacks[t] && f.st.callbacks[t].apply(f, u.isArray(e) ? e : [e]))
    }

    function d(t) {
        return t === e && f.currTemplate.closeBtn || (f.currTemplate.closeBtn = u(f.st.closeMarkup.replace("%title%", f.st.tClose)), e = t), f.currTemplate.closeBtn
    }

    function r() {
        u.magnificPopup.instance || ((f = new t).init(), u.magnificPopup.instance = f)
    }

    var f, i, m, o, g, e, a = "Close", l = "BeforeClose", v = "MarkupParse", n = ".mfp", y = "mfp-ready",
        s = "mfp-removing", w = "mfp-prevent-close", x = !!window.jQuery, b = u(window);
    t.prototype = {
        constructor: t, init: function () {
            var t = navigator.appVersion;
            f.isLowIE = f.isIE8 = document.all && !document.addEventListener, f.isAndroid = /android/gi.test(t), f.isIOS = /iphone|ipad|ipod/gi.test(t), f.supportsTransition = function () {
                var t = document.createElement("p").style, e = ["ms", "O", "Moz", "Webkit"];
                if (void 0 !== t.transition) return !0;
                for (; e.length;) if (e.pop() + "Transition" in t) return !0;
                return !1
            }(), f.probablyMobile = f.isAndroid || f.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), m = u(document), f.popupsCache = {}
        }, open: function (t) {
            if (!1 === t.isObj) {
                f.items = t.items.toArray(), f.index = 0;
                for (var e, n = t.items, i = 0; i < n.length; i++) if ((e = (e = n[i]).parsed ? e.el[0] : e) === t.el[0]) {
                    f.index = i;
                    break
                }
            } else f.items = u.isArray(t.items) ? t.items : [t.items], f.index = t.index || 0;
            if (!f.isOpen) {
                f.types = [], g = "", t.mainEl && t.mainEl.length ? f.ev = t.mainEl.eq(0) : f.ev = m, t.key ? (f.popupsCache[t.key] || (f.popupsCache[t.key] = {}), f.currTemplate = f.popupsCache[t.key]) : f.currTemplate = {}, f.st = u.extend(!0, {}, u.magnificPopup.defaults, t), f.fixedContentPos = "auto" === f.st.fixedContentPos ? !f.probablyMobile : f.st.fixedContentPos, f.st.modal && (f.st.closeOnContentClick = !1, f.st.closeOnBgClick = !1, f.st.showCloseBtn = !1, f.st.enableEscapeKey = !1), f.bgOverlay || (f.bgOverlay = h("bg").on("click.mfp", function () {
                    f.close()
                }), f.wrap = h("wrap").attr("tabindex", -1).on("click.mfp", function (t) {
                    f._checkIfClose(t.target) && f.close()
                }), f.container = h("container", f.wrap)), f.contentContainer = h("content"), f.st.preloader && (f.preloader = h("preloader", f.container, f.st.tLoading));
                var o = u.magnificPopup.modules;
                for (i = 0; i < o.length; i++) {
                    var r = (r = o[i]).charAt(0).toUpperCase() + r.slice(1);
                    f["init" + r].call(f)
                }
                p("BeforeOpen"), f.st.showCloseBtn && (f.st.closeBtnInside ? (c(v, function (t, e, n, i) {
                    n.close_replaceWith = d(i.type)
                }), g += " mfp-close-btn-in") : f.wrap.append(d())), f.st.alignTop && (g += " mfp-align-top"), f.fixedContentPos ? f.wrap.css({
                    overflow: f.st.overflowY,
                    overflowX: "hidden",
                    overflowY: f.st.overflowY
                }) : f.wrap.css({
                    top: b.scrollTop(),
                    position: "absolute"
                }), !1 !== f.st.fixedBgPos && ("auto" !== f.st.fixedBgPos || f.fixedContentPos) || f.bgOverlay.css({
                    height: m.height(),
                    position: "absolute"
                }), f.st.enableEscapeKey && m.on("keyup.mfp", function (t) {
                    27 === t.keyCode && f.close()
                }), b.on("resize.mfp", function () {
                    f.updateSize()
                }), f.st.closeOnContentClick || (g += " mfp-auto-cursor"), g && f.wrap.addClass(g);
                var s = f.wH = b.height(), a = {};
                f.fixedContentPos && f._hasScrollBar(s) && ((l = f._getScrollbarSize()) && (a.marginRight = l)), f.fixedContentPos && (f.isIE7 ? u("body, html").css("overflow", "hidden") : a.overflow = "hidden");
                var l = f.st.mainClass;
                return f.isIE7 && (l += " mfp-ie7"), l && f._addClassToMFP(l), f.updateItemHTML(), p("BuildControls"), u("html").css(a), f.bgOverlay.add(f.wrap).prependTo(f.st.prependTo || u(document.body)), f._lastFocusedEl = document.activeElement, setTimeout(function () {
                    f.content ? (f._addClassToMFP(y), f._setFocus()) : f.bgOverlay.addClass(y), m.on("focusin.mfp", f._onFocusIn)
                }, 16), f.isOpen = !0, f.updateSize(s), p("Open"), t
            }
            f.updateItemHTML()
        }, close: function () {
            f.isOpen && (p(l), f.isOpen = !1, f.st.removalDelay && !f.isLowIE && f.supportsTransition ? (f._addClassToMFP(s), setTimeout(function () {
                f._close()
            }, f.st.removalDelay)) : f._close())
        }, _close: function () {
            p(a);
            var t = s + " " + y + " ";
            f.bgOverlay.detach(), f.wrap.detach(), f.container.empty(), f.st.mainClass && (t += f.st.mainClass + " "), f._removeClassFromMFP(t), f.fixedContentPos && (t = {marginRight: ""}, f.isIE7 ? u("body, html").css("overflow", "") : t.overflow = "", u("html").css(t)), m.off("keyup.mfp focusin.mfp"), f.ev.off(n), f.wrap.attr("class", "mfp-wrap").removeAttr("style"), f.bgOverlay.attr("class", "mfp-bg"), f.container.attr("class", "mfp-container"), !f.st.showCloseBtn || f.st.closeBtnInside && !0 !== f.currTemplate[f.currItem.type] || f.currTemplate.closeBtn && f.currTemplate.closeBtn.detach(), f.st.autoFocusLast && f._lastFocusedEl && u(f._lastFocusedEl).focus(), f.currItem = null, f.content = null, f.currTemplate = null, f.prevHeight = 0, p("AfterClose")
        }, updateSize: function (t) {
            var e;
            f.isIOS ? (e = document.documentElement.clientWidth / window.innerWidth, e = window.innerHeight * e, f.wrap.css("height", e), f.wH = e) : f.wH = t || b.height(), f.fixedContentPos || f.wrap.css("height", f.wH), p("Resize")
        }, updateItemHTML: function () {
            var t = f.items[f.index];
            f.contentContainer.detach(), f.content && f.content.detach();
            var e = (t = !t.parsed ? f.parseEl(f.index) : t).type;
            p("BeforeChange", [f.currItem ? f.currItem.type : "", e]), f.currItem = t, f.currTemplate[e] || (n = !!f.st[e] && f.st[e].markup, p("FirstMarkupParse", n), f.currTemplate[e] = !n || u(n)), o && o !== t.type && f.container.removeClass("mfp-" + o + "-holder");
            var n = f["get" + e.charAt(0).toUpperCase() + e.slice(1)](t, f.currTemplate[e]);
            f.appendContent(n, e), t.preloaded = !0, p("Change", t), o = t.type, f.container.prepend(f.contentContainer), p("AfterChange")
        }, appendContent: function (t, e) {
            (f.content = t) ? f.st.showCloseBtn && f.st.closeBtnInside && !0 === f.currTemplate[e] ? f.content.find(".mfp-close").length || f.content.append(d()) : f.content = t : f.content = "", p("BeforeAppend"), f.container.addClass("mfp-" + e + "-holder"), f.contentContainer.append(f.content)
        }, parseEl: function (t) {
            var e, n = f.items[t];
            if ((n = n.tagName ? {el: u(n)} : (e = n.type, {data: n, src: n.src})).el) {
                for (var i = f.types, o = 0; o < i.length; o++) if (n.el.hasClass("mfp-" + i[o])) {
                    e = i[o];
                    break
                }
                n.src = n.el.attr("data-mfp-src"), n.src || (n.src = n.el.attr("href"))
            }
            return n.type = e || f.st.type || "inline", n.index = t, n.parsed = !0, f.items[t] = n, p("ElementParse", n), f.items[t]
        }, addGroup: function (e, n) {
            function t(t) {
                t.mfpEl = this, f._openClick(t, e, n)
            }

            var i = "click.magnificPopup";
            (n = n || {}).mainEl = e, n.items ? (n.isObj = !0, e.off(i).on(i, t)) : (n.isObj = !1, n.delegate ? e.off(i).on(i, n.delegate, t) : (n.items = e).off(i).on(i, t))
        }, _openClick: function (t, e, n) {
            if ((void 0 !== n.midClick ? n : u.magnificPopup.defaults).midClick || !(2 === t.which || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey)) {
                var i = (void 0 !== n.disableOn ? n : u.magnificPopup.defaults).disableOn;
                if (i) if (u.isFunction(i)) {
                    if (!i.call(f)) return !0
                } else if (b.width() < i) return !0;
                t.type && (t.preventDefault(), f.isOpen && t.stopPropagation()), n.el = u(t.mfpEl), n.delegate && (n.items = e.find(n.delegate)), f.open(n)
            }
        }, updateStatus: function (t, e) {
            var n;
            f.preloader && (i !== t && f.container.removeClass("mfp-s-" + i), n = {
                status: t,
                text: e = !e && "loading" === t ? f.st.tLoading : e
            }, p("UpdateStatus", n), t = n.status, f.preloader.html(e = n.text), f.preloader.find("a").on("click", function (t) {
                t.stopImmediatePropagation()
            }), f.container.addClass("mfp-s-" + t), i = t)
        }, _checkIfClose: function (t) {
            if (!u(t).hasClass(w)) {
                var e = f.st.closeOnContentClick, n = f.st.closeOnBgClick;
                if (e && n) return !0;
                if (!f.content || u(t).hasClass("mfp-close") || f.preloader && t === f.preloader[0]) return !0;
                if (t === f.content[0] || u.contains(f.content[0], t)) {
                    if (e) return !0
                } else if (n && u.contains(document, t)) return !0;
                return !1
            }
        }, _addClassToMFP: function (t) {
            f.bgOverlay.addClass(t), f.wrap.addClass(t)
        }, _removeClassFromMFP: function (t) {
            this.bgOverlay.removeClass(t), f.wrap.removeClass(t)
        }, _hasScrollBar: function (t) {
            return (f.isIE7 ? m.height() : document.body.scrollHeight) > (t || b.height())
        }, _setFocus: function () {
            (f.st.focus ? f.content.find(f.st.focus).eq(0) : f.wrap).focus()
        }, _onFocusIn: function (t) {
            return t.target === f.wrap[0] || u.contains(f.wrap[0], t.target) ? void 0 : (f._setFocus(), !1)
        }, _parseMarkup: function (o, t, e) {
            var r;
            e.data && (t = u.extend(e.data, t)), p(v, [o, t, e]), u.each(t, function (t, e) {
                return void 0 === e || !1 === e || void (1 < (r = t.split("_")).length ? 0 < (n = o.find(".mfp-" + r[0])).length && ("replaceWith" === (i = r[1]) ? n[0] !== e[0] && n.replaceWith(e) : "img" === i ? n.is("img") ? n.attr("src", e) : n.replaceWith(u("<img>").attr("src", e).attr("class", n.attr("class"))) : n.attr(r[1], e)) : o.find(".mfp-" + t).html(e));
                var n, i
            })
        }, _getScrollbarSize: function () {
            var t;
            return void 0 === f.scrollbarSize && ((t = document.createElement("div")).style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(t), f.scrollbarSize = t.offsetWidth - t.clientWidth, document.body.removeChild(t)), f.scrollbarSize
        }
    }, u.magnificPopup = {
        instance: null,
        proto: t.prototype,
        modules: [],
        open: function (t, e) {
            return r(), (t = t ? u.extend(!0, {}, t) : {}).isObj = !0, t.index = e || 0, this.instance.open(t)
        },
        close: function () {
            return u.magnificPopup.instance && u.magnificPopup.instance.close()
        },
        registerModule: function (t, e) {
            e.options && (u.magnificPopup.defaults[t] = e.options), u.extend(this.proto, e.proto), this.modules.push(t)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span>&#215;</span></button>',
            tClose: "Close (Esc)",
            tLoading: "Loading...",
            autoFocusLast: !0
        }
    }, u.fn.magnificPopup = function (t) {
        r();
        var e, n, i, o = u(this);
        return "string" == typeof t ? "open" === t ? (e = x ? o.data("magnificPopup") : o[0].magnificPopup, n = parseInt(arguments[1], 10) || 0, i = e.items ? e.items[n] : (i = o, (i = e.delegate ? i.find(e.delegate) : i).eq(n)), f._openClick({mfpEl: i}, o, e)) : f.isOpen && f[t].apply(f, Array.prototype.slice.call(arguments, 1)) : (t = u.extend(!0, {}, t), x ? o.data("magnificPopup", t) : o[0].magnificPopup = t, f.addGroup(o, t)), o
    };

    function _() {
        T && (z.after(T.addClass(C)).detach(), T = null)
    }

    var C, z, T, S = "inline";
    u.magnificPopup.registerModule(S, {
        options: {hiddenClass: "hide", markup: "", tNotFound: "Content not found"},
        proto: {
            initInline: function () {
                f.types.push(S), c(a + "." + S, function () {
                    _()
                })
            }, getInline: function (t, e) {
                if (_(), t.src) {
                    var n, i = f.st.inline, o = u(t.src);
                    return o.length ? ((n = o[0].parentNode) && n.tagName && (z || (C = i.hiddenClass, z = h(C), C = "mfp-" + C), T = o.after(z).detach().removeClass(C)), f.updateStatus("ready")) : (f.updateStatus("error", i.tNotFound), o = u("<div>")), t.inlineElement = o
                }
                return f.updateStatus("ready"), f._parseMarkup(e, {}, t), e
            }
        }
    });

    function E() {
        L && u(document.body).removeClass(L)
    }

    function k() {
        E(), f.req && f.req.abort()
    }

    var L, W = "ajax";
    u.magnificPopup.registerModule(W, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        }, proto: {
            initAjax: function () {
                f.types.push(W), L = f.st.ajax.cursor, c(a + "." + W, k), c("BeforeChange.ajax", k)
            }, getAjax: function (i) {
                L && u(document.body).addClass(L), f.updateStatus("loading");
                var t = u.extend({
                    url: i.src, success: function (t, e, n) {
                        n = {data: t, xhr: n};
                        p("ParseAjax", n), f.appendContent(u(n.data), W), i.finished = !0, E(), f._setFocus(), setTimeout(function () {
                            f.wrap.addClass(y)
                        }, 16), f.updateStatus("ready"), p("AjaxContentAdded")
                    }, error: function () {
                        E(), i.finished = i.loadError = !0, f.updateStatus("error", f.st.ajax.tError.replace("%url%", i.src))
                    }
                }, f.st.ajax.settings);
                return f.req = u.ajax(t), ""
            }
        }
    });
    var I;
    u.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        }, proto: {
            initImage: function () {
                var t = f.st.image, e = ".image";
                f.types.push("image"), c("Open" + e, function () {
                    "image" === f.currItem.type && t.cursor && u(document.body).addClass(t.cursor)
                }), c(a + e, function () {
                    t.cursor && u(document.body).removeClass(t.cursor), b.off("resize.mfp")
                }), c("Resize" + e, f.resizeImage), f.isLowIE && c("AfterChange", f.resizeImage)
            }, resizeImage: function () {
                var t, e = f.currItem;
                e && e.img && f.st.image.verticalFit && (t = 0, f.isLowIE && (t = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)), e.img.css("max-height", f.wH - t))
            }, _onImageHasSize: function (t) {
                t.img && (t.hasSize = !0, I && clearInterval(I), t.isCheckingImgSize = !1, p("ImageHasSize", t), t.imgHidden && (f.content && f.content.removeClass("mfp-loading"), t.imgHidden = !1))
            }, findImageSize: function (e) {
                var n = 0, i = e.img[0], o = function (t) {
                    I && clearInterval(I), I = setInterval(function () {
                        return 0 < i.naturalWidth ? void f._onImageHasSize(e) : (200 < n && clearInterval(I), void (3 === ++n ? o(10) : 40 === n ? o(50) : 100 === n && o(500)))
                    }, t)
                };
                o(1)
            }, getImage: function (t, e) {
                var n, i = 0, o = function () {
                    t && (t.img[0].complete ? (t.img.off(".mfploader"), t === f.currItem && (f._onImageHasSize(t), f.updateStatus("ready")), t.hasSize = !0, t.loaded = !0, p("ImageLoadComplete")) : ++i < 200 ? setTimeout(o, 100) : r())
                }, r = function () {
                    t && (t.img.off(".mfploader"), t === f.currItem && (f._onImageHasSize(t), f.updateStatus("error", s.tError.replace("%url%", t.src))), t.hasSize = !0, t.loaded = !0, t.loadError = !0)
                }, s = f.st.image, a = e.find(".mfp-img");
                return a.length && ((n = document.createElement("img")).className = "mfp-img", t.el && t.el.find("img").length && (n.alt = t.el.find("img").attr("alt")), t.img = u(n).on("load.mfploader", o).on("error.mfploader", r), n.src = t.src, a.is("img") && (t.img = t.img.clone()), 0 < (n = t.img[0]).naturalWidth ? t.hasSize = !0 : n.width || (t.hasSize = !1)), f._parseMarkup(e, {
                    title: function (t) {
                        if (t.data && void 0 !== t.data.title) return t.data.title;
                        var e = f.st.image.titleSrc;
                        if (e) {
                            if (u.isFunction(e)) return e.call(f, t);
                            if (t.el) return t.el.attr(e) || ""
                        }
                        return ""
                    }(t), img_replaceWith: t.img
                }, t), f.resizeImage(), t.hasSize ? (I && clearInterval(I), t.loadError ? (e.addClass("mfp-loading"), f.updateStatus("error", s.tError.replace("%url%", t.src))) : (e.removeClass("mfp-loading"), f.updateStatus("ready"))) : (f.updateStatus("loading"), t.loading = !0, t.hasSize || (t.imgHidden = !0, e.addClass("mfp-loading"), f.findImageSize(t))), e
            }
        }
    });
    var D;
    u.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1, easing: "ease-in-out", duration: 300, opener: function (t) {
                return t.is("img") ? t : t.find("img")
            }
        }, proto: {
            initZoom: function () {
                var t, e, n, i, o, r, s = f.st.zoom;
                s.enabled && f.supportsTransition && (i = s.duration, o = function (t) {
                    var e = t.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                        n = "all " + s.duration / 1e3 + "s " + s.easing,
                        i = {position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden"},
                        t = "transition";
                    return i["-webkit-" + t] = i["-moz-" + t] = i["-o-" + t] = i[t] = n, e.css(i), e
                }, r = function () {
                    f.content.css("visibility", "visible")
                }, c("BuildControls.zoom", function () {
                    f._allowZoom() && (clearTimeout(e), f.content.css("visibility", "hidden"), (t = f._getItemToZoom()) ? ((n = o(t)).css(f._getOffset()), f.wrap.append(n), e = setTimeout(function () {
                        n.css(f._getOffset(!0)), e = setTimeout(function () {
                            r(), setTimeout(function () {
                                n.remove(), t = n = null, p("ZoomAnimationEnded")
                            }, 16)
                        }, i)
                    }, 16)) : r())
                }), c(l + ".zoom", function () {
                    if (f._allowZoom()) {
                        if (clearTimeout(e), f.st.removalDelay = i, !t) {
                            if (!(t = f._getItemToZoom())) return;
                            n = o(t)
                        }
                        n.css(f._getOffset(!0)), f.wrap.append(n), f.content.css("visibility", "hidden"), setTimeout(function () {
                            n.css(f._getOffset())
                        }, 16)
                    }
                }), c(a + ".zoom", function () {
                    f._allowZoom() && (r(), n && n.remove(), t = null)
                }))
            }, _allowZoom: function () {
                return "image" === f.currItem.type
            }, _getItemToZoom: function () {
                return !!f.currItem.hasSize && f.currItem.img
            }, _getOffset: function (t) {
                var e = t ? f.currItem.img : f.st.zoom.opener(f.currItem.el || f.currItem), n = e.offset(),
                    i = parseInt(e.css("padding-top"), 10), t = parseInt(e.css("padding-bottom"), 10);
                n.top -= u(window).scrollTop() - i;
                i = {width: e.width(), height: (x ? e.innerHeight() : e[0].offsetHeight) - t - i};
                return (D = void 0 === D ? void 0 !== document.createElement("p").style.MozTransform : D) ? i["-moz-transform"] = i.transform = "translate(" + n.left + "px," + n.top + "px)" : (i.left = n.left, i.top = n.top), i
            }
        }
    });

    function O(t) {
        var e;
        !f.currTemplate[A] || (e = f.currTemplate[A].find("iframe")).length && (t || (e[0].src = "//about:blank"), f.isIE8 && e.css("display", t ? "block" : "none"))
    }

    var A = "iframe";
    u.magnificPopup.registerModule(A, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1"},
                vimeo: {index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1"},
                gmaps: {index: "//maps.google.", src: "%id%&output=embed"}
            }
        }, proto: {
            initIframe: function () {
                f.types.push(A), c("BeforeChange", function (t, e, n) {
                    e !== n && (e === A ? O() : n === A && O(!0))
                }), c(a + "." + A, function () {
                    O()
                })
            }, getIframe: function (t, e) {
                var n = t.src, i = f.st.iframe;
                u.each(i.patterns, function () {
                    return -1 < n.indexOf(this.index) ? (this.id && (n = "string" == typeof this.id ? n.substr(n.lastIndexOf(this.id) + this.id.length, n.length) : this.id.call(this, n)), n = this.src.replace("%id%", n), !1) : void 0
                });
                var o = {};
                return i.srcAction && (o[i.srcAction] = n), f._parseMarkup(e, o, t), f.updateStatus("ready"), e
            }
        }
    });

    function j(t) {
        var e = f.items.length;
        return e - 1 < t ? t - e : t < 0 ? e + t : t
    }

    function H(t, e, n) {
        return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, n)
    }

    u.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        }, proto: {
            initGallery: function () {
                var r = f.st.gallery, t = ".mfp-gallery";
                return f.direction = !0, !(!r || !r.enabled) && (g += " mfp-gallery", c("Open" + t, function () {
                    r.navigateByImgClick && f.wrap.on("click" + t, ".mfp-img", function () {
                        return 1 < f.items.length ? (f.next(), !1) : void 0
                    }), m.on("keydown" + t, function (t) {
                        37 === t.keyCode ? f.prev() : 39 === t.keyCode && f.next()
                    })
                }), c("UpdateStatus" + t, function (t, e) {
                    e.text && (e.text = H(e.text, f.currItem.index, f.items.length))
                }), c(v + t, function (t, e, n, i) {
                    var o = f.items.length;
                    n.counter = 1 < o ? H(r.tCounter, i.index, o) : ""
                }), c("BuildControls" + t, function () {
                    var t, e;
                    1 < f.items.length && r.arrows && !f.arrowLeft && (e = r.arrowMarkup, t = f.arrowLeft = u(e.replace(/%title%/gi, r.tPrev).replace(/%dir%/gi, "left")).addClass(w), e = f.arrowRight = u(e.replace(/%title%/gi, r.tNext).replace(/%dir%/gi, "right")).addClass(w), t.click(function () {
                        f.prev()
                    }), e.click(function () {
                        f.next()
                    }), f.container.append(t.add(e)))
                }), c("Change" + t, function () {
                    f._preloadTimeout && clearTimeout(f._preloadTimeout), f._preloadTimeout = setTimeout(function () {
                        f.preloadNearbyImages(), f._preloadTimeout = null
                    }, 16)
                }), void c(a + t, function () {
                    m.off(t), f.wrap.off("click" + t), f.arrowRight = f.arrowLeft = null
                }))
            }, next: function () {
                f.direction = !0, f.index = j(f.index + 1), f.updateItemHTML()
            }, prev: function () {
                f.direction = !1, f.index = j(f.index - 1), f.updateItemHTML()
            }, goTo: function (t) {
                f.direction = t >= f.index, f.index = t, f.updateItemHTML()
            }, preloadNearbyImages: function () {
                for (var t = f.st.gallery.preload, e = Math.min(t[0], f.items.length), n = Math.min(t[1], f.items.length), i = 1; i <= (f.direction ? n : e); i++) f._preloadItem(f.index + i);
                for (i = 1; i <= (f.direction ? e : n); i++) f._preloadItem(f.index - i)
            }, _preloadItem: function (t) {
                var e;
                t = j(t), f.items[t].preloaded || ((e = f.items[t]).parsed || (e = f.parseEl(t)), p("LazyLoad", e), "image" === e.type && (e.img = u('<img class="mfp-img" />').on("load.mfploader", function () {
                    e.hasSize = !0
                }).on("error.mfploader", function () {
                    e.hasSize = !0, e.loadError = !0, p("LazyLoadError", e)
                }).attr("src", e.src)), e.preloaded = !0)
            }
        }
    });
    var N = "retina";
    u.magnificPopup.registerModule(N, {
        options: {
            replaceSrc: function (t) {
                return t.src.replace(/\.\w+$/, function (t) {
                    return "@2x" + t
                })
            }, ratio: 1
        }, proto: {
            initRetina: function () {
                var n, i;
                1 < window.devicePixelRatio && (n = f.st.retina, i = n.ratio, 1 < (i = isNaN(i) ? i() : i) && (c("ImageHasSize." + N, function (t, e) {
                    e.img.css({"max-width": e.img[0].naturalWidth / i, width: "100%"})
                }), c("ElementParse." + N, function (t, e) {
                    e.src = n.replaceSrc(e, i)
                })))
            }
        }
    }), r()
}), function (l, n, i, a) {
    function u(t, e) {
        this.settings = null, this.options = l.extend({}, u.Defaults, e), this.$element = l(t), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: {start: null, current: null},
            direction: null
        }, this._states = {
            current: {},
            tags: {initializing: ["busy"], animating: ["busy"], dragging: ["interacting"]}
        }, l.each(["onResize", "onThrottledResize"], l.proxy(function (t, e) {
            this._handlers[e] = l.proxy(this[e], this)
        }, this)), l.each(u.Plugins, l.proxy(function (t, e) {
            this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this)
        }, this)), l.each(u.Workers, l.proxy(function (t, e) {
            this._pipe.push({filter: e.filter, run: l.proxy(e.run, this)})
        }, this)), this.setup(), this.initialize()
    }

    u.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        checkVisibility: !0,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: n,
        fallbackEasing: "swing",
        slideTransition: "",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab"
    }, u.Width = {Default: "default", Inner: "inner", Outer: "outer"}, u.Type = {
        Event: "event",
        State: "state"
    }, u.Plugins = {}, u.Workers = [{
        filter: ["width", "settings"], run: function () {
            this._width = this.$element.width()
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            t.current = this._items && this._items[this.relative(this._current)]
        }
    }, {
        filter: ["items", "settings"], run: function () {
            this.$stage.children(".cloned").remove()
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            var e = this.settings.margin || "", n = !this.settings.autoWidth, i = this.settings.rtl,
                e = {width: "auto", "margin-left": i ? e : "", "margin-right": i ? "" : e};
            n || this.$stage.children().css(e), t.css = e
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            var e = (this.width() / this.settings.items).toFixed(3) - this.settings.margin, n = null,
                i = this._items.length, o = !this.settings.autoWidth, r = [];
            for (t.items = {
                merge: !1,
                width: e
            }; i--;) n = this._mergers[i], n = this.settings.mergeFit && Math.min(n, this.settings.items) || n, t.items.merge = 1 < n || t.items.merge, r[i] = o ? e * n : this._items[i].width();
            this._widths = r
        }
    }, {
        filter: ["items", "settings"], run: function () {
            var t = [], e = this._items, n = this.settings, i = Math.max(2 * n.items, 4),
                o = 2 * Math.ceil(e.length / 2), r = n.loop && e.length ? n.rewind ? i : Math.max(i, o) : 0, s = "",
                a = "";
            for (r /= 2; 0 < r;) t.push(this.normalize(t.length / 2, !0)), s += e[t[t.length - 1]][0].outerHTML, t.push(this.normalize(e.length - 1 - (t.length - 1) / 2, !0)), a = e[t[t.length - 1]][0].outerHTML + a, --r;
            this._clones = t, l(s).addClass("cloned").appendTo(this.$stage), l(a).addClass("cloned").prependTo(this.$stage)
        }
    }, {
        filter: ["width", "items", "settings"], run: function () {
            for (var t, e, n = this.settings.rtl ? 1 : -1, i = this._clones.length + this._items.length, o = -1, r = []; ++o < i;) t = r[o - 1] || 0, e = this._widths[this.relative(o)] + this.settings.margin, r.push(t + e * n);
            this._coordinates = r
        }
    }, {
        filter: ["width", "items", "settings"], run: function () {
            var t = this.settings.stagePadding, e = this._coordinates, t = {
                width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                "padding-left": t || "",
                "padding-right": t || ""
            };
            this.$stage.css(t)
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            var e = this._coordinates.length, n = !this.settings.autoWidth, i = this.$stage.children();
            if (n && t.items.merge) for (; e--;) t.css.width = this._widths[this.relative(e)], i.eq(e).css(t.css); else n && (t.css.width = t.items.width, i.css(t.css))
        }
    }, {
        filter: ["items"], run: function () {
            this._coordinates.length < 1 && this.$stage.removeAttr("style")
        }
    }, {
        filter: ["width", "items", "settings"], run: function (t) {
            t.current = t.current ? this.$stage.children().index(t.current) : 0, t.current = Math.max(this.minimum(), Math.min(this.maximum(), t.current)), this.reset(t.current)
        }
    }, {
        filter: ["position"], run: function () {
            this.animate(this.coordinates(this._current))
        }
    }, {
        filter: ["width", "position", "items", "settings"], run: function () {
            for (var t, e, n = this.settings.rtl ? 1 : -1, i = 2 * this.settings.stagePadding, o = this.coordinates(this.current()) + i, r = o + this.width() * n, s = [], a = 0, l = this._coordinates.length; a < l; a++) t = this._coordinates[a - 1] || 0, e = Math.abs(this._coordinates[a]) + i * n, (this.op(t, "<=", o) && this.op(t, ">", r) || this.op(e, "<", o) && this.op(e, ">", r)) && s.push(a);
            this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + s.join("), :eq(") + ")").addClass("active"), this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
        }
    }], u.prototype.initializeStage = function () {
        this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), this.$stage = l("<" + this.settings.stageElement + ">", {class: this.settings.stageClass}).wrap(l("<div/>", {class: this.settings.stageOuterClass})), this.$element.append(this.$stage.parent()))
    }, u.prototype.initializeItems = function () {
        var t = this.$element.find(".owl-item");
        if (t.length) return this._items = t.get().map(function (t) {
            return l(t)
        }), this._mergers = this._items.map(function () {
            return 1
        }), void this.refresh();
        this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
    }, u.prototype.initialize = function () {
        var t, e;
        this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading") && (t = this.$element.find("img"), e = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : a, e = this.$element.children(e).width(), t.length && e <= 0 && this.preloadAutoWidthImages(t)), this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized")
    }, u.prototype.isVisible = function () {
        return !this.settings.checkVisibility || this.$element.is(":visible")
    }, u.prototype.setup = function () {
        var e = this.viewport(), t = this.options.responsive, n = -1, i = null;
        t ? (l.each(t, function (t) {
            t <= e && n < t && (n = Number(t))
        }), "function" == typeof (i = l.extend({}, this.options, t[n])).stagePadding && (i.stagePadding = i.stagePadding()), delete i.responsive, i.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + n))) : i = l.extend({}, this.options), this.trigger("change", {
            property: {
                name: "settings",
                value: i
            }
        }), this._breakpoint = n, this.settings = i, this.invalidate("settings"), this.trigger("changed", {
            property: {
                name: "settings",
                value: this.settings
            }
        })
    }, u.prototype.optionsLogic = function () {
        this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
    }, u.prototype.prepare = function (t) {
        var e = this.trigger("prepare", {content: t});
        return e.data || (e.data = l("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(t)), this.trigger("prepared", {content: e.data}), e.data
    }, u.prototype.update = function () {
        for (var t = 0, e = this._pipe.length, n = l.proxy(function (t) {
            return this[t]
        }, this._invalidated), i = {}; t < e;) (this._invalidated.all || 0 < l.grep(this._pipe[t].filter, n).length) && this._pipe[t].run(i), t++;
        this._invalidated = {}, this.is("valid") || this.enter("valid")
    }, u.prototype.width = function (t) {
        switch (t = t || u.Width.Default) {
            case u.Width.Inner:
            case u.Width.Outer:
                return this._width;
            default:
                return this._width - 2 * this.settings.stagePadding + this.settings.margin
        }
    }, u.prototype.refresh = function () {
        this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed")
    }, u.prototype.onThrottledResize = function () {
        n.clearTimeout(this.resizeTimer), this.resizeTimer = n.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
    }, u.prototype.onResize = function () {
        return !!this._items.length && this._width !== this.$element.width() && !!this.isVisible() && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))
    }, u.prototype.registerEventHandlers = function () {
        l.support.transition && this.$stage.on(l.support.transition.end + ".owl.core", l.proxy(this.onTransitionEnd, this)), !1 !== this.settings.responsive && this.on(n, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", l.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
            return !1
        })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", l.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", l.proxy(this.onDragEnd, this)))
    }, u.prototype.onDragStart = function (t) {
        var e = null;
        3 !== t.which && (e = l.support.transform ? {
            x: (e = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === e.length ? 12 : 4],
            y: e[16 === e.length ? 13 : 5]
        } : (e = this.$stage.position(), {
            x: this.settings.rtl ? e.left + this.$stage.width() - this.width() + this.settings.margin : e.left,
            y: e.top
        }), this.is("animating") && (l.support.transform ? this.animate(e.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === t.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = l(t.target), this._drag.stage.start = e, this._drag.stage.current = e, this._drag.pointer = this.pointer(t), l(i).on("mouseup.owl.core touchend.owl.core", l.proxy(this.onDragEnd, this)), l(i).one("mousemove.owl.core touchmove.owl.core", l.proxy(function (t) {
            var e = this.difference(this._drag.pointer, this.pointer(t));
            l(i).on("mousemove.owl.core touchmove.owl.core", l.proxy(this.onDragMove, this)), Math.abs(e.x) < Math.abs(e.y) && this.is("valid") || (t.preventDefault(), this.enter("dragging"), this.trigger("drag"))
        }, this)))
    }, u.prototype.onDragMove = function (t) {
        var e, n = null, i = null, o = this.difference(this._drag.pointer, this.pointer(t)),
            r = this.difference(this._drag.stage.start, o);
        this.is("dragging") && (t.preventDefault(), this.settings.loop ? (n = this.coordinates(this.minimum()), i = this.coordinates(this.maximum() + 1) - n, r.x = ((r.x - n) % i + i) % i + n) : (n = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), i = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), e = this.settings.pullDrag ? -1 * o.x / 5 : 0, r.x = Math.max(Math.min(r.x, n + e), i + e)), this._drag.stage.current = r, this.animate(r.x))
    }, u.prototype.onDragEnd = function (t) {
        var e = this.difference(this._drag.pointer, this.pointer(t)), n = this._drag.stage.current,
            t = 0 < e.x ^ this.settings.rtl ? "left" : "right";
        l(i).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== e.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(n.x, 0 !== e.x ? t : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = t, (3 < Math.abs(e.x) || 300 < (new Date).getTime() - this._drag.time) && this._drag.target.one("click.owl.core", function () {
            return !1
        })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
    }, u.prototype.closest = function (n, i) {
        var o = -1, r = this.width(), s = this.coordinates();
        return this.settings.freeDrag || l.each(s, l.proxy(function (t, e) {
            return "left" === i && e - 30 < n && n < e + 30 ? o = t : "right" === i && e - r - 30 < n && n < e - r + 30 ? o = t + 1 : this.op(n, "<", e) && this.op(n, ">", s[t + 1] !== a ? s[t + 1] : e - r) && (o = "left" === i ? t + 1 : t), -1 === o
        }, this)), this.settings.loop || (this.op(n, ">", s[this.minimum()]) ? o = n = this.minimum() : this.op(n, "<", s[this.maximum()]) && (o = n = this.maximum())), o
    }, u.prototype.animate = function (t) {
        var e = 0 < this.speed();
        this.is("animating") && this.onTransitionEnd(), e && (this.enter("animating"), this.trigger("translate")), l.support.transform3d && l.support.transition ? this.$stage.css({
            transform: "translate3d(" + t + "px,0px,0px)",
            transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
        }) : e ? this.$stage.animate({left: t + "px"}, this.speed(), this.settings.fallbackEasing, l.proxy(this.onTransitionEnd, this)) : this.$stage.css({left: t + "px"})
    }, u.prototype.is = function (t) {
        return this._states.current[t] && 0 < this._states.current[t]
    }, u.prototype.current = function (t) {
        return t === a ? this._current : 0 === this._items.length ? a : (t = this.normalize(t), this._current !== t && ((e = this.trigger("change", {
            property: {
                name: "position",
                value: t
            }
        })).data !== a && (t = this.normalize(e.data)), this._current = t, this.invalidate("position"), this.trigger("changed", {
            property: {
                name: "position",
                value: this._current
            }
        })), this._current);
        var e
    }, u.prototype.invalidate = function (t) {
        return "string" === l.type(t) && (this._invalidated[t] = !0, this.is("valid") && this.leave("valid")), l.map(this._invalidated, function (t, e) {
            return e
        })
    }, u.prototype.reset = function (t) {
        (t = this.normalize(t)) !== a && (this._speed = 0, this._current = t, this.suppress(["translate", "translated"]), this.animate(this.coordinates(t)), this.release(["translate", "translated"]))
    }, u.prototype.normalize = function (t, e) {
        var n = this._items.length, e = e ? 0 : this._clones.length;
        return !this.isNumeric(t) || n < 1 ? t = a : (t < 0 || n + e <= t) && (t = ((t - e / 2) % n + n) % n + e / 2), t
    }, u.prototype.relative = function (t) {
        return t -= this._clones.length / 2, this.normalize(t, !0)
    }, u.prototype.maximum = function (t) {
        var e, n, i, o = this.settings, r = this._coordinates.length;
        if (o.loop) r = this._clones.length / 2 + this._items.length - 1; else if (o.autoWidth || o.merge) {
            if (e = this._items.length) for (n = this._items[--e].width(), i = this.$element.width(); e-- && !((n += this._items[e].width() + this.settings.margin) > i);) ;
            r = e + 1
        } else r = o.center ? this._items.length - 1 : this._items.length - o.items;
        return t && (r -= this._clones.length / 2), Math.max(r, 0)
    }, u.prototype.minimum = function (t) {
        return t ? 0 : this._clones.length / 2
    }, u.prototype.items = function (t) {
        return t === a ? this._items.slice() : (t = this.normalize(t, !0), this._items[t])
    }, u.prototype.mergers = function (t) {
        return t === a ? this._mergers.slice() : (t = this.normalize(t, !0), this._mergers[t])
    }, u.prototype.clones = function (n) {
        function i(t) {
            return t % 2 == 0 ? o + t / 2 : e - (t + 1) / 2
        }

        var e = this._clones.length / 2, o = e + this._items.length;
        return n === a ? l.map(this._clones, function (t, e) {
            return i(e)
        }) : l.map(this._clones, function (t, e) {
            return t === n ? i(e) : null
        })
    }, u.prototype.speed = function (t) {
        return t !== a && (this._speed = t), this._speed
    }, u.prototype.coordinates = function (t) {
        var e, n = 1, i = t - 1;
        return t === a ? l.map(this._coordinates, l.proxy(function (t, e) {
            return this.coordinates(e)
        }, this)) : (this.settings.center ? (this.settings.rtl && (n = -1, i = t + 1), e = this._coordinates[t], e += (this.width() - e + (this._coordinates[i] || 0)) / 2 * n) : e = this._coordinates[i] || 0, Math.ceil(e))
    }, u.prototype.duration = function (t, e, n) {
        return 0 === n ? 0 : Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(n || this.settings.smartSpeed)
    }, u.prototype.to = function (t, e) {
        var n, i = this.current(), o = t - this.relative(i), r = (0 < o) - (o < 0), s = this._items.length,
            a = this.minimum(), l = this.maximum();
        this.settings.loop ? (!this.settings.rewind && Math.abs(o) > s / 2 && (o += -1 * r * s), (n = (((t = i + o) - a) % s + s) % s + a) !== t && n - o <= l && 0 < n - o && this.reset(i = (t = n) - o)) : t = this.settings.rewind ? (t % (l += 1) + l) % l : Math.max(a, Math.min(l, t)), this.speed(this.duration(i, t, e)), this.current(t), this.isVisible() && this.update()
    }, u.prototype.next = function (t) {
        t = t || !1, this.to(this.relative(this.current()) + 1, t)
    }, u.prototype.prev = function (t) {
        t = t || !1, this.to(this.relative(this.current()) - 1, t)
    }, u.prototype.onTransitionEnd = function (t) {
        if (t !== a && (t.stopPropagation(), (t.target || t.srcElement || t.originalTarget) !== this.$stage.get(0))) return !1;
        this.leave("animating"), this.trigger("translated")
    }, u.prototype.viewport = function () {
        var t;
        return this.options.responsiveBaseElement !== n ? t = l(this.options.responsiveBaseElement).width() : n.innerWidth ? t = n.innerWidth : i.documentElement && i.documentElement.clientWidth ? t = i.documentElement.clientWidth : console.warn("Can not detect viewport width."), t
    }, u.prototype.replace = function (t) {
        this.$stage.empty(), this._items = [], t = t && (t instanceof jQuery ? t : l(t)), (t = this.settings.nestedItemSelector ? t.find("." + this.settings.nestedItemSelector) : t).filter(function () {
            return 1 === this.nodeType
        }).each(l.proxy(function (t, e) {
            e = this.prepare(e), this.$stage.append(e), this._items.push(e), this._mergers.push(+e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
        }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
    }, u.prototype.add = function (t, e) {
        var n = this.relative(this._current);
        e = e === a ? this._items.length : this.normalize(e, !0), t = t instanceof jQuery ? t : l(t), this.trigger("add", {
            content: t,
            position: e
        }), t = this.prepare(t), 0 === this._items.length || e === this._items.length ? (0 === this._items.length && this.$stage.append(t), 0 !== this._items.length && this._items[e - 1].after(t), this._items.push(t), this._mergers.push(+t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[e].before(t), this._items.splice(e, 0, t), this._mergers.splice(e, 0, +t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[n] && this.reset(this._items[n].index()), this.invalidate("items"), this.trigger("added", {
            content: t,
            position: e
        })
    }, u.prototype.remove = function (t) {
        (t = this.normalize(t, !0)) !== a && (this.trigger("remove", {
            content: this._items[t],
            position: t
        }), this._items[t].remove(), this._items.splice(t, 1), this._mergers.splice(t, 1), this.invalidate("items"), this.trigger("removed", {
            content: null,
            position: t
        }))
    }, u.prototype.preloadAutoWidthImages = function (t) {
        t.each(l.proxy(function (t, e) {
            this.enter("pre-loading"), e = l(e), l(new Image).one("load", l.proxy(function (t) {
                e.attr("src", t.target.src), e.css("opacity", 1), this.leave("pre-loading"), this.is("pre-loading") || this.is("initializing") || this.refresh()
            }, this)).attr("src", e.attr("src") || e.attr("data-src") || e.attr("data-src-retina"))
        }, this))
    }, u.prototype.destroy = function () {
        for (var t in this.$element.off(".owl.core"), this.$stage.off(".owl.core"), l(i).off(".owl.core"), !1 !== this.settings.responsive && (n.clearTimeout(this.resizeTimer), this.off(n, "resize", this._handlers.onThrottledResize)), this._plugins) this._plugins[t].destroy();
        this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel")
    }, u.prototype.op = function (t, e, n) {
        var i = this.settings.rtl;
        switch (e) {
            case"<":
                return i ? n < t : t < n;
            case">":
                return i ? t < n : n < t;
            case">=":
                return i ? t <= n : n <= t;
            case"<=":
                return i ? n <= t : t <= n
        }
    }, u.prototype.on = function (t, e, n, i) {
        t.addEventListener ? t.addEventListener(e, n, i) : t.attachEvent && t.attachEvent("on" + e, n)
    }, u.prototype.off = function (t, e, n, i) {
        t.removeEventListener ? t.removeEventListener(e, n, i) : t.detachEvent && t.detachEvent("on" + e, n)
    }, u.prototype.trigger = function (t, e, n, i, o) {
        var r = {item: {count: this._items.length, index: this.current()}},
            s = l.camelCase(l.grep(["on", t, n], function (t) {
                return t
            }).join("-").toLowerCase()),
            a = l.Event([t, "owl", n || "carousel"].join(".").toLowerCase(), l.extend({relatedTarget: this}, r, e));
        return this._supress[t] || (l.each(this._plugins, function (t, e) {
            e.onTrigger && e.onTrigger(a)
        }), this.register({
            type: u.Type.Event,
            name: t
        }), this.$element.trigger(a), this.settings && "function" == typeof this.settings[s] && this.settings[s].call(this, a)), a
    }, u.prototype.enter = function (t) {
        l.each([t].concat(this._states.tags[t] || []), l.proxy(function (t, e) {
            this._states.current[e] === a && (this._states.current[e] = 0), this._states.current[e]++
        }, this))
    }, u.prototype.leave = function (t) {
        l.each([t].concat(this._states.tags[t] || []), l.proxy(function (t, e) {
            this._states.current[e]--
        }, this))
    }, u.prototype.register = function (n) {
        var e;
        n.type === u.Type.Event ? (l.event.special[n.name] || (l.event.special[n.name] = {}), l.event.special[n.name].owl || (e = l.event.special[n.name]._default, l.event.special[n.name]._default = function (t) {
            return !e || !e.apply || t.namespace && -1 !== t.namespace.indexOf("owl") ? t.namespace && -1 < t.namespace.indexOf("owl") : e.apply(this, arguments)
        }, l.event.special[n.name].owl = !0)) : n.type === u.Type.State && (this._states.tags[n.name] ? this._states.tags[n.name] = this._states.tags[n.name].concat(n.tags) : this._states.tags[n.name] = n.tags, this._states.tags[n.name] = l.grep(this._states.tags[n.name], l.proxy(function (t, e) {
            return l.inArray(t, this._states.tags[n.name]) === e
        }, this)))
    }, u.prototype.suppress = function (t) {
        l.each(t, l.proxy(function (t, e) {
            this._supress[e] = !0
        }, this))
    }, u.prototype.release = function (t) {
        l.each(t, l.proxy(function (t, e) {
            delete this._supress[e]
        }, this))
    }, u.prototype.pointer = function (t) {
        var e = {x: null, y: null};
        return (t = (t = t.originalEvent || t || n.event).touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t).pageX ? (e.x = t.pageX, e.y = t.pageY) : (e.x = t.clientX, e.y = t.clientY), e
    }, u.prototype.isNumeric = function (t) {
        return !isNaN(parseFloat(t))
    }, u.prototype.difference = function (t, e) {
        return {x: t.x - e.x, y: t.y - e.y}
    }, l.fn.owlCarousel = function (e) {
        var i = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
            var t = l(this), n = t.data("owl.carousel");
            n || (n = new u(this, "object" == typeof e && e), t.data("owl.carousel", n), l.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (t, e) {
                n.register({
                    type: u.Type.Event,
                    name: e
                }), n.$element.on(e + ".owl.carousel.core", l.proxy(function (t) {
                    t.namespace && t.relatedTarget !== this && (this.suppress([e]), n[e].apply(this, [].slice.call(arguments, 1)), this.release([e]))
                }, n))
            })), "string" == typeof e && "_" !== e.charAt(0) && n[e].apply(n, i)
        })
    }, l.fn.owlCarousel.Constructor = u
}(window.Zepto || window.jQuery, window, document), function (e, n) {
    var i = function (t) {
        this._core = t, this._interval = null, this._visible = null, this._handlers = {
            "initialized.owl.carousel": e.proxy(function (t) {
                t.namespace && this._core.settings.autoRefresh && this.watch()
            }, this)
        }, this._core.options = e.extend({}, i.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    i.Defaults = {autoRefresh: !0, autoRefreshInterval: 500}, i.prototype.watch = function () {
        this._interval || (this._visible = this._core.isVisible(), this._interval = n.setInterval(e.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
    }, i.prototype.refresh = function () {
        this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh())
    }, i.prototype.destroy = function () {
        var t, e;
        for (t in n.clearInterval(this._interval), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.AutoRefresh = i
}(window.Zepto || window.jQuery, window, document), function (a, o) {
    var e = function (t) {
        this._core = t, this._loaded = [], this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (t) {
                if (t.namespace && this._core.settings && this._core.settings.lazyLoad && (t.property && "position" == t.property.name || "initialized" == t.type)) {
                    var e = this._core.settings, n = e.center && Math.ceil(e.items / 2) || e.items,
                        i = e.center && -1 * n || 0,
                        o = (t.property && void 0 !== t.property.value ? t.property.value : this._core.current()) + i,
                        r = this._core.clones().length, s = a.proxy(function (t, e) {
                            this.load(e)
                        }, this);
                    for (0 < e.lazyLoadEager && (n += e.lazyLoadEager, e.loop && (o -= e.lazyLoadEager, n++)); i++ < n;) this.load(r / 2 + this._core.relative(o)), r && a.each(this._core.clones(this._core.relative(o)), s), o++
                }
            }, this)
        }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    e.Defaults = {lazyLoad: !1, lazyLoadEager: 0}, e.prototype.load = function (t) {
        var e = this._core.$stage.children().eq(t), t = e && e.find(".owl-lazy");
        !t || -1 < a.inArray(e.get(0), this._loaded) || (t.each(a.proxy(function (t, e) {
            var n = a(e),
                i = 1 < o.devicePixelRatio && n.attr("data-src-retina") || n.attr("data-src") || n.attr("data-srcset");
            this._core.trigger("load", {
                element: n,
                url: i
            }, "lazy"), n.is("img") ? n.one("load.owl.lazy", a.proxy(function () {
                n.css("opacity", 1), this._core.trigger("loaded", {element: n, url: i}, "lazy")
            }, this)).attr("src", i) : n.is("source") ? n.one("load.owl.lazy", a.proxy(function () {
                this._core.trigger("loaded", {element: n, url: i}, "lazy")
            }, this)).attr("srcset", i) : ((e = new Image).onload = a.proxy(function () {
                n.css({"background-image": 'url("' + i + '")', opacity: "1"}), this._core.trigger("loaded", {
                    element: n,
                    url: i
                }, "lazy")
            }, this), e.src = i)
        }, this)), this._loaded.push(e.get(0)))
    }, e.prototype.destroy = function () {
        var t, e;
        for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.Lazy = e
}(window.Zepto || window.jQuery, window, document), function (o, n) {
    var i = function (t) {
        this._core = t, this._previousHeight = null, this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.autoHeight && this.update()
            }, this), "changed.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.autoHeight && "position" === t.property.name && this.update()
            }, this), "loaded.owl.lazy": o.proxy(function (t) {
                t.namespace && this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
            }, this)
        }, this._core.options = o.extend({}, i.Defaults, this._core.options), this._core.$element.on(this._handlers), this._intervalId = null;
        var e = this;
        o(n).on("load", function () {
            e._core.settings.autoHeight && e.update()
        }), o(n).resize(function () {
            e._core.settings.autoHeight && (null != e._intervalId && clearTimeout(e._intervalId), e._intervalId = setTimeout(function () {
                e.update()
            }, 250))
        })
    };
    i.Defaults = {autoHeight: !1, autoHeightClass: "owl-height"}, i.prototype.update = function () {
        var t = this._core._current, e = t + this._core.settings.items, n = this._core.settings.lazyLoad,
            t = this._core.$stage.children().toArray().slice(t, e), i = [], e = 0;
        o.each(t, function (t, e) {
            i.push(o(e).height())
        }), (e = Math.max.apply(null, i)) <= 1 && n && this._previousHeight && (e = this._previousHeight), this._previousHeight = e, this._core.$stage.parent().height(e).addClass(this._core.settings.autoHeightClass)
    }, i.prototype.destroy = function () {
        var t, e;
        for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, o.fn.owlCarousel.Constructor.Plugins.AutoHeight = i
}(window.Zepto || window.jQuery, window, document), function (c, e) {
    var n = function (t) {
        this._core = t, this._videos = {}, this._playing = null, this._handlers = {
            "initialized.owl.carousel": c.proxy(function (t) {
                t.namespace && this._core.register({type: "state", name: "playing", tags: ["interacting"]})
            }, this), "resize.owl.carousel": c.proxy(function (t) {
                t.namespace && this._core.settings.video && this.isInFullScreen() && t.preventDefault()
            }, this), "refreshed.owl.carousel": c.proxy(function (t) {
                t.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
            }, this), "changed.owl.carousel": c.proxy(function (t) {
                t.namespace && "position" === t.property.name && this._playing && this.stop()
            }, this), "prepared.owl.carousel": c.proxy(function (t) {
                var e;
                !t.namespace || (e = c(t.content).find(".owl-video")).length && (e.css("display", "none"), this.fetch(e, c(t.content)))
            }, this)
        }, this._core.options = c.extend({}, n.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", c.proxy(function (t) {
            this.play(t)
        }, this))
    };
    n.Defaults = {video: !1, videoHeight: !1, videoWidth: !1}, n.prototype.fetch = function (t, e) {
        var n = t.attr("data-vimeo-id") ? "vimeo" : t.attr("data-vzaar-id") ? "vzaar" : "youtube",
            i = t.attr("data-vimeo-id") || t.attr("data-youtube-id") || t.attr("data-vzaar-id"),
            o = t.attr("data-width") || this._core.settings.videoWidth,
            r = t.attr("data-height") || this._core.settings.videoHeight, s = t.attr("href");
        if (!s) throw new Error("Missing video URL.");
        if (-1 < (i = s.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu")) n = "youtube"; else if (-1 < i[3].indexOf("vimeo")) n = "vimeo"; else {
            if (!(-1 < i[3].indexOf("vzaar"))) throw new Error("Video URL not supported.");
            n = "vzaar"
        }
        i = i[6], this._videos[s] = {
            type: n,
            id: i,
            width: o,
            height: r
        }, e.attr("data-video", s), this.thumbnail(t, this._videos[s])
    }, n.prototype.thumbnail = function (e, t) {
        function n(t) {
            i = u.lazyLoad ? c("<div/>", {class: "owl-video-tn " + l, srcType: t}) : c("<div/>", {
                class: "owl-video-tn",
                style: "opacity:1;background-image:url(" + t + ")"
            }), e.after(i), e.after('<div class="owl-video-play-icon"></div>')
        }

        var i, o, r = t.width && t.height ? "width:" + t.width + "px;height:" + t.height + "px;" : "",
            s = e.find("img"), a = "src", l = "", u = this._core.settings;
        if (e.wrap(c("<div/>", {
            class: "owl-video-wrapper",
            style: r
        })), this._core.settings.lazyLoad && (a = "data-src", l = "owl-lazy"), s.length) return n(s.attr(a)), s.remove(), !1;
        "youtube" === t.type ? (o = "//img.youtube.com/vi/" + t.id + "/hqdefault.jpg", n(o)) : "vimeo" === t.type ? c.ajax({
            type: "GET",
            url: "//vimeo.com/api/v2/video/" + t.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function (t) {
                o = t[0].thumbnail_large, n(o)
            }
        }) : "vzaar" === t.type && c.ajax({
            type: "GET",
            url: "//vzaar.com/api/videos/" + t.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function (t) {
                o = t.framegrab_url, n(o)
            }
        })
    }, n.prototype.stop = function () {
        this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video")
    }, n.prototype.play = function (t) {
        var e = c(t.target).closest("." + this._core.settings.itemClass), n = this._videos[e.attr("data-video")],
            i = n.width || "100%", o = n.height || this._core.$stage.height();
        this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), e = this._core.items(this._core.relative(e.index())), this._core.reset(e.index()), (t = c('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", o), t.attr("width", i), "youtube" === n.type ? t.attr("src", "//www.youtube.com/embed/" + n.id + "?autoplay=1&rel=0&v=" + n.id) : "vimeo" === n.type ? t.attr("src", "//player.vimeo.com/video/" + n.id + "?autoplay=1") : "vzaar" === n.type && t.attr("src", "//view.vzaar.com/" + n.id + "/player?autoplay=true"), c(t).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")), this._playing = e.addClass("owl-video-playing"))
    }, n.prototype.isInFullScreen = function () {
        var t = e.fullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement;
        return t && c(t).parent().hasClass("owl-video-frame")
    }, n.prototype.destroy = function () {
        var t, e;
        for (t in this._core.$element.off("click.owl.video"), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, c.fn.owlCarousel.Constructor.Plugins.Video = n
}(window.Zepto || window.jQuery, (window, document)), function (s) {
    var e = function (t) {
        this.core = t, this.core.options = s.extend({}, e.Defaults, this.core.options), this.swapping = !0, this.previous = void 0, this.next = void 0, this.handlers = {
            "change.owl.carousel": s.proxy(function (t) {
                t.namespace && "position" == t.property.name && (this.previous = this.core.current(), this.next = t.property.value)
            }, this), "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": s.proxy(function (t) {
                t.namespace && (this.swapping = "translated" == t.type)
            }, this), "translate.owl.carousel": s.proxy(function (t) {
                t.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
            }, this)
        }, this.core.$element.on(this.handlers)
    };
    e.Defaults = {animateOut: !1, animateIn: !1}, e.prototype.swap = function () {
        var t, e, n, i, o, r;
        1 === this.core.settings.items && s.support.animation && s.support.transition && (this.core.speed(0), e = s.proxy(this.clear, this), n = this.core.$stage.children().eq(this.previous), i = this.core.$stage.children().eq(this.next), o = this.core.settings.animateIn, r = this.core.settings.animateOut, this.core.current() !== this.previous && (r && (t = this.core.coordinates(this.previous) - this.core.coordinates(this.next), n.one(s.support.animation.end, e).css({left: t + "px"}).addClass("animated owl-animated-out").addClass(r)), o && i.one(s.support.animation.end, e).addClass("animated owl-animated-in").addClass(o)))
    }, e.prototype.clear = function (t) {
        s(t.target).css({left: ""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd()
    }, e.prototype.destroy = function () {
        var t, e;
        for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, s.fn.owlCarousel.Constructor.Plugins.Animate = e
}(window.Zepto || window.jQuery, (window, document)), function (i, o, e) {
    var n = function (t) {
        this._core = t, this._call = null, this._time = 0, this._timeout = 0, this._paused = !0, this._handlers = {
            "changed.owl.carousel": i.proxy(function (t) {
                t.namespace && "settings" === t.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : t.namespace && "position" === t.property.name && this._paused && (this._time = 0)
            }, this), "initialized.owl.carousel": i.proxy(function (t) {
                t.namespace && this._core.settings.autoplay && this.play()
            }, this), "play.owl.autoplay": i.proxy(function (t, e, n) {
                t.namespace && this.play(e, n)
            }, this), "stop.owl.autoplay": i.proxy(function (t) {
                t.namespace && this.stop()
            }, this), "mouseover.owl.autoplay": i.proxy(function () {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this), "mouseleave.owl.autoplay": i.proxy(function () {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
            }, this), "touchstart.owl.core": i.proxy(function () {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this), "touchend.owl.core": i.proxy(function () {
                this._core.settings.autoplayHoverPause && this.play()
            }, this)
        }, this._core.$element.on(this._handlers), this._core.options = i.extend({}, n.Defaults, this._core.options)
    };
    n.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    }, n.prototype._next = function (t) {
        this._call = o.setTimeout(i.proxy(this._next, this, t), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), this._core.is("interacting") || e.hidden || this._core.next(t || this._core.settings.autoplaySpeed)
    }, n.prototype.read = function () {
        return (new Date).getTime() - this._time
    }, n.prototype.play = function (t, e) {
        var n;
        this._core.is("rotating") || this._core.enter("rotating"), t = t || this._core.settings.autoplayTimeout, n = Math.min(this._time % (this._timeout || t), t), this._paused ? (this._time = this.read(), this._paused = !1) : o.clearTimeout(this._call), this._time += this.read() % t - n, this._timeout = t, this._call = o.setTimeout(i.proxy(this._next, this, e), t - n)
    }, n.prototype.stop = function () {
        this._core.is("rotating") && (this._time = 0, this._paused = !0, o.clearTimeout(this._call), this._core.leave("rotating"))
    }, n.prototype.pause = function () {
        this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = !0, o.clearTimeout(this._call))
    }, n.prototype.destroy = function () {
        var t, e;
        for (t in this.stop(), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, i.fn.owlCarousel.Constructor.Plugins.autoplay = n
}(window.Zepto || window.jQuery, window, document), function (o) {
    "use strict";
    var e = function (t) {
        this._core = t, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to
        }, this._handlers = {
            "prepared.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + o(t.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
            }, this), "added.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 0, this._templates.pop())
            }, this), "remove.owl.carousel": o.proxy(function (t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 1)
            }, this), "changed.owl.carousel": o.proxy(function (t) {
                t.namespace && "position" == t.property.name && this.draw()
            }, this), "initialized.owl.carousel": o.proxy(function (t) {
                t.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"))
            }, this), "refreshed.owl.carousel": o.proxy(function (t) {
                t.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"))
            }, this)
        }, this._core.options = o.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers)
    };
    e.Defaults = {
        nav: !1,
        navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
        navSpeed: !1,
        navElement: 'button type="button" role="presentation"',
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: ["owl-prev", "owl-next"],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1
    }, e.prototype.initialize = function () {
        var t, n = this._core.settings;
        for (t in this._controls.$relative = (n.navContainer ? o(n.navContainer) : o("<div>").addClass(n.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = o("<" + n.navElement + ">").addClass(n.navClass[0]).html(n.navText[0]).prependTo(this._controls.$relative).on("click", o.proxy(function (t) {
            this.prev(n.navSpeed)
        }, this)), this._controls.$next = o("<" + n.navElement + ">").addClass(n.navClass[1]).html(n.navText[1]).appendTo(this._controls.$relative).on("click", o.proxy(function (t) {
            this.next(n.navSpeed)
        }, this)), n.dotsData || (this._templates = [o('<button role="button">').addClass(n.dotClass).append(o("<span>")).prop("outerHTML")]), this._controls.$absolute = (n.dotsContainer ? o(n.dotsContainer) : o("<div>").addClass(n.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "button", o.proxy(function (t) {
            var e = (o(t.target).parent().is(this._controls.$absolute) ? o(t.target) : o(t.target).parent()).index();
            t.preventDefault(), this.to(e, n.dotsSpeed)
        }, this)), this._overrides) this._core[t] = o.proxy(this[t], this)
    }, e.prototype.destroy = function () {
        var t, e, n, i, o = this._core.settings;
        for (t in this._handlers) this.$element.off(t, this._handlers[t]);
        for (e in this._controls) "$relative" === e && o.navContainer ? this._controls[e].html("") : this._controls[e].remove();
        for (i in this.overides) this._core[i] = this._overrides[i];
        for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
    }, e.prototype.update = function () {
        var t, e, n = this._core.clones().length / 2, i = n + this._core.items().length, o = this._core.maximum(!0),
            r = this._core.settings, s = r.center || r.autoWidth || r.dotsData ? 1 : r.dotsEach || r.items;
        if ("page" !== r.slideBy && (r.slideBy = Math.min(r.slideBy, r.items)), r.dots || "page" == r.slideBy) for (this._pages = [], t = n, e = 0; t < i; t++) {
            if (s <= e || 0 === e) {
                if (this._pages.push({start: Math.min(o, t - n), end: t - n + s - 1}), Math.min(o, t - n) === o) break;
                e = 0, 0
            }
            e += this._core.mergers(this._core.relative(t))
        }
    }, e.prototype.draw = function () {
        var t = this._core.settings, e = this._core.items().length <= t.items,
            n = this._core.relative(this._core.current()), i = t.loop || t.rewind;
        this._controls.$relative.toggleClass("disabled", !t.nav || e), t.nav && (this._controls.$previous.toggleClass("disabled", !i && n <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !i && n >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !t.dots || e), t.dots && (e = this._pages.length - this._controls.$absolute.children().length, t.dotsData && 0 != e ? this._controls.$absolute.html(this._templates.join("")) : 0 < e ? this._controls.$absolute.append(new Array(1 + e).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(o.inArray(this.current(), this._pages)).addClass("active"))
    }, e.prototype.onTrigger = function (t) {
        var e = this._core.settings;
        t.page = {
            index: o.inArray(this.current(), this._pages),
            count: this._pages.length,
            size: e && (e.center || e.autoWidth || e.dotsData ? 1 : e.dotsEach || e.items)
        }
    }, e.prototype.current = function () {
        var n = this._core.relative(this._core.current());
        return o.grep(this._pages, o.proxy(function (t, e) {
            return t.start <= n && t.end >= n
        }, this)).pop()
    }, e.prototype.getPosition = function (t) {
        var e, n, i = this._core.settings;
        return "page" == i.slideBy ? (e = o.inArray(this.current(), this._pages), n = this._pages.length, t ? ++e : --e, e = this._pages[(e % n + n) % n].start) : (e = this._core.relative(this._core.current()), n = this._core.items().length, t ? e += i.slideBy : e -= i.slideBy), e
    }, e.prototype.next = function (t) {
        o.proxy(this._overrides.to, this._core)(this.getPosition(!0), t)
    }, e.prototype.prev = function (t) {
        o.proxy(this._overrides.to, this._core)(this.getPosition(!1), t)
    }, e.prototype.to = function (t, e, n) {
        !n && this._pages.length ? (n = this._pages.length, o.proxy(this._overrides.to, this._core)(this._pages[(t % n + n) % n].start, e)) : o.proxy(this._overrides.to, this._core)(t, e)
    }, o.fn.owlCarousel.Constructor.Plugins.Navigation = e
}(window.Zepto || window.jQuery, (window, document)), function (i, o) {
    "use strict";
    var e = function (t) {
        this._core = t, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
            "initialized.owl.carousel": i.proxy(function (t) {
                t.namespace && "URLHash" === this._core.settings.startPosition && i(o).trigger("hashchange.owl.navigation")
            }, this), "prepared.owl.carousel": i.proxy(function (t) {
                var e;
                !t.namespace || (e = i(t.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash")) && (this._hashes[e] = t.content)
            }, this), "changed.owl.carousel": i.proxy(function (t) {
                var n;
                t.namespace && "position" === t.property.name && (n = this._core.items(this._core.relative(this._core.current())), (t = i.map(this._hashes, function (t, e) {
                    return t === n ? e : null
                }).join()) && o.location.hash.slice(1) !== t && (o.location.hash = t))
            }, this)
        }, this._core.options = i.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers), i(o).on("hashchange.owl.navigation", i.proxy(function (t) {
            var e = o.location.hash.substring(1), n = this._core.$stage.children(),
                e = this._hashes[e] && n.index(this._hashes[e]);
            void 0 !== e && e !== this._core.current() && this._core.to(this._core.relative(e), !1, !0)
        }, this))
    };
    e.Defaults = {URLhashListener: !1}, e.prototype.destroy = function () {
        var t, e;
        for (t in i(o).off("hashchange.owl.navigation"), this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, i.fn.owlCarousel.Constructor.Plugins.Hash = e
}(window.Zepto || window.jQuery, window, document), function (o, r) {
    function e(t, n) {
        var i = !1, e = t.charAt(0).toUpperCase() + t.slice(1);
        return o.each((t + " " + a.join(e + " ") + e).split(" "), function (t, e) {
            if (s[e] !== r) return i = !n || e, !1
        }), i
    }

    function t(t) {
        return e(t, !0)
    }

    var s = o("<support>").get(0).style, a = "Webkit Moz O ms".split(" "), n = {
        transition: {
            end: {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd",
                transition: "transitionend"
            }
        },
        animation: {
            end: {
                WebkitAnimation: "webkitAnimationEnd",
                MozAnimation: "animationend",
                OAnimation: "oAnimationEnd",
                animation: "animationend"
            }
        }
    }, i = function () {
        return !!e("transform")
    }, l = function () {
        return !!e("perspective")
    }, u = function () {
        return !!e("animation")
    };
    !function () {
        return !!e("transition")
    }() || (o.support.transition = new String(t("transition")), o.support.transition.end = n.transition.end[o.support.transition]), u() && (o.support.animation = new String(t("animation")), o.support.animation.end = n.animation.end[o.support.animation]), i() && (o.support.transform = new String(t("transform")), o.support.transform3d = l())
}(window.Zepto || window.jQuery, (window, void document)), function (n) {
    var i = {};

    function o(t) {
        if (i[t]) return i[t].exports;
        var e = i[t] = {i: t, l: !1, exports: {}};
        return n[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports
    }

    o.m = n, o.c = i, o.d = function (t, e, n) {
        o.o(t, e) || Object.defineProperty(t, e, {enumerable: !0, get: n})
    }, o.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(t, "__esModule", {value: !0})
    }, o.t = function (e, t) {
        if (1 & t && (e = o(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (o.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for (var i in e) o.d(n, i, function (t) {
            return e[t]
        }.bind(null, i));
        return n
    }, o.n = function (t) {
        var e = t && t.__esModule ? function () {
            return t.default
        } : function () {
            return t
        };
        return o.d(e, "a", e), e
    }, o.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, o.p = "", o(o.s = 0)
}([function (t, e, n) {
    "use strict";
    n.r(e);

    function r(t) {
        return Array.prototype.slice.call(t)
    }

    function s(t, e) {
        return r((e || document).querySelectorAll(t))
    }

    var i = (d.prototype.add = function (t, e) {
            this.matchFns.push(t), this.unmatchFns.push(e), (this.toggler.matches ? t : e)()
        }, d),
        a = ("ontouchstart" in window || navigator.msMaxTouchPoints, -1 < navigator.userAgent.indexOf("MSIE") || -1 < navigator.appVersion.indexOf("Trident/")),
        l = "mm-spn", u = (Object.defineProperty(p.prototype, "prefix", {
            get: function () {
                return l
            }, enumerable: !1, configurable: !0
        }), p.prototype.openPanel = function (t) {
            if(t){
            var e =  t.parentElement;
            if (this.slidingSubmenus) {
                var n = t.dataset.mmSpnTitle;
                e === this.node ? this.node.classList.add(l + "--main") : (this.node.classList.remove(l + "--main"), n || r(e.children).forEach(function (t) {
                    t.matches("a, span") && (n = t.textContent)
                })), n = n || this.title, this.node.dataset.mmSpnTitle = n, s(".mm-spn--open", this.node).forEach(function (t) {
                    t.classList.remove(l + "--open"), t.classList.remove(l + "--parent")
                }), t.classList.add(l + "--open"), t.classList.remove(l + "--parent");
                for (var i = t.parentElement.closest("ul"); i;) i.classList.add(l + "--open"), i.classList.add(l + "--parent"), i = i.parentElement.closest("ul")
            } else {
                e = t.matches(".mm-spn--open");
                s(".mm-spn--open", this.node).forEach(function (t) {
                    t.classList.remove(l + "--open")
                }), t.classList[e ? "remove" : "add"](l + "--open");
                for (var o = t.parentElement.closest("ul"); o;) o.classList.add(l + "--open"), o = o.parentElement.closest("ul")
            }}
        }, p.prototype._setSelectedl = function () {
            var t = s("." + this.selectedClass, this.node), e = t[t.length - 1], t = null,
                t = (t = e ? e.closest("ul") : t) || this.node.querySelector("ul");
            this.openPanel(t)
        }, p.prototype._initAnchors = function () {
            var i = this;
            this.node.addEventListener("click", function (t) {
                var e, n = t.target;
                !n.matches("a") && (!(e = (e = n).closest("span") ? e.parentElement : !!e.closest("li") && e) || (r(e.children).forEach(function (t) {
                    t.matches("ul") && i.openPanel(t)
                }), 0)) && !function () {
                    var t = s(".mm-spn--open", n), t = t[t.length - 1];
                    if (t) {
                        t = t.parentElement.closest("ul");
                        if (t) return i.openPanel(t), !0
                    }
                    return !1
                }() || t.stopImmediatePropagation()
            })
        }, p), o = (Object.defineProperty(h.prototype, "prefix", {
            get: function () {
                return "mm-ocd"
            }, enumerable: !1, configurable: !0
        }), h.prototype.open = function () {
            this.wrapper.classList.add("mm-ocd--open"), document.body.classList.add("mm-ocd-opened")
        }, h.prototype.close = function () {
            this.wrapper.classList.remove("mm-ocd--open"), document.body.classList.remove("mm-ocd-opened")
        }, h), n = (c.prototype.navigation = function (t) {
            var e, n, i, o = this;
            return this.navigator || (e = (t = t || {}).title, n = t.selectedClass, i = t.slidingSubmenus, t = t.theme, this.navigator = new u(this.menu, void 0 === e ? "Menu" : e, void 0 === n ? "Selected" : n, void 0 === i || i, void 0 === t ? "light" : t), this.toggler.add(function () {
                return o.menu.classList.add(o.navigator.prefix)
            }, function () {
                return o.menu.classList.remove(o.navigator.prefix)
            })), this.navigator
        }, c.prototype.offcanvas = function (t) {
            var e, n = this;
            return this.drawer || (t = (t = t || {}).position, this.drawer = new o(null, void 0 === t ? "left" : t), e = document.createComment("original menu location"), this.menu.after(e), this.toggler.add(function () {
                n.drawer.content.append(n.menu)
            }, function () {
                n.drawer.close(), e.after(n.menu)
            })), this.drawer
        }, c);

    function c(t, e) {
        void 0 === e && (e = "all"), this.menu = t, this.toggler = new i(e)
    }

    function h(t, e) {
        var n = this;
        void 0 === t && (t = null), this.wrapper = document.createElement("div"), this.wrapper.classList.add("mm-ocd"), this.wrapper.classList.add("mm-ocd--" + e), this.content = document.createElement("div"), this.content.classList.add("mm-ocd__content"), this.wrapper.append(this.content), this.backdrop = document.createElement("div"), this.backdrop.classList.add("mm-ocd__backdrop"), this.wrapper.append(this.backdrop), document.body.append(this.wrapper), t && this.content.append(t);
        t = function (t) {
            n.close(), t.stopImmediatePropagation()
        };
        this.backdrop.addEventListener("touchstart", t, {passive: !0}), this.backdrop.addEventListener("mousedown", t, {passive: !0})
    }

    function p(t, e, n, i, o) {
        this.node = t, this.title = e, this.slidingSubmenus = i, this.selectedClass = n, this.node.classList.add(l), a && (this.slidingSubmenus = !1), this.node.classList.add(l + "--" + o), this.node.classList.add(l + "--" + (this.slidingSubmenus ? "navbar" : "vertical")), this._setSelectedl(), this._initAnchors()
    }

    function d(t) {
        var e = this;
        this.listener = function (t) {
            (t.matches ? e.matchFns : e.unmatchFns).forEach(function (t) {
                t()
            })
        }, this.toggler = window.matchMedia(t), this.toggler.addListener(this.listener), this.matchFns = [], this.unmatchFns = []
    }

    e.default = n, window.MmenuLight = n
}]), function (t) {
    "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? module.exports = t() : window.noUiSlider = t()
}(function () {
    "use strict";

    function s(t) {
        return null != t
    }

    function G(t) {
        t.preventDefault()
    }

    function r(t) {
        return "number" == typeof t && !isNaN(t) && isFinite(t)
    }

    function Q(t, e, n) {
        0 < n && (tt(t, e), setTimeout(function () {
            et(t, e)
        }, n))
    }

    function J(t) {
        return Math.max(Math.min(t, 100), 0)
    }

    function K(t) {
        return Array.isArray(t) ? t : [t]
    }

    function e(t) {
        t = (t = String(t)).split(".");
        return 1 < t.length ? t[1].length : 0
    }

    function tt(t, e) {
        t.classList ? t.classList.add(e) : t.className += " " + e
    }

    function et(t, e) {
        t.classList ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\b)" + e.split(" ").join("|") + "(\\b|$)", "gi"), " ")
    }

    function nt(t) {
        var e = void 0 !== window.pageXOffset, n = "CSS1Compat" === (t.compatMode || "");
        return {
            x: e ? window.pageXOffset : (n ? t.documentElement : t.body).scrollLeft,
            y: e ? window.pageYOffset : (n ? t.documentElement : t.body).scrollTop
        }
    }

    function a(t, e) {
        return 100 / (e - t)
    }

    function l(t, e) {
        return 100 * e / (t[1] - t[0])
    }

    function u(t, e) {
        for (var n = 1; t >= e[n];) n += 1;
        return n
    }

    function n(t, e, n) {
        if (n >= t.slice(-1)[0]) return 100;
        var i = u(n, t), o = t[i - 1], r = t[i], t = e[i - 1], i = e[i];
        return t + (n = n, l(r = [o, r], r[0] < 0 ? n + Math.abs(r[0]) : n - r[0]) / a(t, i))
    }

    function i(t, e, n, i) {
        if (100 === i) return i;
        var o = u(i, t), r = t[o - 1], s = t[o];
        return n ? (s - r) / 2 < i - r ? s : r : e[o - 1] ? t[o - 1] + (t = i - t[o - 1], o = e[o - 1], Math.round(t / o) * o) : i
    }

    function o(t, e, n) {
        this.xPct = [], this.xVal = [], this.xSteps = [n || !1], this.xNumSteps = [!1], this.xHighestCompleteStep = [], this.snap = e;
        var i, o = [];
        for (i in t) t.hasOwnProperty(i) && o.push([t[i], i]);
        for (o.length && "object" == typeof o[0][0] ? o.sort(function (t, e) {
            return t[0][0] - e[0][0]
        }) : o.sort(function (t, e) {
            return t[0] - e[0]
        }), i = 0; i < o.length; i++) !function (t, e, n) {
            if ("number" == typeof e && (e = [e]), !Array.isArray(e)) throw new Error("noUiSlider (" + ot + "): 'range' contains invalid value.");
            if (!r(t = "min" === t ? 0 : "max" === t ? 100 : parseFloat(t)) || !r(e[0])) throw new Error("noUiSlider (" + ot + "): 'range' value isn't numeric.");
            n.xPct.push(t), n.xVal.push(e[0]), t ? n.xSteps.push(!isNaN(e[1]) && e[1]) : isNaN(e[1]) || (n.xSteps[0] = e[1]), n.xHighestCompleteStep.push(0)
        }(o[i][1], o[i][0], this);
        for (this.xNumSteps = this.xSteps.slice(0), i = 0; i < this.xNumSteps.length; i++) !function (t, e, n) {
            if (!e) return;
            n.xSteps[t] = l([n.xVal[t], n.xVal[t + 1]], e) / a(n.xPct[t], n.xPct[t + 1]), e = (n.xVal[t + 1] - n.xVal[t]) / n.xNumSteps[t], e = Math.ceil(Number(e.toFixed(3)) - 1), e = n.xVal[t] + n.xNumSteps[t] * e, n.xHighestCompleteStep[t] = e
        }(i, this.xNumSteps[i], this)
    }

    function c(t) {
        if ("object" == typeof (t = t) && "function" == typeof t.to && "function" == typeof t.from) return 1;
        throw new Error("noUiSlider (" + ot + "): 'format' requires 'to' and 'from' methods.")
    }

    function h(t, e) {
        if (!r(e)) throw new Error("noUiSlider (" + ot + "): 'step' is not numeric.");
        t.singleStep = e
    }

    function p(t, e) {
        if ("object" != typeof e || Array.isArray(e)) throw new Error("noUiSlider (" + ot + "): 'range' is not an object.");
        if (void 0 === e.min || void 0 === e.max) throw new Error("noUiSlider (" + ot + "): Missing 'min' or 'max' in 'range'.");
        if (e.min === e.max) throw new Error("noUiSlider (" + ot + "): 'range' 'min' and 'max' cannot be equal.");
        t.spectrum = new o(e, t.snap, t.singleStep)
    }

    function d(t, e) {
        if (e = K(e), !Array.isArray(e) || !e.length) throw new Error("noUiSlider (" + ot + "): 'start' option is incorrect.");
        t.handles = e.length, t.start = e
    }

    function f(t, e) {
        if ("boolean" != typeof (t.snap = e)) throw new Error("noUiSlider (" + ot + "): 'snap' option must be a boolean.")
    }

    function m(t, e) {
        if ("boolean" != typeof (t.animate = e)) throw new Error("noUiSlider (" + ot + "): 'animate' option must be a boolean.")
    }

    function g(t, e) {
        if ("number" != typeof (t.animationDuration = e)) throw new Error("noUiSlider (" + ot + "): 'animationDuration' option must be a number.")
    }

    function v(t, e) {
        var n, i = [!1];
        if ("lower" === e ? e = [!0, !1] : "upper" === e && (e = [!1, !0]), !0 === e || !1 === e) {
            for (n = 1; n < t.handles; n++) i.push(e);
            i.push(!1)
        } else {
            if (!Array.isArray(e) || !e.length || e.length !== t.handles + 1) throw new Error("noUiSlider (" + ot + "): 'connect' option doesn't match handle count.");
            i = e
        }
        t.connect = i
    }

    function y(t, e) {
        switch (e) {
            case"horizontal":
                t.ort = 0;
                break;
            case"vertical":
                t.ort = 1;
                break;
            default:
                throw new Error("noUiSlider (" + ot + "): 'orientation' option is invalid.")
        }
    }

    function w(t, e) {
        if (!r(e)) throw new Error("noUiSlider (" + ot + "): 'margin' option must be numeric.");
        if (0 !== e && (t.margin = t.spectrum.getMargin(e), !t.margin)) throw new Error("noUiSlider (" + ot + "): 'margin' option is only supported on linear sliders.")
    }

    function x(t, e) {
        if (!r(e)) throw new Error("noUiSlider (" + ot + "): 'limit' option must be numeric.");
        if (t.limit = t.spectrum.getMargin(e), !t.limit || t.handles < 2) throw new Error("noUiSlider (" + ot + "): 'limit' option is only supported on linear sliders with 2 or more handles.")
    }

    function b(t, e) {
        if (!r(e) && !Array.isArray(e)) throw new Error("noUiSlider (" + ot + "): 'padding' option must be numeric or array of exactly 2 numbers.");
        if (Array.isArray(e) && 2 !== e.length && !r(e[0]) && !r(e[1])) throw new Error("noUiSlider (" + ot + "): 'padding' option must be numeric or array of exactly 2 numbers.");
        if (0 !== e) {
            if (Array.isArray(e) || (e = [e, e]), !(t.padding = [t.spectrum.getMargin(e[0]), t.spectrum.getMargin(e[1])]) === t.padding[0] || !1 === t.padding[1]) throw new Error("noUiSlider (" + ot + "): 'padding' option is only supported on linear sliders.");
            if (t.padding[0] < 0 || t.padding[1] < 0) throw new Error("noUiSlider (" + ot + "): 'padding' option must be a positive number(s).");
            if (100 <= t.padding[0] + t.padding[1]) throw new Error("noUiSlider (" + ot + "): 'padding' option must not exceed 100% of the range.")
        }
    }

    function _(t, e) {
        switch (e) {
            case"ltr":
                t.dir = 0;
                break;
            case"rtl":
                t.dir = 1;
                break;
            default:
                throw new Error("noUiSlider (" + ot + "): 'direction' option was not recognized.")
        }
    }

    function C(t, e) {
        if ("string" != typeof e) throw new Error("noUiSlider (" + ot + "): 'behaviour' must be a string containing options.");
        var n = 0 <= e.indexOf("tap"), i = 0 <= e.indexOf("drag"), o = 0 <= e.indexOf("fixed"),
            r = 0 <= e.indexOf("snap"), e = 0 <= e.indexOf("hover");
        if (o) {
            if (2 !== t.handles) throw new Error("noUiSlider (" + ot + "): 'fixed' behaviour must be used with 2 handles");
            w(t, t.start[1] - t.start[0])
        }
        t.events = {tap: n || r, drag: i, fixed: o, snap: r, hover: e}
    }

    function z(t, e) {
        if (!1 !== e) if (!0 === e) {
            t.tooltips = [];
            for (var n = 0; n < t.handles; n++) t.tooltips.push(!0)
        } else {
            if (t.tooltips = K(e), t.tooltips.length !== t.handles) throw new Error("noUiSlider (" + ot + "): must pass a formatter for all handles.");
            t.tooltips.forEach(function (t) {
                if ("boolean" != typeof t && ("object" != typeof t || "function" != typeof t.to)) throw new Error("noUiSlider (" + ot + "): 'tooltips' must be passed a formatter or 'false'.")
            })
        }
    }

    function T(t, e) {
        c(t.ariaFormat = e)
    }

    function S(t, e) {
        c(t.format = e)
    }

    function E(t, e) {
        if ("string" != typeof e && !1 !== e) throw new Error("noUiSlider (" + ot + "): 'cssPrefix' must be a string or `false`.");
        t.cssPrefix = e
    }

    function k(t, e) {
        if ("object" != typeof e) throw new Error("noUiSlider (" + ot + "): 'cssClasses' must be an object.");
        if ("string" == typeof t.cssPrefix) for (var n in t.cssClasses = {}, e) e.hasOwnProperty(n) && (t.cssClasses[n] = t.cssPrefix + e[n]); else t.cssClasses = e
    }

    function it(e) {
        var n = {margin: 0, limit: 0, padding: 0, animate: !0, animationDuration: 300, ariaFormat: W, format: W}, i = {
            step: {r: !1, t: h},
            start: {r: !0, t: d},
            connect: {r: !0, t: v},
            direction: {r: !0, t: _},
            snap: {r: !1, t: f},
            animate: {r: !1, t: m},
            animationDuration: {r: !1, t: g},
            range: {r: !0, t: p},
            orientation: {r: !1, t: y},
            margin: {r: !1, t: w},
            limit: {r: !1, t: x},
            padding: {r: !1, t: b},
            behaviour: {r: !0, t: C},
            ariaFormat: {r: !1, t: T},
            format: {r: !1, t: S},
            tooltips: {r: !1, t: z},
            cssPrefix: {r: !0, t: E},
            cssClasses: {r: !0, t: k}
        }, o = {
            connect: !1,
            direction: "ltr",
            behaviour: "tap",
            orientation: "horizontal",
            cssPrefix: "noUi-",
            cssClasses: {
                target: "target",
                base: "base",
                origin: "origin",
                handle: "handle",
                handleLower: "handle-lower",
                handleUpper: "handle-upper",
                horizontal: "horizontal",
                vertical: "vertical",
                background: "background",
                connect: "connect",
                connects: "connects",
                ltr: "ltr",
                rtl: "rtl",
                draggable: "draggable",
                drag: "state-drag",
                tap: "state-tap",
                active: "active",
                tooltip: "tooltip",
                pips: "pips",
                pipsHorizontal: "pips-horizontal",
                pipsVertical: "pips-vertical",
                marker: "marker",
                markerHorizontal: "marker-horizontal",
                markerVertical: "marker-vertical",
                markerNormal: "marker-normal",
                markerLarge: "marker-large",
                markerSub: "marker-sub",
                value: "value",
                valueHorizontal: "value-horizontal",
                valueVertical: "value-vertical",
                valueNormal: "value-normal",
                valueLarge: "value-large",
                valueSub: "value-sub"
            }
        };
        e.format && !e.ariaFormat && (e.ariaFormat = e.format), Object.keys(i).forEach(function (t) {
            if (!s(e[t]) && void 0 === o[t]) {
                if (i[t].r) throw new Error("noUiSlider (" + ot + "): '" + t + "' is required.");
                return !0
            }
            i[t].t(n, (s(e[t]) ? e : o)[t])
        }), n.pips = e.pips;
        var t = document.createElement("div"), r = void 0 !== t.style.msTransform, t = void 0 !== t.style.transform;
        n.transformRule = t ? "transform" : r ? "msTransform" : "webkitTransform";
        return n.style = [["left", "top"], ["right", "bottom"]][n.dir][n.ort], n
    }

    function L(t, h, r) {
        function p(t, e) {
            var n = U.createElement("div");
            return e && tt(n, e), t.appendChild(n), n
        }

        function a(t, e) {
            return !!e && p(t, h.cssClasses.connect)
        }

        function e(t, e) {
            return !!h.tooltips[e] && p(t.firstChild, h.cssClasses.tooltip)
        }

        function s(e, i, o) {
            function r(t, e) {
                var n = e === h.cssClasses.value;
                return e + " " + (n ? u : c)[h.ort] + " " + (n ? a : l)[t]
            }

            var s = U.createElement("div"),
                a = [h.cssClasses.valueNormal, h.cssClasses.valueLarge, h.cssClasses.valueSub],
                l = [h.cssClasses.markerNormal, h.cssClasses.markerLarge, h.cssClasses.markerSub],
                u = [h.cssClasses.valueHorizontal, h.cssClasses.valueVertical],
                c = [h.cssClasses.markerHorizontal, h.cssClasses.markerVertical];
            return tt(s, h.cssClasses.pips), tt(s, 0 === h.ort ? h.cssClasses.pipsHorizontal : h.cssClasses.pipsVertical), Object.keys(e).forEach(function (t) {
                !function (t, e) {
                    e[1] = e[1] && i ? i(e[0], e[1]) : e[1];
                    var n = p(s, !1);
                    n.className = r(e[1], h.cssClasses.marker), n.style[h.style] = t + "%", e[1] && ((n = p(s, !1)).className = r(e[1], h.cssClasses.value), n.setAttribute("data-value", e[0]), n.style[h.style] = t + "%", n.innerText = o.to(e[0]))
                }(t, e[t])
            }), s
        }

        function l() {
            var t;
            O && ((t = O).parentElement.removeChild(t), O = null)
        }

        function u(t) {
            l();
            var c, h, p, d, f, m, g, e = t.mode, n = t.density || 1, i = t.filter || !1, o = function (t, e, n) {
                    if ("range" === t || "steps" === t) return F.xVal;
                    if ("count" === t) {
                        if (e < 2) throw new Error("noUiSlider (" + ot + "): 'values' (>= 2) required for mode 'count'.");
                        var i = e - 1, o = 100 / i;
                        for (e = []; i--;) e[i] = i * o;
                        e.push(100), t = "positions"
                    }
                    return "positions" === t ? e.map(function (t) {
                        return F.fromStepping(n ? F.getStep(t) : t)
                    }) : "values" === t ? n ? e.map(function (t) {
                        return F.fromStepping(F.getStep(F.toStepping(t)))
                    }) : e : void 0
                }(e, t.values || !1, t.stepped || !1),
                o = (c = n, h = e, p = o, d = {}, e = F.xVal[0], o = F.xVal[F.xVal.length - 1], m = f = !1, g = 0, (p = p.slice().sort(function (t, e) {
                    return t - e
                }).filter(function (t) {
                    return !this[t] && (this[t] = !0)
                }, {}))[0] !== e && (p.unshift(e), f = !0), p[p.length - 1] !== o && (p.push(o), m = !0), p.forEach(function (t, e) {
                    var n, i, o, r, s, a, t = t, l = p[e + 1], u = (u = "steps" === h ? F.xNumSteps[e] : u) || l - t;
                    if (!1 !== t && void 0 !== l) for (u = Math.max(u, 1e-7), n = t; n <= l; n = +(n + u).toFixed(7)) {
                        for (a = (r = (o = F.toStepping(n)) - g) / (s = Math.round(r / c)), i = 1; i <= s; i += 1) d[(g + i * a).toFixed(5)] = ["x", 0];
                        r = -1 < p.indexOf(n) ? 1 : "steps" === h ? 2 : 0, !e && f && (r = 0), n === l && m || (d[o.toFixed(5)] = [n, r]), g = o
                    }
                }), d), t = t.format || {to: Math.round};
            return O = M.appendChild(s(o, i, t))
        }

        function c() {
            var t = L.getBoundingClientRect(), e = "offset" + ["Width", "Height"][h.ort];
            return 0 === h.ort ? t.width || L[e] : t.height || L[e]
        }

        function d(i, o, r, s) {
            function e(t) {
                return !!(t = function (t, e, n) {
                    var i, o = 0 === t.type.indexOf("touch"), r = 0 === t.type.indexOf("mouse"),
                        s = 0 === t.type.indexOf("pointer");
                    if (0 === t.type.indexOf("MSPointer") && (s = !0), o) {
                        o = function (t) {
                            return t.target === n || n.contains(t.target)
                        };
                        if ("touchstart" === t.type) {
                            var a = Array.prototype.filter.call(t.touches, o);
                            if (1 < a.length) return !1;
                            i = a[0].pageX, a = a[0].pageY
                        } else {
                            o = Array.prototype.find.call(t.changedTouches, o);
                            if (!o) return !1;
                            i = o.pageX, a = o.pageY
                        }
                    }
                    return e = e || nt(U), (r || s) && (i = t.clientX + e.x, a = t.clientY + e.y), t.pageOffset = e, t.points = [i, a], t.cursor = r || s, t
                }(t, s.pageOffset, s.target || o)) && !(M.hasAttribute("disabled") && !s.doNotReject) && (e = M, n = h.cssClasses.tap, !((e.classList ? e.classList.contains(n) : new RegExp("\\b" + n + "\\b").test(e.className)) && !s.doNotReject) && !(i === N.start && void 0 !== t.buttons && 1 < t.buttons) && (!s.hover || !t.buttons) && (P || t.preventDefault(), t.calcPoint = t.points[h.ort], void r(t, s)));
                var e, n
            }

            var n = [];
            return i.split(" ").forEach(function (t) {
                o.addEventListener(t, e, !!P && {passive: !0}), n.push([t, e])
            }), n
        }

        function f(t) {
            var e, n,
                i = J(i = 100 * (t - (i = L, e = h.ort, n = i.getBoundingClientRect(), i = (t = i.ownerDocument).documentElement, t = nt(t), /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (t.x = 0), e ? n.top + t.y - i.clientTop : n.left + t.x - i.clientLeft)) / c());
            return h.dir ? 100 - i : i
        }

        function m(t, e) {
            "mouseout" === t.type && "HTML" === t.target.nodeName && null === t.relatedTarget && v(t, e)
        }

        function g(t, e) {
            if (-1 === navigator.appVersion.indexOf("MSIE 9") && 0 === t.buttons && 0 !== e.buttonsProperty) return v(t, e);
            t = (h.dir ? -1 : 1) * (t.calcPoint - e.startCalcPoint);
            _(0 < t, 100 * t / e.baseSize, e.locations, e.handleNumbers)
        }

        function v(t, e) {
            e.handle && (et(e.handle, h.cssClasses.active), --q), e.listeners.forEach(function (t) {
                Y.removeEventListener(t[0], t[1])
            }), 0 === q && (et(M, h.cssClasses.drag), z(), t.cursor && (X.style.cursor = "", X.removeEventListener("selectstart", G))), e.handleNumbers.forEach(function (t) {
                w("change", t), w("set", t), w("end", t)
            })
        }

        function y(t, e) {
            if (1 === e.handleNumbers.length) {
                var n = W[e.handleNumbers[0]];
                if (n.hasAttribute("disabled")) return !1;
                r = n.children[0], q += 1, tt(r, h.cssClasses.active)
            }
            t.stopPropagation();
            var i = [], o = d(N.move, Y, g, {
                target: t.target,
                handle: r,
                listeners: i,
                startCalcPoint: t.calcPoint,
                baseSize: c(),
                pageOffset: t.pageOffset,
                handleNumbers: e.handleNumbers,
                buttonsProperty: t.buttons,
                locations: R.slice()
            }), n = d(N.end, Y, v, {
                target: t.target,
                handle: r,
                listeners: i,
                doNotReject: !0,
                handleNumbers: e.handleNumbers
            }), r = d("mouseout", Y, m, {
                target: t.target,
                handle: r,
                listeners: i,
                doNotReject: !0,
                handleNumbers: e.handleNumbers
            });
            i.push.apply(i, o.concat(n, r)), t.cursor && (X.style.cursor = getComputedStyle(t.target).cursor, 1 < W.length && tt(M, h.cssClasses.drag), X.addEventListener("selectstart", G, !1)), e.handleNumbers.forEach(function (t) {
                w("start", t)
            })
        }

        function n(t) {
            t.stopPropagation();
            var n, i, o, e = f(t.calcPoint), r = (n = e, o = !(i = 100), W.forEach(function (t, e) {
                t.hasAttribute("disabled") || ((t = Math.abs(R[e] - n)) < i || 100 === t && 100 === i) && (o = e, i = t)
            }), o);
            if (!1 === r) return !1;
            h.events.snap || Q(M, h.cssClasses.tap, h.animationDuration), T(r, e, !0, !0), z(), w("slide", r, !0), w("update", r, !0), w("change", r, !0), w("set", r, !0), h.events.snap && y(t, {handleNumbers: [r]})
        }

        function i(t) {
            var t = f(t.calcPoint), t = F.getStep(t), e = F.fromStepping(t);
            Object.keys(Z).forEach(function (t) {
                "hover" === t.split(".")[0] && Z[t].forEach(function (t) {
                    t.call(D, e)
                })
            })
        }

        function o(t, e) {
            Z[t] = Z[t] || [], Z[t].push(e), "update" === t.split(".")[0] && W.forEach(function (t, e) {
                w("update", e)
            })
        }

        function w(n, i, o) {
            Object.keys(Z).forEach(function (t) {
                var e = t.split(".")[0];
                n === e && Z[t].forEach(function (t) {
                    t.call(D, B.map(h.format.to), i, B.slice(), o || !1, R.slice())
                })
            })
        }

        function x(t, e, n, i, o, r) {
            return 1 < W.length && (i && 0 < e && (n = Math.max(n, t[e - 1] + h.margin)), o && e < W.length - 1 && (n = Math.min(n, t[e + 1] - h.margin))), 1 < W.length && h.limit && (i && 0 < e && (n = Math.min(n, t[e - 1] + h.limit)), o && e < W.length - 1 && (n = Math.max(n, t[e + 1] - h.limit))), h.padding && (0 === e && (n = Math.max(n, h.padding[0])), e === W.length - 1 && (n = Math.min(n, 100 - h.padding[1]))), !((n = J(n = F.getStep(n))) === t[e] && !r) && n
        }

        function b(t, e) {
            var n = h.ort;
            return (n ? e : t) + ", " + (n ? t : e)
        }

        function _(t, n, i, e) {
            var o = i.slice(), r = [!t, t], s = [t, !t];
            e = e.slice(), t && e.reverse(), 1 < e.length ? e.forEach(function (t, e) {
                e = x(o, t, o[t] + n, r[e], s[e], !1);
                !1 === e ? n = 0 : (n = e - o[t], o[t] = e)
            }) : r = s = [!0];
            var a = !1;
            e.forEach(function (t, e) {
                a = T(t, i[t] + n, r[e], s[e]) || a
            }), a && e.forEach(function (t) {
                w("update", t), w("slide", t)
            })
        }

        function C(t, e) {
            return h.dir ? 100 - t - e : t
        }

        function z() {
            $.forEach(function (t) {
                var e = 50 < R[t] ? -1 : 1, e = 3 + (W.length + e * t);
                W[t].style.zIndex = e
            })
        }

        function T(t, e, n, i) {
            return !1 !== (e = x(R, t, e, n, i, !1)) && (e = e, R[t = t] = e, B[t] = F.fromStepping(e), e = "translate(" + b(C(e, 0) - V + "%", "0") + ")", W[t].style[h.transformRule] = e, S(t), S(t + 1), !0)
        }

        function S(t) {
            var e, n;
            I[t] && (n = 100, e = "translate(" + b(C(e = (e = 0) !== t ? R[t - 1] : e, n = (n = t !== I.length - 1 ? R[t] : n) - e) + "%", "0") + ")", n = "scale(" + b(n / 100, "1") + ")", I[t].style[h.transformRule] = e + " " + n)
        }

        function E(t, e) {
            var n = K(t), t = void 0 === R[0];
            e = void 0 === e || !!e, h.animate && !t && Q(M, h.cssClasses.tap, h.animationDuration), $.forEach(function (t) {
                var e;
                T(t, (e = n[t], t = t, null === e || !1 === e || void 0 === e ? R[t] : ("number" == typeof e && (e = String(e)), e = h.format.from(e), !1 === (e = F.toStepping(e)) || isNaN(e) ? R[t] : e)), !0, !1)
            }), $.forEach(function (t) {
                T(t, R[t], !0, !0)
            }), z(), $.forEach(function (t) {
                w("update", t), null !== n[t] && e && w("set", t)
            })
        }

        function k() {
            var t = B.map(h.format.to);
            return 1 === t.length ? t[0] : t
        }

        var L, W, I, D, O, A, j, H, N = window.navigator.pointerEnabled ? {
                start: "pointerdown",
                move: "pointermove",
                end: "pointEURp"
            } : window.navigator.msPointerEnabled ? {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointEURp"
            } : {start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend"},
            P = window.CSS && CSS.supports && CSS.supports("touch-action", "none") && function () {
                var t = !1;
                try {
                    var e = Object.defineProperty({}, "passive", {
                        get: function () {
                            t = !0
                        }
                    });
                    window.addEventListener("test", null, e)
                } catch (t) {
                }
                return t
            }(), M = t, R = [], $ = [], q = 0, F = h.spectrum, B = [], Z = {}, U = t.ownerDocument,
            Y = U.documentElement, X = U.body, V = "rtl" === U.dir || 1 === h.ort ? 0 : 100;
        return tt(H = M, h.cssClasses.target), 0 === h.dir ? tt(H, h.cssClasses.ltr) : tt(H, h.cssClasses.rtl), 0 === h.ort ? tt(H, h.cssClasses.horizontal) : tt(H, h.cssClasses.vertical), L = p(H, h.cssClasses.base), function (t, e) {
            var n = p(e, h.cssClasses.connects);
            W = [], (I = []).push(a(n, t[0]));
            for (var i, o, r, s = 0; s < h.handles; s++) W.push((o = s, r = void 0, r = p(i = e, h.cssClasses.origin), (i = p(r, h.cssClasses.handle)).setAttribute("data-handle", o), i.setAttribute("tabindex", "0"), i.setAttribute("role", "slider"), i.setAttribute("aria-orientation", h.ort ? "vertical" : "horizontal"), 0 === o ? tt(i, h.cssClasses.handleLower) : o === h.handles - 1 && tt(i, h.cssClasses.handleUpper), r)), $[s] = s, I.push(a(n, t[s + 1]))
        }(h.connect, L), (j = h.events).fixed || W.forEach(function (t, e) {
            d(N.start, t.children[0], y, {handleNumbers: [e]})
        }), j.tap && d(N.start, L, n, {}), j.hover && d(N.move, L, i, {hover: !0}), j.drag && I.forEach(function (t, e) {
            var n, i, o;
            !1 !== t && 0 !== e && e !== I.length - 1 && (n = W[e - 1], i = W[e], o = [t], tt(t, h.cssClasses.draggable), j.fixed && (o.push(n.children[0]), o.push(i.children[0])), o.forEach(function (t) {
                d(N.start, t, y, {handles: [n, i], handleNumbers: [e - 1, e]})
            }))
        }), E(h.start), D = {
            destroy: function () {
                for (var t in h.cssClasses) h.cssClasses.hasOwnProperty(t) && et(M, h.cssClasses[t]);
                for (; M.firstChild;) M.removeChild(M.firstChild);
                delete M.noUiSlider
            }, steps: function () {
                return R.map(function (t, e) {
                    var n = F.getNearbySteps(t), i = B[e], o = n.thisStep.step, e = null;
                    !1 !== o && i + o > n.stepAfter.startValue && (o = n.stepAfter.startValue - i), e = i > n.thisStep.startValue ? n.thisStep.step : !1 !== n.stepBefore.step && i - n.stepBefore.highestStep, 100 === t ? o = null : 0 === t && (e = null);
                    t = F.countStepDecimals();
                    return null !== o && !1 !== o && (o = Number(o.toFixed(t))), [e = null !== e && !1 !== e ? Number(e.toFixed(t)) : e, o]
                })
            }, on: o, off: function (t) {
                var i = t && t.split(".")[0], o = i && t.substring(i.length);
                Object.keys(Z).forEach(function (t) {
                    var e = t.split(".")[0], n = t.substring(e.length);
                    i && i !== e || o && o !== n || delete Z[t]
                })
            }, get: k, set: E, reset: function (t) {
                E(h.start, t)
            }, __moveHandles: function (t, e, n) {
                _(t, e, R, n)
            }, options: r, updateOptions: function (e, t) {
                var n = k(), i = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format"];
                i.forEach(function (t) {
                    void 0 !== e[t] && (r[t] = e[t])
                });
                var o = it(r);
                i.forEach(function (t) {
                    void 0 !== e[t] && (h[t] = o[t])
                }), F = o.spectrum, h.margin = o.margin, h.limit = o.limit, h.padding = o.padding, h.pips && u(h.pips), R = [], E(e.start || n, t)
            }, target: M, removePips: l, pips: u
        }, h.pips && u(h.pips), h.tooltips && (A = W.map(e), o("update", function (t, e, n) {
            A[e] && (t = t[e], !0 !== h.tooltips[e] && (t = h.tooltips[e].to(n[e])), A[e].innerHTML = t)
        })), o("update", function (t, e, r, n, s) {
            $.forEach(function (t) {
                var e = W[t], n = x(R, t, 0, !0, !0, !0), i = x(R, t, 100, !0, !0, !0), o = s[t],
                    t = h.ariaFormat.to(r[t]);
                e.children[0].setAttribute("aria-valuemin", n.toFixed(1)), e.children[0].setAttribute("aria-valuemax", i.toFixed(1)), e.children[0].setAttribute("aria-valuenow", o.toFixed(1)), e.children[0].setAttribute("aria-valuetext", t)
            })
        }), D
    }

    var ot = "11.1.0";
    o.prototype.getMargin = function (t) {
        var e = this.xNumSteps[0];
        if (e && t / e % 1 != 0) throw new Error("noUiSlider (" + ot + "): 'limit', 'margin' and 'padding' must be divisible by step.");
        return 2 === this.xPct.length && l(this.xVal, t)
    }, o.prototype.toStepping = function (t) {
        return n(this.xVal, this.xPct, t)
    }, o.prototype.fromStepping = function (t) {
        return function (t, e, n) {
            if (100 <= n) return t.slice(-1)[0];
            var i = u(n, e), o = t[i - 1], r = t[i], t = e[i - 1];
            return r = [o, r], (n - t) * a(t, e[i]) * (r[1] - r[0]) / 100 + r[0]
        }(this.xVal, this.xPct, t)
    }, o.prototype.getStep = function (t) {
        return i(this.xPct, this.xSteps, this.snap, t)
    }, o.prototype.getNearbySteps = function (t) {
        t = u(t, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[t - 2],
                step: this.xNumSteps[t - 2],
                highestStep: this.xHighestCompleteStep[t - 2]
            },
            thisStep: {
                startValue: this.xVal[t - 1],
                step: this.xNumSteps[t - 1],
                highestStep: this.xHighestCompleteStep[t - 1]
            },
            stepAfter: {startValue: this.xVal[+t], step: this.xNumSteps[+t], highestStep: this.xHighestCompleteStep[+t]}
        }
    }, o.prototype.countStepDecimals = function () {
        var t = this.xNumSteps.map(e);
        return Math.max.apply(null, t)
    }, o.prototype.convert = function (t) {
        return this.getStep(this.toStepping(t))
    };
    var W = {
        to: function (t) {
            return void 0 !== t && t.toFixed(2)
        }, from: Number
    };
    return {
        version: ot, create: function (t, e) {
            if (!t || !t.nodeName) throw new Error("noUiSlider (" + ot + "): create requires a single element, got: " + t);
            if (t.noUiSlider) throw new Error("noUiSlider (" + ot + "): Slider was already initialized.");
            return e = L(t, it(e), e), t.noUiSlider = e
        }
    }
});